export const QUESTIONS_EN = [
  {
    "index": 1,
    "id": "ABMW0425RU19",
    "section": "Control of Vehicle",
    "question": "What is a likely consequence of sudden braking?",
    "options": [
      "There will be no consequences as the vehicle's brake lights will come on.",
      "The vehicle could be overtaken.",
      "The vehicle's braking system could overheat.",
      "The vehicle could be hit from behind."
    ],
    "correct_answer": 3,
    "explanation": "As well as reading the road ahead, you should also be aware of traffic travelling behind you. This will help you react correctly in a situation where you need to brake suddenly."
  },
  {
    "index": 2,
    "id": "ABMW0655RU19",
    "section": "Control of Vehicle",
    "question": "If the brake pedal of a vehicle feels soft or spongy when applied, what does this mean?",
    "options": [
      "A fault in the brake fluid system.",
      "A fault in the handbrake cable.",
      "The parking brake is on.",
      "Worn brake pads."
    ],
    "correct_answer": 0,
    "explanation": "If the brake pedal feels soft or spongy when pressed, it could indicate that the brake fluid level is low and there is a fault in the system. Each time a driver sets out on a journey, they should test the brakes. If a fault is detected, have it checked by a competent person. Drivers should check brake fluid levels regularly.",
    "image_name": ""
  },
  {
    "index": 3,
    "id": "ABMW0656RU19",
    "section": "Control of Vehicle",
    "question": "Whilst driving, why might a driver suspect that the brake fluid level in their vehicle is low?",
    "options": [
      "The brakes take longer than usual to release.",
      "The brakes are unusually sharp.",
      "The brakes feel hard to press.",
      "The brakes feel spongy and soft."
    ],
    "correct_answer": 3,
    "explanation": "If the brake pedal feels soft or spongy when pressed, it could indicate that the brake fluid level is low and there is a fault in the system. Each time a driver sets out on a journey, they should test the brakes. If a fault is detected, have it checked by a competent person. Drivers should check brake fluid levels regularly.",
    "image_name": ""
  },
  {
    "index": 4,
    "id": "ABMW0658RU19",
    "section": "Control of Vehicle",
    "question": "If a driver applies the footbrake and hears a scraping noise, what is the most likely cause?",
    "options": [
      "The brake-pads are wet.",
      "One of the rear tyres is flat.",
      "One of the front tyres is flat.",
      "The brake linings or pads are worn."
    ],
    "correct_answer": 3,
    "explanation": "Drivers should test their brakes regularly and particularly before setting out ona journey. However, if when driving they hear a scraping noise when they press the brake, the most likely reason is that the brake linings or pads are worn. In this case, brakes wont work as well as they should and the driver should have them replaced by a competent person immediately.",
    "image_name": ""
  },
  {
    "index": 5,
    "id": "ABMW0659RU19",
    "section": "Control of Vehicle",
    "question": "What may indicate a problem with the vehicle's braking system?",
    "options": [
      "The vehicle's stopping ability is affected.",
      "The vehicle's suspension is affected.",
      "The vehicle's parking brake is more effective.",
      "The vehicle's fuel consumption is reduced."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should test their brakes before setting out on a journey. If when driving they notice that it is taking longer than usual to bring the vehicle to a stop, they should have the brakes checked immediately by a competent person.",
    "image_name": ""
  },
  {
    "index": 6,
    "id": "RSA225190",
    "section": "Control of Vehicle",
    "question": "What is the danger of sudden braking?",
    "options": [
      "Vehicle may skid.",
      "Driver's airbag may deploy.",
      "Handbrake may engage."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should always read the road ahead and drive at a distance that enables them to stop safely. Where a driver has to brake suddenly, they should be aware that they may lose control of the vehicle causing it to skid.",
    "image_name": ""
  },
  {
    "index": 7,
    "id": "ABMW31U19",
    "section": "Control of Vehicle",
    "question": "What can cause a vehicle to skid?",
    "options": [
      "Stopping in fourth gear.",
      "Coasting to a stop.",
      "Controlled acceleration.",
      "Excessive heavy braking."
    ],
    "correct_answer": 3,
    "explanation": "Heavy braking can cause a vehicle to skid, particularly if the road surface is wet or uneven, or if the tyres are worn or incorrectly inflated. Read the road well ahead and try to avoid heavy braking, particularly in wet or slippery conditions.",
    "image_name": ""
  },
  {
    "index": 8,
    "id": "RSA225168",
    "section": "Control of Vehicle",
    "question": "What is the outcome of late clutch use when stopping a vehicle?",
    "options": [
      "Tyres will wear down quicker.",
      "The vehicle may cut out.",
      "It helps to save fuel."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should always make proper use of the clutch on the vehicle when changing gear, this will allow for smooth gear changes at all times. When a vehicle is coming to a stop, the clutch should be used in good time to avoid the vehicle cutting out.",
    "image_name": ""
  },
  {
    "index": 9,
    "id": "ABMW0140RU19",
    "section": "Control of Vehicle",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to move in or turn left.",
      "The cyclist intends to move out or turn right.",
      "The cyclist intends to stop.",
      "The cyclist intends to slow down."
    ],
    "correct_answer": 1,
    "explanation": "This hand signal tells other road users that the cyclist intends to either move out or make a right-hand turn. Drivers should be aware that cyclists could move out into the path of their vehicle without looking.",
    "image_name": "ABMW0140RU19.png"
  },
  {
    "index": 10,
    "id": "RSA225228",
    "section": "Control of Vehicle",
    "question": "What should a driver be aware of when braking to slow down and stop?",
    "options": [
      "A shorter vehicle takes longer to stop.",
      "A loaded vehicle takes longer to stop.",
      "An empty vehicle takes longer to stop."
    ],
    "correct_answer": 1,
    "explanation": "When you are braking you need to take into account that a fully loaded vehicle, because of its additional weight takes a longer distance to come to a complete stop than an unladen vehicle.",
    "image_name": ""
  },
  {
    "index": 11,
    "id": "BW0023RU19",
    "section": "Control of Vehicle",
    "question": "Why should a tractor be driven more slowly on uneven road surfaces?",
    "options": [
      "To avoid fuel spilling from the tank.",
      "To maintain tyre pressure.",
      "To avoid severe bouncing.",
      "To reduce road noise."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should drive more slowly on an uneven road surface because driving a tractor at speed could cause the vehicle or the trailer to become unstable and difficult to control. During severe bouncing, the tractor's wheels can lose contact with the road, negatively affecting steering and braking.",
    "image_name": ""
  },
  {
    "index": 12,
    "id": "BWO0110",
    "section": "Control of Vehicle",
    "question": "What type of noise might fast cornering create?",
    "options": [
      "Tyre squeal.",
      "Exhaust backfire.",
      "Brake squeal.",
      "Engine backfire."
    ],
    "correct_answer": 0,
    "explanation": "If you drive around a corner too fast, the tyres begin to lose contact with the surface of the road, and this causes a squealing sound. If you continue driving in this way, you can lose control of the vehicle.",
    "image_name": ""
  },
  {
    "index": 13,
    "id": "RSA225229",
    "section": "Control of Vehicle",
    "question": "What should a driver do when a vehicle starts to aquaplane?",
    "options": [
      "Ease off the accelerator to slow down.",
      "Maintain speed to avoid skidding.",
      "Brake firmly in order to slow down."
    ],
    "correct_answer": 0,
    "explanation": "Aquaplaning occurs when driving in wet weather in conditions and a film of water builds up between the road surface and the tyres, which in turn effects the handling of the vehicle. When the vehicle aquaplanes, the steering will seem very ‘loose’. Drivers should stay calm, ease off the accelerator to slow down, but avoid braking if possible. At a slower speed the water will be disoersed and the tyres will regain grip ",
    "image_name": ""
  },
  {
    "index": 14,
    "id": "RSA225230",
    "section": "Control of Vehicle",
    "question": "What is the purpose of electronic stability control?",
    "options": [
      "To maintain speed when motorway driving.",
      "To reduce fuel consumption.",
      "To keep the vehicle steady and prevent skidding."
    ],
    "correct_answer": 2,
    "explanation": "Electronic Stability Control (ESC) is an active safety system which can be fitted to cars, buses, coaches and trucks. It is an extension of anti-lock brake technology, which has speed sensors and independent braking for each wheel. It aims to stabilise the vehicle and prevent skidding under all driving conditions and situations, within physical limits. It does so by identifying a critical driving situation and ",
    "image_name": ""
  },
  {
    "index": 15,
    "id": "RSA225231",
    "section": "Control of Vehicle",
    "question": "What is the most common cause of skidding?",
    "options": [
      "Badly worn brake pads.",
      "Excessive speed for the circumstances or conditions.",
      "Hot brake pads from over use on downhill stretches."
    ],
    "correct_answer": 1,
    "explanation": "Excessive speed for the road conditions is a factor which can reduce the grip of tyres on the road and can cause or contribute to a skid. Drivers should adjust their speed to suit the road and traffic conditions and should be aware that wet or greasy roads, worn or improperly inflated tyres, mud, leaves, ice or snow can all cause a vehicle to skid.",
    "image_name": ""
  },
  {
    "index": 16,
    "id": "BW0024RU19",
    "section": "Control of Vehicle",
    "question": "When should the handbrake be used to bring a vehicle to a halt?",
    "options": [
      "Only when going downhill.",
      "Normally never.",
      "At any time.",
      "Only when going uphill."
    ],
    "correct_answer": 1,
    "explanation": "In general the handbrake should never be used to bring a vehicle to a halt. This practice is potentially dangerous, as the rear wheels could lock up and the vehicle could skid out of control. In addition, using the handbrake does not operate the rear brake lights to warn following traffic.",
    "image_name": ""
  },
  {
    "index": 17,
    "id": "BW0025RU19",
    "section": "Control of Vehicle",
    "question": "What is the danger associated with applying the handbrake (parking brake) when the vehicle is moving?",
    "options": [
      "The ABS could disconnect and cause the vehicle to skid.",
      "The engine will stall once the handbrake is applied at speed.",
      "The wheels could lock and cause the vehicle to skid.",
      "There is no danger - the vehicle will not skid as the handbrake can be released quickly."
    ],
    "correct_answer": 2,
    "explanation": "Except in an emergency, the handbrake (parking brake) should never be used when the vehicle is moving. This practice is potentially dangerous, as the wheels could lock up and the vehicle could skid out of control. In addition there is no warning to following traffic from the brake lights.",
    "image_name": ""
  },
  {
    "index": 18,
    "id": "BW0079RU19",
    "section": "Control of Vehicle",
    "question": "The parking brake (handbrake) generally works on which wheels?",
    "options": [
      "All the wheels.",
      "The rear right-hand wheel.",
      "The rear wheels.",
      "The front wheels."
    ],
    "correct_answer": 2,
    "explanation": "In most vehicles, the parking brake operates on the rear wheels only. The function of the parking brake (handbrake) is to stop the vehicle from moving when it is parked or when it is stopped on a hill. Drivers normally use the parking brake when the vehicle is already stationary and should generally not use it to stop the vehicle. It is even more important to use the parking brake when parked on a hill or when ",
    "image_name": ""
  },
  {
    "index": 19,
    "id": "BW0081RU19",
    "section": "Control of Vehicle",
    "question": "What is the recommended method of driving a car with automatic transmission?",
    "options": [
      "Operate the accelerator and brake with the right foot.",
      "Operate the accelerator with the right foot and the brake with the left foot.",
      "Operate the accelerator and brake with the left foot.",
      "Use the handbrake to bring the vehicle to a halt."
    ],
    "correct_answer": 0,
    "explanation": "When driving a car with automatic transmission, drivers should use the right foot to operate both the accelerator and the brake, just as in vehicles with a manual gear box. In general it is important to avoid using the accelerator and the brake at the same time.",
    "image_name": ""
  },
  {
    "index": 20,
    "id": "BWOO96R",
    "section": "Control of Vehicle",
    "question": "What is the effect of an incorrectly adjusted driver's seat?",
    "options": [
      "It improves the driver's ability to operate the clutch.",
      "It gives the driver a better view in the rear-view mirror.",
      "It can delay the driver from operating a control.",
      "It enables the driver to relax more on a long journey."
    ],
    "correct_answer": 2,
    "explanation": "Before starting a journey, you should adopt a suitable and comfortable driving position by adjusting the driver's seat to a position where all the vehicle controls can be operated efficiently.",
    "image_name": ""
  },
  {
    "index": 21,
    "id": "RSA225167",
    "section": "Control of Vehicle",
    "question": "When should a driver have both hands on the steering wheel?",
    "options": [
      "At all times except when on long straight roads.",
      "Only when making a manoeuvre.",
      "At all times except when using another vehicle control."
    ],
    "correct_answer": 2,
    "explanation": "To maintain proper control of a vehicle drivers should have both hands on the steering wheel at all times except when using another vehicle control such as changing gear, using indicators, wipers or handbrake.",
    "image_name": ""
  },
  {
    "index": 22,
    "id": "RSA225289",
    "section": "Control of Vehicle",
    "question": "When using the accelerator, how can a driver help reduce the vehicle's fuel consumption?",
    "options": [
      "A driver should accelerate smoothly to reach and maintain the appropriate speed.",
      "A driver should accelerate quickly to reach the appropriate speed and then ease off to maintain pace.",
      "A driver should accelerate smoothly only when the vehicle is laden."
    ],
    "correct_answer": 0,
    "explanation": "Try to use the accelerator smoothly and progressively. Driving smoothly can reduce fuel consumption as well as reducing wear and tear on your vehicle. REMEMBER - The driver has the single biggest impact on both fuel consumption and safety.",
    "image_name": ""
  },
  {
    "index": 23,
    "id": "BW0038RU23",
    "section": "Control of Vehicle",
    "question": "When must the holder of a learner permit display L plates on their car?",
    "options": [
      "When driving on their first learner permit.",
      "When driving unaccompanied by a full licence holder.",
      "At all times when driving."
    ],
    "correct_answer": 2,
    "explanation": "The holder of a learner permit must display L plates on the front and rear of their car at all times when driving on public roads.",
    "image_name": ""
  },
  {
    "index": 24,
    "id": "ABMW0141RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to move out.",
      "The cyclist is signalling following traffic to overtake.",
      "The cyclist intends to slow down or stop.",
      "The cyclist intends to turn left."
    ],
    "correct_answer": 2,
    "explanation": "This hand signal informs other road users that cyclist intends to slow down or stop. This may indicate that the cyclist is aware of some hazard ahead, so drive with extra care.",
    "image_name": "ABMW0141RU19.png"
  },
  {
    "index": 25,
    "id": "ABMW0142R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to stop.",
      "The cyclist intends to turn left.",
      "The cyclist intends to go straight on.",
      "The cyclist is giving way to other traffic."
    ],
    "correct_answer": 2,
    "explanation": "This hand signal informs other road users that the cyclist intends to proceed straight ahead at a junction and drivers should show caution.",
    "image_name": "ABMW0142R.png"
  },
  {
    "index": 26,
    "id": "ABMW0143RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to turn left.",
      "The cyclist intends to stop.",
      "The cyclist intends to turn right."
    ],
    "correct_answer": 0,
    "explanation": "This hand signal informs other road users that the cyclist intends to make a left- hand turn.",
    "image_name": "ABMW0143R.png"
  },
  {
    "index": 27,
    "id": "ABMW0144RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to stop.",
      "The cyclist intends to turn left.",
      "The cyclist intends to turn right."
    ],
    "correct_answer": 2,
    "explanation": "This hand signal tells other road users that the cyclist intends to either move out or make a right-hand turn. Drivers should be aware that cyclists could cross the path of their vehicle.",
    "image_name": "ABMW0144RU19.png"
  },
  {
    "index": 28,
    "id": "ABMW0145RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The cyclist intends to cross the road.",
      "The cyclist intends to stop.",
      "The cyclist intends to turn left."
    ],
    "correct_answer": 2,
    "explanation": "This hand signal informs other road users that the cyclist intends to turn left.",
    "image_name": "ABMW0145R.png"
  },
  {
    "index": 29,
    "id": "ABMW0146R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to slow down or stop.",
      "The driver intends to turn left.",
      "The driver intends to go straight ahead.",
      "The driver intends to turn right."
    ],
    "correct_answer": 1,
    "explanation": "This hand signal informs other road users that the driver intends to turn left and the vehicle will change direction.",
    "image_name": "ABMW0146R.png"
  },
  {
    "index": 30,
    "id": "ABMW0147R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to do a U-turn.",
      "The driver intends to turn left.",
      "The driver intends to stop ahead.",
      "The driver intends to move out or turn right."
    ],
    "correct_answer": 3,
    "explanation": "This hand signal informs other road users that the driver intends to move out or turn right and the vehicle will change direction.",
    "image_name": "ABMW0147R.png"
  },
  {
    "index": 31,
    "id": "ABMW0148R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to turn left.",
      "The driver intends to turn right.",
      "The driver intends to slow down or stop.",
      "The driver intends to begin a U-turn."
    ],
    "correct_answer": 2,
    "explanation": "This hand signal informs other road users that the driver intends to slow down or stop and following traffic should be prepared to slow down also.",
    "image_name": "ABMW0148R.png"
  },
  {
    "index": 32,
    "id": "ABMW0149R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to stop.",
      "The driver intends to slow down.",
      "The driver intends to turn right.",
      "The driver intends to turn left."
    ],
    "correct_answer": 3,
    "explanation": "This hand signal informs other road users or a Garda directing traffic (facing this vehicle), that the driver intends to make a left-hand turn.",
    "image_name": "ABMW0149R.png"
  },
  {
    "index": 33,
    "id": "ABMW0150R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to slow down.",
      "The driver will begin to reverse.",
      "The driver intends to turn left.",
      "The driver intends to turn right."
    ],
    "correct_answer": 3,
    "explanation": "This hand signal informs other road users or a Garda directing traffic (facing this vehicle) that the driver intends to turn right.",
    "image_name": "ABMW0150R.png"
  },
  {
    "index": 34,
    "id": "ABMW0151RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this hand signal mean?",
    "options": [
      "The driver intends to slow down or stop.",
      "The driver intends to reverse.",
      "The driver intends to turn left.",
      "The driver intends to proceed straight ahead."
    ],
    "correct_answer": 3,
    "explanation": "This hand signal informs other road users or a Garda directing traffic that the driver intends to proceed straight ahead.",
    "image_name": "ABMW0151RU19.png"
  },
  {
    "index": 35,
    "id": "ABMW0152RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this Garda signal mean?",
    "options": [
      "Stop if approaching from the front.",
      "Proceed if approaching from the front.",
      "Stop if approaching from behind."
    ],
    "correct_answer": 0,
    "explanation": "When approaching a Garda giving this signal you must stop.",
    "image_name": "ABMW0152R.png"
  },
  {
    "index": 36,
    "id": "ABMW0153R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this Garda signal mean?",
    "options": [
      "Turn right.",
      "Turn left.",
      "Stop if approaching from behind.",
      "Stop if approaching from front."
    ],
    "correct_answer": 2,
    "explanation": "When approaching a Garda giving this signal you must stop.",
    "image_name": "ABMW0153R.png"
  },
  {
    "index": 37,
    "id": "ABMW0154R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this Garda signal mean?",
    "options": [
      "Turn right.",
      "Turn left.",
      "Proceed if approaching from the front.",
      "Stop if approaching from either the front or behind."
    ],
    "correct_answer": 3,
    "explanation": "When approaching a Garda giving this signal you must stop.",
    "image_name": "ABMW0154R.png"
  },
  {
    "index": 38,
    "id": "ABMW0155R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this Garda signal mean?",
    "options": [
      "The Garda is beckoning on traffic approaching from either side.",
      "The Garda is beckoning on traffic from the front.",
      "The driver must not proceed to the left.",
      "The driver must not proceed to the right."
    ],
    "correct_answer": 0,
    "explanation": "When approaching a Garda giving this signal you may proceed.",
    "image_name": "ABMW0155R.png"
  },
  {
    "index": 39,
    "id": "ABMW0156R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this Garda signal mean?",
    "options": [
      "Traffic approaching from the front may proceed.",
      "Traffic approaching from behind must stop.",
      "Traffic approaching from the front must stop.",
      "Traffic approaching from the right may proceed."
    ],
    "correct_answer": 0,
    "explanation": "When approaching a Garda giving this signal you may proceed.",
    "image_name": "ABMW0156R.png"
  },
  {
    "index": 40,
    "id": "ABMW0211RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When may a trailer be towed on a public road without a rear number plate?",
    "options": [
      "When being towed by an agricultural tractor.",
      "When the tailboard is removed.",
      "When carrying a load that overhangs the trailer.",
      "Never, a number plate must always be displayed."
    ],
    "correct_answer": 3,
    "explanation": "The law requires all motorised vehicles to display a rear number plate that is clean and legible.",
    "image_name": ""
  },
  {
    "index": 41,
    "id": "ABMW0567RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What restriction applies to a driver's full licence if they have passed their test on a vehicle with automatic transmission?",
    "options": [
      "They may not drive vehicles with manual transmission.",
      "They may not drive on motorways.",
      "They may not drive at speeds of more that 80 km/h.",
      "They must continue to display L plates."
    ],
    "correct_answer": 0,
    "explanation": "If you pass your driving test in a vehicle fitted with automatic transmission, a code 78 will be noted on the full licence in the restrictions/information column.",
    "image_name": ""
  },
  {
    "index": 42,
    "id": "ABMW0568RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What roads are learner permit holders allowed to drive on?",
    "options": [
      "All roads except motorways and dual-carriageways.",
      "All roads except motorways.",
      "All roads except national roads.",
      "All roads except dual-carriageways."
    ],
    "correct_answer": 1,
    "explanation": "A learner permit holder must not drive on a motorway. It is a serious offence to do so.",
    "image_name": ""
  },
  {
    "index": 43,
    "id": "ABMW0570RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Which roads are learner permit holders not allowed to drive on?",
    "options": [
      "They may not drive on national roads.",
      "They may not drive on rural roads.",
      "They may not drive on dual carriageways.",
      "They may not drive on motorways."
    ],
    "correct_answer": 3,
    "explanation": "A learner permit holder must not drive on a motorway. It is a serious offence to do so.",
    "image_name": ""
  },
  {
    "index": 44,
    "id": "ABMW0601RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "If a driver passes their test using a vehicle with automatic transmission, which vehicles are they licensed to drive?",
    "options": [
      "All vehicles in the licence category but only automatic vehicles on a motorway.",
      "Only automatic vehicles in the licence category.",
      "All vehicles in the licence category.",
      "Only manual vehicles in the licence category."
    ],
    "correct_answer": 1,
    "explanation": "If you pass your driving test in an automatic or adapted vehicle, your full licence will apply to that type of vehicle only. A licence restricted to automatic vehicles will have a code 78 indicated in the restrictions/information column of the licence.",
    "image_name": ""
  },
  {
    "index": 45,
    "id": "ABMW0569R",
    "section": "Legal Matters/Rules of the Road",
    "question": "How should an L plate be composed?",
    "options": [
      "A white L on a red background.",
      "A green L on a white background.",
      "A red L on a white background.",
      "A red L on a transparent background."
    ],
    "correct_answer": 2,
    "explanation": "L plates should be displayed front and rear. The plates should be a red L on a white background and should be not less than 15 cm high with a border of at least 2 cm. A learner motorcyclist must wear a yellow tabard displaying L plates front and rear. The L plates must be not less than 15 cm high on a white background.",
    "image_name": ""
  },
  {
    "index": 46,
    "id": "ABMW0586RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Is it permitted to use a vehicle in a public place without a current tax disc displayed?",
    "options": [
      "Yes, but for not more than 10 days after the expiry of the previous disc.",
      "No, only vintage vehicles are exempt from displaying a tax disc.",
      "Yes, but for not more than one month after the expiry of the previous disc.",
      "No, all motor vehicles must display a current tax disc."
    ],
    "correct_answer": 3,
    "explanation": "A motor vehicle must be taxed and must display the up-to-date tax disk before it may be taken on the road.",
    "image_name": ""
  },
  {
    "index": 47,
    "id": "ABMW0588RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "If a driver wishes to drive a vehicle but the tax disc is expired, what should they do?",
    "options": [
      "They should drive it only in case of an emergency.",
      "They should contact the Gardaí for approval.",
      "They should renew it within 10 days of expiry.",
      "They should tax it immediately."
    ],
    "correct_answer": 3,
    "explanation": "A motor vehicle must be taxed and must display the up-to-date tax disc before it may be taken on the road.",
    "image_name": ""
  },
  {
    "index": 48,
    "id": "ABMW0589RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "If a driver wishes to drive another vehicle which is not currently taxed, would they be allowed to transfer the current tax disc from their own vehicle onto it?",
    "options": [
      "Under no circumstances should a tax disc be transferred to another vehicle.",
      "Only on a temporary basis if the other vehicle is subject to a lower rate of tax.",
      "Under circumstances when the proper form has been completed and sent to the local Motor Tax Office.",
      "Yes, provided their own vehicle is not being used at the same time."
    ],
    "correct_answer": 0,
    "explanation": "A motor vehicle must be taxed and must display its own current tax disc before it may be taken on the road. The tax disc includes information about the vehicle, including its make and model, colour and registration number.",
    "image_name": ""
  },
  {
    "index": 49,
    "id": "ABMW0590RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When a vehicle is being driven by a person who is not the owner, who is responsible for ensuring that the vehicle is taxed and that a current tax disc is displayed?",
    "options": [
      "The driver is the only one responsible.",
      "The driver and/or the owner of the vehicle are responsible.",
      "The owner is the only one responsible.",
      "The Gardaí have total responsibility in this area."
    ],
    "correct_answer": 1,
    "explanation": "If you are the owner or the driver of a vehicle, you must ensure that it is taxed and that it displays an up-to-date tax disc before you take it on the road.",
    "image_name": ""
  },
  {
    "index": 50,
    "id": "ABMW0591RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When must a current tax disc be displayed on a new vehicle on a public road?",
    "options": [
      "Only when driving on motorways.",
      "Not later than 10 days after registration.",
      "Not later than 1 month after registration.",
      "At all times when the vehicle is on a public road."
    ],
    "correct_answer": 3,
    "explanation": "A motor vehicle must be taxed before it may be taken on the road, and it must always display an up-to-date tax disc.",
    "image_name": ""
  },
  {
    "index": 51,
    "id": "ABMW0592RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Who is authorized to see a driver's vehicle registration document?",
    "options": [
      "Any Fire Brigade or Ambulance personnel at the scene of a collision the driver has been involved in.",
      "Any person with whom the driver is involved in a collision.",
      "A Garda may ask you to produce the vehicle's registration document at a named Garda station.",
      "A member of the car recovery company or anyone assisting in the recovery."
    ],
    "correct_answer": 2,
    "explanation": "A Garda may demand to see your driving licence at any time, and you should always carry this with you when driving. A Garda may also examine your insurance disc, tax disc and NCT disc (if applicable). A Garda may ask you to produce other documents (including the vehicle's registration document) at a named Garda station within  10 days.",
    "image_name": ""
  },
  {
    "index": 52,
    "id": "ABMW0593RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "If a vehicle is being driven by someone who is not the owner but has the owner's consent, who should ensure that the driver is properly insured?",
    "options": [
      "The vehicle owner only.",
      "The driver and the vehicle owner.",
      "The driver only.",
      "The insurance company."
    ],
    "correct_answer": 1,
    "explanation": "All drivers must have insurance covering them to drive a vehicle on a public road. It is a serious offence to drive a vehicle that is not insured. It is also an offence to allow a vehicle that you own to be driven by an uninsured driver.",
    "image_name": ""
  },
  {
    "index": 53,
    "id": "ABMW0594RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Is a driver still insured to drive their vehicle after their insurance policy has expired?",
    "options": [
      "The driver is insured up to 10 days after the expiry of the policy.",
      "The driver is insured up to 7 days after the expiry of the policy.",
      "The driver is insured up to 14 days after the expiry of the policy.",
      "The driver is not insured after the expiry of the policy."
    ],
    "correct_answer": 3,
    "explanation": "All drivers must have insurance covering them to drive a vehicle on a public road. The vehicle must display an up-to-date insurance disc.",
    "image_name": ""
  },
  {
    "index": 54,
    "id": "ABMW0595RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "If a driver wishes to drive another privately-owned vehicle but they are uncertain if they are insured to drive that vehicle, what should they do?",
    "options": [
      "Transfer the insurance disc from their own vehicle on to the vehicle they wish to drive.",
      "Drive if there is an insurance disc on the vehicle.",
      "A driver should contact their own insurer to confirm whether or not their insurance policy covers the driving of other vehicles.",
      "Drive it provided that they tell their insurance company within 10 days and agree to pay any additional premium."
    ],
    "correct_answer": 2,
    "explanation": "If you are in any doubt about your insurance cover, you should discuss the matter with your insurance company. It is a serious offence to drive without insurance.",
    "image_name": ""
  },
  {
    "index": 55,
    "id": "ABMW0596RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When a driver wishes to drive a vehicle and they are not sure if they are covered by insurance, what should they do?",
    "options": [
      "They should not drive until their insurance company confirms that they are insured.",
      "They should check with their local Garda station to see if they are insured.",
      "They should check with their local NDLS office to see if they are insured.",
      "They should check with their local Motor Taxation Office to see if they are insured."
    ],
    "correct_answer": 0,
    "explanation": "If you are in any doubt about your insurance cover, you should discuss the matter with your insurance company. It is a serious offence to drive without insurance.",
    "image_name": ""
  },
  {
    "index": 56,
    "id": "ABMW0597U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the minimum insurance cover a driver needs to drive on a public road?",
    "options": [
      "Third party.",
      "Third party, fire and theft.",
      "Personal accident.",
      "Comprehensive."
    ],
    "correct_answer": 0,
    "explanation": "As a motorist, you must have a minimum of third party insurance.",
    "image_name": ""
  },
  {
    "index": 57,
    "id": "ABMW0781RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Where can drivers locate the Maximum Authorised Mass (MAM) of their vehicle?",
    "options": [
      "On the NCT disc.",
      "On the insurance disc.",
      "On a metal plate on the vehicle.",
      "On the tax disc."
    ],
    "correct_answer": 2,
    "explanation": "The plate displaying the Maximum Authorised Mass (MAM) of a vehicle is normally located under the bonnet or in the passenger compartment. If you are not sure where it is located on your vehicle, check the driver's handbook supplied with the vehicle.",
    "image_name": ""
  },
  {
    "index": 58,
    "id": "ABMW0189RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Where is a driver allowed to park?",
    "options": [
      "Where the driver is not blocking other road users their view of traffic signals or the road ahead.",
      "At road works.",
      "Where there is a continuous white line along the centre of the road.",
      "On a footpath."
    ],
    "correct_answer": 0,
    "explanation": "It is an offence to park at the side of a road that has a single or double continuous white line along its centre. Parking on such a road could create an obstruction and may cause inconvenience or danger to other road users.",
    "image_name": ""
  },
  {
    "index": 59,
    "id": "ABMW0190RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What distance before a zebra crossing is parking prohibited?",
    "options": [
      "15 metres.",
      "5 metres.",
      "20 metres.",
      "10 metres."
    ],
    "correct_answer": 0,
    "explanation": "It is an offence to park 15 metres before or 5 metres after a pedestrian crossing. Parking in this manner may restrict the zone of vision of drivers approaching the crossing and endanger pedestrians.",
    "image_name": ""
  },
  {
    "index": 60,
    "id": "ABMW0191RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Within what distance of a road junction is parking prohibited?",
    "options": [
      "20 metres, unless parking spaces are clearly marked.",
      "10 metres, unless parking spaces are clearly marked.",
      "5 metres, unless parking spaces are clearly marked.",
      "15 metres, unless parking spaces are clearly marked."
    ],
    "correct_answer": 2,
    "explanation": "It is an offence to park within 5 metres of a road junction unless parking spaces are clearly marked. Parking in that area may restrict the zone of vision of drivers approaching the junction and may cause an obstruction to large vehicles wishing to  turn.",
    "image_name": ""
  },
  {
    "index": 61,
    "id": "ABMW0193RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Is a driver permitted to park at an entrance to a property?",
    "options": [
      "Yes, for 1 hour between 23:30 hrs to 07:00 hrs.",
      "Yes, with the property owner's consent.",
      "Yes, for 1 hour between 07:00 hrs to 23:30 hrs.",
      "Yes, outside business hours."
    ],
    "correct_answer": 1,
    "explanation": "You may park across the entrance to a property only with the owner's consent. Parking across an entrance may cause inconvenience and danger to persons entering or leaving the property.",
    "image_name": ""
  },
  {
    "index": 62,
    "id": "ABMW0194RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When is parking permitted on a footpath?",
    "options": [
      "When at least half of the footpath remains free for pedestrians.",
      "When cars are parked on both sides of the road.",
      "When no more than half of the vehicle is on the footpath.",
      "It is never permitted to park on a footpath."
    ],
    "correct_answer": 3,
    "explanation": "It is an offence to park on a footpath. Where a vehicle is parked on a footpath, pedestrians may have to step onto the road to go around the vehicle and so place themselves in danger.",
    "image_name": ""
  },
  {
    "index": 63,
    "id": "ABMW0195RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When is double parking permitted?",
    "options": [
      "When there are double white lines.",
      "When there are double yellow lines.",
      "When there is a hard shoulder.",
      "It is never permitted."
    ],
    "correct_answer": 3,
    "explanation": "Double parking is never permitted. Parking is never permitted where it might interfere in any way with the normal flow of traffic or obstruct or endanger other road users.",
    "image_name": ""
  },
  {
    "index": 64,
    "id": "ABMW0196RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When is parking permitted at a taxi rank?",
    "options": [
      "When waiting to collect passengers from a taxi.",
      "When parking for less than 15 minutes.",
      "When the rank is unoccupied.",
      "Parking at a taxi rank is prohibited unless driving a taxi."
    ],
    "correct_answer": 3,
    "explanation": "Stopping or parking within an area marked as a taxi rank is prohibited as this may obstruct taxis entering or leaving the rank.",
    "image_name": ""
  },
  {
    "index": 65,
    "id": "ABMW0197RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When is parking permitted at a sharp bend?",
    "options": [
      "Parking is never permitted at a sharp bend.",
      "When parking no more than 45 centimetres from the kerb or edge of the road.",
      "When drivers coming from behind can see the parked vehicle.",
      "When the hazard warning lights of the parked vehicle are on."
    ],
    "correct_answer": 0,
    "explanation": "Parking is never permitted where it might interfere in any way with the normal flow of traffic or obstruct or endanger other road users - for example, by forcing other drivers into the path of oncoming traffic.",
    "image_name": ""
  },
  {
    "index": 66,
    "id": "ABMW0198RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When is parking permitted on the brow of a hill?",
    "options": [
      "When the driver angles the wheels towards the kerb.",
      "Only when there is no traffic on the road.",
      "Parking is permitted when a vehicle has an efficient handbrake.",
      "Parking is never permitted on the brow of a hill."
    ],
    "correct_answer": 3,
    "explanation": "Parking on the brow of a hill or on a humpbacked bridge is prohibited. Parking in such a place may restrict the zone of vision of drivers approaching the hill and force them into the path of oncoming traffic.",
    "image_name": ""
  },
  {
    "index": 67,
    "id": "ABMW0251",
    "section": "Legal Matters/Rules of the Road",
    "question": "Which car, if any, is parked incorrectly?",
    "options": [
      "The red car.",
      "Neither car.",
      "Both cars.",
      "The green car."
    ],
    "correct_answer": 2,
    "explanation": "It is an offence to park within 15 metres before or 5 metres after a pedestrian crossing. Parking in this manner may restrict the zone of vision of drivers approaching the crossing and endanger pedestrians.",
    "image_name": "ABMW0251.png"
  },
  {
    "index": 68,
    "id": "ABMW0001U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "The driver must stop for school crossing ahead.",
      "The driver must give way to traffic coming from the right.",
      "The driver must stop their vehicle."
    ],
    "correct_answer": 2,
    "explanation": "This sign appears at junctions where a minor road joins a major road. You must stop your vehicle completely at a STOP sign.",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 69,
    "id": "ABMW0002R23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What must a driver do when this sign is accompanied by a white stop line on the road?",
    "options": [
      "Stop past the line.",
      "Stop at the line.",
      "Stop at the line only if you see traffic approaching."
    ],
    "correct_answer": 1,
    "explanation": "When accompanied by a STOP sign, the white stop line indicates the point at which you must stop your vehicle.",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 70,
    "id": "ABMW0003R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What must a driver do when this sign is NOT accompanied by a white stop line on the road?",
    "options": [
      "Stop past the sign.",
      "Stop no more than one car length past the sign.",
      "Stop at the sign.",
      "Stop only if there is traffic on the major road."
    ],
    "correct_answer": 2,
    "explanation": "Where a STOP sign is not accompanied by a white stop line, you must stop at the sign.",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 71,
    "id": "ABMW0004R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean at a junction?",
    "options": [
      "Yield to traffic coming from your right only.",
      "Yield to all heavy goods vehicles.",
      "Slow down and yield to pedestrians.",
      "Yield to traffic on the major road."
    ],
    "correct_answer": 3,
    "explanation": "At a junction, the YIELD sign tells you that you must give way to traffic on a major road ahead. This means that you must slow down and be prepared to stop.",
    "image_name": "ABMW0004R.png"
  },
  {
    "index": 72,
    "id": "ABMW0005RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean at a roundabout?",
    "options": [
      "Yield to traffic coming from the right, or already on the roundabout.",
      "Yield to buses and trucks only.",
      "Yield to traffic coming from the left.",
      "Yield to cyclists and motorcyclists only."
    ],
    "correct_answer": 0,
    "explanation": "At a roundabout, the YIELD sign tells you that you must slow down and be prepared to stop. You must yield (give way) to traffic already on the roundabout or coming from the right.",
    "image_name": "ABMW0004R.png"
  },
  {
    "index": 73,
    "id": "ABMW0006R23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Straight ahead only.",
      "Height restriction ahead.",
      "Motorway ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign tells you that you must proceed straight ahead. This sign is usually displayed on the entry to a one-way street.",
    "image_name": "ABMW0006R.png"
  },
  {
    "index": 74,
    "id": "ABMW0007",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic from the right has priority.",
      "Motorway to the left.",
      "Turn left only.",
      "Diversion ahead to the left."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must turn left. It is usually displayed at a junction where all traffic must turn left - for example, in a one-way system that incorporates a junction.",
    "image_name": "ABMW0007.png"
  },
  {
    "index": 75,
    "id": "ABMW0008U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Diversion ahead to the right.",
      "Major road joining from the left.",
      "Turn right only.",
      "Overtake only on the right."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must turn right. It is usually displayed at a junction where all traffic must turn right - for example, in a one-way system that incorporates a junction.",
    "image_name": "ABMW0008U19.png"
  },
  {
    "index": 76,
    "id": "ABMW0009R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "One-way traffic to the left ahead.",
      "Turn left ahead.",
      "Sharp corner to the left ahead.",
      "Diversion to the left ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that you must turn left ahead. It is usually displayed on the approach to a one-way system.",
    "image_name": "ABMW0009R.png"
  },
  {
    "index": 77,
    "id": "ABMW0010U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "One-way traffic to the right ahead.",
      "You must turn right ahead.",
      "Diversion to the right ahead.",
      "Sharp bend to the right ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that you must turn right ahead. It is usually displayed on the approach to a one-way system.",
    "image_name": "ABMW0010U19.png"
  },
  {
    "index": 78,
    "id": "ABMW0011RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Pass on the left.",
      "Steep decline to the left.",
      "Keep left."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must keep left. It is usually displayed at a traffic island in the centre of the road and also used on occasion to control traffic at roadworks.",
    "image_name": "ABMW0011RU19.png"
  },
  {
    "index": 79,
    "id": "ABMW0012RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic crossing from the left.",
      "Keep right.",
      "Steep decline from the left."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that you must keep right. It is usually found in a one-way system where the traffic is required to keep to the right and also used on occasion to control traffic at roadworks.",
    "image_name": "ABMW0012RU19.png"
  },
  {
    "index": 80,
    "id": "ABMW0013U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Pass either side.",
      "Two-way traffic ahead.",
      "Dual carriageway ahead.",
      "One-way street."
    ],
    "correct_answer": 0,
    "explanation": "This sign tells you that traffic may pass on either side of the traffic island.",
    "image_name": "ABMW0013U19.png"
  },
  {
    "index": 81,
    "id": "ABMW0014RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Cul-de-sac ahead.",
      "No height restriction ahead.",
      "No entry ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must not proceed in the direction of the arrow. This is displayed to prevent traffic going in the wrong direction - for example, the wrong way up a one-way street.",
    "image_name": "ABMW0014RU19.png"
  },
  {
    "index": 82,
    "id": "ABMW0015RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "No right turn.",
      "Turn right only.",
      "Cul-de-sac to the right."
    ],
    "correct_answer": 0,
    "explanation": "This sign is displayed at a junction where you must not turn right.",
    "image_name": "ABMW0015R.png"
  },
  {
    "index": 83,
    "id": "ABMW0016RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Turn right ahead.",
      "Dangerous bend to the right ahead.",
      "No right turn."
    ],
    "correct_answer": 2,
    "explanation": "This sign is displayed at a junction where you may not turn right.",
    "image_name": "ABMW0015R.png"
  },
  {
    "index": 84,
    "id": "ABMW0017RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Turn right only.",
      "No left turn.",
      "No right turn."
    ],
    "correct_answer": 1,
    "explanation": "This sign is displayed at a junction where you may not turn left.",
    "image_name": "ABMW0017RU19.png"
  },
  {
    "index": 85,
    "id": "ABMW0018RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Two-way traffic prohibited.",
      "Entry to tunnel prohibited.",
      "U-turn not permitted.",
      "Reversing not permitted."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you are not permitted to make a U-turn. It is commonly displayed on approach to junctions on dual carriageways. Drivers should also be aware that U-turns are also not permitted anywhere there is a continuous white line along the centre of the road or on a one-way street.",
    "image_name": "ABMW0018RU19.png"
  },
  {
    "index": 86,
    "id": "ABMW0019U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Maximum speed is 30 km/h.",
      "Minimum speed is 30 km/h.",
      "Speed limit continues for 30 kilometres."
    ],
    "correct_answer": 0,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 30 km/h. These signs are commonly found in slow zones in residential areas.",
    "image_name": "ABMW0019U19.png"
  },
  {
    "index": 87,
    "id": "ABMW0020U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Speed limit continues for 50 kilometres.",
      "Maximum speed is 50 km/h.",
      "Minimum speed is 50 km/h."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 50 km/h.",
    "image_name": "ABMW0020U19.png"
  },
  {
    "index": 88,
    "id": "ABMW0021U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Minimum speed is 60 km/h.",
      "Maximum speed is 60 km/h.",
      "Speed limit continues for 60 metres."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 60 km/h.",
    "image_name": "ABMW0021U19.png"
  },
  {
    "index": 89,
    "id": "ABMW0022RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Speed limit continues for 80 metres.",
      "Maximum speed is 80 km/h.",
      "Minimum speed is 80 km/h."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 80 km/h.",
    "image_name": "ABMW0022RU19.png"
  },
  {
    "index": 90,
    "id": "ABMW0023U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Maximum speed is 100 km/h.",
      "Minimum speed is 100 km/h.",
      "Speed limit continues for 100 metres."
    ],
    "correct_answer": 0,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 100 km/h.",
    "image_name": "ABMW0023U19.png"
  },
  {
    "index": 91,
    "id": "ABMW0024U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic merging at 120 metres ahead.",
      "Maximum speed is 120 km/h.",
      "Minimum speed is 120 km/h."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that the maximum legal speed limit permitted for this section of road is 120 km/h.",
    "image_name": "ABMW0024U19.png"
  },
  {
    "index": 92,
    "id": "ABMW0025U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Parking permitted during the times shown.",
      "Parking prohibited at the times shown.",
      "Maximum parking for one hour during times shown."
    ],
    "correct_answer": 0,
    "explanation": "These signs tells you that parking is permitted in both directions, but only at the times shown on the information plate.",
    "image_name": "ABMW0025U19.png"
  },
  {
    "index": 93,
    "id": "ABMW0026U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Public service vehicles parking only.",
      "Private vehicles parking only.",
      "Parking is not allowed."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that parking is prohibited in both directions.",
    "image_name": "ABMW0026.png"
  },
  {
    "index": 94,
    "id": "ABMW0027U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Clearway - no stopping or parking during the times shown.",
      "Road closed during the times shown.",
      "Pedestrianised street - no access for vehicles."
    ],
    "correct_answer": 0,
    "explanation": "A clearway sign means that stopping or parking is not permitted in this area during the times shown on the information plate.",
    "image_name": "ABMW0027U19.png"
  },
  {
    "index": 95,
    "id": "ABMW0028U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Parking without a disc is allowed during the hours shown.",
      "Disc parking operates during the time shown.",
      "Disc parking operates except during the hours shown.",
      "Parking is prohibited during the hours shown."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that vehicles must display a parking disc when parked during the hours shown on the information plate.",
    "image_name": "ABMW0028U19.png"
  },
  {
    "index": 96,
    "id": "ABMW0029RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Private vehicles may pick up or set down passengers.",
      "Private parking is permitted when the taxi rank is empty.",
      "Designated rank for taxis.",
      "Only taxis may turn right or left."
    ],
    "correct_answer": 2,
    "explanation": "A taxi rank sign indicates that this is an area reserved for taxis, and parking or stopping by other road users is not permitted.",
    "image_name": "ABMW0029RU19.png"
  },
  {
    "index": 97,
    "id": "ABMW0030U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Track reserved for motorcyclist.",
      "Cyclists must dismount ahead.",
      "Bicycle race track.",
      "Start of cycle track."
    ],
    "correct_answer": 3,
    "explanation": "This sign indicates the start of a cycle track. If the track is bounded by a broken white line, other road users should avoid using it wherever possible. If it is bounded by a continuous white line, drivers of cars and other vehicles must not drive on it.",
    "image_name": "ABMW0030U19.png"
  },
  {
    "index": 98,
    "id": "ABMW0033RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do these signs together mean?",
    "options": [
      "Access for buses and taxis only during times shown.",
      "Parking not allowed during times shown.",
      "Clearway ahead - no stopping or parking during times shown.",
      "Pedestrianised street ahead - traffic not allowed except during times shown."
    ],
    "correct_answer": 3,
    "explanation": "When posted together these signs tells you that there is a pedestrianised street ahead and that traffic is not allowed to enter except during the times stated on the information plate.",
    "image_name": "ABMW0033RU19.png"
  },
  {
    "index": 99,
    "id": "ABMW0034U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "3-axled vehicles are not permitted.",
      "Minimum permitted weight is 3 tonnes.",
      "Maximum permitted weight is 3 tonnes.",
      "Only 3-axled vehicles are permitted."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must not enter this area if your vehicle is over 3 tonnes or 3,000 kg.",
    "image_name": "ABMW0034U19.png"
  },
  {
    "index": 100,
    "id": "ABMW0039U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Double parking not allowed.",
      "No stopping/parking on the right.",
      "End of dual carriageway.",
      "No overtaking."
    ],
    "correct_answer": 3,
    "explanation": "This sign tells you that overtaking is prohibited. These signs are usually found in places where overtaking may be dangerous, such as in areas with reduced visibility.",
    "image_name": "ABMW0039U19.png"
  },
  {
    "index": 101,
    "id": "ABMW0040RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Only buses and cyclists may park during the times indicated.",
      "Only cyclists and buses are allowed to use the lane during the times indicated.",
      "Only buses, cyclists and taxis are allowed to use the lane ahead during the hours indicated.",
      "Only buses, cyclists and taxis are allowed to use the lane outside the hours indicated."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you there is a with-flow nearside bus lane ahead on the left - that is, one where the buses move in the same direction as the traffic to their right. The information plate tells the times when the bus lane is in operation. Only buses, taxis and cyclists may use the bus lane during those hours.",
    "image_name": "ABMW0040RU19.png"
  },
  {
    "index": 102,
    "id": "ABMW0041RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Only double-decker buses and cyclists may use lane.",
      "Only buses and cyclists may park.",
      "With-flow bus and cycle lane ahead on left.",
      "Cyclists and buses must turn left."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you there is a with-flow nearside bus lane ahead to the left. Only buses, taxis and cyclists may use the bus lane during the stated operational hours.",
    "image_name": "ABMW0041RU19.png"
  },
  {
    "index": 103,
    "id": "ABMW0042RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Parking for buses and bicycles on left.",
      "With-flow bus and cycle lane on left.",
      "Cycle track ahead may be crossed by buses only."
    ],
    "correct_answer": 1,
    "explanation": "This sign indicates a nearside with-flow bus lane on the left. Only buses, taxis and cyclists may use the bus lane during the stated operational hours.",
    "image_name": "ABMW0042RU19.png"
  },
  {
    "index": 104,
    "id": "ABMW0043RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Buses must give way to other traffic ahead.",
      "Cyclists must give way to buses ahead.",
      "Buses must give way to cyclists ahead.",
      "Bus and cycle lane ahead on right."
    ],
    "correct_answer": 3,
    "explanation": "This sign tells you that there is an offside bus lane ahead on the right. Only buses, taxis and cyclists may use the bus lane during the stated operational hours.",
    "image_name": "ABMW0043RU19.png"
  },
  {
    "index": 105,
    "id": "ABMWO0044RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Contra-flow bus lane ahead.",
      "Buses may block the driver's view of cyclists.",
      "With-flow bus lane on the left.",
      "With-flow bus lane on the right."
    ],
    "correct_answer": 3,
    "explanation": "This sign indicates a with-flow offside bus lane on the right. Only buses, taxis and cyclists may use the bus lane during the stated operational hours.",
    "image_name": "ABMW0044RAU19.png"
  },
  {
    "index": 106,
    "id": "ABMW0045RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Cycle track may be crossed by buses.",
      "With-flow bus lane to right.",
      "Contra-flow bus lane on the right.",
      "Buses emerging from right."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you that you must drive on the left and not use the contra-flow bus lane day or night. A contraflow bus lane is one where the buses are going in the opposite direction.",
    "image_name": "ABMW0045RU19.png"
  },
  {
    "index": 107,
    "id": "ABMW0046U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Two-way traffic system.",
      "Contra-flow bus lane.",
      "Double-decker buses only.",
      "With-flow bus lane."
    ],
    "correct_answer": 1,
    "explanation": "This sign tells you that you must drive on the left and not use the contra-flow bus lane day or night. A contra-flow bus lane is one where the buses are going in the opposite direction.",
    "image_name": "ABMW0045RU19.png"
  },
  {
    "index": 108,
    "id": "ABMWOO50RAU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Tram lane on right.",
      "Parking only inside the white line.",
      "Tram lane on left.",
      "With-flow bus lane ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign tells you there is an offside tram lane on the right. Drivers should also be aware that there might be pedestrians in the area.",
    "image_name": "ABMW0050RAU19.png"
  },
  {
    "index": 109,
    "id": "ABMW0109RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Entry to motorway.",
      "End of motorway.",
      "Bridge ahead."
    ],
    "correct_answer": 0,
    "explanation": "This road sign informs road users that they are entering the motorway and must obey motorway rules. Before driving on the motorway users must familiarise themselves with motorway rules.",
    "image_name": "ABMW0109RU19.png"
  },
  {
    "index": 110,
    "id": "ABMW0110U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Low bridge 500 metres ahead.",
      "Bridge repair 500 metres ahead.",
      "No overtaking for 500 metres.",
      "Motorway ends 500 metres ahead."
    ],
    "correct_answer": 3,
    "explanation": "This is a motorway information sign that tells you that the motorway will end in 500 metres ahead. Motorway rules will no longer apply, for example a lower speed limit may be applicable.",
    "image_name": "ABMW0110U19.png"
  },
  {
    "index": 111,
    "id": "ABMW0111RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "End of motorway.",
      "No bridges ahead.",
      "End of overhead bridge area.",
      "No overtaking."
    ],
    "correct_answer": 0,
    "explanation": "This sign indicates the end of the motorway. You are leaving the motorway and its rules will no longer apply.",
    "image_name": "ABMW0111RU19.png"
  },
  {
    "index": 112,
    "id": "ABMW0112RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Three hundred meters to the next exit.",
      "Crossing traffic ahead.",
      "Three lanes ahead."
    ],
    "correct_answer": 0,
    "explanation": "This is a motorway information sign that tells you that the next exit off the motorway is 300 metres ahead.",
    "image_name": "ABMW0112R.png"
  },
  {
    "index": 113,
    "id": "ABMW0113R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Dual carriageway crossing ahead.",
      "No overtaking for 200 metres.",
      "Sharp descent in 200 metres.",
      "200 metres to the next exit."
    ],
    "correct_answer": 3,
    "explanation": "This is a motorway information sign that tells you that the next exit off the motorway is 200 metres ahead.",
    "image_name": "ABMW0113R.png"
  },
  {
    "index": 114,
    "id": "ABMW0114RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Low bridge ahead.",
      "Sharp descent for 100 metres.",
      "100 metres to the next exit."
    ],
    "correct_answer": 2,
    "explanation": "This is a motorway information sign that tells you that the next exit off the motorway is 100 metres ahead.",
    "image_name": "ABMW0114R.png"
  },
  {
    "index": 115,
    "id": "ABMW0132RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "At roadworks, what does this sign mean?",
    "options": [
      "Proceed with caution.",
      "Proceed only when beckoned to do so.",
      "Proceed using hand signals only."
    ],
    "correct_answer": 0,
    "explanation": "This traffic control sign tells you that you may proceed with caution through road works.",
    "image_name": "ABMW0132RU19.png"
  },
  {
    "index": 116,
    "id": "ABMW0133RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "At roadworks, what does this sign mean?",
    "options": [
      "Stop for school warden.",
      "Stop only if faced by oncoming traffic.",
      "Stop before or at the sign."
    ],
    "correct_answer": 2,
    "explanation": "This traffic control sign at roadworks means you must stop.",
    "image_name": "ABMW0133RU19.png"
  },
  {
    "index": 117,
    "id": "ABMW3U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean when displayed on the approach to a toll plaza?",
    "options": [
      "Toll collector operating lane.",
      "Garda checkpoint to the left.",
      "Service station ahead.",
      "This lane closed - keep left."
    ],
    "correct_answer": 0,
    "explanation": "This sign is used at toll plazas to direct traffic into a lane where the toll charge may be paid directly to a cashier. This lane would normally be used by motorists who have neither the exact change nor an electronic tag on their vehicle.",
    "image_name": "ABMW3U19.png"
  },
  {
    "index": 118,
    "id": "ABMW4U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean when displayed on the approach to a toll plaza?",
    "options": [
      "Coin basket in this lane.",
      "Ticket dispenser in this lane.",
      "Cashier in this lane.",
      "Electronic toll collection."
    ],
    "correct_answer": 0,
    "explanation": "This sign is used at toll plazas to direct traffic into a lane where the toll charge may be paid by putting the exact change into an automatic coin machine. This lane usually has a height barrier fitted to prevent large vehicles using it.",
    "image_name": "ABMW4U19.png"
  },
  {
    "index": 119,
    "id": "ABMW5U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean when displayed on the approach to a toll plaza?",
    "options": [
      "Electronic toll accepted in any lane.",
      "Electronic toll not accepted in this lane.",
      "Payment in euros only in this lane.",
      "Electronic toll out of order in this lane."
    ],
    "correct_answer": 0,
    "explanation": "This sign is used at toll plazas to direct traffic into a lane where the toll charge is collected electronically. When the vehicle passes through the plaza it is identified by means of an electronic tag fitted to the front windscreen. Payment will be collected via the users account. Only vehicles fitted with the tags are allowed to use those lanes.",
    "image_name": "ABMW5U19.png"
  },
  {
    "index": 120,
    "id": "ABMW0183U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the maximum speed allowed for cars and motorcycles on motorways?",
    "options": [
      "120 km/h.",
      "80 km/h.",
      "60 km/h.",
      "100 km/h."
    ],
    "correct_answer": 0,
    "explanation": "It is illegal to exceed 120 km/h when driving on a motorway.",
    "image_name": ""
  },
  {
    "index": 121,
    "id": "ABMW0184RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Unless otherwise indicated, what is the maximum speed allowed for cars or motorcycles on national roads?",
    "options": [
      "120 km/h.",
      "60 km/h.",
      "80 km/h.",
      "100 km/h."
    ],
    "correct_answer": 3,
    "explanation": "It is illegal to exceed 100 km/h when driving on a single carriageway national road.",
    "image_name": ""
  },
  {
    "index": 122,
    "id": "ABMW0185RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Unless otherwise indicated, what is the maximum speed allowed for a car towing a caravan on national roads?",
    "options": [
      "100 km/h.",
      "60 km/h.",
      "120 km/h.",
      "80 km/h."
    ],
    "correct_answer": 3,
    "explanation": "When towing a caravan on a national road, it is illegal to exceed 80 km/h - excessive speed will make such a vehicle unstable.",
    "image_name": ""
  },
  {
    "index": 123,
    "id": "ABMW0186U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Unless otherwise indicated, what is the maximum speed allowed for a car towing a caravan on a motorway?",
    "options": [
      "100 km/h.",
      "90 km/h.",
      "80 km/h.",
      "120 km/h."
    ],
    "correct_answer": 2,
    "explanation": "When towing a caravan on a motorway it is illegal to exceed 80 km/h - excessive speed will make such a vehicle unstable.",
    "image_name": ""
  },
  {
    "index": 124,
    "id": "ABMW0187U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Unless otherwise indicated, what is the maximum speed allowed for a car towing a trailer on national roads?",
    "options": [
      "100 km/h.",
      "60 km/h.",
      "120 km/h.",
      "80 km/h."
    ],
    "correct_answer": 3,
    "explanation": "When towing a trailer on a national road, it is illegal to exceed 80 km/h - exceeding this speed will make the vehicle unstable.",
    "image_name": ""
  },
  {
    "index": 125,
    "id": "ABMW0188U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "Unless otherwise indicated, what is the maximum speed allowed for a car towing a trailer on a motorway?",
    "options": [
      "100 km/h.",
      "60 km/h.",
      "120 km/h.",
      "80 km/h."
    ],
    "correct_answer": 3,
    "explanation": "When towing a trailer on a motorway it is illegal to exceed 80 km/h - excessive speed will make such a vehicle unstable.",
    "image_name": ""
  },
  {
    "index": 126,
    "id": "ABMW0221RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When do temporary speed limits apply at roadworks?",
    "options": [
      "During business hours only.",
      "Only when road workers are on site.",
      "Only when there is oncoming traffic.",
      "For the duration of the roadworks."
    ],
    "correct_answer": 3,
    "explanation": "Temporary speed limits at road works apply for the duration of the works. When road works are completed, normal speed limits apply.",
    "image_name": ""
  },
  {
    "index": 127,
    "id": "ABMW0739R",
    "section": "Legal Matters/Rules of the Road",
    "question": "Which vehicle is exempt from speed limits when being used in an emergency?",
    "options": [
      "Mountain rescue.",
      "Breakdown recovery.",
      "Doctor on call.",
      "Fire Brigade."
    ],
    "correct_answer": 3,
    "explanation": "In the course of their duty Gardai, Fire Brigade and Ambulance personnel are exempt from some traffic laws including speed limits, as long as they do not put other road users in danger. If you hear or see a Garda or emergency vehicle approaching under emergency conditions, be extra careful and give way, if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 128,
    "id": "ABMW33",
    "section": "Legal Matters/Rules of the Road",
    "question": "Which vehicle is exempt from speed limits when being used in an emergency?",
    "options": [
      "Mountain rescue.",
      "Ambulance.",
      "Breakdown recovery.",
      "Doctor on call."
    ],
    "correct_answer": 1,
    "explanation": "In the course of their duty Gardai, Fire Brigade and Ambulance personnel are exempt from some traffic laws including speed limits, as long as they do not put other road users in danger. If you hear or see a Garda or emergency vehicle approaching under emergency conditions, be extra careful and give way, if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 129,
    "id": "ABMW34",
    "section": "Legal Matters/Rules of the Road",
    "question": "Which vehicle is exempt from speed limits when being used in an emergency?",
    "options": [
      "Garda.",
      "Mountain rescue.",
      "Breakdown recovery.",
      "Doctor on call."
    ],
    "correct_answer": 0,
    "explanation": "In the course of their duty Gardai, Fire Brigade and Ambulance personnel are exempt from some traffic laws including speed limits, as long as they do not put other road users in danger. If you hear or see a Garda or emergency vehicle approaching under emergency conditions, be extra careful and give way, if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 130,
    "id": "ABMW0038U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Passing other traffic that exceeds the weight shown is not allowed.",
      "Parking of vehicles under the weight shown is not allowed.",
      "Parking in loading area is not allowed.",
      "Parking of vehicles exceeding the weight shown is not allowed."
    ],
    "correct_answer": 3,
    "explanation": "This sign tells you that you must not park in this area if your vehicle is over the weight limit indicated.",
    "image_name": "ABMW0038U19.png"
  },
  {
    "index": 131,
    "id": "ABMW0157RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking indicate?",
    "options": [
      "Pedestrian island.",
      "Traffic calming.",
      "Zebra crossing."
    ],
    "correct_answer": 2,
    "explanation": "A zebra crossing is a designated area for pedestrians to cross the road. As a driver you must always yield to pedestrians on a zebra crossing.",
    "image_name": "ABMW0157R.png"
  },
  {
    "index": 132,
    "id": "ABMW0158R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking indicate?",
    "options": [
      "Zebra crossing.",
      "No entry.",
      "Speed control ramp.",
      "Pelican crossing."
    ],
    "correct_answer": 0,
    "explanation": "A zebra crossing is a designated area for pedestrians to cross the road. As a driver you must always yield to pedestrians on a zebra crossing.",
    "image_name": "ABMW0157R.png"
  },
  {
    "index": 133,
    "id": "ABMW0159R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "Set down area only.",
      "A driver may overtake in this area.",
      "Road surface is uneven.",
      "No parking in this area."
    ],
    "correct_answer": 3,
    "explanation": "White zigzag lines indicate that you are approaching a pedestrian crossing. You must not park or overtake within this area.",
    "image_name": "ABMW0159R.png"
  },
  {
    "index": 134,
    "id": "ABMW0160U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "Traffic entering a box junction from right and left has the right of way unless continuing straight on.",
      "Traffic entering a box junction may have right of way over traffic from both right and left.",
      "Taxi set-down area.",
      "Traffic must not enter unless they can clear the box junction without stopping, or when turning right."
    ],
    "correct_answer": 3,
    "explanation": "You must not enter the yellow box junction unless you can clear it without stopping or unless you are turning right and are prevented from doing so by oncoming traffic.",
    "image_name": "ABMW0160U19.png"
  },
  {
    "index": 135,
    "id": "ABMW0161U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "A driver may overtake.",
      "All traffic must keep to the left of the white line.",
      "Road narrows ahead.",
      "A driver is approaching a STOP sign."
    ],
    "correct_answer": 1,
    "explanation": "Where there is a continuous white line in the centre of the road, you are not permitted to: 1. Straddle or cross the white line; 2. Overtake another vehicle; 3. Perform a U-turn; or 4. Park on the road.",
    "image_name": "ABMW0161U19.png"
  },
  {
    "index": 136,
    "id": "ABMW0163RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking and information plate together mean?",
    "options": [
      "Taxi parking only at the times and days shown.",
      "Taxi parking only outside the times and days shown.",
      "Parking only at times and days shown.",
      "Parking not allowed at the times and days shown."
    ],
    "correct_answer": 3,
    "explanation": "A single yellow line along the edge of a road means that you must not park there during the times shown on the accompanying information plate.",
    "image_name": "ABMW0163RU19.png"
  },
  {
    "index": 137,
    "id": "ABMW0164R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking and information plate together mean?",
    "options": [
      "Loading bay at times shown.",
      "No parking at any time.",
      "Taxi rank at times shown.",
      "Parking not allowed at the times shown."
    ],
    "correct_answer": 3,
    "explanation": "A single yellow line along the edge of a road means that you must not park there during the times shown on the accompanying information plate.",
    "image_name": "ABMW0164R.png"
  },
  {
    "index": 138,
    "id": "ABMW0165R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "A driver must not cross the broken white line unless it is safe to do so.",
      "A driver may overtake provided they do not cross the broken white line.",
      "A driver may not park along this road.",
      "A driver may not overtake along this road."
    ],
    "correct_answer": 0,
    "explanation": "A broken white line along the centre of the road means you must not cross the line unless it is safe to do so when overtaking or passing.",
    "image_name": "ABMW0165R.png"
  },
  {
    "index": 139,
    "id": "ABMW0166RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do these road markings mean?",
    "options": [
      "Dual carriageway ahead.",
      "No parking allowed.",
      "Continuous white lines ahead.",
      "No overtaking allowed."
    ],
    "correct_answer": 2,
    "explanation": "Double broken white lines along the centre of the road alert you to continuous white lines ahead. Do not cross them unless it is safe to do so.",
    "image_name": "ABMW0166RU19.png"
  },
  {
    "index": 140,
    "id": "ABMW0167R",
    "section": "Legal Matters/Rules of the Road",
    "question": "If driving from A to B, what do these road markings mean?",
    "options": [
      "A driver may overtake if it is safe to do so.",
      "A driver may not overtake.",
      "Dual carriageway ahead.",
      "Road narrows ahead."
    ],
    "correct_answer": 0,
    "explanation": "Where there is a broken white line and a continuous white line along the centre of the road, you must obey the line that is nearest to you. In this case you may cross the lines as long as it is safe to do so.",
    "image_name": "ABMW0167R.png"
  },
  {
    "index": 141,
    "id": "ABMW0168R",
    "section": "Legal Matters/Rules of the Road",
    "question": "If driving from A to B, what do these road markings mean?",
    "options": [
      "Only motorcyclists may cross the lines to overtake.",
      "A driver may not cross the lines to overtake.",
      "Oncoming traffic may not cross the lines to overtake.",
      "A driver may cross the lines to overtake."
    ],
    "correct_answer": 1,
    "explanation": "Where there is a broken white line and a continuous white line along the centre of the road, you must obey the line that is nearest to you. In this case you may not cross the lines.",
    "image_name": "ABMW0168R.png"
  },
  {
    "index": 142,
    "id": "ABMW0169RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "Pedestrian crossing.",
      "Private vehicles not allowed.",
      "No entry.",
      "The road ahead is a cul-de-sac."
    ],
    "correct_answer": 2,
    "explanation": "This road marking indicates a one-way street. You may not enter this street.",
    "image_name": "ABMW0169RU19.png"
  },
  {
    "index": 143,
    "id": "ABMW0170",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "Keep outside the yellow lines.",
      "Taxi parking only.",
      "Parking prohibited during business hours.",
      "Parking prohibited at all times."
    ],
    "correct_answer": 3,
    "explanation": "A double yellow line along the edge of the road means parking is not allowed at any time.",
    "image_name": "ABMW0170.png"
  },
  {
    "index": 144,
    "id": "ABMW0171R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this road marking mean?",
    "options": [
      "Only motorcyclists may cross the lines to overtake.",
      "Drivers must keep left of the continuous white line.",
      "Oncoming traffic may cross the line to overtake.",
      "Drivers may cross the line to overtake."
    ],
    "correct_answer": 1,
    "explanation": "A single continuous white line along the centre of the road means all traffic must keep to the left of the line. You are not permitted to overtake or perform a U-turn on this section of road.",
    "image_name": "ABMW0171R.png"
  },
  {
    "index": 145,
    "id": "ABMW0172R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does the broken yellow line road marking mean?",
    "options": [
      "No stopping for any reason except in an emergency.",
      "Parking prohibited at all times.",
      "The edge of the carriageway or hard shoulder.",
      "Slow lane for heavy vehicles only."
    ],
    "correct_answer": 2,
    "explanation": "A single broken yellow line along the side of the road marks the edge of the carriageway/hard shoulder. This is normally for the use of pedestrians and cyclists. As a driver, however, you may use it briefly to allow faster traffic to overtake, but only where it is safe to do so.",
    "image_name": "ABMW0172R.png"
  },
  {
    "index": 146,
    "id": "ABMW0173R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this traffic light mean?",
    "options": [
      "Proceed if the way is clear.",
      "Prepare to move off.",
      "The traffic lights are out of order.",
      "Stop, unless it is unsafe to do so."
    ],
    "correct_answer": 3,
    "explanation": "When the traffic light is showing amber you must not go beyond the stop line unless you so close to the traffic lights that stopping would be dangerous.",
    "image_name": "ABMW0173R.png"
  },
  {
    "index": 147,
    "id": "ABMW0174RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this traffic light mean?",
    "options": [
      "The driver must divert to the right.",
      "The driver may proceed in the direction of the green arrow if the way is clear.",
      "The driver must stop and wait until the full green light appears."
    ],
    "correct_answer": 1,
    "explanation": "A green arrow (filter light) means that traffic may proceed in the direction of the arrow if it is safe to do so.",
    "image_name": "ABMW0174R.png"
  },
  {
    "index": 148,
    "id": "ABMW0175U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this traffic light mean?",
    "options": [
      "Traffic turning left should prepare for full green to move off.",
      "All traffic must turn left only.",
      "Traffic turning left may proceed if the way is clear.",
      "Traffic is not allowed to turn left."
    ],
    "correct_answer": 2,
    "explanation": "A green arrow (filter light) means that traffic may proceed in the direction of the arrow if it is safe to do so.",
    "image_name": "ABMW0175U19.png"
  },
  {
    "index": 149,
    "id": "ABMW0176RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this traffic light mean?",
    "options": [
      "Traffic may stop if safe to do so.",
      "Traffic must stop at the traffic light.",
      "Traffic must proceed if safe to do so."
    ],
    "correct_answer": 1,
    "explanation": "A red light means STOP. You must not go beyond the stop line or (if there is no stop line) beyond the light.",
    "image_name": "ABMW0176R.png"
  },
  {
    "index": 150,
    "id": "ABMW0177R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this traffic light mean?",
    "options": [
      "Traffic may proceed but not turn right.",
      "Give way to any oncoming traffic turning right.",
      "Traffic may proceed if the way is clear.",
      "Traffic must stop at the traffic light."
    ],
    "correct_answer": 2,
    "explanation": "You may proceed on a green traffic light if it is safe to do so.",
    "image_name": "ABMW0177R.png"
  },
  {
    "index": 151,
    "id": "ABMW0178",
    "section": "Legal Matters/Rules of the Road",
    "question": "What colour traffic light comes on after the green?",
    "options": [
      "Green arrow.",
      "Red only.",
      "Amber only.",
      "Flashing amber."
    ],
    "correct_answer": 2,
    "explanation": "The normal sequence of traffic lights is red-green-amber.",
    "image_name": ""
  },
  {
    "index": 152,
    "id": "ABMW0179RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When traffic lights are green, when should a driver not proceed?",
    "options": [
      "When it would be unsafe to do so.",
      "When oncoming traffic is waiting to turn left.",
      "When traffic is stopped waiting to turn from the road on the left.",
      "When traffic is stopped waiting to turn from the road on the right."
    ],
    "correct_answer": 0,
    "explanation": "Although a green traffic light means proceed with caution, you should not enter a junction if the way is not clear or if by doing so you would cause an obstruction to other road users.",
    "image_name": ""
  },
  {
    "index": 153,
    "id": "ABMW0180RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does a flashing amber arrow pointing left at a traffic light mean?",
    "options": [
      "A driver may proceed before traffic on the other road.",
      "A driver must not proceed in this direction.",
      "The driver must wait until the traffic lights turn green.",
      "A driver may turn left but must yield to traffic on the other road."
    ],
    "correct_answer": 3,
    "explanation": "A flashing left amber arrow at a junction means you may proceed left but must give way to pedestrians and traffic already coming through the junction on the other road.",
    "image_name": "ABMW0180RU19.png"
  },
  {
    "index": 154,
    "id": "ABMW0181R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What colour traffic light comes on after a non-flashing amber light?",
    "options": [
      "Red only.",
      "Green only.",
      "Flashing red light.",
      "Flashing amber light."
    ],
    "correct_answer": 0,
    "explanation": "The normal sequence of traffic lights is red-green-amber.",
    "image_name": ""
  },
  {
    "index": 155,
    "id": "ABMW0182",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do flashing amber lights at a pelican crossing mean?",
    "options": [
      "Drivers have right of way.",
      "A driver is entering a special speed limit area.",
      "Danger ahead. A driver must stop and wait until the light stops flashing.",
      "Stop and give way to pedestrians - proceed if the way is clear."
    ],
    "correct_answer": 3,
    "explanation": "A flashing amber light at a pelican crossing means you must yield to pedestrians. You may proceed, however, if the crossing is clear.",
    "image_name": ""
  },
  {
    "index": 156,
    "id": "ABMW0205RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What road users must comply with traffic lights (including pedestrian lights)?",
    "options": [
      "Drivers and pedestrians only.",
      "All road users.",
      "Drivers and cyclists only."
    ],
    "correct_answer": 1,
    "explanation": "All road users including pedestrians must comply with traffic controls. Drivers should be aware that traffic lights and pedestrian lights can be combined at junctions and should show caution and consideration to pedestrians.",
    "image_name": ""
  },
  {
    "index": 157,
    "id": "ABMW0210RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the purpose of traffic calming measures?",
    "options": [
      "To prioritise heavy goods traffic.",
      "To slow down traffic in the vicinity.",
      "To inform the driver of an increased speed limit ahead.",
      "To alert drivers to road flooding ahead."
    ],
    "correct_answer": 1,
    "explanation": "The purpose of traffic calming measures is to slow down fast-moving traffic to a speed more suitable for the area they are entering. These measures are usually found in rural areas on the entry points to towns or villages.",
    "image_name": ""
  },
  {
    "index": 158,
    "id": "ABMW0213R",
    "section": "Legal Matters/Rules of the Road",
    "question": "Who can use a signed cycle track accompanied by a continuous white line on the left-hand side?",
    "options": [
      "Cyclists and motorcyclists.",
      "Drivers, when it is not being used by a cyclist.",
      "Drivers when overtaking a vehicle turning right.",
      "Cyclists and users of motorised wheelchairs."
    ],
    "correct_answer": 3,
    "explanation": "A cycle track is for the use of cyclists and motorised wheelchairs only. No other vehicles may cross into or over a mandatory cycle track unless this is necessary in order to leave or enter a side road or a property adjacent to the cycle track.",
    "image_name": ""
  },
  {
    "index": 159,
    "id": "ABMW0214RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What traffic may use a cycle lane accompanied by a continuous white line?",
    "options": [
      "Cyclists and motorised wheelchairs.",
      "Cyclists and motorcyclists.",
      "Buses and cyclists.",
      "Cyclists and taxis."
    ],
    "correct_answer": 0,
    "explanation": "A cycle track is for the use of cyclists and motorised wheelchairs. No other vehicles may cross into or over a mandatory cycle track unless this is necessary in order to leave a side road or a property adjacent to the cycle track.",
    "image_name": ""
  },
  {
    "index": 160,
    "id": "ABMW0215RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Apart from cyclists and motorised wheelchairs, what other road users may use an unoccupied cycle lane accompanied by a broken white line?",
    "options": [
      "All drivers may make temporary use.",
      "Only moped riders and motorcyclists.",
      "Only hackneys and taxis.",
      "Only buses and taxis."
    ],
    "correct_answer": 0,
    "explanation": "Drivers may make temporary use of a cycle track with a broken white line on the right-hand side if it is not occupied.",
    "image_name": ""
  },
  {
    "index": 161,
    "id": "ABMW0216RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When must drivers stop at an automated railway level crossing with barriers and red flashing lights?",
    "options": [
      "When there are no lights visible.",
      "Stop safely when the amber light shows, or when red lights start to flash.",
      "When the red and amber lights stop flashing.",
      "When the barrier is fully up."
    ],
    "correct_answer": 1,
    "explanation": "You must stop safely when the amber light shows. Flashing red lights have the same meaning as a steady red traffic light - stop safely when they show.",
    "image_name": ""
  },
  {
    "index": 162,
    "id": "ABMW0217RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "At a railway level crossing with unattended gates, what should a car driver do?",
    "options": [
      "Open both gates before proceeding to cross.",
      "Telephone the nearest railway station before opening a gate.",
      "Open both gates and after passing the first, stop and close it.",
      "Drive halfway across and close the first gate before opening the second."
    ],
    "correct_answer": 0,
    "explanation": "At a level crossing with unattended gates a driver must stop, look for trains and listen for the sound of a horn or approaching trains. If it is safe, open both gates, complete the crossing and then close both gates.",
    "image_name": ""
  },
  {
    "index": 163,
    "id": "ABMW0218R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What lights indicate a zebra crossing?",
    "options": [
      "Continuously lit amber beacons.",
      "Continuously lit red beacons.",
      "Flashing amber beacons.",
      "Flashing red beacons."
    ],
    "correct_answer": 2,
    "explanation": "A zebra crossing is indicated by amber flashing beacons on poles and black and white stripes on the road. You must stop for pedestrians on the crossing and for those about to cross.",
    "image_name": ""
  },
  {
    "index": 164,
    "id": "ABMW0219RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do flashing amber arrows indicate at a junction?",
    "options": [
      "Proceed smartly through junction to avoid delay.",
      "The direction indicated is a cul-de-sac.",
      "When safe, drivers should proceed in the direction indicated.",
      "It is prohibited to proceed in the direction indicated."
    ],
    "correct_answer": 2,
    "explanation": "When you meet a flashing amber arrow at a junction, you should proceed in the direction indicated provided it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 165,
    "id": "ABMW0220R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do temporary traffic lights at road works mean?",
    "options": [
      "A driver need only comply when there is oncoming traffic.",
      "A driver must comply with the lights at all times.",
      "A driver need not comply if a convoy of traffic is going in the same direction.",
      "A driver must comply with the lights when workers are on site only."
    ],
    "correct_answer": 1,
    "explanation": "You must comply with any temporary traffic lights used to control vehicle movements at or near road works. It is an offence not to obey these lights.",
    "image_name": ""
  },
  {
    "index": 166,
    "id": "ABMW0256RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does a continuous white line along the centre of the road mean?",
    "options": [
      "Traffic can overtake.",
      "No U-turn allowed.",
      "Parking allowed during business hours.",
      "U-turn allowed during daylight hours."
    ],
    "correct_answer": 1,
    "explanation": "You must never do a U-turn on any stretch of road with a continuous white line along its centre. The restricted vision at such places would make doing a U-turn very unsafe.",
    "image_name": "ABMW0256RU19.png"
  },
  {
    "index": 167,
    "id": "ABMW0259RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does a continuous white line in the centre of the road mean?",
    "options": [
      "Vehicles may cross the line for a short time.",
      "Vehicles may perform a U-turn.",
      "Vehicles may park during daylight hours only.",
      "Vehicles may not cross or drive over the line."
    ],
    "correct_answer": 3,
    "explanation": "You must not cross or straddle a continuous white line in the centre of the road unless you wish to enter land or premises and it is safe to do so.",
    "image_name": "ABMW0259RU19.png"
  },
  {
    "index": 168,
    "id": "ABMW0268R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What should a driver do when approaching traffic lights that change from green to amber?",
    "options": [
      "Sound the horn while proceeding through the junction.",
      "Stop, unless it is unsafe to do so.",
      "Accelerate to clear the junction.",
      "Stop the vehicle immediately."
    ],
    "correct_answer": 1,
    "explanation": "When you are approaching a set of traffic lights showing green, you should take care and be prepared to stop if the amber light comes on.",
    "image_name": "ABMW0268R.png"
  },
  {
    "index": 169,
    "id": "ABMW0280R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What should a driver do at an amber traffic light?",
    "options": [
      "Continue only if sure that the junction is clear of pedestrians.",
      "Make sure to pass the lights before they turn red.",
      "Continue as there is no traffic at the junction.",
      "Stop at the line unless it is not safe to do so."
    ],
    "correct_answer": 3,
    "explanation": "By law you must stop at an amber traffic light if it is safe to do so.",
    "image_name": "ABMW0280R.png"
  },
  {
    "index": 170,
    "id": "ABMW0331RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When wanting to stop temporarily in a congested area where should the driver park?",
    "options": [
      "Park on the footpath so as not to impede the free flow of traffic in the road.",
      "Park slightly up on the footpath with the hazard lights on.",
      "Double park in a convenient place with your hazard lights on.",
      "Park in a safe, legal and convenient place."
    ],
    "correct_answer": 3,
    "explanation": "You should park only where it is safe, legal and convenient to do so. Your parked vehicle must not cause a danger or an obstruction to other road users. The use of hazard warning lights does not excuse unsafe or illegal parking.",
    "image_name": ""
  },
  {
    "index": 171,
    "id": "ABMW0501RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is a clearway?",
    "options": [
      "An area where stopping and parking is not permitted during certain times.",
      "An area that is reserved for pedestrians and motorised wheelchairs.",
      "An area where stopping and parking is reserved for buses and taxis only.",
      "An area that is strictly reserved for the loading and unloading of HGVs."
    ],
    "correct_answer": 0,
    "explanation": "A clearway is an area of road that must be kept clear for moving traffic during certain times of the day (usually busy periods). The times when stopping or parking is prohibited are shown on an information plate under the sign.",
    "image_name": ""
  },
  {
    "index": 172,
    "id": "ABMW0051R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Junction ahead with roads of greater importance.",
      "Junction ahead with railway crossing.",
      "Junction ahead with roads of equal importance.",
      "Junction ahead with roads of lesser importance."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a junction ahead with minor roads on either side. Be aware that vehicles may be emerging from the minor roads.",
    "image_name": "ABMW0051R.png"
  },
  {
    "index": 173,
    "id": "ABMW0052RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Y-junction where vehicles must go left.",
      "Y-junction where main road bears to the left.",
      "Y-junction where main road bears to the right.",
      "Y-junction where heavy vehicles must go left."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a Y-junction with a minor road ahead. The wider arm of the Y indicates the course of the main road.",
    "image_name": "ABMW0052RU19.png"
  },
  {
    "index": 174,
    "id": "ABMW0053RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Roads closed ahead to both left and right.",
      "Staggered crossroads ahead with roads of equal importance.",
      "Cul-de-sac to both left and right."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a staggered junction ahead with roads to the left and right. Be aware that vehicles may be emerging from these roads.",
    "image_name": "ABMW0053R.png"
  },
  {
    "index": 175,
    "id": "ABMW0054RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Major road ahead.",
      "Crossroads ahead with roads of equal importance.",
      "Crossroads ahead with roads of lesser importance."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a crossroad junction ahead where the roads are of equal importance. At this type of junction you should yield to traffic approaching from the right and traffic already turning.",
    "image_name": "ABMW0054RU19.png"
  },
  {
    "index": 176,
    "id": "ABMW0055R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "T-junction ahead with merging traffic.",
      "T-junction ahead with dual carriageway.",
      "T-junction ahead with roads of equal importance.",
      "T-junction ahead with road of less importance."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of a T-junction ahead with a road of equal importance. You must give way to traffic already on the road you are joining.",
    "image_name": "ABMW0055R.png"
  },
  {
    "index": 177,
    "id": "ABMW0056RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Minor road ahead.",
      "Y-junction ahead with roads of equal importance.",
      "Junction ahead with dual carriageway.",
      "Y-junction ahead with roads of lesser importance."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a Y-junction ahead with roads of equal importance. Approach such a junction with caution and be prepared to react to any changes in the traffic situation.",
    "image_name": "ABMW0056RU19.png"
  },
  {
    "index": 178,
    "id": "ABMW0057RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Y-junction ahead with roads of equal importance.",
      "Minor road ahead.",
      "Start of dual carriageway."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a Y-junction hazard ahead with a road of equal importance. Be prepared to yield to other road users.",
    "image_name": "ABMW0056RU19.png"
  },
  {
    "index": 179,
    "id": "ABMW0058RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Crossroads with major road ahead.",
      "Road passing under a bridge ahead.",
      "T-junction ahead with roads of major importance.",
      "Crossroads with dual carriageway ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a crossroads junction with a major road ahead. Be prepared to stop.",
    "image_name": "ABMW0058RU19.png"
  },
  {
    "index": 180,
    "id": "ABMW0059RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Cul-de-sac to the left and right.",
      "Cul-de-sac to the right.",
      "T-junction ahead with a road of major importance.",
      "T-junction ahead with a road of minor importance."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of a T-junction ahead with a major road. Be prepared to yield or stop as necessary.",
    "image_name": "ABMW0059RU19.png"
  },
  {
    "index": 181,
    "id": "ABMW0060RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Level crossing ahead guarded by gates.",
      "T-junction with crossroads ahead.",
      "Unguarded level crossing ahead.",
      "Crossroads with dual carriageway ahead."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a crossroads junction at a dual carriageway ahead. Drivers need to be observant, taking extra care for traffic coming from each direction. Yield and/or stop as appropriate.",
    "image_name": "ABMW0060RU19.png"
  },
  {
    "index": 182,
    "id": "ABMW0061RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Low bridge ahead.",
      "T-junction with dual carriageway ahead.",
      "Guarded level crossing ahead.",
      "Unguarded level crossing ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a T-junction at a dual carriageway ahead. Drivers need to be observant, taking extra care for traffic coming from each direction. Yield and/or stop as appropriate.",
    "image_name": "ABMW0061RU19.png"
  },
  {
    "index": 183,
    "id": "ABMW0062RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic merging from the right.",
      "End of dual carriageway ahead.",
      "Traffic merging from the left.",
      "Traffic from the left has priority."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of traffic merging from the left. You should expect vehicles to join from the left. You may need to slow down, allowing them to merge safely.",
    "image_name": "ABMW0062RU19.png"
  },
  {
    "index": 184,
    "id": "ABMW0063RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Diversion at junction ahead.",
      "Traffic merging/diverging ahead.",
      "Yield to merging/diverging traffic ahead.",
      "Road narrows briefly ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of roads both merging (entering onto the main road) and diverging (exiting the main road). Drivers should be prepared for traffic changing speed and direction as vehicles enter or exit at the junctions on the left ahead.",
    "image_name": "ABMW0063RU19.png"
  },
  {
    "index": 185,
    "id": "ABMW0064RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Ring road ahead.",
      "Roundabout ahead.",
      "Loop road ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a roundabout ahead. You must be prepared to yield to other road users already on the roundabout or coming from the right.",
    "image_name": "ABMW0064RU19.png"
  },
  {
    "index": 186,
    "id": "ABMW0065RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Mini-roundabout ahead.",
      "Roadworks ahead, diversion in operation.",
      "Loop road ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a mini-roundabout ahead. You must be prepared to yield to other road users already on the roundabout or coming from the right.",
    "image_name": "ABMW0065RU19.png"
  },
  {
    "index": 187,
    "id": "ABMW0066U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Dangerous bend ahead.",
      "One-way street ahead.",
      "Junction to the left.",
      "Dangerous corner ahead."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a dangerous corner to the left. You may need to slow down and react to any changes in the traffic situation ahead.",
    "image_name": "ABMW0066U19.png"
  },
  {
    "index": 188,
    "id": "ABMW0067U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Dangerous corner ahead.",
      "Dangerous bend ahead.",
      "Turn left."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a dangerous bend to the left. You may need to slow down and react to any changes in the traffic situation ahead.",
    "image_name": "ABMW0067U19.png"
  },
  {
    "index": 189,
    "id": "ABMW0068U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Overhead electric cables.",
      "Series of dangerous corners ahead.",
      "Series of dangerous bends ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a series of dangerous corners ahead. You should slow down and react to any changes in the traffic situation.",
    "image_name": "ABMW0068U19.png"
  },
  {
    "index": 190,
    "id": "ABMW0069RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Series of dangerous corners ahead.",
      "Series of dangerous bends ahead.",
      "Slippery road ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a series of dangerous bends ahead. You should slow down and react to any changes in the traffic situation.",
    "image_name": "ABMW0069RU19.png"
  },
  {
    "index": 191,
    "id": "ABMW0070RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Sharp change of direction to the right.",
      "Sharp change of direction to the left.",
      "Series of speed ramps ahead.",
      "Road closed - drivers must turn back."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a sharp change of direction to the right. You should slow down as you approach the hazard.",
    "image_name": "ABMW0070RU19.png"
  },
  {
    "index": 192,
    "id": "ABMW0071RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Merging traffic from the left.",
      "Road narrows on the left.",
      "The driver must overtake on the right only.",
      "End of dual carriageway."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning that the road narrows on the left ahead. You should show caution and prepare to adjust your road position.",
    "image_name": "ABMW0071RU19.png"
  },
  {
    "index": 193,
    "id": "ABMW0072U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Dual carriageway ahead.",
      "Road narrows on both sides.",
      "End of dual carriageway."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning that the road is narrowing on both sides ahead. You should show caution and prepare to slow down.",
    "image_name": "ABMW0072U19.png"
  },
  {
    "index": 194,
    "id": "ABMW0073RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Road divides ahead.",
      "Overtake only on the left ahead.",
      "Tramline ahead.",
      "Railway tunnel ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that the road divides ahead. You should prepare to move to the left.",
    "image_name": "ABMW0073RU19.png"
  },
  {
    "index": 195,
    "id": "ABMW0074U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Tunnel ahead.",
      "Dual carriageway ends.",
      "Road narrows ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of the end of a dual carriageway. You will soon be entering a 2-way road.",
    "image_name": "ABMW0074.png"
  },
  {
    "index": 196,
    "id": "ABMW0075U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Dual carriageway ahead.",
      "One-way street ahead.",
      "Two-way traffic ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of two-way traffic ahead, with oncoming traffic in the opposite lane.",
    "image_name": "ABMW0075U19.png"
  },
  {
    "index": 197,
    "id": "ABMW0076U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "River or unprotected quay ahead.",
      "Uneven road surface ahead.",
      "Steep ascent ahead.",
      "Steep descent ahead."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a steep descent/downward slope ahead. You should react accordingly by adjusting speed and selecting the appropriate gear.",
    "image_name": "ABMW0076U19.png"
  },
  {
    "index": 198,
    "id": "ABMW0077U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Steep descent ahead.",
      "Humpback bridge ahead.",
      "Steep ascent ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of a steep ascent/upward hill ahead. You should react by selecting the appropriate gear.",
    "image_name": "ABMW0077U19.png"
  },
  {
    "index": 199,
    "id": "ABMW0078U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Restricted road width ahead.",
      "Road narrows ahead - maximum length of vehicle is indicated.",
      "Low bridge up ahead.",
      "Restricted weight limit for road segment indicated."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning that you are approaching a low bridge, with restricted headroom as shown on the sign.",
    "image_name": "ABMW0078U19.png"
  },
  {
    "index": 200,
    "id": "ABMW0079",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Sharp corners ahead.",
      "Overhead electric cables.",
      "Radio transmission mast ahead.",
      "Crosswinds ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of electric cables overhead. Drivers with a high load should be particularly careful.",
    "image_name": "ABMW0079.png"
  },
  {
    "index": 201,
    "id": "ABMW0080R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "End of major roadworks ahead.",
      "Level crossing ahead unguarded by gates or barriers.",
      "Major roadworks ahead.",
      "Level crossing ahead guarded by gates or barriers."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advanced warning of an unguarded level crossing ahead. This is a crossing without gates or barriers and you should cross it with extreme caution.",
    "image_name": "ABMW0080R.png"
  },
  {
    "index": 202,
    "id": "ABMW0081",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Level crossing ahead guarded by gates or barriers.",
      "Farm machinery crossing ahead.",
      "Road fencing ahead.",
      "Private grounds - no entry."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a railway crossing ahead that is protected by gates or lifting barriers. You should be prepared to stop and follow the required procedure.",
    "image_name": "ABMW0081.png"
  },
  {
    "index": 203,
    "id": "ABMW0082U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Railway bridge ahead.",
      "Level crossing ahead protected by lights and barriers.",
      "Railway station ahead.",
      "Level crossing ahead unprotected by lights and barriers."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of a railway level crossing ahead protected by lights and barriers. The crossing may also have an audible warning alarm. You should be prepared to stop.",
    "image_name": "ABMW0082U19.png"
  },
  {
    "index": 204,
    "id": "ABMW0083U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "The driver must stop when red lights show.",
      "Stop and wait for green light before proceeding.",
      "Stop and wait for amber light before proceeding."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that you must stop when red lights show. This sign may be displayed at a railway level crossing.",
    "image_name": "ABMW0083.png"
  },
  {
    "index": 205,
    "id": "ABMW0084RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Attended level crossing ahead.",
      "Unguarded level crossing ahead.",
      "Automatic level crossing ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of an automatic level crossing ahead. Drivers should approach with caution and be prepared to slow down or stop as necessary.",
    "image_name": "ABMW0084RU19.png"
  },
  {
    "index": 206,
    "id": "ABMW0085R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Road falls from centre to left and right.",
      "Traffic island ahead.",
      "Series of bumps or hollows ahead.",
      "Sharp rise in the road ahead - for example, a humpback bridge."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a hump in the road. You should adjust your speed accordingly.",
    "image_name": "ABMW0085R.png"
  },
  {
    "index": 207,
    "id": "ABMW0086RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Road damaged ahead.",
      "Road divides ahead - pass on the left or right.",
      "Sharp depression or dip ahead.",
      "Road flooded ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of a dip or depression in the road ahead which may be hidden and could obscure your view of oncoming traffic. You should reduce your speed accordingly and be aware that overtaking is dangerous in these areas.",
    "image_name": "ABMW0086RU19.png"
  },
  {
    "index": 208,
    "id": "ABMW0087RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Steep hills ahead.",
      "Series of rumble strips ahead.",
      "Series of bumps or hollows ahead.",
      "Road works ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of a series of bumps or hollows ahead. Be prepared to reduce your speed as necessary.",
    "image_name": "ABMW0087RU19.png"
  },
  {
    "index": 209,
    "id": "ABMW0088U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Series of bends ahead.",
      "Slippery road ahead.",
      "Steep hill ahead.",
      "Road narrows from right."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning of the potential danger of slippery road surfaces ahead.",
    "image_name": "ABMW0088U19.png"
  },
  {
    "index": 210,
    "id": "ABMW0089RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Steep descent ahead.",
      "Road likely to flood.",
      "Unprotected quay, canal or river ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning of an unprotected area of water ahead. You should be cautious due to the extreme danger.",
    "image_name": "ABMW0089RU19.png"
  },
  {
    "index": 211,
    "id": "ABMW0090RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic signals ahead.",
      "School children crossing ahead.",
      "Stop at zebra crossing.",
      "Railway level crossing ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a traffic light controlled junction ahead. This sign is generally found in areas where the lights may not be visible to drivers in good time - for example, following a bend in the road.",
    "image_name": "ABMW0090RU19.png"
  },
  {
    "index": 212,
    "id": "ABMW0091RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Children's play area ahead.",
      "Pedestrian crossing ahead.",
      "Picnic area ahead.",
      "School ahead."
    ],
    "correct_answer": 3,
    "explanation": "This sign gives advance warning of a school ahead. You should adjust your speed and react accordingly as there may be children in the area.",
    "image_name": "ABMW0091RU19.png"
  },
  {
    "index": 213,
    "id": "ABMW0092U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "School children crossing ahead.",
      "Playground ahead.",
      "Level crossing ahead with pedestrian walkway."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that there may be school children crossing the road ahead, slow down if required and be prepared to stop.",
    "image_name": "ABMW0092U19.png"
  },
  {
    "index": 214,
    "id": "ABMW0093U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "School playground ahead.",
      "School children crossing ahead.",
      "Children's play area ahead."
    ],
    "correct_answer": 1,
    "explanation": "This sign gives advance warning that there may be school children crossing the road ahead, slow down if required and be prepared to stop.",
    "image_name": "ABMW0092U19.png"
  },
  {
    "index": 215,
    "id": "ABMW0094U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do these signs together mean?",
    "options": [
      "Slippery road - children may fall.",
      "Beware of children crossing.",
      "Loose chippings on the road ahead."
    ],
    "correct_answer": 1,
    "explanation": "These signs are usually displayed in residential areas, and they give advance warning that children might be crossing ahead. You should proceed cautiously and be prepared to stop suddenly.",
    "image_name": "ABMW0094U19.png"
  },
  {
    "index": 216,
    "id": "ABMW0095R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Entrance to horse riding school.",
      "Riding path - no vehicles allowed.",
      "Accompanied horses and ponies ahead.",
      "Racecourse ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning that there may be horses on the road ahead. You should show due regard for horses and their riders.",
    "image_name": "ABMW0095R.png"
  },
  {
    "index": 217,
    "id": "ABMW0096U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Livestock mart ahead.",
      "Cattle grid ahead.",
      "Possibility of cattle or farm animals ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning that there may be cattle or other farm animals on the road ahead. Slow down if required and be prepared to stop.",
    "image_name": "ABMW0096U19.png"
  },
  {
    "index": 218,
    "id": "ABMW0097U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Abattoir ahead.",
      "Sheep market ahead.",
      "Possibility of sheep ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning that there may be sheep on the road ahead. Slow down if required and be prepared to stop.",
    "image_name": "ABMW0097U19.png"
  },
  {
    "index": 219,
    "id": "ABMW0098U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Deer or wild animals ahead.",
      "Stag hunting ahead.",
      "Cattle and farm animals ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that there may be deer or other wild animals coming onto the roadway. Be prepared to slow down or stop suddenly if required.",
    "image_name": "ABMW0098U19.png"
  },
  {
    "index": 220,
    "id": "ABMW0099RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Crosswinds ahead.",
      "Falling rocks ahead.",
      "Airport ahead.",
      "Golf course ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that there may be crosswinds ahead. Crosswinds can affect the stability of your vehicle on the road. Be prepared to slow down if necessary.",
    "image_name": "ABMW0099RU19.png"
  },
  {
    "index": 221,
    "id": "ABMW0100R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Pedestrian crossing ahead.",
      "Lane reserved for pedestrians.",
      "School ahead.",
      "Beware of pedestrians at night."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a pedestrian crossing ahead. You should show caution and be prepared to stop.",
    "image_name": "ABMW0100R.png"
  },
  {
    "index": 222,
    "id": "ABMW0101RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Tunnel ahead.",
      "Historic site ahead.",
      "Low bridge ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning of a tunnel ahead. You should be aware of the procedures to follow when entering a tunnel - which include keeping a safe distance from the vehicle ahead or removing sunglasses.",
    "image_name": "ABMW0101RU19.png"
  },
  {
    "index": 223,
    "id": "ABMW0102RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Danger of falling rocks ahead.",
      "Steep descent ahead.",
      "Rugged coast ahead."
    ],
    "correct_answer": 0,
    "explanation": "This sign gives advance warning that there is a danger of rocks and other debris falling onto the road. Drive with caution.",
    "image_name": "ABMW0102RU19.png"
  },
  {
    "index": 224,
    "id": "ABMW0103RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Direction of prevailing wind.",
      "Airport ahead.",
      "Possibility of low flying aircraft."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning that there may be low-flying aircraft in the area. Low-flying aircraft can cause distraction due to a sudden loud noise.",
    "image_name": "ABMW0103RU19.png"
  },
  {
    "index": 225,
    "id": "ABMW0104RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "A driver must drive on the left-hand side.",
      "A driver must merge from the left.",
      "A driver must overtake on the left-hand side."
    ],
    "correct_answer": 0,
    "explanation": "This sign is generally in areas where tourists might be travelling and reminds motorists to drive on the left. These signs are commonly found around airports and ferry ports.",
    "image_name": "ABMW0104RU19.png"
  },
  {
    "index": 226,
    "id": "ABMW0105RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Level crossing ahead.",
      "Railway station.",
      "Tramway crossing ahead.",
      "Bus and tramway crossing ahead."
    ],
    "correct_answer": 2,
    "explanation": "This sign gives advance warning sign of a tram crossing ahead. You should be prepared to stop and yield to the tram, if required.",
    "image_name": "ABMW0105RU23.png"
  },
  {
    "index": 227,
    "id": "ABMW0115U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Flagman ahead.",
      "Roadworks ahead.",
      "Building site ahead."
    ],
    "correct_answer": 1,
    "explanation": "This warning sign tells you that there are roadworks ahead. You should approach with caution and be alert for a change in the road surface, and for the presence of machinery and road workers.",
    "image_name": "ABMW0115U19.png"
  },
  {
    "index": 228,
    "id": "ABMW0117RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Slippery road.",
      "Road narrows from the right.",
      "Series of bends ahead."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that the surface ahead is slippery due to mud or debris and there is an increased risk of skidding.",
    "image_name": "ABMW0117RU19.png"
  },
  {
    "index": 229,
    "id": "ABMW0118RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Left-hand lane has an uneven surface.",
      "Road narrows from left.",
      "Slow lane ends ahead."
    ],
    "correct_answer": 1,
    "explanation": "This warning sign tells you that there are roadworks up ahead where the road narrows from the left creating a potential hazard.",
    "image_name": "ABMW0118RU19.png"
  },
  {
    "index": 230,
    "id": "ABMW0119RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Road narrows from right.",
      "Overtaking lane ends ahead.",
      "Right-hand lane has an uneven surface.",
      "A driver may overtake on the right only."
    ],
    "correct_answer": 0,
    "explanation": "Where there are roadworks up ahead, this warning sign tells you that the road narrows from the right creating a potential hazard.",
    "image_name": "ABMW0119RU19.png"
  },
  {
    "index": 231,
    "id": "ABMW0120RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "End of obstruction between lanes.",
      "Road narrows on both sides.",
      "Traffic merging from both sides.",
      "End of dual carriageway ahead."
    ],
    "correct_answer": 1,
    "explanation": "This roadworks warning sign tells you that the road narrows on both sides creating a potential hazard. Be prepared to slow down and drive with extra care.",
    "image_name": "ABMW0120RU19.png"
  },
  {
    "index": 232,
    "id": "ABMW0121RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Football stadium ahead.",
      "Pedestrian crossing to right.",
      "Hitch-hiking permitted.",
      "Flagman ahead."
    ],
    "correct_answer": 3,
    "explanation": "This roadworks warning sign tells you that the traffic flow ahead is controlled manually by a flagman. Be aware and follow directions given by the flagman.",
    "image_name": "ABMW0121RU19.png"
  },
  {
    "index": 233,
    "id": "ABMW0122RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Temporary traffic signals ahead.",
      "School children crossing ahead.",
      "Railway crossing ahead."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that temporary traffic signals are in use ahead. You should prepare to slow down, approach with caution and comply with the signal displayed.",
    "image_name": "ABMW0122RU19.png"
  },
  {
    "index": 234,
    "id": "ABMW0123U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic may not stop.",
      "One-way street.",
      "Two-way traffic.",
      "Dual carriageway ahead."
    ],
    "correct_answer": 2,
    "explanation": "This warning sign tells you that during roadworks there will be two-way traffic in operation ahead. Continue to drive with extra care.",
    "image_name": "ABMW0123U19.png"
  },
  {
    "index": 235,
    "id": "ABMW0124RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Offside lane of two closed.",
      "T-junction ahead in the left lane.",
      "Traffic in nearside lane must turn left.",
      "Nearside lane of two closed."
    ],
    "correct_answer": 3,
    "explanation": "This roadworks warning sign tells you that the nearside (left-hand) lane is closed ahead. If you are in this lane you will need to move to the offside (right-hand) lane when it is safe to do so.",
    "image_name": "ABMW0124RU19.png"
  },
  {
    "index": 236,
    "id": "ABMW0125RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Overtaking permitted, except on the left lane.",
      "Do not drive on the hard shoulder.",
      "Nearside lane of three closed."
    ],
    "correct_answer": 2,
    "explanation": "This roadworks warning sign tells you that the nearside (left-hand) lane of three is closed up ahead. If you are in this lane you will need to move to the centre (middle) lane when it is safe to do so.",
    "image_name": "ABMW0125RU19.png"
  },
  {
    "index": 237,
    "id": "ABMW0127RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Offside lane closed ahead.",
      "No stopping, except in offside lane.",
      "Corner ahead on offside lane.",
      "End of dual carriageway."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that the offside (right-hand) lane of three is closed ahead. Drivers in the nearside or centre lanes should be aware that traffic may merge from the right.",
    "image_name": "ABMW0127RU19.png"
  },
  {
    "index": 238,
    "id": "ABMW0134U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What do these signs together mean?",
    "options": [
      "End of road.",
      "End of detour.",
      "End of road works."
    ],
    "correct_answer": 1,
    "explanation": "Together these two signs indicate that a detour has ended.",
    "image_name": "ABMW0134U19.png"
  },
  {
    "index": 239,
    "id": "ABMW0135RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic should cross back to the left-hand lane ahead.",
      "Lay-by ahead.",
      "Slow lane ahead for heavy traffic.",
      "Bend in the road to the left ahead."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that the course of the road will return to the left ahead. This usually appears after a stretch where traffic was diverted to a right- hand lane.",
    "image_name": "ABMW0135RU19.png"
  },
  {
    "index": 240,
    "id": "ABMW0136RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Traffic should cross out to the right-hand lane ahead.",
      "End of \"no overtaking\" zone.",
      "Bend in the road to the right ahead.",
      "Traffic calming measures ahead."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that the course of the road will divert to the right ahead.",
    "image_name": "ABMW0136RU19.png"
  },
  {
    "index": 241,
    "id": "ABMW0137R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Start of central reserve or obstruction.",
      "Dual carriageway ahead.",
      "Mini-roundabout ahead.",
      "Heavy vehicles have priority."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that two-way traffic will separate to avoid an obstruction.",
    "image_name": "ABMW0137R.png"
  },
  {
    "index": 242,
    "id": "ABMW0138RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Beware of vehicle with a wide load.",
      "Dual carriageway ends ahead.",
      "End of central reserve or obstruction.",
      "Tunnel ends ahead."
    ],
    "correct_answer": 2,
    "explanation": "This roadworks warning sign tells you that traffic previously separated by the central reserve or an obstruction will revert to two-way traffic.",
    "image_name": "ABMW0138RU19.png"
  },
  {
    "index": 243,
    "id": "ABMW2",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "No parking inside the white line.",
      "Bus and tram lane on left.",
      "Tram lane on left.",
      "Trams emerging from left."
    ],
    "correct_answer": 2,
    "explanation": "This sign tells you there is a tram lane on the left. Be aware that there might be pedestrians in the area and crossing the road.",
    "image_name": "ABMW2.png"
  },
  {
    "index": 244,
    "id": "ABMW6U23",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Uneven surface on left.",
      "Loose chippings on road.",
      "Slippery road up ahead."
    ],
    "correct_answer": 1,
    "explanation": "This roadworks warning sign tells you that the road ahead has been resurfaced and there may be loose chippings. You should reduce speed while driving through this area as the loose chippings could affect your vehicle's road holding and braking.",
    "image_name": "ABMW6.png"
  },
  {
    "index": 245,
    "id": "ABMW7",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Three vehicles may queue ahead.",
      "Parking for works vehicles on left.",
      "Traffic queues likely ahead.",
      "Steep incline ahead."
    ],
    "correct_answer": 2,
    "explanation": "This roadworks warning sign tells you that there may be traffic queues ahead, possibly due to temporary traffic lights at the works. Proceed with caution.",
    "image_name": "ABMW7.png"
  },
  {
    "index": 246,
    "id": "ABMW8U19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What does this sign mean?",
    "options": [
      "Uneven surface.",
      "Soft margin on left.",
      "Slippery surface.",
      "Parking on left only."
    ],
    "correct_answer": 0,
    "explanation": "This roadworks warning sign tells you that the road surface may be uneven, possibly due to the resurfacing of part of a lane. Proceed with caution.",
    "image_name": "ABMW8U19.png"
  },
  {
    "index": 247,
    "id": "ABMW0405R",
    "section": "Legal Matters/Rules of the Road",
    "question": "How does driving at high speed affect a vehicle's road holding?",
    "options": [
      "The suspension compensates for any unevenness in the road surface.",
      "The wheel alignment keeps the tyres in full contact with the road.",
      "The road holding ability of the vehicle is increased.",
      "The road holding ability of the vehicle is reduced."
    ],
    "correct_answer": 3,
    "explanation": "Driving at high speed is a factor that affects road holding. At higher speeds the airflow under a vehicle reduces tyre grip on the road and when you are approaching a bend or corner, the momentum of the vehicle makes it more difficult to change direction.",
    "image_name": ""
  },
  {
    "index": 248,
    "id": "BW0044RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the maximum number of passengers that may be carried in a vehicle driven by the holder of a Category B driving licence?",
    "options": [
      "7 passengers.",
      "10 passengers.",
      "9 passengers.",
      "8 passengers."
    ],
    "correct_answer": 3,
    "explanation": "The holder of a Category B driving licence is not permitted to drive a vehicle that has seating for more than 8 passengers excluding the driver.",
    "image_name": ""
  },
  {
    "index": 249,
    "id": "BW0045RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When can the holder of a Category W learner permit carry a passenger?",
    "options": [
      "Only when the passenger also holds a Category W driving licence and the vehicle is designed to carry a passenger.",
      "Only when the passenger holds a Category AM driving licence and the vehicle is designed to carry a passenger.",
      "Only when the passenger holds a Category AM driving licence.",
      "Only when the passenger also holds a Category W driving licence."
    ],
    "correct_answer": 0,
    "explanation": "The holder of a Category W learner permit may carry a passenger in the vehicle only if: The vehicle is designed to take a passenger, and the passenger has held a full driving licence in Category W for two or more years.",
    "image_name": ""
  },
  {
    "index": 250,
    "id": "BW0052RU23",
    "section": "Legal Matters/Rules of the Road",
    "question": "When can a child under the age of sixteen drive a tractor on a public road?",
    "options": [
      "A child under 16 is allowed to drive a tractor on a public road when they hold a learner permit.",
      "A child under 16 is allowed to drive a tractor on a public road when accompanied by a fully licensed driver.",
      "Children under 16 are not allowed to drive a tractor on a public road."
    ],
    "correct_answer": 2,
    "explanation": "Persons under 16 years of age are not permitted to drive a tractor in a public place.",
    "image_name": ""
  },
  {
    "index": 251,
    "id": "BW0037R",
    "section": "Legal Matters/Rules of the Road",
    "question": "Where should L plates be displayed on cars?",
    "options": [
      "On the rear only.",
      "On the driver's side only.",
      "On the front only.",
      "Both front and rear."
    ],
    "correct_answer": 3,
    "explanation": "The holder of a learner permit must display L plates on the front and rear of their car at all times when driving on public roads.",
    "image_name": ""
  },
  {
    "index": 252,
    "id": "BW0039RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "How would a driver calculate the maximum overall permitted weight of their vehicle?",
    "options": [
      "By checking the unladen weight of the vehicle.",
      "By adding the unladen weight of the vehicle to the load permitted to be carried.",
      "By checking the weight of the load which may be carried.",
      "By calculating the unladen weight of the vehicle plus the weight of the fuel."
    ],
    "correct_answer": 1,
    "explanation": "The maximum permitted weight of a vehicle is the sum of the unladen weight of the vehicle plus the maximum load that may be carried in it. It is an offence to overload a vehicle, as it reduces your ability to control it effectively.",
    "image_name": ""
  },
  {
    "index": 253,
    "id": "BW0040RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the Maximum Authorised Mass (MAM) of a car that may be driven by the holder of a Category B driving licence?",
    "options": [
      "3,500 kilograms.",
      "4,000 kilograms.",
      "3,750 kilograms.",
      "3,000 kilograms."
    ],
    "correct_answer": 0,
    "explanation": "The holder of a Category B driving licence is not permitted to drive a vehicle with a MAM of more than 3,500 kg. This restriction is noted on the licence.",
    "image_name": ""
  },
  {
    "index": 254,
    "id": "BW0582R",
    "section": "Legal Matters/Rules of the Road",
    "question": "What is the maximum gross weight of a vehicle that may be driven by the holder of a Category B driving licence?",
    "options": [
      "3,450 kilograms",
      "3,000 kilograms",
      "3,250 kilograms",
      "3,500 kilograms"
    ],
    "correct_answer": 3,
    "explanation": "The holder of a Category B driving licence is not permitted to drive a vehicle with a design gross vehicle weight of more than 3,500 kg. This restriction is noted on the licence.",
    "image_name": ""
  },
  {
    "index": 255,
    "id": "BW0085RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "Is a driver allowed to use rebated (green) diesel fuel in a car on a public road?",
    "options": [
      "Green diesel may never be used in a car.",
      "Green diesel may be used in a car only if the car is a taxis.",
      "Green diesel may be used in a car only in summer months.",
      "Green diesel may be used in a car only in winter months."
    ],
    "correct_answer": 0,
    "explanation": "If, in its normal use, a vehicle is used on a public road, it must use unmarked (white) diesel, as the appropriate excise duties are included in the purchase price. Drivers can be prosecuted for using green diesel in a vehicle on a public road.",
    "image_name": ""
  },
  {
    "index": 256,
    "id": "RSA225298",
    "section": "Legal Matters/Rules of the Road",
    "question": "What should a driver check when parking their vehicle?",
    "options": [
      "That the roadway is adequately lit.",
      "That the vehicle is at least 15 centimetres from the kerb.",
      "That they comply with mandatory road markings and signs."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should ensure when parking their vehicle on a roadway that they comply with all relevant road markings and road signs posted, e.g. a driver should not park opposite a continuous white line.",
    "image_name": ""
  },
  {
    "index": 257,
    "id": "BW0087RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "When must a tractor or works vehicle be fitted with a rear-view mirror?",
    "options": [
      "A rear-view mirror must be fitted only when towing a trailer.",
      "A rear-view mirror must always be fitted.",
      "A rear-view mirror must be fitted only when towing a trailer over 8 metres long.",
      "A rear-view mirror is not required in a tractor or works vehicle."
    ],
    "correct_answer": 1,
    "explanation": "All vehicles used on a public road must have a rear-view mirror. The mirror should be used to enable the driver to see the traffic and road conditions behind and to each side.",
    "image_name": ""
  },
  {
    "index": 258,
    "id": "RSA225233",
    "section": "Legal Matters/Rules of the Road",
    "question": "What distance after a pedestrian crossing can a driver park to make a delivery?",
    "options": [
      "10 metres",
      "15 metres",
      "5 metres"
    ],
    "correct_answer": 2,
    "explanation": "Make sure you do not interfere with normal traffic flow and that your vehicle does not disturb, block or endanger other road users. A driver must not park 15 metres before or 5 metres after a pedestrian crossing or traffic lights.",
    "image_name": ""
  },
  {
    "index": 259,
    "id": "RSA225291",
    "section": "Legal Matters/Rules of the Road",
    "question": "What lights are recommended to be used when parking or leaving a vehicle for a short period of time on the side of the road at night?",
    "options": [
      "Front and rear side lights to alert other road users to the vehicle's presence.",
      "Front dipped headlights in order to alert other road users to the vehicle's location.",
      "Rear fog lights in order to alert other road users to the vehicle's size."
    ],
    "correct_answer": 0,
    "explanation": "Drivers can quickly become dazzled and disorientated by headlights or fog lights of parked vehicles. If you need to have lights on in these circumstances, you should use only side or parking lights. You should not leave headlights on when parked.",
    "image_name": ""
  },
  {
    "index": 260,
    "id": "BW0046RU19",
    "section": "Legal Matters/Rules of the Road",
    "question": "A driver has stalled in the middle of an unguarded level crossing and cannot restart the engine. The warning bell is ringing. What should the driver do?",
    "options": [
      "Stay at the vehicle and warn the approaching train.",
      "Push the vehicle clear of the crossing.",
      "Walk clear of the crossing and phone the signal operator so that trains can be stopped.",
      "Try to restart the engine in first gear."
    ],
    "correct_answer": 2,
    "explanation": "In this situation, the driver and all passengers should get out of the vehicle and immediately use the emergency phone at the crossing to contact the signal operator so that trains can be stopped. If necessary, warn other motorists. Do not return to the vehicle until instructed by the signal operator or emergency services.",
    "image_name": ""
  },
  {
    "index": 261,
    "id": "ABMW0430RU19",
    "section": "Managing Risk",
    "question": "What effect does carrying a load have on a vehicle's braking ability?",
    "options": [
      "It has no effect provided the brakes are good.",
      "It increases the efficiency of the brakes.",
      "It increases the distance required to stop.",
      "It reduces the distance required to stop."
    ],
    "correct_answer": 2,
    "explanation": "When driving a vehicle which is carrying a load, the driver should be aware that the forces acting on the vehicle will increase the distance required to stop. The driver should allow for this by increasing the distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 262,
    "id": "ABMW0434RU19",
    "section": "Managing Risk",
    "question": "What effect does towing a loaded trailer have on stopping ability?",
    "options": [
      "It reduces the stopping distance.",
      "It increases the stopping distance.",
      "It increases the efficiency of the brakes.",
      "It has no effect on stopping distance."
    ],
    "correct_answer": 1,
    "explanation": "If you are towing a loaded trailer, you need to be aware that your braking distance could be considerably greater, depending on the weight and size of the trailer. The driver should allow for this by increasing the distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 263,
    "id": "ABMW0611RU19",
    "section": "Managing Risk",
    "question": "What should a driver do when involved in an incident where nobody is injured but the vehicles are causing a danger or obstruction on the road?",
    "options": [
      "Move all passengers and put a red warning triangle on the road.",
      "Take care when moving damaged vehicles and make every effort to warn other traffic.",
      "Halt all traffic until it has been established who is at fault.",
      "Wait for the Gardaí to arrive before moving the vehicles."
    ],
    "correct_answer": 1,
    "explanation": "In a collision where nobody is injured and there is only minor damage to vehicles, the vehicles should be moved to the side of the road to ensure that they do not cause an obstruction or endanger other road users.",
    "image_name": ""
  },
  {
    "index": 264,
    "id": "ABMW0615RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if involved in an incident where there is damage to property only?",
    "options": [
      "Report the incident both to the property owner and the Gardaí within 48 hours.",
      "It is only necessary to report the incident to the Gardaí within 10 days.",
      "There is no need to report the incident if there is no damage to the vehicle.",
      "It is not necessary to report it to the Gardaí provided it has been reported to the property owner."
    ],
    "correct_answer": 3,
    "explanation": "If the incident causes damage to property only and there is a Garda present, it must be reported to the Garda. If there is no Garda present, the owner or the person in charge of the property must be informed. If neither are present then the relevant information must be provided at a Garda station as soon as possible.",
    "image_name": ""
  },
  {
    "index": 265,
    "id": "ABMW0616RU19",
    "section": "Managing Risk",
    "question": "What should a driver do where a person has been injured in a collision?",
    "options": [
      "Move the vehicles out of the way to avoid causing obstruction.",
      "Move the victim only if there is a risk of fire or further injury.",
      "Move the victim to the side of the road.",
      "Always move the victim and the vehicles."
    ],
    "correct_answer": 1,
    "explanation": "Never move an injured person at the scene of a collision unless there is a risk of fire or further injury. Moving an injured person could add to their injuries. Trained personnel know best how to attend to injured persons. Call the emergency services (on 999 or 112) or make sure that someone else has called them.",
    "image_name": ""
  },
  {
    "index": 266,
    "id": "ABMW0617RU19",
    "section": "Managing Risk",
    "question": "What type of drink should be given to a person who has been injured in a collision?",
    "options": [
      "A hot drink.",
      "A cold drink.",
      "A non-alcoholic drink.",
      "No drink should be given."
    ],
    "correct_answer": 3,
    "explanation": "A person who has been injured in a collision should not be given anything to drink, as this could cause them to choke. Ideally trained personnel should be consulted before attending to an injured person. Call the emergency services (on 999 or 112) or make sure that someone else has called them.",
    "image_name": ""
  },
  {
    "index": 267,
    "id": "ABMW0618RU19",
    "section": "Managing Risk",
    "question": "What should a driver do to assist a person who is unconscious following a collision?",
    "options": [
      "Move the person to the nearest hospital immediately.",
      "Try and get the person to drink something warm.",
      "Try to keep the person warm with a blanket or overcoat.",
      "Raise the person's head and hold it in that position."
    ],
    "correct_answer": 2,
    "explanation": "If a person is unconscious following a collision, a driver should try to keep them warm with a blanket or overcoat until the emergency services arrive. Call the emergency services (on 999 or 112) or make sure that someone else has called  them.",
    "image_name": ""
  },
  {
    "index": 268,
    "id": "ABMW0621RU23",
    "section": "Managing Risk",
    "question": "Who should first be contacted where a person has been injured in a collision?",
    "options": [
      "The emergency services.",
      "The person's relatives.",
      "The injured person's insurance company."
    ],
    "correct_answer": 0,
    "explanation": "Where somebody has been injured in a collision, it is important to call the emergency services immediately on 999 or 112. Trained emergency services personnel know best how to attend to injured persons.",
    "image_name": ""
  },
  {
    "index": 269,
    "id": "ABMW0623RU19",
    "section": "Managing Risk",
    "question": "If a driver is involved in a serious collision with an uninsured motorist, where nobody is injured, who should it be reported to?",
    "options": [
      "The local Motor Taxation Office.",
      "The Irish Insurance Federation.",
      "The driver's insurance company and the Gardaí.",
      "The National Driver Licence Service (NDLS)."
    ],
    "correct_answer": 2,
    "explanation": "If you are involved in a serious collision, you should always report it to the Gardai and to your insurance company.",
    "image_name": ""
  },
  {
    "index": 270,
    "id": "ABMW0624RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if involved in a collision with another vehicle where nobody is injured?",
    "options": [
      "Exchange all relevant details with the other driver.",
      "Submit a written report to the Insurance Bureau of Ireland.",
      "Exchange no details but report the incident to the Gardaí.",
      "Give their name and address only to the other person."
    ],
    "correct_answer": 0,
    "explanation": "If a you are involved in a collision with another vehicle where nobody is injured, you should exchange all the relevant details with the other driver - including name, address, vehicle registration, make and model and all insurance details.",
    "image_name": ""
  },
  {
    "index": 271,
    "id": "ABMW0625RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if they arrive at the scene of a collision involving a vehicle carrying hazardous materials?",
    "options": [
      "Contact the haulage company who own the vehicle.",
      "Try to move the vehicle to a safe place.",
      "Keep well clear and call the emergency services.",
      "Try to prevent any further leakage of hazardous materials before raising the alarm."
    ],
    "correct_answer": 2,
    "explanation": "If a driver arrives at the scene of a collision involving a vehicle carrying hazardous materials, they should keep well clear of the scene. Call the emergency services on 999 or 112 and give them as much information as you can about the marking labels on the vehicle. You should also warn other road users about the danger. Allow the emergency services to do any rescuing.",
    "image_name": ""
  },
  {
    "index": 272,
    "id": "CPC1297U19",
    "section": "Managing Risk",
    "question": "If a vehicle breaks down, where should the driver stop?",
    "options": [
      "In the lane where the problem occurred.",
      "The nearest exit ramp.",
      "As far to the left as possible.",
      "As far to the right as possible."
    ],
    "correct_answer": 2,
    "explanation": "When a vehicle breaks down it is important to move as far in to the left as possible for the convenience of other road users and the safety of the vehicles occupants.",
    "image_name": ""
  },
  {
    "index": 273,
    "id": "CPC1307U19",
    "section": "Managing Risk",
    "question": "What is the quickest way to warn other traffic of a crash?",
    "options": [
      "Place a large object in the centre of the road.",
      "Stand in the road and wave arms.",
      "Call local radio station.",
      "Use hazard lights."
    ],
    "correct_answer": 3,
    "explanation": "If you arrive at the scene of a crash, find a safe place to stop so that you don't endanger yourself or others, warn other road users of the incident by using hazard lights.",
    "image_name": ""
  },
  {
    "index": 274,
    "id": "CPC1316U19",
    "section": "Managing Risk",
    "question": "In order to inform the emergency services of a crash what telephone number should be called?",
    "options": [
      "555",
      "112",
      "199",
      "911"
    ],
    "correct_answer": 1,
    "explanation": "If a driver arrives at or is involved in a crash it may be essential to obtain the assistance of the emergency services as a matter of urgency. The common European emergency number is 112 however in Ireland you may also use 999.",
    "image_name": ""
  },
  {
    "index": 275,
    "id": "CPC1317U19",
    "section": "Managing Risk",
    "question": "When calling for help on an emergency telephone on the motorway, who does the call go to?",
    "options": [
      "National Safety Council.",
      "National Roads Authority.",
      "Road Safety Authority.",
      "The Gardaí."
    ],
    "correct_answer": 3,
    "explanation": "The emergency telephones at the side of a motorway are linked directly to An Garda Siochana in order for them to respond appropriately as soon as possible. The Gardai know precisely the location of each call using these phones.",
    "image_name": ""
  },
  {
    "index": 276,
    "id": "CPC1322U19",
    "section": "Managing Risk",
    "question": "Where an injured person is discovered lying in the road, when should they be moved?",
    "options": [
      "If the person is cold.",
      "If the person has broken bones.",
      "If the person needs CPR.",
      "If the person is bleeding."
    ],
    "correct_answer": 2,
    "explanation": "If a person discovered lying in the road is not breathing, it may be essential to move them in order to safely carry out emergency CPR. It may also be necessary to move them under other circumstances but an urgent assessment of the situation should  be carried out first.",
    "image_name": ""
  },
  {
    "index": 277,
    "id": "CPC1324U19",
    "section": "Managing Risk",
    "question": "When dealing with crash victims, remember A B C. What does A stand for?",
    "options": [
      "Assist.",
      "Accident.",
      "Arms.",
      "Airway."
    ],
    "correct_answer": 3,
    "explanation": "In assessing a crash victim's vital signs, the following basic procedure should be used: First check the victim's Airway is clear, then check they are Breathing and then check their Circulation (ABC).",
    "image_name": ""
  },
  {
    "index": 278,
    "id": "CPC1329U19",
    "section": "Managing Risk",
    "question": "What is good basic first aid for a person who has been burned?",
    "options": [
      "Remove clothing covering the burn.",
      "Apply warm water to the burn.",
      "Apply grease to the burn.",
      "Apply cold water to the burn."
    ],
    "correct_answer": 3,
    "explanation": "When a person has been burned firstly check the person for shock, then try to cool the burn if you can. Try to find water or other liquid that is clean, cold and non-toxic to pour on it. The cool liquid may cool the affected area down and reduce damage. The person should be advised to seek medical advice as soon as possible.",
    "image_name": ""
  },
  {
    "index": 279,
    "id": "ABMW0633RU19",
    "section": "Managing Risk",
    "question": "Why is it important to ensure that the vehicle headlights are correctly aligned?",
    "options": [
      "To enable the driver to see properly.",
      "To increase the lifespan of the headlights.",
      "To enable the driver to drive faster in the dark.",
      "To reduce battery consumption."
    ],
    "correct_answer": 0,
    "explanation": "A driver should ensure their headlights are properly aligned so as not to dazzle oncoming drivers and also to see properly themselves.",
    "image_name": ""
  },
  {
    "index": 280,
    "id": "ABMW0635R",
    "section": "Managing Risk",
    "question": "What effect could incorrectly aligned headlights have?",
    "options": [
      "They could dazzle oncoming drivers.",
      "They could wear out the bulbs prematurely.",
      "They could cause a fire.",
      "They could reduce battery life."
    ],
    "correct_answer": 0,
    "explanation": "A driver should ensure their headlights are properly aligned so as not to dazzle oncoming drivers and also to see properly themselves.",
    "image_name": ""
  },
  {
    "index": 281,
    "id": "ABMW0636RU19",
    "section": "Managing Risk",
    "question": "In general, how frequently should a vehicle's lights be checked?",
    "options": [
      "At minor service intervals.",
      "Daily before driving.",
      "At major service intervals.",
      "When wintertime approaches."
    ],
    "correct_answer": 1,
    "explanation": "A driver is responsible for their vehicle's roadworthiness and they should check it daily before driving. Among the checks they should make are that all the lights are clean and in working order.",
    "image_name": ""
  },
  {
    "index": 282,
    "id": "ABMW0637RU19",
    "section": "Managing Risk",
    "question": "What effect can a broken lens have on headlights?",
    "options": [
      "It can cause the bulb to overheat.",
      "It can increase the brightness of the beam in the other headlight.",
      "It can reduce and distort the beam.",
      "It can cause other bulbs to blow if not fixed immediately."
    ],
    "correct_answer": 2,
    "explanation": "A driver is responsible for their vehicle's roadworthiness and they should check it at regular intervals. Among the checks they should make are that all the lights are in working order. If they find defects in the lights, such as a broken lens, they should have them repaired or replaced as soon as possible.",
    "image_name": ""
  },
  {
    "index": 283,
    "id": "ABMW0642RU23",
    "section": "Managing Risk",
    "question": "Is it allowed for a vehicle to be driven on a public road when the brake lights are not working?",
    "options": [
      "No, it is never permitted to be driven.",
      "Yes, outside of lighting-up times.",
      "Yes, during lighting-up times.",
      "No, unless driving in a built-up area."
    ],
    "correct_answer": 0,
    "explanation": "A driver must always ensure that their vehicle's brake-lights are clean and working correctly before driving on a public road. Never drive a vehicle when the brake lights are not working properly.",
    "image_name": ""
  },
  {
    "index": 284,
    "id": "ABMW0643RU19",
    "section": "Managing Risk",
    "question": "What does this light mean?",
    "options": [
      "The oil level is too low.",
      "The battery is not charging.",
      "The gear box is over-heating.",
      "The engine is over-heating."
    ],
    "correct_answer": 1,
    "explanation": "If the battery warning light comes on whilst driving, it means there is some kind of problem with the electrical charging system of the vehicle and the battery is not being charged properly. The driver should get this checked by a professional as soon as possible. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": "ABMW0643RU19.png"
  },
  {
    "index": 285,
    "id": "ABMW0644RU19",
    "section": "Managing Risk",
    "question": "What does this light mean?",
    "options": [
      "The headlight beam should be dipped.",
      "The reversing light is switched on.",
      "The high-beam headlights are switched on.",
      "The number plate light is faulty."
    ],
    "correct_answer": 2,
    "explanation": "All vehicles are fitted with warning lights to alert the driver to different things. This light comes on when the full beam headlights are turned on. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": "ABMW0644RU19.png"
  },
  {
    "index": 286,
    "id": "ABMW0645U19",
    "section": "Managing Risk",
    "question": "What does this light mean?",
    "options": [
      "Low battery fluid level.",
      "Low engine oil level.",
      "Low brake fluid level.",
      "Low engine coolant level."
    ],
    "correct_answer": 1,
    "explanation": "If the engine oil warning light comes on, it means that the engine oil level/pressure has dropped. You should not drive the vehicle until the problem is fixed. If the light comes on while driving, pull over and stop in a safe place as soon as possible. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": "ABMW0645U19.png"
  },
  {
    "index": 287,
    "id": "ABMW0646RU19",
    "section": "Managing Risk",
    "question": "What does this light mean?",
    "options": [
      "Directional indicator on.",
      "Brake light bulb blown.",
      "Headlight bulb blown.",
      "Right-hand fog light on."
    ],
    "correct_answer": 0,
    "explanation": "All vehicles are fitted with warning lights to alert you to different things. This light tells you that the directional indicator is on. If this light is still on after you have completed your manoeuvre, cancel it to avoid misleading other road users. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": "ABMW0646RU19.png"
  },
  {
    "index": 288,
    "id": "ABMW0628RU19",
    "section": "Managing Risk",
    "question": "How does the driver know the vehicle's total load-carrying capacity?",
    "options": [
      "By checking the horse power of the engine.",
      "By referring to the vehicle manufacturer's specification.",
      "By counting the number of seats.",
      "By measuring the size of the boot."
    ],
    "correct_answer": 1,
    "explanation": "Design Gross Vehicle Weight is the term used by manufacturers for the weight of the vehicle together with the maximum load it is designed to carry. Drivers must understand the carrying capacity of their vehicle. Overloading your vehicle will make it more difficult to control, and its an offence.",
    "image_name": ""
  },
  {
    "index": 289,
    "id": "ABMW0629U19",
    "section": "Managing Risk",
    "question": "What determines the maximum allowed towing capacity of a vehicle?",
    "options": [
      "The combined weight of the vehicle and its trailer.",
      "The strength of the tow bar.",
      "The manufacturer's specifications.",
      "The size of the tyres on the vehicle."
    ],
    "correct_answer": 2,
    "explanation": "The maximum weight that your vehicle can safely tow is specified by the manufacturer, and is usually set out in the driver's handbook for the vehicle, and in some cases on a plate attached to the vehicle. This is the safe towing limit for the  vehicle and you should not exceed it.",
    "image_name": ""
  },
  {
    "index": 290,
    "id": "ABMW0630U19",
    "section": "Managing Risk",
    "question": "What effect can overloading a vehicle have on its road-holding?",
    "options": [
      "Provided the load is evenly distributed, it improves the stability of the vehicle.",
      "The load can make the vehicle more difficult to control, but only when going downhill.",
      "The load can make the vehicle more difficult to control, but only when reversing.",
      "The load can make the vehicle more difficult to control."
    ],
    "correct_answer": 3,
    "explanation": "Overloading your vehicle will make it more difficult to control. Remember: It's an offence to overload a vehicle.",
    "image_name": ""
  },
  {
    "index": 291,
    "id": "ABMW0631RU19",
    "section": "Managing Risk",
    "question": "What would be the effect of overloading a vehicle with passengers or goods?",
    "options": [
      "It would improve the vehicle's road-holding ability.",
      "Overloading will not reduce the ability to control the vehicle.",
      "It would not have any effect provided speed is reduced.",
      "It would reduce the driver's ability to control the vehicle."
    ],
    "correct_answer": 3,
    "explanation": "Overloading your vehicle will make it more difficult to control, and will increase the risk of a collision.",
    "image_name": ""
  },
  {
    "index": 292,
    "id": "ABMW0632RU19",
    "section": "Managing Risk",
    "question": "What effect could an unevenly distributed load have on a vehicle?",
    "options": [
      "It could cause the clutch to slip while accelerating.",
      "It could make the vehicle unstable while turning.",
      "It could cause the vehicle to overheat.",
      "It could cause the gear box to overheat."
    ],
    "correct_answer": 1,
    "explanation": "When loading a vehicle you should ensure that the load is distributed evenly. An unevenly distributed load may change the vehicle's centre of gravity and this could affect the braking and steering.",
    "image_name": ""
  },
  {
    "index": 293,
    "id": "RSA225187",
    "section": "Managing Risk",
    "question": "What would make a pedestrian more visible to a driver at night?",
    "options": [
      "Wearing a waterproof jacket.",
      "Wearing headphones.",
      "Wearing a hi-vis jacket."
    ],
    "correct_answer": 2,
    "explanation": "Even with the best vehicle headlights, drivers can see less at night than during the day, pedestrians as vulnerable road users are extremely difficult to see in the dark. Wearing reflective clothing makes pedestrians more visible. Pedestrians should always wear bright and hi-vis clothing during the day and reflective clothing at night when walking outside built-up areas.",
    "image_name": ""
  },
  {
    "index": 294,
    "id": "RSA225313",
    "section": "Managing Risk",
    "question": "What is the purpose of daytime running lights on a vehicle?",
    "options": [
      "To illuminate the road in bad weather conditions in daylight hours.",
      "To give the vehicle extra light when driving at night.",
      "To increase the vehicles visibility in daylight hours."
    ],
    "correct_answer": 2,
    "explanation": "Daytime running lights refer to the white lighting systems on the front of a vehicle that automatically come on during daylight hours. The purpose of daytime running lights are to increase the visibility and presence of the vehicle to other road users.",
    "image_name": ""
  },
  {
    "index": 295,
    "id": "ABMW0487RU19",
    "section": "Managing Risk",
    "question": "Which of the following statements is true in relation to tyre pressure and driving on a motorway?",
    "options": [
      "The driver should increase the front tyre pressure in order to cope with sustained high speed.",
      "The driver should increase the rear tyre pressure in order to cope with sustained high speed.",
      "The driver should ensure that tyre pressure is correct, in line with the manufacturer's recommendations.",
      "The driver should reduce tyre pressure because high speeds will cause them to heat up."
    ],
    "correct_answer": 2,
    "explanation": "The driver should ensure that the tyre pressure of their vehicle is correct at all times. Correct tyre pressure is especially important when travelling long distances, on motorways and at speed.",
    "image_name": ""
  },
  {
    "index": 296,
    "id": "ABMW0640RU19",
    "section": "Managing Risk",
    "question": "How would a driver know that a brake-light bulb is not working?",
    "options": [
      "By standing at the rear of the vehicle and checking as another person presses the brake pedal.",
      "They would notice the brake pedal become firmer under pressure.",
      "They would notice the brake pedal getting softer under pressure.",
      "By standing at the rear of the vehicle and getting another person to turn on side lights."
    ],
    "correct_answer": 0,
    "explanation": "In order for a driver to know that the rear brake lights are working correctly, they should stand at the rear of the vehicle and check that the brake lights come on while another person presses the brakes.",
    "image_name": ""
  },
  {
    "index": 297,
    "id": "ABMW0650RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if a system warning light lights up on the dashboard of their vehicle whilst driving?",
    "options": [
      "Carry on and check the problem later.",
      "Stop and check the problem.",
      "Continue to drive and listen for any unusual sounds.",
      "Continue for a distance to see if the light goes out."
    ],
    "correct_answer": 1,
    "explanation": "If a system warning light lights up while you are driving, you should stop in a safe place as soon as possible and investigate the problem before deciding what action to take. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": ""
  },
  {
    "index": 298,
    "id": "ABMW0651RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if a red system warning light lights up on the dashboard of their vehicle?",
    "options": [
      "Continue on and listen for any unusual sounds.",
      "Stop and investigate the cause.",
      "Drive to the nearest garage and have it checked.",
      "Continue on and see if it goes out."
    ],
    "correct_answer": 1,
    "explanation": "If a red system warning light comes on while you are driving, you should stop ina safe place as soon as possible and investigate the problem before deciding what action to take. It is important to understand the meaning of your vehicle's warning lights, information on which can be found in the vehicle's handbook.",
    "image_name": ""
  },
  {
    "index": 299,
    "id": "ABMW0652RU19",
    "section": "Managing Risk",
    "question": "What is the purpose of the red reflectors at the rear of a vehicle?",
    "options": [
      "They warn the driver behind to switch to main beam.",
      "They are a substitute in case of brake-light failure.",
      "They reflect light at night to make other road users aware of the vehicle.",
      "They warn pedestrians of the vehicle's location."
    ],
    "correct_answer": 2,
    "explanation": "Motor vehicles are fitted with red reflectors to make it easier to be seen by other road users. Drivers should keep reflectors clean, intact and check them by shining a light on them to make sure that they are working effectively. Whilst driving, drivers should be cautious as red reflectors may be an indication of both parked/stationery or moving vehicles ahead.",
    "image_name": ""
  },
  {
    "index": 300,
    "id": "ABMW0664RU19",
    "section": "Managing Risk",
    "question": "If, when driving along, the driver notices that the engine power is lower than normal, what should they do?",
    "options": [
      "Switch to a different fuel.",
      "Have the vehicle checked by a competent person.",
      "Adjust the fuel mixture control mechanism.",
      "Replace the engine oil filter."
    ],
    "correct_answer": 1,
    "explanation": "If the driver notices that the vehicle seems underpowered when driving, this could present a number of problems, e.g. lack of power when overtaking. The driver should have it checked by a competent person as soon as possible as there may be a number of causes, some of which may deteriorate further.",
    "image_name": ""
  },
  {
    "index": 301,
    "id": "ABMW0672RU23",
    "section": "Managing Risk",
    "question": "While driving, a driver notices a strong smell of fuel. What should they do?",
    "options": [
      "Drive at a reduced speed.",
      "Stop where safe and investigate.",
      "Turn on the fan to clear the air."
    ],
    "correct_answer": 1,
    "explanation": "A strong smell of fuel is usually an indication that something is wrong, and drivers should stop and investigate as soon as possible. Leaking or spilling petrol can be dangerous because it is so combustible, and leaking diesel fuel can make the road very slippery.",
    "image_name": ""
  },
  {
    "index": 302,
    "id": "ABMW0677RU19",
    "section": "Managing Risk",
    "question": "While driving, the driver notices the vehicle temperature gauge showing red. What should they do?",
    "options": [
      "Remove the filler cap from the radiator and check for leakage.",
      "Do not drive until an anti-waxing agent is added to the coolant.",
      "Stop in a safe place and have the problem investigated.",
      "Drive to the nearest service depot and top-up the water in the radiator."
    ],
    "correct_answer": 2,
    "explanation": "Many vehicles are fitted with various warning lights and gauges. A warning light or a red zone on a temperature gauge means the engine is starting to overheat and the vehicle should not be driven until the problem is rectified. Refer to the vehicle handbook for further information and guidance or seek advice from a competent person.",
    "image_name": ""
  },
  {
    "index": 303,
    "id": "ABMW0678RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if they notice steam rising from the engine compartment?",
    "options": [
      "Increase speed to increase the air flow into the engine compartment.",
      "Remove the filler cap from the coolant bottle.",
      "Stop where safe and investigate the cause.",
      "Top up with anti-freeze immediately."
    ],
    "correct_answer": 2,
    "explanation": "If a driver notices steam rising from the engine compartment of their vehicle, they  should stop where safe and only investigate the cause once it has cooled down. Do not remove a radiator or header tank cap when the engine is hot. Steam rising from the engine is an indication that the engine is overheating and it should not continue to be driven. Refer to the vehicle handbook for further information and guidance or ",
    "image_name": ""
  },
  {
    "index": 304,
    "id": "ABMW0680RU19",
    "section": "Managing Risk",
    "question": "If a driver notices that structural parts of their vehicle's body have been affected by rust, what should they do?",
    "options": [
      "Have paint sprayed over it of the same colour.",
      "Have it repaired by a competent repair shop.",
      "Treat the area with grease and paint over it.",
      "Have it sandpapered and keep the affected area dry."
    ],
    "correct_answer": 1,
    "explanation": "Over time vehicles may become affected by rust to various degrees. Drivers should inspect their vehicles periodically and if they find signs of rust they should have it assessed and repaired if necessary to prevent further deterioration. A weakened vehicle structure may have serious consequences in the event of a collision.",
    "image_name": ""
  },
  {
    "index": 305,
    "id": "ABMW0694RU19",
    "section": "Managing Risk",
    "question": "After changing a wheel on a vehicle, which of the following should be checked soon afterwards?",
    "options": [
      "The air valve.",
      "The wheel nuts.",
      "The brake pad clearance.",
      "The tyre tread depth."
    ],
    "correct_answer": 1,
    "explanation": "After changing a wheel on a vehicle it is recommended to check the wheel nuts after a short period of driving to ensure they are still properly secured.",
    "image_name": ""
  },
  {
    "index": 306,
    "id": "ABMW0696RU19",
    "section": "Managing Risk",
    "question": "In general, how often should a driver check the tyre pressure of a vehicle?",
    "options": [
      "Regularly.",
      "Annually.",
      "Monthly.",
      "Six monthly."
    ],
    "correct_answer": 0,
    "explanation": "Drivers have a legal responsibility to make sure that their vehicle is roadworthy. To do this, they should carry out regular, weekly and periodic checks, including a weekly tyre pressure check. Incorrectly inflated tyres may cause vehicle instability, uneven tyre wear and longer stopping distances.",
    "image_name": ""
  },
  {
    "index": 307,
    "id": "ABMW0697RU19",
    "section": "Managing Risk",
    "question": "What is the main reason for maintaining the correct tyre pressures?",
    "options": [
      "To reduce engine wear.",
      "To help provide optimum road holding.",
      "To help maintain the correct ground clearance.",
      "To stop the vehicle from sloping to the left."
    ],
    "correct_answer": 1,
    "explanation": "The vehicle manufacturer specifies the pressure to which tyres on a vehicle should be inflated. This is the pressure that gives the best performance in road holding, efficient braking and fuel consumption. Some manufacturers specify different pressures for front and rear tyres.",
    "image_name": ""
  },
  {
    "index": 308,
    "id": "ABMW0698RU19",
    "section": "Managing Risk",
    "question": "A fault in which component may lead to uneven or excessive tyre wear?",
    "options": [
      "Accelerator.",
      "Clutch.",
      "Gearbox.",
      "Suspension."
    ],
    "correct_answer": 3,
    "explanation": "If a vehicle has a worn suspension it may lead to uneven or excessive tyre wear. If drivers notice that their tyres are unevenly worn, they should investigate the reason and have it repaired by a competent person.",
    "image_name": ""
  },
  {
    "index": 309,
    "id": "ABMW0699RU19",
    "section": "Managing Risk",
    "question": "What can be affected by driving on under-inflated tyres?",
    "options": [
      "The coolant system.",
      "Oil pressure.",
      "Fuel consumption.",
      "The exhaust system."
    ],
    "correct_answer": 2,
    "explanation": "Incorrect tyre pressure adversely affects many of a vehicle's systems, including brakes, suspension and steering. In particular, under-inflated tyres can increase the vehicle's fuel consumption. Check tyre pressures regularly and ensure they are inflated as per manufacturer's recommendations.",
    "image_name": ""
  },
  {
    "index": 310,
    "id": "ABMW0700RU19",
    "section": "Managing Risk",
    "question": "When should tyre pressure be checked?",
    "options": [
      "When the tyres are hot.",
      "When the tyres are part-worn.",
      "When the tyres are cold.",
      "At service intervals only."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should check the tyre pressure in their vehicle at least once a week and before commencing a long journey. For accuracy, do this when the tyres are cold and using a reliable gauge. Tyres should always be inflated according to the vehicle manufacturer's guidelines, information on which can be found in the vehicle handbook.",
    "image_name": ""
  },
  {
    "index": 311,
    "id": "ABMW0702RU19",
    "section": "Managing Risk",
    "question": "During a weekly check, a driver notices a badly worn front tyre. What should the driver do?",
    "options": [
      "Reduce speed when driving on wet roads.",
      "Check the tyre pressure to ensure it remains constant.",
      "Have the worn tyre replaced.",
      "Fit the worn tyre on one of the rear wheels."
    ],
    "correct_answer": 2,
    "explanation": "The tyres are the vehicle's only contact with the road, the area of contact is small and, if worn, will not grip properly and safely. The quality of the tyres on a vehicle is an important factor in the vehicle's road holding and braking ability. Drivers should check their tyres regularly and if they notice that a tyre is badly worn, they should replace it immediately. Whilst the minimum legal tread depth for tyres on most ",
    "image_name": ""
  },
  {
    "index": 312,
    "id": "ABMW0703RU19",
    "section": "Managing Risk",
    "question": "What effect could hitting or mounting the kerb have on a vehicle's tyres?",
    "options": [
      "It could damage the sidewalls.",
      "It could strengthen the sidewalls.",
      "It could increase the air pressure.",
      "It could wear the tread."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should avoid hitting or mounting the kerb as it causes damage to the sidewalls of the tyre. The damage caused could cause the tyre to blow-out later. If this happens at high speed the driver may lose control of the vehicle with dangerous consequences.",
    "image_name": ""
  },
  {
    "index": 313,
    "id": "ABMW0704RU19",
    "section": "Managing Risk",
    "question": "What does worn tread along the edge of the inside of a tyre suggest?",
    "options": [
      "The vehicle has been driven too fast around corners.",
      "Air pressure is low.",
      "Air pressure is high.",
      "Steering alignment may be faulty."
    ],
    "correct_answer": 3,
    "explanation": "If a driver notices the inside edge of the tyre is worn, this may indicate a problem with the steering alignment. This is a potentially dangerous problem, and should be fixed by a competent person as soon as possible. Failure to do so may result in a blow-out and loss of control of the vehicle.",
    "image_name": ""
  },
  {
    "index": 314,
    "id": "ABMW0706RU19",
    "section": "Managing Risk",
    "question": "With regard to tyres, what should a driver do before starting a long journey?",
    "options": [
      "Increase the air pressure in the tyres.",
      "Check the tyres are inflated to normal air pressure.",
      "Reduce the air pressure in the tyres.",
      "Reduce front tyre air pressure and increase rear tyre air pressure."
    ],
    "correct_answer": 1,
    "explanation": "It is important to check the tyre pressure before starting a long journey as incorrect air pressure can adversely affect many of the vehicle's systems, including brakes, steering, suspension and fuel consumption. Tyres should always be inflated according to the vehicle manufacturer's guidelines, information on which can be found in the vehicle handbook.",
    "image_name": ""
  },
  {
    "index": 315,
    "id": "ABMW0707RU23",
    "section": "Managing Risk",
    "question": "Under what circumstances would a driver increase the air pressure in the tyres?",
    "options": [
      "When taking a journey with additional passengers.",
      "When the tread depth on the tyres is below 2 mm.",
      "When higher speeds are expected on motorway driving.",
      "When the journey exceeds 200 km."
    ],
    "correct_answer": 0,
    "explanation": "Before starting a journey with extra passengers or loads, drivers should check the air pressure and when they inflate the tyres, they should increase the vehicle's tyre pressures in accordance with the vehicle manufacturer's recommended tyre pressure. This information can be found in the vehicle manufacturer's handbook.",
    "image_name": ""
  },
  {
    "index": 316,
    "id": "ABMW0714RU19",
    "section": "Managing Risk",
    "question": "What is the most common cause of heavy steering?",
    "options": [
      "Poorly oiled steering.",
      "Over-inflated tyres.",
      "Under-inflated tyres.",
      "Badly worn brakes."
    ],
    "correct_answer": 2,
    "explanation": "Heavy steering is when a driver needs to use more effort than usual to turn the steering wheel, this may be as a direct result of under-inflated tyres. Check your tyre pressures but be aware there may be other causes of heavy steering such as low power steering fluid level. Seek advice from a competent person and have this investigated immediately.",
    "image_name": ""
  },
  {
    "index": 317,
    "id": "ABMW0262RU23",
    "section": "Managing Risk",
    "question": "Why might it be dangerous to drive on a poorly-lit street?",
    "options": [
      "Drivers can only see the traffic in front of them.",
      "Pedestrians crossing in a dark area might be difficult to see.",
      "Drivers can only see the traffic coming against them."
    ],
    "correct_answer": 1,
    "explanation": "When you are driving along a poorly-lit street, you should take extra care - vulnerable road users such as pedestrians might not be so easy to see. You should always be prepared to react to a change in the traffic situation.",
    "image_name": "ABMW0262RU23.png"
  },
  {
    "index": 318,
    "id": "BW0051RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if their vehicle breaks down on an automatic railway level crossing?",
    "options": [
      "Get passengers clear of the crossing and phone the signal operator so that trains can be stopped.",
      "Turn on the warning bells at the crossing.",
      "Try to push the vehicle clear of the crossing as soon as possible.",
      "Walk along the track to give warning to any approaching trains."
    ],
    "correct_answer": 0,
    "explanation": "In this situation, you and all passengers should get out of the vehicle and immediately use the emergency phone at the crossing to contact the signal operator so that trains can be stopped. If necessary, warn other motorists. Do not return to the vehicle until instructed by the signal operator or emergency services.",
    "image_name": ""
  },
  {
    "index": 319,
    "id": "BW0053U23",
    "section": "Managing Risk",
    "question": "What is the immediate effect of a head-on collision between two cars at speed?",
    "options": [
      "All persons in each vehicle are thrown violently backwards only.",
      "Only front seatbelts will activate.",
      "All persons in each vehicle are thrown violently forward."
    ],
    "correct_answer": 2,
    "explanation": "In a head-on collision passengers in both vehicles are propelled forwards, and if they are not wearing seatbelts they may go through the windscreen. It is the driver's responsibility to ensure that all passengers under the age of 17 wear seatbelts. Older passengers are themselves responsible for wearing seatbelts.",
    "image_name": ""
  },
  {
    "index": 320,
    "id": "BW0073RU19",
    "section": "Managing Risk",
    "question": "When should a driver use their hazard warning lights?",
    "options": [
      "When the vehicle has broken down.",
      "When parking for a short time on a single yellow line.",
      "When the brake lights are not working.",
      "When about to pull in and stop."
    ],
    "correct_answer": 0,
    "explanation": "Use the hazard warning lights to warn other road users of a danger ahead. For example, if a driver's vehicle has broken down and is stopped on the hard shoulder, they should use the vehicle's hazard warning lights to warn other road users of their  presence.",
    "image_name": ""
  },
  {
    "index": 321,
    "id": "BW0075RU19",
    "section": "Managing Risk",
    "question": "When should a driver use their vehicle's hazard warning lights?",
    "options": [
      "When causing an unavoidable obstruction.",
      "When double parking.",
      "When the brake lights are not working.",
      "When a following vehicle is too close."
    ],
    "correct_answer": 0,
    "explanation": "Use the hazard warning lights to warn other road users of a danger ahead. For example, if a driver's vehicle is causing an unavoidable obstruction such as being broken down, they should use the vehicle's hazard warning lights to warn other road users of their presence.",
    "image_name": ""
  },
  {
    "index": 322,
    "id": "BW0076RU19",
    "section": "Managing Risk",
    "question": "When should a driver use their vehicle's hazard warning lights?",
    "options": [
      "When parked at a bend or corner.",
      "When broken down and causing an obstruction.",
      "When reversing onto a narrow road.",
      "When moving slowly in traffic."
    ],
    "correct_answer": 1,
    "explanation": "Use the hazard warning lights to warn other road users of a danger ahead. For example, if a driver's vehicle is causing an unavoidable obstruction such as being broken down, they should use the vehicle's hazard warning lights to warn other road users of their presence.",
    "image_name": ""
  },
  {
    "index": 323,
    "id": "BW0099RU19",
    "section": "Managing Risk",
    "question": "When a wiper blade fails to clear the windscreen what should the driver do?",
    "options": [
      "Have the wiper blades replaced as soon as possible.",
      "Bend the wiper arm to apply more pressure on the windscreen.",
      "Switch the wiper control from high speed to low speed repeatedly.",
      "Apply a light film of oil to both of the wiper blades."
    ],
    "correct_answer": 0,
    "explanation": "Use the windscreen wipers to keep the windscreen clear of rain, spray, snow or fog. Check them regularly to ensure that they are in good working order, and replace them when they become worn, before they become ineffective.",
    "image_name": ""
  },
  {
    "index": 324,
    "id": "BW0112U19",
    "section": "Managing Risk",
    "question": "If a vehicle breaks down on a motorway, what should a person do?",
    "options": [
      "Turn on the full beam headlights to alert other drivers.",
      "Ask a passenger to stand on the road to warn other traffic.",
      "Use a roadside phone to contact Gardaí and never try to carry out repairs yourself.",
      "Place a red warning triangle on the motorway to warn other drivers."
    ],
    "correct_answer": 2,
    "explanation": "When a vehicle breaks down on a motorway, a driver should move the vehicle to the hard shoulder, use the roadside phone to contact the Gardai, and do not place a warning device on the motorway. The driver should never try to do repairs themselves in the hard shoulder.",
    "image_name": ""
  },
  {
    "index": 325,
    "id": "BW1U19",
    "section": "Managing Risk",
    "question": "On a motorway, when should a driver use the hazard warning lights?",
    "options": [
      "When another vehicle is following too closely.",
      "When towing another vehicle.",
      "When parked in the hard shoulder to take a phone call.",
      "When the vehicle has broken down."
    ],
    "correct_answer": 3,
    "explanation": "Use the hazard warning lights to warn other road users of a danger ahead. For example, if your vehicle has broken down and is stopped on the hard shoulder, you can use the hazard warning lights to warn following vehicles of your presence.",
    "image_name": ""
  },
  {
    "index": 326,
    "id": "BW3U19",
    "section": "Managing Risk",
    "question": "If a vehicle breaks down on a motorway, what should a person do?",
    "options": [
      "Move the vehicle to the hard shoulder.",
      "Ask a passenger to stand on the motorway to warn other traffic.",
      "Turn on the full beam headlights.",
      "Place a red warning triangle to the left of the vehicle."
    ],
    "correct_answer": 0,
    "explanation": "Move the vehicle to the hard shoulder. Park as near to the left as possible. If this is not possible, take steps to warn other drivers, such as switching on the hazard warning lights.",
    "image_name": ""
  },
  {
    "index": 327,
    "id": "BW4U19",
    "section": "Managing Risk",
    "question": "If a vehicle breaks down on a motorway, what should a person do?",
    "options": [
      "Turn on the full beam headlights.",
      "Place a red warning triangle to the left of the vehicle.",
      "Wear a high-visibility vest.",
      "Ask a passenger to stand on the motorway to warn other traffic."
    ],
    "correct_answer": 2,
    "explanation": "Move the vehicle to the hard shoulder. Park as near to the left as possible. If this is not possible, take steps to warn other drivers, such as switching on the hazard warning lights. Wear a high-visibility vest. Always carry at least two in the vehicle.",
    "image_name": ""
  },
  {
    "index": 328,
    "id": "ABMW0638RU19",
    "section": "Managing Risk",
    "question": "A driver wishes to drive at night, but the offside (right-hand side) headlight bulb is blown. What should the driver do?",
    "options": [
      "Replace it temporarily with the brake-light bulb.",
      "Drive with the hazard lights on.",
      "Not drive until the bulb is replaced.",
      "Replace it temporarily with the nearside (left-hand side) bulb."
    ],
    "correct_answer": 2,
    "explanation": "A driver is responsible for their vehicle's roadworthiness and they should check it at regular intervals. Drivers must not drive on the road unless their vehicle's headlights are in good working order, adjusted properly and clean.",
    "image_name": ""
  },
  {
    "index": 329,
    "id": "BW0028RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if the right-hand headlight bulb fails when driving at night?",
    "options": [
      "Drive with the hazard lights on.",
      "Replace it temporarily with the left-hand headlight bulb.",
      "Have the bulb replaced immediately.",
      "Replace it temporarily with the brake light bulb."
    ],
    "correct_answer": 2,
    "explanation": "Vehicles (except motorcycles) are required by law to have right and left headlights. Faulty lights should be repaired immediately. A vehicle with only one headlight can cause a hazard to other road users or be mistaken for a motorcycle.",
    "image_name": ""
  },
  {
    "index": 330,
    "id": "BW0032U19",
    "section": "Managing Risk",
    "question": "Generally what lighting must a car, tractor or works vehicle have when driving?",
    "options": [
      "Headlights, front and rear side lights, rear number plate light, red rear reflectors, brake lights and indicators.",
      "Headlights, brake lights and indicators only.",
      "Headlights, number plate and rear reflectors only.",
      "Headlights and a reversing light."
    ],
    "correct_answer": 0,
    "explanation": "In general all cars, tractors and works vehicles are required by law to have headlights, front and rear side lights, rear number plate light, rear reflectors, brake lights and indicators. There are some exceptions to this, such as electric cars with a maximum speed of 38 km/h.",
    "image_name": ""
  },
  {
    "index": 331,
    "id": "BW0072RU19",
    "section": "Managing Risk",
    "question": "What effect do the hazard warning lights have on the brake lights?",
    "options": [
      "They cause the brake lights to switch off completely.",
      "They cause the brake lights to flash repeatedly.",
      "They have no effect.",
      "They cause the left and right brake lights to flash alternately."
    ],
    "correct_answer": 2,
    "explanation": "The hazard lights work independently of the other lights on the vehicle (except the direction indicators), and have no effect on the brake lights. Use the hazard warning lights to warn other road users of a danger ahead, when your vehicle is broken down and causing an obstruction, or when you needs to slow down sharply ona motorway.",
    "image_name": ""
  },
  {
    "index": 332,
    "id": "BW0077RU19",
    "section": "Managing Risk",
    "question": "What lighting must be on a two-axle car-trailer?",
    "options": [
      "Indicators and rear number plate lights only.",
      "Brake lights and indicators only.",
      "Flashing rear tail lights.",
      "Indicators, brake lights, rear number plate light, red reflectors and rear tail lights."
    ],
    "correct_answer": 3,
    "explanation": "All vehicles, including trailers, must have rear indicators, brake lights, a rear number plate light, red reflectors and rear tail lights.",
    "image_name": ""
  },
  {
    "index": 333,
    "id": "BW0078U19",
    "section": "Managing Risk",
    "question": "What lighting must be on a tractors trailer during lighting-up hours?",
    "options": [
      "Brake lights and indicators only.",
      "An unloading light.",
      "Indicators, brake lights, rear number plate light, red reflectors and rear tail lights.",
      "Indicators, two white or yellow headlamps and rear number plate lights only."
    ],
    "correct_answer": 2,
    "explanation": "A trailer being towed by a tractor must have rear indicators, brake lights, a rear number plate light, red reflectors and rear tail lights whilst being towed on a public road.",
    "image_name": ""
  },
  {
    "index": 334,
    "id": "BW0034RU19",
    "section": "Managing Risk",
    "question": "What danger could be associated with driving a tractor and trailer over a humpbacked bridge?",
    "options": [
      "The trailer could jack-knife.",
      "The trailer could become detached.",
      "The tractor's suspension could smooth out the bump.",
      "The trailer's parking brake could automatically engage."
    ],
    "correct_answer": 1,
    "explanation": "Before towing a trailer, a driver should ensure that the tow hitch has sufficient ground clearance. If this hits the road, for example when travelling over a humpbacked bridge, there is a danger that the trailer will become detached. Drivers should also plan and carry out their journey with an awareness of this risk.",
    "image_name": ""
  },
  {
    "index": 335,
    "id": "BW0057R",
    "section": "Managing Risk",
    "question": "What should a driver do when requested to drive a vehicle that they feel is overloaded?",
    "options": [
      "Refuse to drive the vehicle.",
      "Drive at a slower speed than normal.",
      "Drive the vehicle only if accompanied.",
      "Ensure that the load is properly restrained."
    ],
    "correct_answer": 0,
    "explanation": "You should not take a vehicle that you believe to be overloaded onto a public road. Overloading is dangerous, as it affects the stability and braking capabilities of the vehicle.",
    "image_name": ""
  },
  {
    "index": 336,
    "id": "BWOO58R",
    "section": "Managing Risk",
    "question": "How could towing an overloaded trailer affect a vehicle?",
    "options": [
      "It could improve braking ability when going downhill.",
      "It could impair the vehicle's steering and braking.",
      "It could improve the vehicle's fuel consumption.",
      "It could improve road holding on bends."
    ],
    "correct_answer": 1,
    "explanation": "You should not take an overloaded trailer onto a public road. An overloaded trailer impairs the stability, steering and braking of the towing vehicle.",
    "image_name": ""
  },
  {
    "index": 337,
    "id": "BW0091",
    "section": "Managing Risk",
    "question": "What does the load index of a tyre indicate?",
    "options": [
      "The maximum load a tyre can carry.",
      "The maximum air pressure of the tyre.",
      "The maximum load per axle.",
      "The maximum load of the vehicle."
    ],
    "correct_answer": 0,
    "explanation": "The load index indicates the maximum weight that a tyre can support safely. When replacing a tyre on your vehicle, you should make sure that the new tyre maintains the proper load index for the vehicle.",
    "image_name": ""
  },
  {
    "index": 338,
    "id": "BW0005RU19",
    "section": "Managing Risk",
    "question": "What should a driver do before towing a caravan?",
    "options": [
      "Ensure all passengers are securely seated in the caravan.",
      "Have extended mirrors fitted to the towing vehicle.",
      "Have an extended mirror fitted to the driver's side of the vehicle only.",
      "Ensure that only adult passengers are seated in the caravan."
    ],
    "correct_answer": 1,
    "explanation": "If a driver intends towing a caravan, they should fit extended mirrors to both sides of the towing vehicle. This will allow the driver to better observe the traffic situation behind and to the sides.",
    "image_name": ""
  },
  {
    "index": 339,
    "id": "BW0010RU19",
    "section": "Managing Risk",
    "question": "What should a driver do if condensation is affecting the vehicle's windows?",
    "options": [
      "Dry the windows with a cloth and then use the demister system.",
      "Drive for a few kilometres with a window open.",
      "Make sure that all demister vents and windows are closed.",
      "Wipe the windows with the back of the hand."
    ],
    "correct_answer": 0,
    "explanation": "Make sure the windows are clear and clean at all times so that the driver can see the road and traffic conditions all around. Condensation on the window can seriously impair your ability to make proper observations. Drivers should familiarise themselves with how to correctly set the vehicle's ventilation system in order to keep the windows clear.",
    "image_name": ""
  },
  {
    "index": 340,
    "id": "BW0011RU23",
    "section": "Managing Risk",
    "question": "How can sunlight affect visibility in a car with dirty windows?",
    "options": [
      "It can seriously reduce visibility.",
      "It can cause objects to seem further away than they are.",
      "It can enhance visibility.",
      "It can cause objects to seem closer than they are."
    ],
    "correct_answer": 0,
    "explanation": "It is essential that all vehicle windows are clear and clean at all times so that drivers can see road and traffic conditions all around. Dirty windows are a particular hazard when the sun is low in the sky. Dirty windows also decrease visibility during hours of  twilight and darkness.",
    "image_name": ""
  },
  {
    "index": 341,
    "id": "BWO055R",
    "section": "Managing Risk",
    "question": "When changing a wheel on a public road, what should a person do to ensure their own safety?",
    "options": [
      "Ensure the vehicle is in reverse gear and front wheels are facing the roadway.",
      "Ask a bystander to warn traffic by beckoning them from the middle of the road.",
      "Ensure the vehicle is in first gear and the wheels are facing the roadway.",
      "Wear reflective clothing and switch on the vehicle hazard warning lights."
    ],
    "correct_answer": 3,
    "explanation": "When changing a wheel at the side of the road, switch on the vehicle hazard warning lights, and wear reflective or light-coloured clothing. This will help other motorists to react and slow down when passing.",
    "image_name": ""
  },
  {
    "index": 342,
    "id": "BW0086RU19",
    "section": "Managing Risk",
    "question": "What should a driver do to reduce the risk of neck injury in the event of a rear-end collision?",
    "options": [
      "Use a properly adjusted head restraint.",
      "Ensure the vehicle has a rear spoiler.",
      "Ensure the vehicle has anti-lock brakes.",
      "Use a properly adjusted seat belt."
    ],
    "correct_answer": 0,
    "explanation": "It is essential that head restraints be properly adjusted for both the driver and the passengers. Head restraints are designed to protect the neck and spine in a collision and thus prevent or reduce whiplash. If head restraints are not properly adjusted there is an increased risk to the vehicles occupants.",
    "image_name": ""
  },
  {
    "index": 343,
    "id": "BW0118RU23",
    "section": "Managing Risk",
    "question": "Where safety belts are fitted to a car when must adult occupants wear them?",
    "options": [
      "At all times.",
      "When travelling on long journeys.",
      "Only when instructed to do so by the driver."
    ],
    "correct_answer": 0,
    "explanation": "The driver and all passengers in a car must wear a safety belt or, in the case of a child, a suitable restraint system.",
    "image_name": ""
  },
  {
    "index": 344,
    "id": "BW0121RU19",
    "section": "Managing Risk",
    "question": "Who is responsible for ensuring that a passenger over 17 years of age is wearing a seat belt while travelling in a car?",
    "options": [
      "Both the driver and the passenger.",
      "The passenger only.",
      "The driver when the passenger is in the front seat.",
      "The driver only."
    ],
    "correct_answer": 1,
    "explanation": "Where the passenger is over the age of 17 and travelling in a car it is their legal responsibility to comply with the seat belt regulations. Below that age, it is the driver's responsibility.",
    "image_name": ""
  },
  {
    "index": 345,
    "id": "BW0122RU19",
    "section": "Managing Risk",
    "question": "Who is responsible for ensuring that a passenger under 17 years of age is wearing a seat belt while travelling in a car?",
    "options": [
      "The passenger only.",
      "The driver, but only when the passenger is in the front seat.",
      "The passenger's parents.",
      "The driver only."
    ],
    "correct_answer": 3,
    "explanation": "Where the passenger is over the age of 17 and travelling in a car it is their legal responsibility to comply with the seat belt regulations. Below that age, it is the driver's responsibility.",
    "image_name": ""
  },
  {
    "index": 346,
    "id": "BW0123AU19",
    "section": "Managing Risk",
    "question": "Who is responsible for ensuring that a child wears a child restraint system in a vehicle?",
    "options": [
      "The driver only.",
      "Any adult passenger.",
      "The parents of the child only.",
      "The child, if over 12 years of age."
    ],
    "correct_answer": 0,
    "explanation": "Where the passenger is over the age of 17 and travelling in a car it is their legal responsibility to comply with the child restraint regulations. Below that age, it is the driver's responsibility.",
    "image_name": ""
  },
  {
    "index": 347,
    "id": "BW0124U19",
    "section": "Managing Risk",
    "question": "In general, how should children under 3 years of age be secured in a vehicle?",
    "options": [
      "They should always be placed in the front passenger seat wearing a seat belt.",
      "They should always be secured in the correct child seat.",
      "They should always sit on the rear passenger seat.",
      "They should always be carried in an adult's lap."
    ],
    "correct_answer": 1,
    "explanation": "Safety belts are designed mainly for adults and older children. Children under 3 years of age must be restrained in an appropriate child restraint system. Warning:  Never use a rearward facing child car seat in a seat protected by an active frontal airbag.",
    "image_name": ""
  },
  {
    "index": 348,
    "id": "BW0125RU19",
    "section": "Managing Risk",
    "question": "Can a child under the age of 3 years be carried unrestrained in the vehicle's front passenger seat?",
    "options": [
      "No, unless the child is using a child booster seat.",
      "Yes, but only if the vehicle is fitted with active airbags.",
      "No, an infant must always be restrained in the correct child seat.",
      "Yes, provided the infant is held securely by an adult."
    ],
    "correct_answer": 2,
    "explanation": "Generally, children must never travel unrestrained in a vehicle. Children under 3 years of age must be restrained in an appropriate child restraint system. Warning:  Never use a rearward facing child car seat in a seat protected by an active frontal airbag.",
    "image_name": ""
  },
  {
    "index": 349,
    "id": "RSA225307",
    "section": "Managing Risk",
    "question": "Why should a driver adjust their head restraint before starting a journey?",
    "options": [
      "To prevent glare from the headlights of following vehicles.",
      "To improve rear passengers view of the road ahead.",
      "To provide support to the neck in the event of a collision."
    ],
    "correct_answer": 2,
    "explanation": "Vehicle seats are fitted with head restraints to help reduce injury such as whiplash in the event of the vehicle being involved in a collision. Drivers and passengers should ensure that head restraints are adjusted to provide maximum protection. The top of the head restraint should be in line with the top of the head. The centre of the head restraint should be roughly in line with the top of the ears.",
    "image_name": ""
  },
  {
    "index": 350,
    "id": "ABMW0710RU19",
    "section": "Managing Risk",
    "question": "What should the driver do to secure the vehicle when changing a front nearside (left-hand side) wheel?",
    "options": [
      "Ensure the gear lever is in neutral.",
      "Point the front wheels towards the kerb.",
      "Ensure that the vehicle cannot roll when jacked up.",
      "Point the front wheels away from the kerb."
    ],
    "correct_answer": 2,
    "explanation": "If a driver has to change a front nearside (left-hand side) wheel, make sure to do it in a safe place on level ground. Take care, wear high-visibility vest/jacket, use a warning triangle and hazard warning lights as appropriate. The vehicle should be secured by applying the parking brake (handbrake), switching off the engine, engaging a low gear and using a wheel chock if necessary. If unfamiliar with how to ",
    "image_name": ""
  },
  {
    "index": 351,
    "id": "ABMW25U19",
    "section": "Managing Risk",
    "question": "Which of the following is a driver required to keep in good condition?",
    "options": [
      "Upholstery.",
      "Paintwork.",
      "Radio.",
      "Seatbelts."
    ],
    "correct_answer": 3,
    "explanation": "Drivers are responsible for their vehicles' roadworthiness and should check them at regular intervals. Among the checks they should make are that all the seatbelts (drivers and passengers) are clean, untangled and in good working order.",
    "image_name": ""
  },
  {
    "index": 352,
    "id": "BW0054",
    "section": "Managing Risk",
    "question": "What danger can arise from the power take-off shaft of a tractor?",
    "options": [
      "If it is not disengaged, the steering will lock.",
      "If it is not disengaged, the battery will run flat.",
      "If it is not covered, the tractor will speed up rapidly.",
      "If it is not covered, clothing can get caught in it."
    ],
    "correct_answer": 3,
    "explanation": "If you are working at the rear of a tractor, you should bear in mind that if the power take-off shaft is not covered, loose clothing might get caught in it and lead to injury or death.",
    "image_name": ""
  },
  {
    "index": 353,
    "id": "BW0060RU19",
    "section": "Managing Risk",
    "question": "When attaching a trailer to their vehicle, what must a driver check?",
    "options": [
      "That the load is evenly spread.",
      "That the load is positioned to the front of the trailer.",
      "That the trailer has a spare wheel.",
      "That the load is positioned to the rear of the trailer."
    ],
    "correct_answer": 0,
    "explanation": "Proper weight distribution helps to ensure the stability of both the towing vehicle and the trailer. In the trailer, the bulk of the load should be over the axles. If a heavy load is positioned at the front of the trailer, this will result in too much nose weight on the hitch of the towing vehicle and make it difficult to steer. If a heavy load is positioned at the rear of the trailer, this will result in reduced weight on the rear axle ",
    "image_name": ""
  },
  {
    "index": 354,
    "id": "BW0061RU19",
    "section": "Managing Risk",
    "question": "When attaching a trailer to their vehicle, what must a driver check?",
    "options": [
      "That the trailer coupling is attached securely.",
      "That the trailer has a spare wheel.",
      "That the trailer springs are well greased.",
      "That the load is positioned to the front of the trailer."
    ],
    "correct_answer": 0,
    "explanation": "Before towing a trailer or a caravan, check that the tow bar is securely attached to the towing vehicle, that the trailer coupling is properly attached to the tow bar and locked in place, and that the breakaway cable is properly connected.",
    "image_name": ""
  },
  {
    "index": 355,
    "id": "BWO0062R",
    "section": "Managing Risk",
    "question": "What should a driver do to secure the towing vehicle before unhitching a trailer?",
    "options": [
      "Apply the handbrake, lower the jockey wheel and switch off the engine.",
      "Apply the handbrake, switch off the ignition and engage a low gear.",
      "Disconnect the electrical supply to the trailer lights and lower the jockey wheel.",
      "Lower the jockey wheel and then switch off the ignition."
    ],
    "correct_answer": 1,
    "explanation": "Before unhitching a trailer, apply the handbrake, switch off the ignition and engage a lower gear, so that the towing vehicle does not move while you are unhitching the trailer.",
    "image_name": ""
  },
  {
    "index": 356,
    "id": "BWO088R",
    "section": "Managing Risk",
    "question": "What is the minimum legal tread depth for tyres on cars?",
    "options": [
      "2.6 millimetres",
      "1 millimetre",
      "0.6 millimetres",
      "1.6 millimetres"
    ],
    "correct_answer": 3,
    "explanation": "All road vehicles, except motorcycles and vintage vehicles, must have a minimum tyre tread depth of 1.6 mm over the main tread. However, for safety reasons, you should replace the vehicle's tyres before they become this worn.",
    "image_name": ""
  },
  {
    "index": 357,
    "id": "BW0097RU19",
    "section": "Managing Risk",
    "question": "A driver notices that the wiper blades are worn. What should they do?",
    "options": [
      "Roll down the window and drive slowly.",
      "Have the blades replaced as soon as possible.",
      "Wipe the windscreen with newspaper.",
      "Use the windscreen washer system while it is raining."
    ],
    "correct_answer": 1,
    "explanation": "Use the windscreen wipers to keep the windscreen clear of rain, spray, snow or fog. Check them regularly to ensure that they are in good working order, and replace them when they become worn, before they become ineffective.",
    "image_name": ""
  },
  {
    "index": 358,
    "id": "BW0126RU19",
    "section": "Managing Risk",
    "question": "How should a child restraint system be fitted in a vehicle?",
    "options": [
      "It should be placed on a front passenger seat only.",
      "It should be placed on the floor.",
      "It should be left unsecured.",
      "It should be fitted in accordance with the manufacturer's instructions."
    ],
    "correct_answer": 3,
    "explanation": "It is recommended to fit the child seat correctly, according to the manufacturer's instructions, it is safer to fit the seat in the back seat of the car and to buy a child car seat only from a retailer who will check that it fits both the car and the child.",
    "image_name": ""
  },
  {
    "index": 359,
    "id": "BW0001RU23",
    "section": "Managing Risk",
    "question": "What should a driver do when they want to use a mobile phone?",
    "options": [
      "Reduce speed, show caution, and be alert for other road users.",
      "Allow a wider gap to open up with the vehicle in front and continue at normal speed.",
      "Keep the conversation short.",
      "Pull in and stop in a safe place."
    ],
    "correct_answer": 3,
    "explanation": "It is illegal to use or handle a mobile phone while driving. Driving requires all of your attention, all of the time, so you should never use or handle a mobile phone while driving. If you want to use a mobile phone, the only safe thing to do is to find a safe  place to stop.",
    "image_name": ""
  },
  {
    "index": 360,
    "id": "ABMW0263R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Why might it be dangerous to drive on a poorly-lit street?",
    "options": [
      "Traffic lights will not be working.",
      "Drivers can only see the traffic coming against them.",
      "Drivers can only see the traffic in front of them.",
      "It may be difficult to make out poorly lit vehicles in the dark areas."
    ],
    "correct_answer": 3,
    "explanation": "When you are driving along a poorly-lit street, you should take extra care and be prepared to react to hazards such as unlit parked vehicles.",
    "image_name": "ABMW0263R.png"
  },
  {
    "index": 361,
    "id": "ABMW0266RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if dazzled by the lights of an oncoming vehicle?",
    "options": [
      "Flash the oncoming vehicle and move to the left.",
      "Look to the left-hand edge (nearside) of the roadway and slow down if necessary.",
      "Accelerate to get out of range of light as quickly as possible."
    ],
    "correct_answer": 1,
    "explanation": "If you are dazzled by the lights of oncoming traffic, turn your eyes to the left edge (nearside) of the road. If necessary, stop and allow your eyes to recover before driving on.",
    "image_name": "ABMW0266RU23.png"
  },
  {
    "index": 362,
    "id": "ABMW0341RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should signals (for example, with indicators) be given to other road users?",
    "options": [
      "Only when it is necessary to warn following traffic.",
      "Clearly and in good time to let other road users know what you intend to do.",
      "When turning, except where road markings indicate your direction."
    ],
    "correct_answer": 1,
    "explanation": "Giving signals is a way of telling other road users what you intend to do. So, you should signal properly before moving off, turning right or left, changing lanes, overtaking, slowing down or stopping. Signal clearly and in good time, and keep in mind that giving a signal does not give you the right of way.",
    "image_name": ""
  },
  {
    "index": 363,
    "id": "ABMW0489RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Is a driver permitted to pick up or set down a passenger on a motorway?",
    "options": [
      "It is only permitted within 200 metres of a slip-road.",
      "It is not permitted, except during daylight hours.",
      "A driver is never permitted to pick up or set down passengers on a motorway.",
      "It is permitted provided that the driver stops on the hard-shoulder."
    ],
    "correct_answer": 2,
    "explanation": "Motorways are designed so that traffic can move faster and more freely. It is illegal and dangerous to stop a vehicle on any part of a motorway except in an emergency or when signalled to do so by a Garda.",
    "image_name": ""
  },
  {
    "index": 364,
    "id": "ABMW0223RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "An approaching driver notices that the boy on the children's bicycle has said goodbye to his friend. What is the correct action for the driver to take?",
    "options": [
      "Stop the car until the boy has moved off.",
      "Proceed as the boy is on the footpath.",
      "Slow down and beckon the boy to cross the road.",
      "Be prepared for the boy setting off at any moment."
    ],
    "correct_answer": 3,
    "explanation": "Because it is difficult to predict children's behaviour, you should always be prepared to react to a change in the traffic situation or to stop.",
    "image_name": "ABMW0223RU19.png"
  },
  {
    "index": 365,
    "id": "ABMW0226RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What must a driver be prepared for in this situation?",
    "options": [
      "A child could turn back to collect the ball from the roadway.",
      "The oncoming vehicle may swerve in your direction.",
      "The ball may burst after you have passed.",
      "The ball could damage your vehicle."
    ],
    "correct_answer": 0,
    "explanation": "Because it is difficult to predict children's behaviour, you should always be prepared to react to a change in the traffic situation and be prepared to stop.",
    "image_name": "ABMW0223RU19.png"
  },
  {
    "index": 366,
    "id": "ABMW0227RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When approaching the pedestrian crossing, what should the driver do in this situation?",
    "options": [
      "Slow down in good time and be prepared to stop.",
      "Maintain speed, because the pedestrians have not stepped on to the crossing.",
      "Continue to drive on fast because the pedestrians have to wait."
    ],
    "correct_answer": 0,
    "explanation": "When there are pedestrians at or near a Zebra crossing, you should slow down on approach and be prepared to stop to allow the pedestrians to cross safely.",
    "image_name": "ABMW0226RU19.png"
  },
  {
    "index": 367,
    "id": "ABMW0232RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do if there are children playing at the edge of the roadway?",
    "options": [
      "Accelerate and move to the right-hand side of the road to avoid the children.",
      "Give a warning signal and drive past at the same speed.",
      "Reduce speed, drive cautiously and remain ready to brake."
    ],
    "correct_answer": 2,
    "explanation": "Because it is difficult to predict children's behaviour, you should always be prepared to react to a change in the traffic situation and be prepared to stop.",
    "image_name": "ABMW0232RU23.png"
  },
  {
    "index": 368,
    "id": "ABMW0236R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be conscious of in this situation?",
    "options": [
      "The bus may start to reverse.",
      "Traffic emerging from the street on the left.",
      "People crossing the street at the rear of the bus.",
      "The bus driver will always signal before moving off."
    ],
    "correct_answer": 2,
    "explanation": "You should always read the road ahead and be prepared to react to the changing traffic situation. In particular, you should be aware that pedestrians might emerge at the rear of the bus. In this situation you should also look out for pedestrians making their way towards the waiting bus.",
    "image_name": "ABMW0236R.png"
  },
  {
    "index": 369,
    "id": "ABMW0237R",
    "section": "Safe and Socially Responsible Driving",
    "question": "The silver car is overtaking the parked red car, what should the driver do in this situation?",
    "options": [
      "The driver should move closer to the red car.",
      "The driver should drive on at the same speed.",
      "The driver should drive on if he does not hit the ball.",
      "Reduce speed considerably and be ready to stop."
    ],
    "correct_answer": 3,
    "explanation": "You should read the road and be extra careful while driving through an area where children might be playing. When a ball bounces out on the road you should expect that a child might follow to retrieve the ball.",
    "image_name": "ABMW0237R.png"
  },
  {
    "index": 370,
    "id": "ABMW0238RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of in this situation?",
    "options": [
      "The pedestrian may leave the traffic island without paying attention.",
      "There is no danger as the tram is on rails.",
      "The pedestrian always has the right of way to cross in front of traffic.",
      "The tram may move away without warning."
    ],
    "correct_answer": 0,
    "explanation": "You should read the road ahead and expect extra pedestrian activity when the tram is at the stop.",
    "image_name": "ABMW0238RU19.png"
  },
  {
    "index": 371,
    "id": "ABMW0239R",
    "section": "Safe and Socially Responsible Driving",
    "question": "The driver is following these two vehicles and wishes to overtake - what must the driver consider before overtaking here?",
    "options": [
      "The driver should overtake both vehicles together.",
      "The driver of the silver car may decide to turn right.",
      "The roadway markings forbid overtaking here.",
      "The driver's field of view is not good enough to allow safe overtaking."
    ],
    "correct_answer": 3,
    "explanation": "You should always make sure that the road ahead is clear so that there is enough distance to allow you to overtake and get back to the correct side of the road without forcing any other road user to alter speed or course. In this case, the brow of the hill is too close to allow a driver to overtake safely.",
    "image_name": "ABMW0239R.png"
  },
  {
    "index": 372,
    "id": "ABMW0240R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when approaching a vehicle which is attempting to park?",
    "options": [
      "That the vehicle being parked may move out without warning.",
      "The driver may have to stop and assist the driver parking the vehicle.",
      "The vehicle may be parking at an area designated for loading.",
      "That there may be a driveway at the point where the vehicle is parking."
    ],
    "correct_answer": 0,
    "explanation": "When you approach a vehicle that is being parked on the roadway, you should be aware that its driver will probably be concentrating on parking the vehicle and may not be aware of moving out into the road to correct its position.",
    "image_name": "ABMW0240R.png"
  },
  {
    "index": 373,
    "id": "ABMW0248RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver be most conscious of in this situation?",
    "options": [
      "The pedestrian may suddenly cross the road in front of the vehicle.",
      "No vehicles should be parked on the left-hand side of the road.",
      "The pedestrian always has right of way to cross the road.",
      "One of the parked vehicles may reverse into the driver's path."
    ],
    "correct_answer": 0,
    "explanation": "It is often difficult to predict other road users behaviour. Where there are parked vehicles on both sides of the road you should approach with caution, and be prepared to react to a change in the traffic situation and to stop.",
    "image_name": "ABMW0248RU19.png"
  },
  {
    "index": 374,
    "id": "ABMW0255R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when travelling behind this vehicle?",
    "options": [
      "Pass the vehicle slowly by mounting the kerb on the left.",
      "Reduce speed and prepare to stop if necessary.",
      "Overtake the vehicle in front.",
      "Drive as close as possible to the vehicle."
    ],
    "correct_answer": 1,
    "explanation": "You should always read the road ahead and be prepared to react to the changing traffic situation as you approach junctions.",
    "image_name": "ABMW0255R.png"
  },
  {
    "index": 375,
    "id": "ABMW0278RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of in this situation?",
    "options": [
      "There may be a car hidden from view in front of the bus.",
      "The bus may be parked at a terminus.",
      "Only buses may use this road."
    ],
    "correct_answer": 0,
    "explanation": "On approach to an area with a restricted view you should be extra careful and be prepared to react to a change in the traffic situation.",
    "image_name": "ABMW0278RU23.png"
  },
  {
    "index": 376,
    "id": "ABMW0287RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on this one-way street with vehicles parked on both sides, what should a driver be prepared for?",
    "options": [
      "Oncoming traffic as the driver overtakes the truck.",
      "The truck may be a left-hand drive vehicle.",
      "A vehicle door may open on either side of the street."
    ],
    "correct_answer": 2,
    "explanation": "When driving on a one-way street, you should be extra careful and should be prepared to react to a change in the traffic situation.",
    "image_name": "ABMW0287R.png"
  },
  {
    "index": 377,
    "id": "ABMW0292RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the car driver be aware of in this situation?",
    "options": [
      "The road ahead becomes a dual carriageway.",
      "Road marking is taking place ahead.",
      "Following traffic may cut the corner.",
      "Slowing down and being prepared to react."
    ],
    "correct_answer": 3,
    "explanation": "When you are approaching a bend or corner with a restricted view you should slow down if necessary and be prepared to react to any changes in the traffic situation.",
    "image_name": "ABMW0292RU19.png"
  },
  {
    "index": 378,
    "id": "ABMW0294R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when driving at night along a shopping street with many different light sources?",
    "options": [
      "It is easier to see pedestrians because of the bright lights.",
      "Parking spaces may be difficult to notice.",
      "Traffic lights may be difficult to distinguish from the other bright lights.",
      "Other vehicles do not need to use their head lights."
    ],
    "correct_answer": 2,
    "explanation": "When driving at night in an area where there is a variety of light sources, you need to be extra careful, as potential hazards might be more difficult to see.",
    "image_name": "ABMW0294R.png"
  },
  {
    "index": 379,
    "id": "ABMW0295RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be most aware of in this situation?",
    "options": [
      "A car might appear unexpectedly at the brow of the hill.",
      "Children may unexpectedly run out from between parked cars.",
      "One of the parked vehicles may reverse into the driver's path.",
      "Parking opposite double yellow lines is prohibited."
    ],
    "correct_answer": 1,
    "explanation": "When driving in a residential area you need to take account of the danger you might pose to children playing. You should always observe warning signs relating to children and drive accordingly.",
    "image_name": "ABMW0295RU19.png"
  },
  {
    "index": 380,
    "id": "ABMW0296RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in this situation?",
    "options": [
      "Reduce speed and be prepared to stop as other children could follow.",
      "Sound the horn as a warning and proceed.",
      "Continue ahead while indicating to overtake parked car."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should always be aware of other road users especially children, who can be unpredictable and show no road sense. Drivers should slow down and take extra care in areas where there are children about - for example, near schools, playgrounds and in residential areas.",
    "image_name": "ABMW0296RU23.png"
  },
  {
    "index": 381,
    "id": "ABMW0304R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of in this situation?",
    "options": [
      "A minor road to the right ahead.",
      "A dangerous right-hand bend ahead.",
      "A sharp dip in the road ahead.",
      "A minor road to the left ahead."
    ],
    "correct_answer": 1,
    "explanation": "You should always read the road ahead and be prepared to react to changing traffic situations - in this case paying attention to the warning sign clearly indicating a right-hand bend ahead.",
    "image_name": "ABMW0304R.png"
  },
  {
    "index": 382,
    "id": "ABMW0314RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do when there is a sharp dip in the road ahead?",
    "options": [
      "Pull in, stop and switch on hazard warning lights.",
      "Increase speed and make progress through the dip.",
      "Reduce speed, keep to the left and be alert for hazards ahead.",
      "Move to the centre of the road in order to avoid any vehicles that might be parked on the left."
    ],
    "correct_answer": 2,
    "explanation": "As you approach a sharp dip in the road, you should be aware that there might be hidden dangers ahead. For example, there might be pedestrians, cyclists or other approaching traffic, or the road could be flooded in the dip. You should always read the road ahead and be prepared to react to changing traffic situations - you might need to reduce your speed and drive with extra care.",
    "image_name": ""
  },
  {
    "index": 383,
    "id": "ABMW0315R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they see a red warning triangle on the road?",
    "options": [
      "The driver should maintain speed, carry on and avoid the triangle.",
      "The driver should slow down and expect a hazard up ahead.",
      "The driver should remove the triangle as it is causing an obstruction on the road.",
      "The driver should stop and await instructions."
    ],
    "correct_answer": 1,
    "explanation": "Warning triangles are used to alert approaching traffic that there is a vehicle breakdown or collision ahead. When you come across a warning triangle, you should slow down and be prepared to stop if necessary. Do not allow yourself to be distracted by the incident.",
    "image_name": ""
  },
  {
    "index": 384,
    "id": "ABMW0316RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "The driver is approaching traffic lights that they know have been green for some time. What should the driver do?",
    "options": [
      "The driver should maintain speed until the light changes to amber.",
      "The driver should be aware that the lights may change and accelerate to clear the lights before they do.",
      "The driver should be aware that the lights may change before they reach them and be prepared to stop.",
      "The driver should stop as the lights are about to change to red."
    ],
    "correct_answer": 2,
    "explanation": "You should always read the road ahead and be prepared to react to changing traffic situations. Where traffic lights have been green for some time, you should be prepared to stop, as the lights are probably about to change to amber.",
    "image_name": ""
  },
  {
    "index": 385,
    "id": "ABMW0317RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when approaching a junction normally controlled by traffic lights and the traffic lights are not lighting?",
    "options": [
      "Proceed smartly through the junction to avoid delay.",
      "Switch on headlights, move to centre of the junction and proceed as quickly as possible.",
      "Stop at the junction and give way to traffic on the left.",
      "Treat it as an unmarked junction and proceed cautiously while watching out for other traffic."
    ],
    "correct_answer": 3,
    "explanation": "You should always read the road ahead and be prepared to react to changing traffic situations. If the traffic lights are not working, you should approach the junction with extra care, and you should proceed only if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 386,
    "id": "ABMW0318RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do if there are cattle on the road ahead?",
    "options": [
      "The driver should sound the horn to try to get the cattle to move aside.",
      "The driver should reduce speed and pass them with care.",
      "The driver should switch on the headlights and try to pass as quickly as possible.",
      "The driver should sound the horn, switch on headlights, reduce speed and pass with care."
    ],
    "correct_answer": 1,
    "explanation": "You should always read the road ahead and be prepared to react to changing traffic situations. If you meet cattle or other animals on the road, you should slow down and be prepared to stop. Don't use the horn or do anything that might frighten the animals. You must stop if directed to do so by the person in charge of animals.",
    "image_name": ""
  },
  {
    "index": 387,
    "id": "ABMW0319RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they see horse riders on the road ahead?",
    "options": [
      "The driver should increase speed and allow extra clearance.",
      "The driver should reduce speed, allow extra clearance and pass with care.",
      "The driver should reduce speed and sound the horn.",
      "The driver should turn on hazard warning lights and continue at normal speed."
    ],
    "correct_answer": 1,
    "explanation": "You should always read the road ahead and be prepared to react to changing traffic situations. If you meet horses or other animals on the road, you should slow down and be prepared to stop. Don't use the horn or do anything that might frighten the animals. You must stop if directed to do so by the person in charge of animals.",
    "image_name": ""
  },
  {
    "index": 388,
    "id": "ABMW0320R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should drivers be aware of if they meet horses with riders on the road?",
    "options": [
      "Drivers should be aware that loud noises from their vehicle will not frighten the horses.",
      "Drivers should be aware that horse riders are obliged to dismount and control their horses while traffic is passing.",
      "Drivers should be aware that loud noises from their vehicle may frighten the horses and cause them to bolt.",
      "Drivers should be aware that all horse riders are experienced at handling horses."
    ],
    "correct_answer": 2,
    "explanation": "You must know your responsibilities towards animal traffic on the road. Horses are easily startled and any sudden noises or activity could cause them to bolt.",
    "image_name": ""
  },
  {
    "index": 389,
    "id": "ABMW0321RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do when approaching a humpbacked hill?",
    "options": [
      "The driver should reduce speed, keep to the left and be alert for hazards ahead.",
      "The driver should maintain normal speed and road position.",
      "The driver should increase speed and make progress over the humpbacked hill.",
      "The driver should move to the centre in order to avoid vehicles that may be parked on the left."
    ],
    "correct_answer": 0,
    "explanation": "As you approach a humpbacked bridge or hill, you should be aware that there might be hidden dangers ahead - for example, overtaking traffic coming towards you. You should always read the road ahead and be prepared to react to changing traffic situations such as this.",
    "image_name": ""
  },
  {
    "index": 390,
    "id": "ABMW0339RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What danger can arise during daylight when a driver enters an area that is heavily shaded by overhanging trees?",
    "options": [
      "Visibility could suddenly be reduced.",
      "The vehicle engine could suddenly run cold.",
      "The tyre pressure could be reduced.",
      "The vehicle's windscreen could fog up."
    ],
    "correct_answer": 0,
    "explanation": "When you enter a heavily shaded area after driving in bright sunlight, it might take a while for your eyes to adjust to the change, and you might not see a hazard immediately ahead.",
    "image_name": ""
  },
  {
    "index": 391,
    "id": "ABMW0343RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How does giving a late signal affect other road users?",
    "options": [
      "They are not affected.",
      "It only affects other road users at traffic lights.",
      "It only affects other road users at roundabouts.",
      "They may not have been given enough time to react."
    ],
    "correct_answer": 3,
    "explanation": "Giving signals is a way of telling other road users what you intend to do. So, you should signal properly before moving off, turning right or left, changing lanes, overtaking, slowing down or stopping. Signal clearly and in good time, and keep in mind that giving a signal does not give you the right of way. Late signals may confuse other road users.",
    "image_name": ""
  },
  {
    "index": 392,
    "id": "ABMW0345RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver is at a junction where visibility is extremely limited, what should the driver do?",
    "options": [
      "Sound the horn and quickly proceed.",
      "Move the vehicle out onto the road to enable other drivers to see you.",
      "Move out with extreme care, watching carefully to the left and right."
    ],
    "correct_answer": 2,
    "explanation": "Where your view is obstructed at a junction, you should move carefully into a position where you can see, but without interfering with other road users. You should then assess the situation before you continue.",
    "image_name": ""
  },
  {
    "index": 393,
    "id": "ABMW0348RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when approaching traffic lights stuck on red?",
    "options": [
      "Indicate and increase speed.",
      "Stop and proceed with great caution.",
      "Sound the horn and proceed ahead.",
      "Check that there are no oncoming vehicles and increase speed."
    ],
    "correct_answer": 1,
    "explanation": "On approach to traffic lights that are stuck on red, a driver should stop and proceed with caution when the way is clear.",
    "image_name": ""
  },
  {
    "index": 394,
    "id": "ABMW0464RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a rider be aware of when crossing road markings such as lines or arrows?",
    "options": [
      "Steering is improved.",
      "Tyre grip is reduced.",
      "Tyre grip is not affected."
    ],
    "correct_answer": 1,
    "explanation": "Riding on just 2 wheels, riders need to be on the constant lookout for irregularities and other problems with the road surface. This can include all road markings.",
    "image_name": ""
  },
  {
    "index": 395,
    "id": "ABMW0468RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when approaching roadworks warning signs?",
    "options": [
      "Maintain speed until signalled to slow down by a flagman.",
      "Increase speed and move to the centre of the road.",
      "Reduce speed and be prepared to stop for works vehicles or a flagman."
    ],
    "correct_answer": 2,
    "explanation": "A driver should always approach roadworks with caution and reduce speed as there are many possible hazards to deal with - including road workers, works vehicles, uneven road surfaces and temporary traffic controls.",
    "image_name": ""
  },
  {
    "index": 396,
    "id": "ABMW0560RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "If a driver suspects that their vehicle indicators have not been seen, what should the driver do?",
    "options": [
      "The driver's position on the road is enough of a signal.",
      "It is unnecessary to give signals provided observation is taken.",
      "Use a clear, decisive hand signal as well."
    ],
    "correct_answer": 2,
    "explanation": "If the driver is concerned that for whatever reason the indicators are not giving an adequate signal, they should use clear decisive hand signals as well to advise other road users of their intention.",
    "image_name": ""
  },
  {
    "index": 397,
    "id": "ABMW0627RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to avoid the need for harsh braking?",
    "options": [
      "Drive with one foot resting on the clutch pedal.",
      "Look ahead and be prepared for what others may do.",
      "Drive with cruise control engaged.",
      "Drive with one foot resting on the brake pedal."
    ],
    "correct_answer": 1,
    "explanation": "You should know what speed you're travelling at and you should always drive at a speed that is appropriate to the conditions you are driving in, and you should be able to stop smoothly and safely within the distance you can see to be clear ahead.",
    "image_name": ""
  },
  {
    "index": 398,
    "id": "ABMW0380RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving along and wishing to use a hand-held mobile phone, what should a driver do?",
    "options": [
      "Steer with one hand.",
      "Stop at a safe location before using the phone.",
      "Secure the phone between head and shoulders while steering with both hands.",
      "Move the phone as needed and keep the call to just a few minutes."
    ],
    "correct_answer": 1,
    "explanation": "It is an offence and very unsafe to use a hand-held mobile phone while driving a vehicle or riding a motorbike as it prevents you from concentrating fully on your driving. While using a hands-free phone kit is not illegal, in some circumstances it could be a dangerous distraction, and you could be prosecuted for dangerous driving, careless driving or driving without due care and attention. If a driver needs ",
    "image_name": ""
  },
  {
    "index": 399,
    "id": "ABMW0337RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "Why is tailgating (driving too close behind the vehicle in front) dangerous?",
    "options": [
      "The vehicle will exceed the speed limit.",
      "The vehicle will not have enough distance to stop safely in an emergency.",
      "The engine may overheat because of restricted air flow over the vehicle's engine.",
      "The braking system is less efficient in the slipstream of the vehicle in front."
    ],
    "correct_answer": 1,
    "explanation": "If you drive too close to the vehicle in front and it brakes suddenly, you will not have enough time to react. For that reason you should always keep a safe distance from the vehicle in front. One way of calculating a safe distance in dry weather is the two- second rule: Allow at least two seconds to elapse between the vehicle in front and your own vehicle passing a fixed point such as a lamp post or sign post.",
    "image_name": ""
  },
  {
    "index": 400,
    "id": "ABMW0338RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Is tailgating allowed on a motorway or dual carriageway?",
    "options": [
      "Yes, because there is oncoming traffic.",
      "Yes, because all traffic moves in the one direction at the same time.",
      "No, because the vehicle in front may stop suddenly.",
      "No, because other vehicles do not have room to overtake."
    ],
    "correct_answer": 2,
    "explanation": "If you drive too close to the vehicle in front and it brakes suddenly, you will not have enough time to react. For that reason you should always keep a safe distance from the vehicle in front. One way of calculating a safe distance in dry weather is the two- second rule: Allow at least two seconds to elapse between the vehicle in front and your own vehicle passing a fixed point such as a lamp post or sign post.",
    "image_name": ""
  },
  {
    "index": 401,
    "id": "ABMW0382RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if another vehicle blocks their right of way at a junction?",
    "options": [
      "Flash the headlights to express displeasure.",
      "Pursue the vehicle and express displeasure.",
      "Be patient and show restraint.",
      "Sound the horn and flash the lights to show your frustration."
    ],
    "correct_answer": 2,
    "explanation": "You should always try to show restraint. It is important to understand that the right of way is not an absolute right of way, and you must always proceed with caution and with regard for other road users. It's safer and more socially responsible.",
    "image_name": ""
  },
  {
    "index": 402,
    "id": "ABMW0383RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver who is about to undertake a journey is upset or angry. What should they do?",
    "options": [
      "A driver should not drive until they are calm.",
      "Drive slower than normal for a distance.",
      "Being upset or angry does not affect driving."
    ],
    "correct_answer": 0,
    "explanation": "If you drive when you are angry or upset, you are more likely to be involved ina collision, and more likely to react to other drivers bad behaviour. Take the time to calm down and compose yourself before you set out on a journey.",
    "image_name": ""
  },
  {
    "index": 403,
    "id": "ABMW0384RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When being overtaken and there is oncoming traffic, what should a driver do?",
    "options": [
      "Speed up so the following vehicle cannot overtake.",
      "Allow the overtaking vehicle to pass and return safely to the left side of the road.",
      "Maintain position and flash the headlights to warn the oncoming traffic.",
      "Maintain position because other drivers should not have attempted to overtake."
    ],
    "correct_answer": 1,
    "explanation": "When you are being overtaken and there are oncoming vehicles, you should show consideration for all the other traffic and allow the overtaking vehicle to move in front of you to avoid the risk of a collision.",
    "image_name": ""
  },
  {
    "index": 404,
    "id": "ABMW0385RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When another driver is in a hurry and cuts in front what should a driver do?",
    "options": [
      "Be patient and do not react.",
      "Drive faster to make up for lost time.",
      "Drive closely behind them so other vehicles cannot do the same.",
      "Flash the headlights to express their annoyance."
    ],
    "correct_answer": 0,
    "explanation": "If another driver behaves badly, you should not let it annoy you - show restraint and don't react. Road rage only increases the risk of a collision.",
    "image_name": ""
  },
  {
    "index": 405,
    "id": "ABMW0469RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when driving through a section of road where roadworks are ongoing?",
    "options": [
      "Narrower lanes than usual and restricted shoulder areas.",
      "That road workers are always aware of the movement of traffic.",
      "That the area will be cleared for the driver so that there are no traffic delays."
    ],
    "correct_answer": 0,
    "explanation": "When travelling through a section of roadworks, a driver needs to be extra careful, as the road surface area may be considerably reduced. It may be narrower, uneven, slippery or there may be loose chippings which may pose a danger for road workers and other road users.",
    "image_name": ""
  },
  {
    "index": 406,
    "id": "CPC1348U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "To whom should a driver report aggressive driving?",
    "options": [
      "Health and Safety Authority.",
      "Road Safety Authority.",
      "Local Garda station or Traffic Watch.",
      "Transport Infrastructure Ireland."
    ],
    "correct_answer": 2,
    "explanation": "Report all aggressive driving incidents to Traffic Watch or a Garda station. They are the best people to deal with aggressive driving.",
    "image_name": ""
  },
  {
    "index": 407,
    "id": "ABMW0285R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a cobblestone road why should you take extra care?",
    "options": [
      "The road surface is particularly even and tyre grip is improved.",
      "The smoothness of the cobblestones helps to improve grip.",
      "The road surface is uneven and road grip varies.",
      "The gaps between the stones helps road holding and grip is improved."
    ],
    "correct_answer": 2,
    "explanation": "Different road surfaces can affect your vehicle's grip on the road and its stopping distances. You should be aware of this when driving on different surfaces.",
    "image_name": "ABMW0285R.png"
  },
  {
    "index": 408,
    "id": "ABMW0289R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Why must a driver be particularly careful here?",
    "options": [
      "Because a vehicle could come from the left.",
      "The vehicle coming from the right has the right of way.",
      "Because there is an increased danger of skidding.",
      "The vehicle coming from the right is not required to signal."
    ],
    "correct_answer": 2,
    "explanation": "Where there are fallen leaves on the road surface, your tyres might have reduced grip on the road surface and your braking distances might be greater.",
    "image_name": "ABMW0289R.png"
  },
  {
    "index": 409,
    "id": "ABMW0322RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if there is a large oil spill on the road?",
    "options": [
      "Maintain normal speed in a lower gear and switch on hazard warning lights.",
      "Depress the clutch and brake sharply and switch on the hazard warning lights.",
      "Reduce speed by gently applying the brakes and switch on the hazard warning lights.",
      "Maintain normal speed and try to drive on the spill with the wheels."
    ],
    "correct_answer": 2,
    "explanation": "Where oil is spilt on the road, your tyres will have reduced grip, and you might be at risk of skidding if you brake sharply. If you do come across oil on the road, brake gently and switch on your hazard warning lights for a short period to alert other traffic to the hazard.",
    "image_name": ""
  },
  {
    "index": 410,
    "id": "ABMW0325RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of before crossing railway or tram lines?",
    "options": [
      "There may be an uneven surface and tyre grip may be reduced when crossing the rails.",
      "The tyre grip may be improved crossing the rails.",
      "The wheels may become caught in the rails, causing the tyres to deflate.",
      "There may be a reduction in tyre noise while crossing the rails."
    ],
    "correct_answer": 0,
    "explanation": "You should be aware of the impact of changes in the road surface. For example, at railway and tram crossings the uneven surface or oil deposits could reduce the grip of your tyres. Slow down as you approach railway or tram crossings and increase your distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 411,
    "id": "ABMW0378RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should drivers do if they approach road works and there is earth-moving machinery moving about?",
    "options": [
      "Reduce speed as there may be loose gravel or mud on the road.",
      "Stop, turn the vehicle around on the road and find an alternative route.",
      "Switch on headlights as a warning and carry on as normal."
    ],
    "correct_answer": 0,
    "explanation": "Where earth-moving machinery is working, there are likely to be mud and gravel deposits on the road. Also the noise of such machines might make it hard for road workers to hear the approaching traffic. When you come across earth-moving machinery, slow down and proceed with extreme caution.",
    "image_name": ""
  },
  {
    "index": 412,
    "id": "ABMW0401RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they encounter loose chippings on a road?",
    "options": [
      "Stop the vehicle until the loose chippings can be removed.",
      "Slow down and allow extra clearance to other traffic.",
      "A driver should press their hand against the windscreen.",
      "Increase speed so as to avoid causing damage to the vehicle."
    ],
    "correct_answer": 1,
    "explanation": "Where there are loose chippings on the road, you should slow down and comply with any reduced speed limit and leave extra room (or clearance) between your vehicle and other traffic. This will also give you more time to stop if you need to, and it will help to reduce the amount of chippings your vehicle throws up against other vehicles and possible injury to pedestrians.",
    "image_name": ""
  },
  {
    "index": 413,
    "id": "ABMW0402RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect does spilt diesel have on a road?",
    "options": [
      "It improves the vehicle's braking ability.",
      "It makes the road more slippery.",
      "It increases tyre noise."
    ],
    "correct_answer": 1,
    "explanation": "Diesel spilt on the road can make the road surface extremely slippery, particularly if the road is wet.",
    "image_name": ""
  },
  {
    "index": 414,
    "id": "ABMW12",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a road with tram lines why should a driver take extra care?",
    "options": [
      "Driving on the tracks can reduce tyre grip.",
      "Driving on the tracks can improve braking.",
      "Driving on the tracks can improve steering.",
      "Driving on the tracks can improve tyre grip."
    ],
    "correct_answer": 0,
    "explanation": "Different road surfaces can affect your vehicle's grip on the road and its stopping distances. You should be aware of this when driving on different surfaces.",
    "image_name": ""
  },
  {
    "index": 415,
    "id": "ABMW0207RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver use dipped headlights?",
    "options": [
      "When visibility is less than 200 metres.",
      "From just after dusk to just before dawn.",
      "When visibility is less than 300 metres.",
      "From 00:00 hrs to 06:00 hrs."
    ],
    "correct_answer": 1,
    "explanation": "Lighting up hours are defined as the period of time during which drivers should turn on dipped headlights in order to be seen. This period normally starts half an hour after sunset and ends half an hour before sunrise.",
    "image_name": ""
  },
  {
    "index": 416,
    "id": "ABMW0208RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What lights should a vehicle show at dusk?",
    "options": [
      "Daytime Running Lights (DRLs) only.",
      "Full headlights.",
      "Fog lights.",
      "Dipped headlights."
    ],
    "correct_answer": 3,
    "explanation": "Drivers need to see and be seen during all periods of low light levels - for example, at dusk and dawn and in some bad weather conditions. At times of low light, you should turn on dipped headlights. The Road Safety Authority recommends that motorcyclists and drivers turn on their dipped headlights or daytime running lights during daylight hours.",
    "image_name": ""
  },
  {
    "index": 417,
    "id": "ABMW0437RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night the full headlights of a typical car should enable the driver to see for a distance of how many metres?",
    "options": [
      "150 metres.",
      "50 metres.",
      "100 metres.",
      "200 metres."
    ],
    "correct_answer": 2,
    "explanation": "At night in good driving conditions the full headlights of a car will typically let you see 100 metres ahead. So, you should travel at a speed that allows you to stop within that distance.",
    "image_name": ""
  },
  {
    "index": 418,
    "id": "ABMW0438RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night the dipped headlights of a typical car should enable the driver to see for a distance of how many metres?",
    "options": [
      "40 metres.",
      "30 metres.",
      "50 metres.",
      "20 metres."
    ],
    "correct_answer": 1,
    "explanation": "When driving at night in good driving conditions the dipped headlights of a car will typically let you see 30 metres ahead. So, you should travel at a speed that allows you to stop in that distance.",
    "image_name": ""
  },
  {
    "index": 419,
    "id": "ABMW0439RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What are the possible consequences of having incorrectly adjusted headlights?",
    "options": [
      "The wattage of the headlights could be reduced.",
      "The headlights could overheat.",
      "Visibility could be increased.",
      "Oncoming road users could be dazzled."
    ],
    "correct_answer": 3,
    "explanation": "You are responsible for making sure that your vehicle is roadworthy and that its headlights are adjusted correctly. If the headlights are out of line they are less effective and may dazzle oncoming traffic, even when dipped.",
    "image_name": ""
  },
  {
    "index": 420,
    "id": "ABMW0440R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night, when must a driver dip the vehicle's full headlights?",
    "options": [
      "When meeting or driving behind other traffic.",
      "When there is no oncoming traffic.",
      "When driving at less than 50 km/h.",
      "When entering a motorway."
    ],
    "correct_answer": 0,
    "explanation": "When driving at night you should dip your headlights when you meet oncoming vehicles so that you do not dazzle them. And you should also dip your headlights when you are driving behind another vehicle so the driver is not dazzled by your lights in their mirror.",
    "image_name": ""
  },
  {
    "index": 421,
    "id": "ABMW0441RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night and blinded by the lights of an oncoming vehicle, what should a driver do?",
    "options": [
      "Repeatedly flash the headlights to warn the offending driver.",
      "Drive well to the left and maintain normal speed.",
      "Look towards the verge and slow down and stop if necessary.",
      "Reduce speed and switch on the full headlights."
    ],
    "correct_answer": 2,
    "explanation": "If you are dazzled by the lights of an oncoming vehicle, look towards the verge until the vehicle has passed. Slow down and stop if necessary.",
    "image_name": ""
  },
  {
    "index": 422,
    "id": "ABMW0442RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver has been driving regularly in daylight and must now undertake a journey at night. What should the driver do?",
    "options": [
      "Drive at a higher speed than during the day as traffic is lighter at night.",
      "Drive at a higher speed than during the day to minimise the chances of falling asleep.",
      "Drive at the same speed as during the day as there is no extra danger.",
      "Drive at a slower speed than in the day as visibility is reduced at night."
    ],
    "correct_answer": 3,
    "explanation": "If you are not familiar with driving at night time, it can take quite a while to adjust to conditions. For that reason, you might need to drive slower until you get used to the reduced visibility at night.",
    "image_name": ""
  },
  {
    "index": 423,
    "id": "ABMW0443RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "With regard to vehicle speed, what should a driver do when driving at night?",
    "options": [
      "Maintain normal vehicle speed and drive with full headlights.",
      "Drive at a higher speed than during the day to reduce the chances of falling asleep.",
      "Increase vehicle speed as traffic is lighter at night.",
      "Drive at a speed that enables the driver to stop within the distance ahead that they can see to be clear."
    ],
    "correct_answer": 3,
    "explanation": "When driving at night in good driving conditions the full headlights of a car will typically let you see 100 metres ahead. So, you should travel at a speed that allows you to stop in that distance.",
    "image_name": ""
  },
  {
    "index": 424,
    "id": "ABMW0444RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night, what is the safest approach for a driver to adopt?",
    "options": [
      "Drive at a speed that enables the driver to stop within the distance ahead that they can see to be clear.",
      "Drive at the maximum speed limit with full headlights on to see clearly ahead.",
      "Drive at the maximum speed limit with dipped headlights on at all times.",
      "Drive with full headlights on at all times."
    ],
    "correct_answer": 0,
    "explanation": "When driving at night in good driving conditions the dipped headlights of a car will typically let you see 30 metres ahead. So, you should travel at a speed that allows you to stop in that distance.",
    "image_name": ""
  },
  {
    "index": 425,
    "id": "ABMW0445RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When meeting an oncoming vehicle at night, what should a driver do?",
    "options": [
      "Increase speed to pass the oncoming vehicle.",
      "Avoid looking directly at the oncoming vehicle's lights.",
      "Focus eyes directly on the oncoming vehicle's lights.",
      "Focus eyes directly on the steering."
    ],
    "correct_answer": 1,
    "explanation": "If you are dazzled by the lights of an oncoming vehicle, look towards the verge until the vehicle has passed and/or slow down and stop if necessary.",
    "image_name": ""
  },
  {
    "index": 426,
    "id": "ABMW0446RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is it safe for a driver to use the main beam headlights when driving at night?",
    "options": [
      "When following a vehicle a short distance ahead.",
      "This practice is not permitted.",
      "When there is no oncoming traffic.",
      "In built up areas where there is good street lighting."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should use the main beam headlights, to improve visibility, when driving at night in unlit rural areas - this will enable them to see as far ahead as possible. Making sure, however, that these lights are dimmed where necessary to avoid dazzling or inconveniencing other road users.",
    "image_name": ""
  },
  {
    "index": 427,
    "id": "ABMW0447RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What lights should a driver have on when driving behind other traffic at night?",
    "options": [
      "Dipped headlights.",
      "Side lights.",
      "Main beam headlights.",
      "Front fog lights."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should dip their headlights when driving behind another vehicle so the driver in front is not dazzled by your lights in their mirror.",
    "image_name": ""
  },
  {
    "index": 428,
    "id": "ABMW0448RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving at night, when must a driver use dipped headlights?",
    "options": [
      "When meeting or driving behind other traffic.",
      "When driving at more than 100 km/h.",
      "When there is no oncoming traffic.",
      "When driving at less than 50 km/h."
    ],
    "correct_answer": 0,
    "explanation": "When driving at night drivers should dip their main beam headlights when meeting or following traffic to avoid dazzling or endangering other road users.",
    "image_name": ""
  },
  {
    "index": 429,
    "id": "ABMW0450RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When dazzled by the lights of an oncoming vehicle, what should a driver do?",
    "options": [
      "Shield their eyes with their hand.",
      "Look at the dashboard momentarily.",
      "Do not look directly at the lights.",
      "Turn their head to the right."
    ],
    "correct_answer": 2,
    "explanation": "If dazzled by the lights of an oncoming vehicle, do not look directly at the oncoming lights. Instead glance towards the verge until the vehicle has passed and/or slow down and stop if necessary. This will avoid any temporary blindness caused by the brightness of the oncoming lights.",
    "image_name": ""
  },
  {
    "index": 430,
    "id": "ABMW0721RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Is a driver allowed to sound the horn while driving in a built-up area at night?",
    "options": [
      "Yes, but between 11:30 pm and 7:00 am the horn may be sounded only in an emergency.",
      "Yes, but only for momentary use.",
      "No, use of the horn is not permitted in a built-up area between 11:30 pm and 7:00 am.",
      "Yes, but only between 11:30 pm and 7:00 am."
    ],
    "correct_answer": 0,
    "explanation": "Drivers are not allowed to use the horn in a built-up area between 11:30 pm and 7:00 am unless there is a traffic emergency. Only use a horn to warn other road users of danger or if needed to make them aware of your vehicle's presence for safety reasons. Using the horn does not give drivers an automatic right of way.  Never use the horn to provoke a reaction from or to rebuke another motorist.",
    "image_name": ""
  },
  {
    "index": 431,
    "id": "ABMW0723RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is the use of the horn prohibited?",
    "options": [
      "Between 11:30 pm and 7:00 am in a built-up area.",
      "Between 11:30 pm and 6:00 am on any road.",
      "Between 10:00 pm and 6:00 am in a built-up area.",
      "At all times in a built-up area."
    ],
    "correct_answer": 0,
    "explanation": "Drivers are not permitted to sound the horn in a built-up area between 11:30 pm and 7:00 am unless there is a traffic emergency. Only sound the horn to warn other road users of oncoming danger or if they need to be made aware of your presence for safety reasons. Sounding the horn does not give the driver an automatic right of way. Never sound the horn to provoke a reaction from or to rebuke another motorist.",
    "image_name": ""
  },
  {
    "index": 432,
    "id": "ABMW0241RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver allow for when following the bus on an icy road?",
    "options": [
      "Same braking distance as in wet conditions.",
      "A longer braking distance is required.",
      "A shorter braking distance is required."
    ],
    "correct_answer": 1,
    "explanation": "When driving in icy conditions, you should always reduce speed and allow a bigger gap to the vehicle in front in order to be able to stop safely if necessary.",
    "image_name": "ABMW0241RU23.png"
  },
  {
    "index": 433,
    "id": "ABMW0246RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What lights should a driver use in dense fog?",
    "options": [
      "Front and rear fog lights along with hazard warning lights.",
      "Front and rear fog lights along with side lights.",
      "Front and rear fog lights along with main beam lights.",
      "Front and rear fog lights along with dipped headlights."
    ],
    "correct_answer": 3,
    "explanation": "When driving in dense fog you should switch on your front and rear fog lights along with dipped headlights. You should not drive in fog with main beam headlights on.",
    "image_name": "ABMW0246RU19.png"
  },
  {
    "index": 434,
    "id": "ABMW0286RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "After a heavy downpour, why should a driver keep a greater distance from the vehicle in front?",
    "options": [
      "Because wheels rotate at a greater speed after rain.",
      "Because wheels rotate at a slower speed after rain.",
      "Because wheel-spray may impair visibility.",
      "Because required stopping distances are decreased."
    ],
    "correct_answer": 2,
    "explanation": "Heavy rain can affect how well you can see and how well you can be seen by other road users. Because of that you should slow down in heavy rain and keep a greater distance from the vehicle in front.",
    "image_name": "ABMW0286RU19.png"
  },
  {
    "index": 435,
    "id": "ABMW0326RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver be aware of when crossing road markings such as lines and directional arrows in wet weather?",
    "options": [
      "Steering control is improved.",
      "The tyre grip is improved.",
      "The required stopping distance is reduced due to improved tyre grip.",
      "The required stopping distance is increased due to reduced tyre grip."
    ],
    "correct_answer": 3,
    "explanation": "You should be aware of the impact of changes in the road surface. For example, road markings and directional arrows can become slippery when wet. Where  possible, avoid driving on road markings, and be aware of the increased risk of skidding.",
    "image_name": ""
  },
  {
    "index": 436,
    "id": "ABMW0344R",
    "section": "Safe and Socially Responsible Driving",
    "question": "How does rain affect driving in this situation?",
    "options": [
      "It reduces the danger of skidding.",
      "It increases the danger of skidding.",
      "It increases tyre grip on the road.",
      "It increases visibility."
    ],
    "correct_answer": 1,
    "explanation": "When it is wet, your tyres do not grip the road surface as well as when it is dry, your stopping distance is increased and you are more likely to skid. For these reasons you should slow down during or after rain and keep a greater distance from the vehicle in front.",
    "image_name": "ABMW0344R.png"
  },
  {
    "index": 437,
    "id": "ABMW0349RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when there are dark clouds and visibility is reduced during daylight hours?",
    "options": [
      "Drive with dipped headlights switched on.",
      "Keep close to any vehicle in front with headlights off.",
      "Drive with main beam headlights switched on.",
      "Driver should not switch on lights until lighting up hours."
    ],
    "correct_answer": 0,
    "explanation": "Drivers need to see and be seen during all periods of low light levels - for example, at dusk and dawn and in some bad weather conditions. At times of low light, you should turn on dipped headlights.",
    "image_name": ""
  },
  {
    "index": 438,
    "id": "ABMW0392RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect does a wet road surface have on a vehicle's braking ability?",
    "options": [
      "It reduces the braking distance of that required on a dry surface.",
      "It makes no difference to the required braking distance.",
      "Generally, it doubles the braking distance of that required on a dry surface.",
      "Modern tyres provide grip on a wet road as effectively as on a dry road."
    ],
    "correct_answer": 2,
    "explanation": "When it is wet, your tyres do not grip the road surface as well as when it is dry and your stopping distance is increased. For these reasons you should slow down during or after rain and keep a greater distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 439,
    "id": "ABMW0397RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What stopping distance should a driver allow for when driving in snow or icy conditions?",
    "options": [
      "Up to ten times the normal distance.",
      "Twice the normal distance.",
      "The normal distance.",
      "Up to half the normal distance."
    ],
    "correct_answer": 0,
    "explanation": "When driving in snow or icy conditions a driver should allow a greater distance from the vehicle in front as stopping distances can be increased by up to ten times the normal.",
    "image_name": ""
  },
  {
    "index": 440,
    "id": "ABMW0399AU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Why does it take longer to stop the vehicle on a wet road?",
    "options": [
      "The brake fluid is less effective in wet weather.",
      "The tyres have less road grip than in dry weather.",
      "The suspension of the vehicle is lighter in wet weather.",
      "The tyres have more grip than in dry weather."
    ],
    "correct_answer": 1,
    "explanation": "When driving on wet road surfaces the grip of your tyres is reduced which may lead to significantly longer stopping distances. Drivers should be aware of these conditions and reduce speed as stopping quickly may result in skidding.",
    "image_name": ""
  },
  {
    "index": 441,
    "id": "ABMW0400RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the effect on the control of the vehicle if there is a film of water between the vehicle's tyres and the road surface?",
    "options": [
      "Steering will be more effective.",
      "Braking only will be less effective.",
      "Steering and braking will be less effective.",
      "Steering and braking will be more effective."
    ],
    "correct_answer": 2,
    "explanation": "When driving on a road where there is a lot of surface water, a film of water can build up between the tyres and the road surface. When this occurs it is called aquaplaning, it reduces the grip of the tyres on the road and can result in the total loss of control over the vehicle's steering and braking.",
    "image_name": ""
  },
  {
    "index": 442,
    "id": "ABMW0403RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving in slippery road conditions?",
    "options": [
      "Drive at lower speeds and use gentle acceleration and braking.",
      "Maintain a normal distance from the vehicle in front.",
      "Apply the brakes sharply from time to time to test the road surface.",
      "Drive at normal speed but allow extra stopping distance."
    ],
    "correct_answer": 0,
    "explanation": "When driving in slippery road conditions, drivers should be particularly smooth and gradual in the way they accelerate and brake. This will help to avoid skidding or slipping and helps to maintain control of the vehicle.",
    "image_name": ""
  },
  {
    "index": 443,
    "id": "ABMW0404RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when travelling downhill on snow or ice?",
    "options": [
      "Select an appropriate gear and brake gently to control speed.",
      "Use a higher gear than normal in order to avoid wheel spin.",
      "Avoid using the brake and use a high gear.",
      "Keep close to the left and brake sharply to reduce speed."
    ],
    "correct_answer": 0,
    "explanation": "When travelling downhill in snow or ice, you should select a lower gear to take advantage of engine braking and use the brakes very gently when you need to.",
    "image_name": ""
  },
  {
    "index": 444,
    "id": "ABMW0428RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In wet weather how might a driver judge what is a safe following distance from the vehicle in front?",
    "options": [
      "By allowing four vehicle lengths between the vehicles.",
      "By allowing two vehicle lengths between the vehicles.",
      "By allowing at least two seconds to elapse between the vehicle in front and the driver's own vehicle passing a fixed point.",
      "By allowing at least four seconds to elapse between the vehicle in front and the driver's own vehicle passing a fixed point."
    ],
    "correct_answer": 3,
    "explanation": "In wet conditions you should maintain a gap of at least four seconds from the vehicle in front - at least twice as long as in dry conditions.",
    "image_name": ""
  },
  {
    "index": 445,
    "id": "ABMW0435RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What lights should a driver use when driving in dense fog?",
    "options": [
      "Drive with sidelights and hazard warning lights.",
      "Drive with full headlights and fog lights.",
      "Drive with dipped headlights and fog lights.",
      "Drive with sidelights and fog lights."
    ],
    "correct_answer": 2,
    "explanation": "In dense fog you should use dipped headlights and fog lights (where fitted). Sidelights are not strong enough in fog, and full headlights can reflect off the fog and make it harder to see where you are going.",
    "image_name": ""
  },
  {
    "index": 446,
    "id": "ABMW0436R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving in dense fog?",
    "options": [
      "Reduce speed and use full headlights.",
      "Reduce speed and use dipped headlights.",
      "Drive along the central dividing line and watch for the reflective markings.",
      "Drive along the hard shoulder and watch for the reflective markers."
    ],
    "correct_answer": 1,
    "explanation": "In dense fog you should reduce your speed and use dipped headlights and fog lights (where fitted). Sidelights are not strong enough in fog, and full headlights can reflect off the fog and make it harder to see where you are going.",
    "image_name": ""
  },
  {
    "index": 447,
    "id": "ABMW0451RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver use fog lights on their vehicle?",
    "options": [
      "Use fog lights only in dense fog and falling snow.",
      "Switch on fog lights as a warning to pedestrians.",
      "Use fog lights on a badly lit country road.",
      "Use fog lights to improve visibility during light rain."
    ],
    "correct_answer": 0,
    "explanation": "A driver should use fog lights only during dense fog or falling snow. They must be switched off at all other times.",
    "image_name": ""
  },
  {
    "index": 448,
    "id": "ABMW0452RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When can a driver expect to encounter black ice?",
    "options": [
      "When the temperature drops close to freezing.",
      "Black ice only occurs on motorways.",
      "Only in the early hours of the morning.",
      "Only late at night."
    ],
    "correct_answer": 0,
    "explanation": "Black ice is an almost invisible and thin coating of ice on the surface of the road. Sometimes it can look like a sheet of water or as if the road is wet.",
    "image_name": ""
  },
  {
    "index": 449,
    "id": "ABMW0453RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if there is black ice on the road?",
    "options": [
      "Apply the brakes regularly to prevent them from freezing.",
      "Avoid harsh braking, steering and acceleration.",
      "Apply the brakes regularly to check road surface.",
      "Only use a low gear to improve traction."
    ],
    "correct_answer": 1,
    "explanation": "If a driver suspects black ice, they should avoid harsh braking, steering and acceleration. This will help reduce the risk of skidding.",
    "image_name": ""
  },
  {
    "index": 450,
    "id": "ABMW0454RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Where is black ice likely to occur on the road?",
    "options": [
      "Only in built-up areas.",
      "On a hard shoulder only.",
      "In sheltered or shaded areas.",
      "In mild weather on a coastal road."
    ],
    "correct_answer": 2,
    "explanation": "Black ice occurs when moisture freezes on a very cold surface. Exposed roads and bridges can have black ice when other sections of the same road may be clear. Black ice is virtually invisible, and so presents a particular hazard for motorcyclists and drivers. In wintry conditions, if you notice a reduction in tyre noise or if the steering becomes lighter, you should suspect that there may be black ice on the ",
    "image_name": ""
  },
  {
    "index": 451,
    "id": "ABMW0455RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the safest practice when driving on icy roads?",
    "options": [
      "Rely completely on the ABS or other advanced driver assistance systems.",
      "Drive at normal speed but apply the brakes from time to time to check for grip.",
      "Drive at a slower speed than usual using gentle acceleration and braking.",
      "Drive in a low gear at all times using maximum acceleration."
    ],
    "correct_answer": 2,
    "explanation": "When driving on icy roads a driver should avoid harsh braking, steering and acceleration. This will help reduce the risk of skidding.",
    "image_name": ""
  },
  {
    "index": 452,
    "id": "ABMW0456RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving, what effect could icy roads have on the vehicle?",
    "options": [
      "Rear tyre pressure increases.",
      "Tyre grip improves in lower temperatures.",
      "The vehicle would be more likely to skid.",
      "Front tyre pressure increases."
    ],
    "correct_answer": 2,
    "explanation": "Icy roads can have a dramatic effect on the way a vehicle handles, and there can be an increased risk of skidding. When driving on icy roads a driver should avoid harsh braking, steering and acceleration. This will help reduce the risk of skidding.",
    "image_name": ""
  },
  {
    "index": 453,
    "id": "ABMW0457RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving in slippery road conditions?",
    "options": [
      "Accelerate harder using only the lower gears.",
      "Brake regularly to improve tyre grip.",
      "Use gentle acceleration and braking.",
      "Drive slower than normal keeping a close distance to the vehicle in front."
    ],
    "correct_answer": 2,
    "explanation": "Tyres have less grip on the road when it is wet or icy. Slow down in slippery conditions, and keep a greater distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 454,
    "id": "ABMW0458RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver manage a steep hill or humpbacked bridge when the road is slippery?",
    "options": [
      "Select neutral gear position.",
      "Press the clutch only.",
      "Press the clutch and brake together.",
      "Drive with extreme care."
    ],
    "correct_answer": 3,
    "explanation": "Be extra careful when negotiating steep hills or humpbacked bridges in slippery conditions. Slow down gently on the approach, select the appropriate gear for the speed of the vehicle and use gentle steering and acceleration.",
    "image_name": ""
  },
  {
    "index": 455,
    "id": "ABMW0459RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Apart from the risk of skidding, what should the driver be aware of when driving in snow?",
    "options": [
      "The air in the tyres may freeze, causing them to burst.",
      "The brake fluid may freeze, causing the brakes to fail.",
      "Road signs and road markings may become obscured.",
      "The power steering fluid may freeze causing the steering to fail."
    ],
    "correct_answer": 2,
    "explanation": "Road signs and road markings may become obscured by snow. If this happens you may have difficulty reading regulatory, warning and information signs. This is the main reason why these signs are different shapes. Drivers should pay particular attention when travelling in these conditions.",
    "image_name": ""
  },
  {
    "index": 456,
    "id": "ABMW0460RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving in heavy rain?",
    "options": [
      "Be aware that the vehicle may slide or 'aquaplane'.",
      "Increase speed so that the vehicle will glide over any standing water.",
      "Weave the vehicle slightly in order to improve tyre grip.",
      "Maintain normal speeds as on a dry road."
    ],
    "correct_answer": 0,
    "explanation": "On a wet road, a film of water can build up between the tyres and the road surface. This is called aquaplaning and it has the effect of reducing the grip of the tyres on the road, and this affects the steering and braking. For these reasons the driver should slow down during and after rain and keep a greater distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 457,
    "id": "ABMW0461RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the danger in driving at high speeds on wet roads?",
    "options": [
      "Danger that tyre pressure will automatically increase.",
      "There is no danger provided that the tyre pressure has been increased to take account of weather conditions.",
      "Danger of 'aquaplaning' or sliding across the road surface.",
      "There is no danger provided that the tyre pressure has been reduced to take account of weather conditions."
    ],
    "correct_answer": 2,
    "explanation": "The driver should moderate their speed during heavy rain or where water is building up on the road surface. This will help to avoid 'aquaplaning' which has the effect of reducing the grip of the tyres on the road, and this affects the steering and braking. For these reasons the driver should slow down during and after rain and keep a greater distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 458,
    "id": "ABMW0465RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do after passing through a flooded section of road?",
    "options": [
      "Apply the handbrake gradually to dry out the rear brakes only.",
      "Increase the speed of the vehicle to dry out the brakes.",
      "Apply the brake pedal lightly at slow speed for a short distance to dry the brakes.",
      "Apply the brakes firmly to check if they are still effective."
    ],
    "correct_answer": 2,
    "explanation": "When driving through a flooded section of road, brakes may become less effective. If this happens, test brakes to ensure that they have not been affected by the water - check mirrors before doing so. If they have been affected, press gently on the brake pedal when driving until they dry out and return to normal.",
    "image_name": ""
  },
  {
    "index": 459,
    "id": "ABMW0467RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do where a section of road ahead has a shallow flooded area?",
    "options": [
      "Decrease speed and use a higher gear.",
      "Increase speed and use a higher gear.",
      "Drive in a low gear as slowly as possible keeping the revs high.",
      "Use a high gear and maintain the same speed keeping the engine revs low."
    ],
    "correct_answer": 2,
    "explanation": "When approaching a stretch of road with shallow flooding, reduce speed and assess the area for any danger. When driving through surface water, drive in a low gear as slowly as possible keeping the revs high to avoid stalling.",
    "image_name": ""
  },
  {
    "index": 460,
    "id": "ABMW13U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "After a heavy downpour, why should a driver keep a greater distance from the vehicle in front?",
    "options": [
      "Because tyre grip improves when wet.",
      "Because wheels rotate at a greater speed after rain.",
      "Because wheels rotate at a slower speed after rain.",
      "Because the required stopping distances is greater."
    ],
    "correct_answer": 3,
    "explanation": "On a wet road surface, your tyres do not grip the road surface as well as in dry conditions and your required stopping distance is increased. Because of that you should slow down during or after rain and keep a greater distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 461,
    "id": "ABMW0515RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In general, which of the following should a driver do before entering a tunnel?",
    "options": [
      "Switch on hazard warning lights to alert other traffic of their presence.",
      "Ensure that full headlights are switched on.",
      "Only use dipped headlights if there is other traffic in the tunnel.",
      "Ensure that dipped headlights are switched on."
    ],
    "correct_answer": 3,
    "explanation": "In general, a driver should switch on their dipped headlights before entering a tunnel.",
    "image_name": ""
  },
  {
    "index": 462,
    "id": "ABMW0516RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when entering a tunnel?",
    "options": [
      "Always switch off your radio to avoid distractions.",
      "Keep a safe distance from the vehicle in front.",
      "Drive closer to the vehicle in front.",
      "Never drive below the posted speed limit."
    ],
    "correct_answer": 1,
    "explanation": "The driver should keep a safe distance from the vehicle in front remembering that they are entering a tunnel and tailgating could create an emergency. The minimum recommended safe distance for a car or motor cycle is 50 metres and is 100 metres for all other vehicles. Always remember the 2 second rule.",
    "image_name": ""
  },
  {
    "index": 463,
    "id": "ABMW0520RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if there is very heavy traffic congestion in a tunnel?",
    "options": [
      "Keep close to the vehicle in front.",
      "Leave the vehicle.",
      "Switch on hazard warning lights.",
      "Stop at the nearest emergency exit."
    ],
    "correct_answer": 2,
    "explanation": "If there is traffic congestion in a tunnel, you should switch on hazard lights and remain patient. Keep a safe distance from the vehicle in front even in slow-moving traffic. Listen for traffic messages on the tunnel radio station, if available.",
    "image_name": ""
  },
  {
    "index": 464,
    "id": "ABMW0521RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if traffic comes to a halt in a tunnel?",
    "options": [
      "Select a low gear and keep the engine running.",
      "Switch off the engine.",
      "Switch on front and rear fog lights."
    ],
    "correct_answer": 1,
    "explanation": "If traffic comes to a halt in a tunnel, switch off your engine to prevent a build up of fumes in the tunnel. Stay patient and follow the instructions of the tunnel operators.",
    "image_name": ""
  },
  {
    "index": 465,
    "id": "ABMW0522R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle breaks down or they are involved in a collision in a tunnel?",
    "options": [
      "Signal all other traffic to stop.",
      "Beckon other traffic to overtake.",
      "Switch off all lights and remain in vehicle until help arrives.",
      "Switch on hazard warning lights and walk to emergency station to call for help."
    ],
    "correct_answer": 3,
    "explanation": "If your vehicle breaks down or is involved in a collision in a tunnel, switch on your hazard warning lights, switch off your engine, go to an emergency station and use the emergency phone to alert the tunnel operator.",
    "image_name": ""
  },
  {
    "index": 466,
    "id": "ABMW0523R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle breaks down in a tunnel?",
    "options": [
      "Use the emergency telephone to call for help.",
      "Walk to the end of the tunnel and call the Gardaí.",
      "Wait in the vehicle until help arrives.",
      "Flag down a passing motorist and ask for help."
    ],
    "correct_answer": 0,
    "explanation": "If your vehicle breaks down or is involved in a collision in a tunnel, switch on your hazard warning lights, switch off your engine, go to an emergency station and use the emergency phone to alert the tunnel operator.",
    "image_name": ""
  },
  {
    "index": 467,
    "id": "ABMW0524RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in the event of a breakdown or incident in a tunnel?",
    "options": [
      "Switch off the engine and switch on the hazard lights.",
      "Reverse the vehicle if necessary to make room for overtaking traffic.",
      "Beckon other traffic to overtake.",
      "Signal the vehicle behind to stop and ask the driver to summon help at the other end of the tunnel."
    ],
    "correct_answer": 0,
    "explanation": "If your vehicle breaks down or is involved in a collision in a tunnel, switch on your hazard warning lights, switch off your engine, go to an emergency station and use the emergency phone to alert the tunnel operator.",
    "image_name": ""
  },
  {
    "index": 468,
    "id": "ABMW0525R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle goes on fire in a tunnel?",
    "options": [
      "Leave the vehicle and use the fire extinguishers provided in the tunnel to extinguish the fire.",
      "Leave the vehicle and follow the emergency escape route.",
      "Drive to the nearest emergency station.",
      "Drive to the nearest fire exit."
    ],
    "correct_answer": 1,
    "explanation": "If your vehicle goes on fire in a tunnel, you should stop the vehicle as soon as possible, evacuate any passengers to a safe place, go to an emergency station and use the emergency phone to alert the tunnel operator.",
    "image_name": ""
  },
  {
    "index": 469,
    "id": "ABMW0462RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they encounter mud on the road?",
    "options": [
      "Gradually increase speed so that the mud on the road will not stick to the tyres.",
      "Apply the brakes immediately and put on the hazard warning lights.",
      "Reduce speed and be aware of farm or works vehicles on the road.",
      "Change to a lower gear and pump the brakes to see how slippery the surface is."
    ],
    "correct_answer": 2,
    "explanation": "Where there is mud on the road you should slow down and be aware that there is a danger of skidding. Your stopping distance will also be greater where there is mud on the road.",
    "image_name": ""
  },
  {
    "index": 470,
    "id": "ABMW0662RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does this dial provide information on?",
    "options": [
      "Gearbox revolution.",
      "Fuel level.",
      "Engine revolution.",
      "Oil level."
    ],
    "correct_answer": 2,
    "explanation": "The rev counter measures the speed of the engine, in revolutions per minute. Generally, the higher the revs, the more fuel the engine is using, so drivers should keep an eye on the rev counter to help drive in a more eco-friendly manner.",
    "image_name": "ABMW0662RU19.png"
  },
  {
    "index": 471,
    "id": "ABMW0663RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does a rev counter provide information on?",
    "options": [
      "Engine revolutions.",
      "Wheel revolutions.",
      "Heater-fan revolutions.",
      "Gear box revolutions."
    ],
    "correct_answer": 0,
    "explanation": "The rev counter measures the speed of the engine, in revolutions per minute. Generally, the higher the revs, the more fuel the engine is using, so drivers should keep an eye on the rev counter to help drive in a more eco-friendly manner.",
    "image_name": "ABMW0662RU19.png"
  },
  {
    "index": 472,
    "id": "ABMW0688RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does blue smoke coming from the vehicle's exhaust generally mean?",
    "options": [
      "The catalytic converter is worn out.",
      "The engine is overheating.",
      "The engine is burning oil.",
      "The air filter needs to be replaced."
    ],
    "correct_answer": 2,
    "explanation": "A vehicle can give off blue smoke from the exhaust when it is burning oil. Poor maintenance and worn engines are typical causes. This blue smoke is harmful to the environment and may be costly. Drivers should have the vehicle checked by a competent person.",
    "image_name": ""
  },
  {
    "index": 473,
    "id": "ABMW0689RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the effect of a worn exhaust?",
    "options": [
      "Fuel efficiency is increased as the fumes escape more quickly.",
      "The filtering of fumes is reduced and engine noise is louder.",
      "Gear-changing is more difficult.",
      "The engine overheats."
    ],
    "correct_answer": 1,
    "explanation": "A worn exhaust system can have a number of effects, including increased noise from the engine and more environmentally damaging fumes (as they are not filtered properly). There are requirements to ensure vehicles are compliant with EU and Irish legislation. Vehicles are tested for compliance during road worthiness testing.",
    "image_name": ""
  },
  {
    "index": 474,
    "id": "ABMW0690RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect can a faulty exhaust system have?",
    "options": [
      "It can increase wear on the vehicle's engine.",
      "It can reduce the vehicle's engine noise.",
      "It can improve the vehicle's fuel consumption.",
      "It can increase the vehicle's noise and pollution levels."
    ],
    "correct_answer": 3,
    "explanation": "A worn exhaust system can have a number of negative effects, including increased noise from the engine and more environmentally damaging fumes (as they are not filtered properly). There are requirements to ensure vehicles are compliant with EU and Irish legislation. Vehicles are tested for compliance during road worthiness testing.",
    "image_name": ""
  },
  {
    "index": 475,
    "id": "ABMW0691U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the purpose of a catalytic converter?",
    "options": [
      "It increases engine power.",
      "It decreases engine power.",
      "It filters exhaust gases and reduces air pollution.",
      "It allows the engine to quickly reach its normal operating temperature."
    ],
    "correct_answer": 2,
    "explanation": "The purpose of a catalytic converter (CAT) is to remove toxic or polluting gases such as carbon monoxide, nitrogen oxide and unburned hydrocarbons from the exhaust emissions. When the CAT is faulty, an engine management warning light illuminates on the dashboard and drivers should seek advice from a competent person.",
    "image_name": ""
  },
  {
    "index": 476,
    "id": "ABMW0715U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How does harsh acceleration affect fuel consumption?",
    "options": [
      "Fuel consumption decreases.",
      "There is no effect provided the engine is properly tuned.",
      "Fuel consumption increases.",
      "There is no effect if a high gear is engaged."
    ],
    "correct_answer": 2,
    "explanation": "Harsh acceleration increases fuel consumption. Smooth acceleration helps to reduce fuel consumption and the emissions from vehicles. Try not to over-rev the engine and use the appropriate gear for the speed of the vehicle. When slowing down, take your foot off the accelerator and allow the vehicle to slow progressively before you brake.",
    "image_name": ""
  },
  {
    "index": 477,
    "id": "ABMW0716RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to minimise fuel consumption in their vehicle?",
    "options": [
      "Use gentle acceleration and braking.",
      "Use maximum acceleration between gear changes.",
      "Drive gently in a low gear."
    ],
    "correct_answer": 0,
    "explanation": "Driving smoothly will help reduce fuel consumption. Read the road ahead and adjust speed in good time, and avoid harsh acceleration and late braking.",
    "image_name": ""
  },
  {
    "index": 478,
    "id": "ABMW0717RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How does continuous high-speed driving affect fuel consumption?",
    "options": [
      "It reduces fuel consumption as long as the road is straight.",
      "It increases fuel consumption.",
      "It uses the same consumption of fuel as lower speed driving.",
      "It reduces fuel consumption."
    ],
    "correct_answer": 1,
    "explanation": "Driving at continuous high speeds increases your fuel consumption. Vehicles driving at 112 km/h consumes approximately 30% more fuel than a vehicle travelling at 80 km/h.",
    "image_name": ""
  },
  {
    "index": 479,
    "id": "ABMW0718R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to ensure better fuel efficiency from their vehicle?",
    "options": [
      "Ensure that the vehicle is regularly serviced.",
      "Ensure that heavier items are carried at the rear of the vehicle.",
      "Drive at higher speeds in order to reduce the time spent on the road.",
      "Ensure any load carried is equally distributed on the vehicle."
    ],
    "correct_answer": 0,
    "explanation": "One of the keys to good fuel efficiency is making sure that your vehicle is well maintained. Servicing should be carried out as recommended by the manufacturer. Checking the tyre pressure regularly can also help ensure good fuel efficiency.",
    "image_name": ""
  },
  {
    "index": 480,
    "id": "ABMW0719RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How can fuel efficiency be improved?",
    "options": [
      "By using an anti-waxing agent only in freezing conditions.",
      "By using gentle acceleration and making gear changes appropriate to speed.",
      "By accelerating hard up through the gears to reach the desired speed as quickly as possible.",
      "By driving the vehicle in a lower gear for as long as possible."
    ],
    "correct_answer": 1,
    "explanation": "A driver can contribute to their vehicle's fuel efficiency by reading the road ahead and driving smoothly. This is achieved by accelerating gently, using the most appropriate gear for the speed they are travelling at and avoiding harsh braking.",
    "image_name": ""
  },
  {
    "index": 481,
    "id": "ABMW0720RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect does a worn exhaust have on a vehicle?",
    "options": [
      "It causes noise and gas pollution levels to increase.",
      "It causes the water coolant to leak from the engine.",
      "It decreases fuel consumption.",
      "It causes oil to leak on the road."
    ],
    "correct_answer": 0,
    "explanation": "A vehicle with a worn exhaust will probably be noisier and will produce more polluting emissions. There are strict regulations governing the noise and emission levels of vehicles, and these are rigorously checked during a vehicle's NCT.",
    "image_name": ""
  },
  {
    "index": 482,
    "id": "ABMW0725R",
    "section": "Safe and Socially Responsible Driving",
    "question": "In what way do motor vehicles harm the environment?",
    "options": [
      "By increasing carbon monoxide levels.",
      "By decreasing radon levels.",
      "By decreasing carbon monoxide levels.",
      "By increasing radon levels."
    ],
    "correct_answer": 0,
    "explanation": "Carbon monoxide is a poisonous gas emitted by vehicle exhausts into the atmosphere. Driving economically and keeping a vehicle well maintained can reduce the level of carbon monoxide emissions.",
    "image_name": ""
  },
  {
    "index": 483,
    "id": "ABMW0727RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What can a driver do to maximise fuel efficiency while driving?",
    "options": [
      "Increase road speed.",
      "Fit a roof rack.",
      "Reduce pressure in all tyres.",
      "Avoid carrying unnecessary weight."
    ],
    "correct_answer": 3,
    "explanation": "The more extra weight is in your vehicle, the more fuel you use. Using a roof rack or a roof box increases wind resistance and this also increases fuel consumption - by as much as 15%. Remove roof racks and roof boxes when not in use.",
    "image_name": ""
  },
  {
    "index": 484,
    "id": "ABMW0728RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which action is likely to cause an increase in fuel consumption?",
    "options": [
      "Driving at a constant speed.",
      "Turning off air conditioning.",
      "Harsh acceleration.",
      "Looking ahead and anticipating traffic flow."
    ],
    "correct_answer": 2,
    "explanation": "Harsh acceleration increases fuel consumption. Driving smoothly reduces wear and tear and also improves fuel consumption. Use the highest gear possible without causing the engine to labour.",
    "image_name": ""
  },
  {
    "index": 485,
    "id": "ABMW0729RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What alternatives can drivers take to help protect the environment?",
    "options": [
      "Only use low gears.",
      "Accelerate and brake harshly while driving.",
      "Use public transport."
    ],
    "correct_answer": 2,
    "explanation": "Using public transport helps to protect the environment. Buses, trams and trains are a more environmentally friendly way to move large numbers of people especially in urban areas. Consider using public transport where possible - not only is it more environmentally friendly, but it can also be more cost-effective when you take the cost of fuel and parking charges into account.",
    "image_name": ""
  },
  {
    "index": 486,
    "id": "ABMW0730R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What can be achieved by the driving style known as 'Eco-Driving'?",
    "options": [
      "Increased journey times.",
      "Increased fuel consumption.",
      "Reduced fuel consumption.",
      "Reduced journey times."
    ],
    "correct_answer": 2,
    "explanation": "The advantages of eco-driving include improved road safety, improved fuel consumption and reduced emissions. The eco-conscious driver becomes a more efficient driver because they learn to read the road further ahead and display better anticipation skills. This reduces the need for harsh acceleration and braking which results in a more economical style of driving and a smoother drive.",
    "image_name": ""
  },
  {
    "index": 487,
    "id": "ABMW0731R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which action contributes to eco-driving?",
    "options": [
      "Braking harshly.",
      "Fitting a roof rack.",
      "Driving in a low gear at high speed.",
      "Selecting a high gear as soon as possible."
    ],
    "correct_answer": 3,
    "explanation": "Eco-driving contributes to road safety and also reduces fuel consumption and harmful emissions. Eco-conscious drivers will read the road well in advance and avoid harsh acceleration and braking. Fuel consumption can be reduced by using the highest gear possible without causing the engine to labour.",
    "image_name": ""
  },
  {
    "index": 488,
    "id": "ABMW0732R",
    "section": "Safe and Socially Responsible Driving",
    "question": "How can a driver help the environment?",
    "options": [
      "By braking harshly.",
      "By harsh acceleration.",
      "By reducing speed.",
      "By increasing speed."
    ],
    "correct_answer": 2,
    "explanation": "As a driver you can do less damage to the environment if you drive smoothly and avoid harsh acceleration and braking. Vehicles travelling at 110 km/h use up to 30%  more fuel than those travelling at 80 km/h. However, you should not drive so slow as to inconvenience other road users.",
    "image_name": ""
  },
  {
    "index": 489,
    "id": "ABMW279U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What can be achieved by the driving style known as 'Eco-Driving'?",
    "options": [
      "Increased journey times.",
      "Improved road safety.",
      "Reduced journey times.",
      "Increased emissions."
    ],
    "correct_answer": 1,
    "explanation": "The advantages of eco-driving include improved road safety, improved fuel consumption and reduced emissions. The eco-conscious driver becomes a more efficient driver because they learn to read the road further ahead and display better anticipation skills. This reduces the need for harsh acceleration and braking which results in a more economical style of driving and a smoother drive.",
    "image_name": ""
  },
  {
    "index": 490,
    "id": "ABMW28U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What can be achieved by the driving style known as 'Eco-Driving'?",
    "options": [
      "Increased fuel consumption.",
      "Increased journey times.",
      "Increased fuel efficiency.",
      "Increased emissions."
    ],
    "correct_answer": 2,
    "explanation": "One of the many advantages of an eco-driving style, includes: Increased fuel efficiency, reduced emissions and improved driver safety. The eco-conscious driver becomes a more efficient driver because they learn to read the road further ahead and display better anticipation skills. This reduces the need for harsh acceleration and braking which results in a more economical style of driving and a smoother ",
    "image_name": ""
  },
  {
    "index": 491,
    "id": "ABMW29U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which action contributes to eco-driving?",
    "options": [
      "Braking harshly.",
      "Driving with the windows open.",
      "Maintaining a steady speed.",
      "Driving in a low gear at high speed."
    ],
    "correct_answer": 2,
    "explanation": "One of the many advantages of maintaining a steady speed includes: Increased fuel efficiency, reduced emissions and improved driver safety. The eco-conscious driver becomes a more efficient driver because they learn to read the road further ahead and display better anticipation skills. This reduces the need for harsh acceleration and braking which results in a more economical style of driving and a smoother ",
    "image_name": ""
  },
  {
    "index": 492,
    "id": "ABMW30U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which action contributes to eco-driving?",
    "options": [
      "Braking harshly.",
      "Looking ahead and anticipating.",
      "Driving in a low gear at high speed.",
      "Reducing tyre pressure."
    ],
    "correct_answer": 1,
    "explanation": "One of the many advantages of an eco-driving style, includes: Increased fuel efficiency, reduced emissions and improved driver safety. The eco-conscious driver becomes a more efficient driver because they learn to read the road further ahead and display better anticipation skills. This reduces the need for harsh acceleration and braking which results in a more economical style of driving and a smoother ",
    "image_name": ""
  },
  {
    "index": 493,
    "id": "ABMW0359R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should drivers do if they become drowsy while driving?",
    "options": [
      "Turn up the heating.",
      "Stop, take a break including a short walk if possible.",
      "Open a window or turn on the air conditioning to let cool air into the vehicle.",
      "Stop and have a good meal to boost energy levels."
    ],
    "correct_answer": 1,
    "explanation": "Driving when you are tired can be very dangerous, and tiredness is one of the main  causes of serious road collisions. If you become drowsy while driving, stop in a safe place and take a short nap. Then get some fresh air and stretch your legs for a few  minutes before setting off again. Taking a caffeine-based drink such as coffee may also help.",
    "image_name": ""
  },
  {
    "index": 494,
    "id": "ABMW0360RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do if they are driving and feel tired?",
    "options": [
      "The driver should drive along the centre of the road and reduce speed.",
      "The driver should stop and take a break.",
      "The driver should drive on the hard shoulder where available."
    ],
    "correct_answer": 1,
    "explanation": "Driving when you are tired can be very dangerous, and it may cause you to micro- sleep (or nod off momentarily). At 100 km/h you travel at 28 metres a second, so if you micro-sleep for just 4 seconds you would travel over 100 metres without being in control of the vehicle. Never drive if you are fighting sleep.",
    "image_name": ""
  },
  {
    "index": 495,
    "id": "ABMW0388RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect does alcohol have on driver behaviour?",
    "options": [
      "It slows down a driver's reactions.",
      "It can increase perception and awareness.",
      "It can reduce a driver's confidence.",
      "It does not affect driver behaviour or ability."
    ],
    "correct_answer": 0,
    "explanation": "Alcohol is a major factor in collisions that can lead to death and injury. Even small amounts of alcohol affect your judgement and ability to drive.",
    "image_name": ""
  },
  {
    "index": 496,
    "id": "ABMW0389RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect does drinking alcohol have on a driver?",
    "options": [
      "It increases concentration.",
      "It improves coordination.",
      "It reduces concentration.",
      "It increases awareness."
    ],
    "correct_answer": 2,
    "explanation": "Alcohol is a major factor in collisions that lead to death and injury. Even small amounts of alcohol affect your judgement, your concentration and your ability to react to hazards. A driver should never ever drink and drive.",
    "image_name": ""
  },
  {
    "index": 497,
    "id": "ABMW0390RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "If a motorist or a motorcyclist is taking medication which may affect their driving, what should they do?",
    "options": [
      "Drive for short distances only.",
      "Drive slower when under the influence of medication that affects driving.",
      "Drink plenty of water while driving.",
      "Seek medical advice in relation to driving."
    ],
    "correct_answer": 3,
    "explanation": "Some medication can affect a driver's ability to drive safely. If you are on medication of any kind, you should ask your doctor or pharmacist to tell you if it is safe to drive while taking it. Read the patient information leaflet supplied with the medication.",
    "image_name": ""
  },
  {
    "index": 498,
    "id": "ABMW0449RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving late at night what should a driver be aware of?",
    "options": [
      "That speed limits do not apply between midnight and 6:00 am.",
      "That all pedestrians will be wearing high-visibility clothing.",
      "That there is a danger of themselves or other drivers falling asleep.",
      "That trucks may drive in the outside lane of a motorway."
    ],
    "correct_answer": 2,
    "explanation": "Driving when tired can be very dangerous and driver fatigue is one of the main causes of serious road collisions. If a driver becomes drowsy while driving, they should stop in a safe place take a caffeine-based drink and take a short nap. After this they should then get some fresh air and stretch their legs for a few minutes before setting off again. The only cure for fatigue is proper sleep. Never ever drive ",
    "image_name": ""
  },
  {
    "index": 499,
    "id": "RSA00045A",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver is automatically disqualified from driving for how long if, on a first offence, they refused to provide a member of An Garda Síochána with a sample of blood, urine or breath?",
    "options": [
      "4 years.",
      "3 years.",
      "2 years.",
      "1 year."
    ],
    "correct_answer": 0,
    "explanation": "It is an offence not to comply with a request from a member of An Garda Siochana to provide to provide a sample of breath, urine or blood.",
    "image_name": ""
  },
  {
    "index": 500,
    "id": "RSA00046AU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which of the following is a possible consequence for a learner driver if they drive after drinking as little as just one unit of alcohol?",
    "options": [
      "A €90 fine.",
      "A €60 fine.",
      "A three month disqualification from driving.",
      "A one month disqualification from driving."
    ],
    "correct_answer": 2,
    "explanation": "The blood alcohol concentrate limit for novice/learner drivers is much lower than that of a driver who has held their full licence for more than two years (not a novice driver). Therefore as little as one unit of alcohol would result in the driver exceeding the lower limit.",
    "image_name": ""
  },
  {
    "index": 501,
    "id": "RSA00049A",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the maximum disqualification period imposed in court when the learner driver has a blood alcohol concentration (BAC) level in excess of 80 mg?",
    "options": [
      "One year.",
      "Four years.",
      "Six years.",
      "Two years."
    ],
    "correct_answer": 2,
    "explanation": "Where a learner driver has failed to pay a fixed penalty notice they will be summonsed to court where a judge can apply a disqualification period of between 1-6 years.",
    "image_name": ""
  },
  {
    "index": 502,
    "id": "RSA0200",
    "section": "Safe and Socially Responsible Driving",
    "question": "What are the drink driving penalties for a learner driver with a blood alcohol concentrate (BAC) of 20 mg to 80 mg per 100 millilitres of blood?",
    "options": [
      "€200 fine and 3 penalty points.",
      "€200 fine and 6 months driving disqualification.",
      "€200 fine and 3 months driving disqualification.",
      "€200 fine and 5 penalty points."
    ],
    "correct_answer": 2,
    "explanation": "Alcohol is a major factor in crashes that lead to death and injury. Research proves that even small amounts of alcohol affect your judgement and ability to drive. It is illegal to drive with alcohol levels above the legal limits.",
    "image_name": ""
  },
  {
    "index": 503,
    "id": "RSA0201",
    "section": "Safe and Socially Responsible Driving",
    "question": "What are the drink driving penalties for a professional driver holding a full car licence and found to have a blood alcohol concentrate (BAC) of 20 mg to 80 mg per 100 millilitres of blood?",
    "options": [
      "€200 fine and 3 months driving disqualification.",
      "There are no penalties below 50 mg (BAC).",
      "The penalties only apply over 80 mg (BAC).",
      "€100 fine and 6 months driving disqualification."
    ],
    "correct_answer": 0,
    "explanation": "Alcohol is a major factor in crashes that lead to death and injury. Research proves that even small amounts of alcohol affect your judgement and ability to drive. It is illegal to drive with alcohol levels above the legal limits.",
    "image_name": ""
  },
  {
    "index": 504,
    "id": "RSA0202",
    "section": "Safe and Socially Responsible Driving",
    "question": "What are the drink driving penalties for a driver with a blood alcohol concentrate (BAC) of 80 mg to 100 mg per 100 millilitres of blood?",
    "options": [
      "€400 fine and 6 months driving disqualification.",
      "€400 fine and 3 months driving disqualification.",
      "€200 fine and 3 months driving disqualification.",
      "€200 fine and 6 months driving disqualification."
    ],
    "correct_answer": 0,
    "explanation": "Alcohol is a major factor in crashes that lead to death and injury. Research proves that even small amounts of alcohol affect your judgement and ability to drive. It is illegal to drive with alcohol levels above the legal limits.",
    "image_name": ""
  },
  {
    "index": 505,
    "id": "RSA0203",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the penalty for a driver who refuses to give breath, blood or urine samples as evidence for a second offence to An Gárda Síochána?",
    "options": [
      "Automatic disqualification for 4 years.",
      "Automatic disqualification for 6 years.",
      "Automatic disqualification for 3 months.",
      "Automatic disqualification for 12 months."
    ],
    "correct_answer": 1,
    "explanation": "Alcohol is a major factor in crashes that lead to death and injury. Research proves that even small amounts of alcohol or drugs affect your judgement and ability to drive. It is illegal to drive with alcohol levels above the legal limits, or while under the influence of drugs. It is an offence to refuse to give a breath, blood or urine sample.",
    "image_name": ""
  },
  {
    "index": 506,
    "id": "RSA0204",
    "section": "Safe and Socially Responsible Driving",
    "question": "Can An Gárda Síochána conduct roadside testing for drugs and alcohol in the mornings?",
    "options": [
      "They can check for drugs only.",
      "No, they can't check until after midday.",
      "Yes, they can check at any time.",
      "They can check for alcohol only."
    ],
    "correct_answer": 2,
    "explanation": "It is against the law to drive a car, motor bike, truck, bus, pedal bike or an animal- drawn vehicle while 'under the influence of an intoxicant to such an extent as to be incapable of having control of the vehicle’. Intoxicants include alcohol and drugs, whether taken separately or together. The word 'drugs' here includes legal prescribed and Over-The-Counter (OTC) medicines.",
    "image_name": ""
  },
  {
    "index": 507,
    "id": "RSA0205",
    "section": "Safe and Socially Responsible Driving",
    "question": "Along with an impairment test, what may a Garda request if they suspect a driver of driving under the influence of drugs?",
    "options": [
      "A driver's licence.",
      "A saliva sample.",
      "A breath sample.",
      "An insurance certificate."
    ],
    "correct_answer": 1,
    "explanation": "If a driver is stopped at a roadside check, they should be aware that, along with the impairment test, Gardai can also request a saliva sample if they suspect the driver is driving under the influence of drugs.",
    "image_name": ""
  },
  {
    "index": 508,
    "id": "RSA0206",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the maximum penalty on conviction for drug driving?",
    "options": [
      "€3,000 fine and 12 months driving disqualification.",
      "€3,000 fine and 12 months in prison.",
      "€5,000 fine and 6 months in prison.",
      "€5,000 fine and 6 months driving disqualification."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should be aware of the severe penalties if they chose to drive having taken drugs and are detected. Drug driving is extremely dangerous due to the effect drugs have on the brain.",
    "image_name": ""
  },
  {
    "index": 509,
    "id": "RSA0207",
    "section": "Safe and Socially Responsible Driving",
    "question": "Do the limits for drink and drug driving differ if detected in the morning?",
    "options": [
      "No, they are the same at all times.",
      "No, unless tested after 10:00 am.",
      "Yes, they are lower in the mornings.",
      "Yes, they are higher in the evening."
    ],
    "correct_answer": 0,
    "explanation": "The limits for drink and drug driving do not change depending on the time of the day drivers are checked. Drink and drugs remain in the body for a period of time. A driver should think carefully before driving a vehicle the morning after taking drink or drugs, and be aware that they could still be well over the limit.",
    "image_name": ""
  },
  {
    "index": 510,
    "id": "RSA225300",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they feel tired before starting a journey?",
    "options": [
      "Open the windows in the vehicle before they start their journey.",
      "Do not start the journey until they are rested.",
      "Bring a cup of strong coffee to drink in the vehicle during the journey."
    ],
    "correct_answer": 1,
    "explanation": "A driver should not drive or begin a journey if they are feeling tired or fatigued. Research has shown that tired drivers are a major road safety risk, both to themselves and to others.",
    "image_name": ""
  },
  {
    "index": 511,
    "id": "RSA225301",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they experience micro-sleep whilst driving?",
    "options": [
      "Have a 20 minute sleep when they reach their destination.",
      "Stop in a safe place.",
      "Open all vehicle windows to reduce temperature."
    ],
    "correct_answer": 1,
    "explanation": "A driver should not drive while tired or fatigued. Research has shown that tired drivers are a major road safety risk, both to themselves and to others. If a driver is tired and fighting sleep, they are likely to experience \"micro-sleeps\" these episodes can last up to 10 seconds and can be experienced even when eyes are open. During a micro-sleep of even 4 seconds, a vehicle can travel 100 metres (more than the ",
    "image_name": ""
  },
  {
    "index": 512,
    "id": "RSA225302",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they are taking a medication which can make them feel drowsy?",
    "options": [
      "Continue driving until they begin to feel drowsy.",
      "Only drive during daylight hours.",
      "Do not drive a vehicle."
    ],
    "correct_answer": 2,
    "explanation": "It is against the law to drive a vehicle while under the influence of an intoxicant to such an extent as to be incapable of having control of the vehicle. Intoxicants include alcohol or drugs, whether taken separately or together. Drugs include legally prescribed or Over-The-Counter (OTC) medicines.",
    "image_name": ""
  },
  {
    "index": 513,
    "id": "ABMW0379U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Subject to the speed limit, what is the 'safest' speed to drive at?",
    "options": [
      "A driver should always try to drive at the speed limit for the road that they are on.",
      "The speed that will enable the driver to stop the vehicle within the distance ahead that they can see to be clear.",
      "A driver should always try to drive at the speed of other road users, regardless of the speed limit.",
      "The speed of the slowest vehicle on the road."
    ],
    "correct_answer": 1,
    "explanation": "You should always drive at a speed that allows you to stop within the distance that you can see to be clear ahead. If you don't think you could safely bring the vehicle to a stop within the range of what you can see, then you're driving too fast - slow down.",
    "image_name": ""
  },
  {
    "index": 514,
    "id": "ABMW0406RAU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the recommended minimum stopping distance for a car travelling at 50 km/h on a dry road?",
    "options": [
      "55 metres.",
      "15 metres.",
      "5 metres.",
      "25 metres."
    ],
    "correct_answer": 3,
    "explanation": "The total minimum stopping distance of a vehicle depends on four things: Perception time, reaction time, the vehicle's speed and the vehicle's braking capability. The recommend minimum stopping distance of a car driving at 50 km/h under dry conditions is 25 metres.",
    "image_name": ""
  },
  {
    "index": 515,
    "id": "ABMW0407RAU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the recommended minimum stopping distance for a car travelling at 50 km/h on a wet road?",
    "options": [
      "36 metres.",
      "16 metres.",
      "56 metres.",
      "76 metres."
    ],
    "correct_answer": 0,
    "explanation": "The total minimum stopping distance of a vehicle depends on four things: Perception time, reaction time, the vehicle's speed and the vehicle's braking capability. The recommend minimum stopping distance of a car driving at 50 km/h under wet conditions is 36 metres.",
    "image_name": ""
  },
  {
    "index": 516,
    "id": "ABMW0408RAU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the recommended minimum stopping distance for a car travelling at 100 km/h on a dry road?",
    "options": [
      "120 metres.",
      "30 metres.",
      "90 metres.",
      "70 metres."
    ],
    "correct_answer": 3,
    "explanation": "The total minimum stopping distance of a vehicle depends on four things: Perception time, reaction time, the vehicle's speed and the vehicle's braking capability. The recommend minimum stopping distance of a car driving at 100 km/h under dry conditions is 70 metres.",
    "image_name": ""
  },
  {
    "index": 517,
    "id": "ABMW0426R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which of the following affects the braking distance of a vehicle?",
    "options": [
      "The speed and weight of the vehicle.",
      "The use of unleaded fuel.",
      "The power of the engine.",
      "The brake-pad clearance."
    ],
    "correct_answer": 0,
    "explanation": "The overall stopping distance of your vehicle depends on its speed and weight - faster and heavier vehicles require greater stopping distances.",
    "image_name": ""
  },
  {
    "index": 518,
    "id": "ABMW0488RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when joining a motorway from a slip road?",
    "options": [
      "Try to match the vehicle speed to that of traffic already on the motorway and merge into it in a suitable gap.",
      "Drive directly onto the motorway as the driver on the acceleration lane has right of way.",
      "Always stop at the end of the acceleration lane and yield to traffic on the motorway.",
      "Drive along the hard shoulder until a suitable gap appears in the motorway traffic to allow the driver to merge into it."
    ],
    "correct_answer": 0,
    "explanation": "When joining a motorway a driver should try to match their speed to that of the motorway traffic and merge into it when a suitable gap appears, avoiding driving in the hard shoulder, while yielding to traffic already on the motorway.",
    "image_name": ""
  },
  {
    "index": 519,
    "id": "ABMW0490RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a motorway, what should a driver do if they miss their exit?",
    "options": [
      "Wait on the hard shoulder until a suitable gap appears in traffic from both directions and then cross to the opposite side of the motorway.",
      "Leave the motorway at the next exit and cross to the other side using the fly-over (or underpass).",
      "Cross to the opposite side of the motorway when there is a suitable gap in the oncoming traffic.",
      "Stop on the hard shoulder, switch on their hazard lights and reverse back to the desired exit."
    ],
    "correct_answer": 1,
    "explanation": "If a driver misses their intended exit when driving on a motorway, they should proceed to the next junction exit where they can leave the motorway and then rejoin it on the opposite side of the motorway.",
    "image_name": ""
  },
  {
    "index": 520,
    "id": "ABMW0492RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when entering a slip road after leaving a motorway?",
    "options": [
      "Comply with the speed limit on the road the driver is joining.",
      "Always reduce speed gradually for a few kilometres.",
      "There is never a need to adjust speed when on a slip road.",
      "Brake severely when entering the slip road in order to slow down."
    ],
    "correct_answer": 0,
    "explanation": "When a driver is leaving a motorway, they should enter the deceleration lane and reduce their speed. They should comply with the speed limit of the road they are entering.",
    "image_name": ""
  },
  {
    "index": 521,
    "id": "ABMW0493RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they drive past their intended exit by mistake?",
    "options": [
      "Use the emergency telephone to ask for advice.",
      "Stop on the hard shoulder and reverse back to the exit.",
      "Drive on and leave at the next exit.",
      "Carefully complete a U-turn."
    ],
    "correct_answer": 2,
    "explanation": "If a driver misses their intended exit when driving on a motorway, they should proceed to the next junction exit where they can leave the motorway and then rejoin it in the opposite direction.",
    "image_name": ""
  },
  {
    "index": 522,
    "id": "ABMW0494RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the main difference between driving on a motorway and driving on other types of road?",
    "options": [
      "Traffic is generally permitted to travel at a higher speed on a motorway.",
      "Learner permit holders must be accompanied by a full licence holder.",
      "Traffic generally travels at lower speeds on a motorway than on a dual-carriageway.",
      "Traffic travelling at 120 km/h must only use the outside lane of a motorway."
    ],
    "correct_answer": 0,
    "explanation": "Motorways are designed so that traffic can move faster and more freely, without traffic lights, crossroads, level crossings and other road features that might slow down traffic. There are also restrictions on who may use a motorway - for example learner-drivers and motorcycles under 50 cc are prohibited.",
    "image_name": ""
  },
  {
    "index": 523,
    "id": "ABMW0495RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "On a 2-lane motorway, what procedure should a driver adopt when wishing to overtake another vehicle safely?",
    "options": [
      "Use their mirrors, signal and overtake in the right-hand lane when it is safe to do so.",
      "Signal, use their mirrors and overtake in any available lane when it is safe to do so.",
      "Use their mirrors, signal and overtake in the left-hand lane only.",
      "Check for following traffic and overtake in either lane."
    ],
    "correct_answer": 0,
    "explanation": "When a driver wants to overtake on a motorway, they should generally only overtake on the right unless traffic is travelling in slow moving queues. The driver should use the Mirror-Signal-Mirror (blind spots)-Manoeuvre routine. Check mirrors, signal intention, check mirrors again (and blind spots), and complete the manoeuvre when itis safe to do so. They should pay particular attention to the speed of the traffic ",
    "image_name": ""
  },
  {
    "index": 524,
    "id": "RSA225170",
    "section": "Safe and Socially Responsible Driving",
    "question": "When can a driver travel in the right-hand lane on a dual carriageway?",
    "options": [
      "When overtaking a vehicle in the left-hand lane.",
      "In order to keep a greater distance from the hard shoulder.",
      "When following other traffic in the right-hand lane."
    ],
    "correct_answer": 0,
    "explanation": "You must normally drive in the left-hand lane of a dual carriageway. You should not use the right-hand lane as a driving lane. You may use the right-hand lane when overtaking or when intending to turn right a short distance ahead.",
    "image_name": ""
  },
  {
    "index": 525,
    "id": "RSA225191",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver move into an auxiliary lane on a motorway?",
    "options": [
      "To leave the motorway.",
      "To overtake slower traffic in other lanes.",
      "To allow other traffic to overtake."
    ],
    "correct_answer": 0,
    "explanation": "Auxiliary lanes are found on some motorways and are to the left of the main motorway lanes. They link the off-ramp of the road you are leaving with the next available off-ramp or exit. If a driver is already in lane 1 of the motorway and they intend to take the next exit, they should enter the auxiliary lane to do so. The auxiliary lane is normally identified by a broken white line to the right of the lane, ",
    "image_name": ""
  },
  {
    "index": 526,
    "id": "ABMW0222RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the correct action to take in this situation?",
    "options": [
      "Keep a close eye on the children and be prepared to brake in good time.",
      "Drive closer to the left-hand side (nearside) and sound the horn.",
      "Continue to drive at the same speed."
    ],
    "correct_answer": 0,
    "explanation": "Because it is difficult to predict children's behaviour, you should always be prepared to react to a change in the traffic situation or to stop.",
    "image_name": "ABMW0222RU23.png"
  },
  {
    "index": 527,
    "id": "ABMW0249RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do when approaching this situation?",
    "options": [
      "The driver should maintain current speed and reduce distance from the silver car.",
      "The driver should be prepared for the vehicle in front to increase speed.",
      "The driver may overtake the car and the girl as the road is marked with a broken white line.",
      "Reduce speed and remain ready to brake since the girl on the footpath could suddenly cross the road."
    ],
    "correct_answer": 3,
    "explanation": "It is often difficult to predict other road users behaviour. You should be prepared in case the pedestrian steps onto the road and the silver car stops suddenly.",
    "image_name": "ABMW0249RU19.png"
  },
  {
    "index": 528,
    "id": "ABMW0346R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver use the vehicle's rear view mirror?",
    "options": [
      "Before switching on the rear demister.",
      "Before reversing only.",
      "Before moving off only.",
      "Before changing direction."
    ],
    "correct_answer": 3,
    "explanation": "You should use your mirrors to stay aware of traffic situations behind and around you. Always check your mirror before you change direction on a road, and before you signal or begin a manoeuvre.",
    "image_name": ""
  },
  {
    "index": 529,
    "id": "ABMW0347RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver proceed if their view is blocked at a junction?",
    "options": [
      "Ask a passer-by for guidance onto the other road.",
      "Move out slowly onto the road while watching carefully for other traffic.",
      "Sound the horn several times and proceed.",
      "Flash headlights on and off before moving out."
    ],
    "correct_answer": 1,
    "explanation": "At junctions where the view is blocked, move carefully into a position where you can see without interfering with other road users. Then assess the situation before you continue.",
    "image_name": ""
  },
  {
    "index": 530,
    "id": "ABMW0354RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "Where are the blind spots that a driver needs to be aware of when towing a loaded trailer?",
    "options": [
      "The goods or cargo area on the back of the trailer.",
      "The area to the side and rear of the vehicle and the trailer that the driver cannot see.",
      "Parts of the road ahead which are blocked by other large vehicles.",
      "The view to the front hidden by the sun-visor."
    ],
    "correct_answer": 1,
    "explanation": "A blind spot is an area that a driver cannot see when looking forward or when looking in the mirrors. You should check your blind spots before changing direction or changing lane. The bigger the vehicle, the bigger the blind spots, and you should keep this in mind if you are driving behind a large vehicle, such as one towing a loaded trailer. In this situation, if you cannot see the towing vehicle's mirror, then the ",
    "image_name": ""
  },
  {
    "index": 531,
    "id": "ABMW0357RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver who wishes to perform a U-turn do?",
    "options": [
      "Only perform a U-turn outside the urban speed limit area.",
      "Check behind for approaching traffic and signal them to stop.",
      "Check that the road is not one way.",
      "Check ahead for approaching traffic and signal them to stop."
    ],
    "correct_answer": 2,
    "explanation": "If you want to do a U-turn you must first choose a place where it is safe and legal to do it. Check all around for other road users and do not impede their right of way. Complete the manoeuvre efficiently and safely.",
    "image_name": ""
  },
  {
    "index": 532,
    "id": "ABMW0358RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do who wishes to turn a vehicle around on the road?",
    "options": [
      "Drive onto a footpath if necessary in order to ensure that they have enough room to turn.",
      "Check ahead and behind for oncoming traffic and turn the vehicle around while still keeping a look out.",
      "It is not allowed to turn a vehicle around on the road in any circumstance.",
      "Drive into somebody's driveway and reverse back onto the road."
    ],
    "correct_answer": 1,
    "explanation": "If you want to turn a vehicle around on the road, you must first choose a place where it is safe and legal to do so. Check all around for other road users and do not impede their right of way. Complete the manoeuvre efficiently and safely.",
    "image_name": ""
  },
  {
    "index": 533,
    "id": "ABMW0387RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they want to safely change to the lane on the right in which there is other traffic?",
    "options": [
      "Use the mirror, signal and move into the right-hand lane when a suitable gap appears in the traffic in that lane.",
      "Pull in and stop, wait until a suitable gap appears and then move out to the right-hand lane.",
      "Increase speed until travelling at the same speed as the traffic in the right lane, then move over and check mirrors.",
      "Move gradually into the right-hand lane, indicate and then check mirrors."
    ],
    "correct_answer": 0,
    "explanation": "Any time you change lanes, you should use the Mirror-Signal-Mirror (blind spots) - Manoeuvre routine. Check your mirrors, signal your intention, check your mirrors again (and your blind spots), and when a suitable gap becomes available manoeuvre the vehicle into the next lane, giving way to traffic already in that lane.",
    "image_name": ""
  },
  {
    "index": 534,
    "id": "ABMW0683RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver be able to see in the vehicle mirrors when they are properly adjusted?",
    "options": [
      "The area behind and to each side of the vehicle.",
      "The passenger area of the vehicle.",
      "The position of all the wheels.",
      "The position of the left-side wheels."
    ],
    "correct_answer": 0,
    "explanation": "Properly adjusted vehicle mirrors enable drivers to see the road behind and to the sides. This helps drivers to take into account what's happening behind them, so that they can make informed, correct and safer decisions.",
    "image_name": ""
  },
  {
    "index": 535,
    "id": "ABMW0684RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver be able to see in the exterior mirrors of a vehicle when they are properly adjusted?",
    "options": [
      "The sides of the vehicle only.",
      "The area to each side of the vehicle.",
      "60% angled to the vehicle and 40% to the road.",
      "The back of the vehicle only."
    ],
    "correct_answer": 1,
    "explanation": "Exterior mirrors enable drivers to see the area on each side of the vehicle. Drivers must take into account all visible hazards in order to make informed, correct and safer decisions.",
    "image_name": ""
  },
  {
    "index": 536,
    "id": "ABMW0685U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "The vehicle's exterior mirrors are covered by a film of mud and dust. What should the driver do?",
    "options": [
      "Drive in the slip stream of other traffic, as this will eventually clean the mirrors.",
      "Continue on and clean them after reaching the destination.",
      "Angle the mirrors towards the front for a distance in order to clean them.",
      "Clean them with a cloth or tissue before starting their journey."
    ],
    "correct_answer": 3,
    "explanation": "The purpose of mirrors is to increase the driver's view to the rear and sides of the vehicle and to enable them to take into account all visible hazards. Proper use will enable drivers to make informed, correct and safer decisions. Drivers should ensure that all mirrors, including the exterior ones, are clean and properly adjusted at all times to ensure optimum view.",
    "image_name": ""
  },
  {
    "index": 537,
    "id": "ABMW0687U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect can wet weather have on a vehicle's exterior mirrors?",
    "options": [
      "Water droplets help to keep them clean.",
      "Water droplets can obscure the reflected image.",
      "Water can cause a short-circuit in the electrically heated mirrors.",
      "Water droplets can make the reflected object appear closer than it really is."
    ],
    "correct_answer": 1,
    "explanation": "When driving in wet weather conditions, small water droplets can form on the glass of the exterior mirrors. This could make it more difficult to see the road behind and to the sides. Switch on the mirror demisters, if they are fitted. If necessary, stop and clear them.",
    "image_name": ""
  },
  {
    "index": 538,
    "id": "ABMW0212RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When may you pass another vehicle on the left-hand side?",
    "options": [
      "When a driver cannot pass on the right-hand side because of oncoming traffic.",
      "When the vehicle in front is signalling to turn right or in slow moving lanes of traffic.",
      "A driver must never overtake on the left.",
      "When there is enough space to do so."
    ],
    "correct_answer": 1,
    "explanation": "Normally you must overtake on the right. There are, however, circumstances where you may overtake on the left - for example, when the vehicle has moved out and signalled to turn right.",
    "image_name": ""
  },
  {
    "index": 539,
    "id": "ABMW0396RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when overtaking parked vehicles in a residential area?",
    "options": [
      "Allow enough clearance when passing.",
      "Keep close to the parked vehicles allowing maximum room for oncoming traffic.",
      "Increase speed to overtake the vehicles as quickly as possible.",
      "Move as far to the right as possible."
    ],
    "correct_answer": 0,
    "explanation": "When you are passing parked vehicles in a residential area, move into a safe overtaking position in good time and leave plenty of clearance between your vehicle and the parked vehicles to increase visibility of small children in the area and in case someone opens their car door in front of you.",
    "image_name": ""
  },
  {
    "index": 540,
    "id": "RSA225272",
    "section": "Safe and Socially Responsible Driving",
    "question": "When overtaking a cyclist what should a driver be aware of?",
    "options": [
      "The cyclist may suddenly change direction.",
      "The cyclist is not wearing a safety helmet.",
      "The cyclist is only permitted to use the bus lane."
    ],
    "correct_answer": 0,
    "explanation": "Cyclists are just as entitled to use the road as other vehicles, and drivers need to pay special attention to them. Cyclists are vulnerable road users and sometimes make sudden movements - for example, to avoid a pothole, some broken glass or other debris on the road. Sufficient clearance should be given when overtaking them to lessen the possible danger.",
    "image_name": ""
  },
  {
    "index": 541,
    "id": "RSA225310",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver ensure when overtaking a cyclist?",
    "options": [
      "Overtake when the cyclist pulls in and stops.",
      "Overtake only when the cyclist is in a cycle lane.",
      "Overtake giving them plenty of space."
    ],
    "correct_answer": 2,
    "explanation": "Cyclists are vulnerable road users. Motorists must give good clearance when overtaking cyclists.",
    "image_name": ""
  },
  {
    "index": 542,
    "id": "RSA225311",
    "section": "Safe and Socially Responsible Driving",
    "question": "Is a driver allowed to exceed the speed limit when overtaking?",
    "options": [
      "The driver may exceed the speed limit briefly in order to complete the manoeuvre.",
      "The driver may not exceed the speed limit when overtaking.",
      "The driver may exceed the speed limit if the vehicle in front is turning left."
    ],
    "correct_answer": 1,
    "explanation": "When overtaking the driver is not permitted to exceed the speed limit.",
    "image_name": ""
  },
  {
    "index": 543,
    "id": "RSA225312",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is a driver allowed to overtake another vehicle on the left?",
    "options": [
      "A driver is never allowed to overtake on the left.",
      "When on the motorway in fast moving traffic.",
      "When the driver is turning left."
    ],
    "correct_answer": 2,
    "explanation": "Drivers must normally overtake on the right however they may overtake on the left when they have signalled that they intend to turn left and it is done in a safe manner relative to the traffic conditions.",
    "image_name": ""
  },
  {
    "index": 544,
    "id": "ABMW0507RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When approaching a roundabout, to whom should a driver give way?",
    "options": [
      "The driver approaching the roundabout always has right of way.",
      "The driver must give way to traffic approaching from the right or already on the roundabout.",
      "The driver must only give way to pedestrians and cyclists on the roundabout."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should always approach roundabouts with caution. They should be prepared to give way to traffic on the right, traffic already on the roundabout, pedestrians already crossing and to always stop if necessary.",
    "image_name": ""
  },
  {
    "index": 545,
    "id": "ABMW0508R",
    "section": "Safe and Socially Responsible Driving",
    "question": "In what direction should a driver turn when entering a roundabout?",
    "options": [
      "To the right.",
      "To either left or right.",
      "To the right when controlled by a traffic light.",
      "To the left."
    ],
    "correct_answer": 3,
    "explanation": "By law you must enter a roundabout by turning to the left and giving way to traffic already on the roundabout.",
    "image_name": ""
  },
  {
    "index": 546,
    "id": "ABMW0509RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In general, where two lanes are provided on the approach to a roundabout, which lane should a driver select when they intend taking an exit to the right (past the 12 o'clock position) of the roundabout?",
    "options": [
      "By straddling both lanes.",
      "The left-hand lane.",
      "Either lane.",
      "The right-hand lane."
    ],
    "correct_answer": 3,
    "explanation": "When a driver approaches a roundabout where two lanes are provided, they should choose the most suitable one based on the road markings and the exit they intend to take off the roundabout. The left lane is generally used for vehicles exiting to the left (9 o'clock) or straight ahead (12 o'clock) and the right is for vehicles exiting at any exit after 12 o'clock.",
    "image_name": ""
  },
  {
    "index": 547,
    "id": "ABMW0510RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What position should a driver generally adopt on approach to a roundabout when intending to take the first exit to the left?",
    "options": [
      "Approach by straddling both lanes.",
      "Approach in the right-hand lane.",
      "Approach in any lane available.",
      "Approach in the left-hand lane."
    ],
    "correct_answer": 3,
    "explanation": "When a driver intends to take any exit between the 6 o'clock and 12 o'clock positions they should generally approach the roundabout in the left lane unless road markings dictate otherwise.",
    "image_name": ""
  },
  {
    "index": 548,
    "id": "ABMW0224R",
    "section": "Safe and Socially Responsible Driving",
    "question": "As the driver of the car, which conduct is correct?",
    "options": [
      "A driver must drive on the right-hand side to allow clearance to the motorcyclist.",
      "A driver must give way to traffic on the left.",
      "Slow down and beckon the motorcyclist to cross the road.",
      "A driver may proceed with caution."
    ],
    "correct_answer": 3,
    "explanation": "You may proceed, but you should be aware of the presence of the motorcyclist. You should always be prepared to react to a change in the traffic situation - for example, the motorcyclist might not have seen your vehicle.",
    "image_name": "ABMW0224R.png"
  },
  {
    "index": 549,
    "id": "ABMW0228R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do in this situation?",
    "options": [
      "The driver may proceed onto the roundabout in front of the yellow car.",
      "As the driver is entering the roundabout they have right of way.",
      "The driver must yield to the yellow car on the roundabout.",
      "The driver must wait for the yellow car to stop."
    ],
    "correct_answer": 2,
    "explanation": "When you reach the roundabout, you must give way to traffic approaching from the right - unless signs, road markings or traffic lights tell you otherwise.",
    "image_name": "ABMW0228R.png"
  },
  {
    "index": 550,
    "id": "ABMW0230R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do in this situation?",
    "options": [
      "The driver must allow the red car to proceed.",
      "The driver must stop and allow all other traffic to proceed.",
      "The driver must allow the blue car to proceed.",
      "The driver may turn in front of the other two cars."
    ],
    "correct_answer": 3,
    "explanation": "When you are turning right from a major road to a minor road, you must yield to oncoming traffic and only proceed when it is safe to do so. However, the drivers on the minor roads must give way to the traffic on the major road.",
    "image_name": "ABMW0230R.png"
  },
  {
    "index": 551,
    "id": "ABMW0233RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do in this situation?",
    "options": [
      "The driver may continue ahead with caution.",
      "The driver must allow the van to cross the junction.",
      "The cyclist must allow the other vehicles to proceed.",
      "The cyclist must proceed first."
    ],
    "correct_answer": 0,
    "explanation": "On approaching a crossroads you should check the road sign to see which traffic has priority and be prepared for emerging traffic from either side. Vehicles do not have an automatic right of way on the road. The overriding rule is to proceed with caution in all circumstances.",
    "image_name": "ABMW0233RU19.png"
  },
  {
    "index": 552,
    "id": "ABMW0234RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do in this situation?",
    "options": [
      "The driver must turn left.",
      "The driver must allow the orange car to cross.",
      "The driver is not allowed to turn right.",
      "The driver may turn right."
    ],
    "correct_answer": 3,
    "explanation": "You may turn right if there no oncoming traffic but you should also be aware that there might be traffic emerging from the minor roads.",
    "image_name": "ABMW0234RU19.png"
  },
  {
    "index": 553,
    "id": "ABMW0235R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do in this situation?",
    "options": [
      "The driver may proceed first.",
      "The driver must allow the blue truck to proceed.",
      "The driver must allow the red car to proceed."
    ],
    "correct_answer": 1,
    "explanation": "When you are turning right from a major road to a minor road, you must yield to oncoming traffic and proceed only when it is safe to do so. You should also be aware that there might be emerging from the minor road.",
    "image_name": "ABMW0235R.png"
  },
  {
    "index": 554,
    "id": "ABMW0250R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do?",
    "options": [
      "The driver must stop and yield to all traffic.",
      "The driver should allow the oncoming cyclist to turn first.",
      "The driver should allow the yellow car to proceed.",
      "The driver may turn left first."
    ],
    "correct_answer": 2,
    "explanation": "At a cross junction of equal importance the traffic approaching from the right has priority. It is important to understand that the right of way is not an absolute right. You must proceed with caution while showing regard for other road users.",
    "image_name": "ABMW0250R.png"
  },
  {
    "index": 555,
    "id": "ABMW0254R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What action should the driver take?",
    "options": [
      "Stop at the stop line.",
      "Proceed in front of the bus.",
      "Proceed in front of the cyclist.",
      "Signal the bus to proceed."
    ],
    "correct_answer": 0,
    "explanation": "By law you must stop at a stop line (or at a STOP sign if there is no stop line), and wait for other traffic to clear before proceeding.",
    "image_name": "ABMW0254R.png"
  },
  {
    "index": 556,
    "id": "ABMW0261R",
    "section": "Safe and Socially Responsible Driving",
    "question": "The driver intends to turn left at this junction - what should the driver do?",
    "options": [
      "Allow the cyclist to continue before turning left.",
      "Yield right of way to the van.",
      "Allow the van and cyclist to proceed.",
      "Turn left in front of the cyclist."
    ],
    "correct_answer": 0,
    "explanation": "Do not overtake a cyclist as you approach a junction at which you are turning left. The cyclist might be continuing ahead. Cyclists are vulnerable road users and may be unstable in slow-moving traffic and at junctions. Give them more room.",
    "image_name": "ABMW0261R.png"
  },
  {
    "index": 557,
    "id": "ABMW0264RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "The driver intends to turn right at this junction - what should the driver do?",
    "options": [
      "Proceed after the motorcycle and bus have passed.",
      "Proceed in front of the bus only.",
      "Proceed after the motorcycle only.",
      "Proceed in front of the bus and motorcyclist."
    ],
    "correct_answer": 0,
    "explanation": "When you are turning right at a junction, you should yield to traffic on the major road, and to oncoming traffic at the junction.",
    "image_name": "ABMW0264RU19.png"
  },
  {
    "index": 558,
    "id": "ABMW0265RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "The driver intends to turn right at this junction - what should the driver do?",
    "options": [
      "Stop in front of the bus.",
      "Stop at the line.",
      "Stop in front of the motorcycle."
    ],
    "correct_answer": 1,
    "explanation": "You must stop at the line where a junction is controlled by a STOP sign and stop line. Do not proceed until it is safe to do so.",
    "image_name": "ABMW0265RU23.png"
  },
  {
    "index": 559,
    "id": "ABMW0270RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When intending to turn right as shown, what should the car driver do?",
    "options": [
      "Continue with care as the driver has right of way.",
      "Wait and allow the oncoming vehicle to pass.",
      "Wait and allow the truck and the oncoming vehicle to proceed first.",
      "Wait and allow the truck to proceed first."
    ],
    "correct_answer": 1,
    "explanation": "When you are turning right from a main road onto a side road, you must by law give way to oncoming traffic on the main road.",
    "image_name": "ABMW0270RU19.png"
  },
  {
    "index": 560,
    "id": "ABMW0272RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What action should a driver take on approach to the brow of this hill?",
    "options": [
      "Reduce speed as possible hazards ahead.",
      "Comply with the road markings.",
      "Maintain normal speed."
    ],
    "correct_answer": 0,
    "explanation": "On the approach to the brow of a hill you should be extra careful and be prepared to react to a change in the traffic situation.",
    "image_name": "ABMW0272R.png"
  },
  {
    "index": 561,
    "id": "ABMW0279R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when continuing straight ahead in the middle lane?",
    "options": [
      "Overtake the other vehicles quickly on the right-hand side.",
      "Take any lane as convenient.",
      "Take position in the right-hand lane even if proceeding straight ahead.",
      "Slow down and allow the driver in front to change lanes."
    ],
    "correct_answer": 3,
    "explanation": "You should always keep a safe distance from the vehicle in front especially when it is slowing down or stopping.",
    "image_name": "ABMW0279R.png"
  },
  {
    "index": 562,
    "id": "ABMW0282RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when following the motorcyclist, and the white car is reversing onto the road?",
    "options": [
      "The reversing driver will stop when they see the motorcyclist.",
      "The motorcyclist may signal the reversing driver to stop.",
      "The driver following the motorcycle may need a longer braking distance than normal.",
      "The brake lights on the motorcycle may not be working."
    ],
    "correct_answer": 2,
    "explanation": "You should always keep a safe distance from the vehicle in front if it is slowing down or stopping. Always read the road and be prepared to react correctly to changes in the traffic ahead.",
    "image_name": "ABMW0282RU19.png"
  },
  {
    "index": 563,
    "id": "ABMW0283R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do on the approach to this situation?",
    "options": [
      "Reduce speed and stop if necessary.",
      "Drive on because the oncoming traffic must wait.",
      "Give way only if you are towing a trailer or caravan.",
      "Increase speed in order to clear the bridge before the oncoming car."
    ],
    "correct_answer": 0,
    "explanation": "When road priority is unclear you might have to yield to oncoming vehicles. Never drive a vehicle into an area that it might not be able to clear or where it could cause an obstruction or bottleneck.",
    "image_name": "ABMW0283R.png"
  },
  {
    "index": 564,
    "id": "ABMW0288RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on this one-way street with vehicles parked on both sides, what should a driver be prepared for?",
    "options": [
      "Pedestrians crossing between the vehicles.",
      "Oncoming traffic as the driver overtakes the truck.",
      "The truck may be a left-hand drive vehicle."
    ],
    "correct_answer": 0,
    "explanation": "When driving on a one-way street, you should be extra careful and be prepared to react to a change in the traffic situation.",
    "image_name": "ABMW0288R.png"
  },
  {
    "index": 565,
    "id": "ABMW0290RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in this situation when intending to turn left?",
    "options": [
      "Yield to pedestrians already crossing.",
      "Stop and beckon both pedestrians to cross.",
      "Proceed between both pedestrians."
    ],
    "correct_answer": 0,
    "explanation": "By law you must yield to pedestrians already crossing at a junction. Pedestrians are vulnerable road users and you should be extra careful driving at places where pedestrians are attempting to cross the road.",
    "image_name": "ABMW0290RU23.png"
  },
  {
    "index": 566,
    "id": "ABMW0291R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when turning right at this junction?",
    "options": [
      "Allow the red car to proceed.",
      "Proceed ahead of both cars.",
      "Allow the blue car to proceed.",
      "Allow both cars to proceed."
    ],
    "correct_answer": 0,
    "explanation": "When you are turning right from a main road into a side road, you must give way to oncoming traffic on the main road even if they are turning left into the same road.",
    "image_name": "ABMW0291R.png"
  },
  {
    "index": 567,
    "id": "ABMW0297R",
    "section": "Safe and Socially Responsible Driving",
    "question": "In this situation who should wait?",
    "options": [
      "Neither vehicle should wait.",
      "Whichever vehicle is furthest away from the van.",
      "The driver behind the stopped van should wait.",
      "The oncoming vehicle must wait."
    ],
    "correct_answer": 2,
    "explanation": "When you are overtaking a parked vehicle or obstruction, you should yield to oncoming vehicles so that they don't have to slow down or take evasive action.",
    "image_name": "ABMW0297R.png"
  },
  {
    "index": 568,
    "id": "ABMW0298R",
    "section": "Safe and Socially Responsible Driving",
    "question": "In this situation, who should wait?",
    "options": [
      "The driver on the main road should wait.",
      "Both drivers should wait.",
      "The driver in the red car should wait.",
      "Neither driver should wait."
    ],
    "correct_answer": 2,
    "explanation": "A vehicle driving on the main road has priority over vehicles emerging from side roads. However, you must understand that the right of way is not an absolute right of way and you should be considerate of other road users at all times.",
    "image_name": "ABMW0298R.png"
  },
  {
    "index": 569,
    "id": "ABMW0306RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver who wants to turn right do in this situation?",
    "options": [
      "Reverse and get into the right lane.",
      "Proceed straight ahead or turn left.",
      "Proceed straight ahead and take a wide turn to the right.",
      "Turn right from the left lane."
    ],
    "correct_answer": 1,
    "explanation": "As you approach a junction where you want to turn right, you should read the road ahead and take up the correct position for turning in good time.",
    "image_name": "ABMW0306RU19.png"
  },
  {
    "index": 570,
    "id": "ABMW0307R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which vehicle is in the correct position to make a right turn from the major road into the minor road?",
    "options": [
      "1",
      "4",
      "3",
      "2"
    ],
    "correct_answer": 2,
    "explanation": "The correct position from which to turn right from a major road to a minor road is just left of centre. You should take up the correct position in good time and avoid cutting the corner or swan necking - that is going beyond the turning point as car 2 is in the picture.",
    "image_name": "ABMW0307R.png"
  },
  {
    "index": 571,
    "id": "ABMW0312R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which vehicle is in the correct position to make a right turn from a minor road onto a major road?",
    "options": [
      "1",
      "4",
      "2",
      "3"
    ],
    "correct_answer": 0,
    "explanation": "The correct position from which to turn right from a minor road to a major road is just left of centre of the road. You should take up the correct position in good time and complete the turn by entering the left-hand side of the major road.",
    "image_name": "ABMW0312R.png"
  },
  {
    "index": 572,
    "id": "ABMW0323RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What do flashing amber beacons on an oncoming vehicle alert a driver to?",
    "options": [
      "That the oncoming vehicle is a military vehicle.",
      "That the oncoming vehicle may be slow moving or extra wide.",
      "That the oncoming vehicle is an emergency vehicle.",
      "That the oncoming vehicle is fast moving."
    ],
    "correct_answer": 1,
    "explanation": "Flashing amber beacons are used by recovery vehicles and vehicles carrying abnormal loads. You should be aware that these vehicles may need extra room and could conceal following traffic. When you come across such vehicles, slow down and be prepared to stop if necessary.",
    "image_name": ""
  },
  {
    "index": 573,
    "id": "ABMW0324RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they meet a vehicle with flashing amber beacons?",
    "options": [
      "Flash their headlights to acknowledge the beacons.",
      "Increase speed while keeping left.",
      "Slow down and prepare to stop.",
      "Stop because it is an emergency vehicle."
    ],
    "correct_answer": 2,
    "explanation": "Flashing amber beacons are used by recovery vehicles and vehicles carrying abnormal loads. You should be aware that these vehicles may need extra room and could conceal following traffic. When you come across such vehicles, slow down and be prepared to stop if necessary.",
    "image_name": ""
  },
  {
    "index": 574,
    "id": "ABMW0328R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When preparing to stop, a driver notices the vehicle behind is towing a trailer. What should the driver do?",
    "options": [
      "Use the handbrake to slow down and stop.",
      "Indicate in good time and pull in gradually to allow the vehicle behind extra stopping distance.",
      "Stop quickly keeping a close eye on the rear-view mirror.",
      "Speed up temporarily to put distance between their vehicle and the vehicle behind."
    ],
    "correct_answer": 1,
    "explanation": "When you are slowing down or stopping, you should be mindful of the type of vehicle that is following you. For example, if the vehicle following you is a large vehicle or one towing a trailer, you should think of indicating a little earlier than normal to allow the following vehicle enough time to react safely.",
    "image_name": ""
  },
  {
    "index": 575,
    "id": "ABMW0329RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When approaching a bus up ahead that is signalling to move off from a bus stop, what should a driver do?",
    "options": [
      "Slow down and allow it to move out.",
      "Indicate and try to get past it promptly.",
      "Stop immediately as the bus has the right of way."
    ],
    "correct_answer": 0,
    "explanation": "A driver should allow signalling buses back into the stream of traffic when they are moving out from a stop. Be careful of pedestrians getting on and off buses, particularly of children near schools.",
    "image_name": ""
  },
  {
    "index": 576,
    "id": "ABMW0330RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do on a narrow road when another vehicle is coming in the opposite direction?",
    "options": [
      "Maintain position and expect the other vehicle to move over.",
      "Reduce speed and allow reasonable clearance between their vehicle and the oncoming one before proceeding.",
      "Position your vehicle along the middle of the road to encourage the other driver to pull in.",
      "Maintain road position and speed. Then flash the vehicle's lights to alert the other driver to your presence."
    ],
    "correct_answer": 1,
    "explanation": "You should always be prepared to react to hazards ahead. When you meet a vehicle coming against you on a narrow road, you should show consideration and slow down to a appropriate speed so that the two vehicles can pass each other safely.",
    "image_name": ""
  },
  {
    "index": 577,
    "id": "ABMW0332RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver is driving behind another vehicle that they do not intend to overtake, what should the driver do?",
    "options": [
      "Keep well back and to the centre of the road.",
      "Drive close behind it in order to let following traffic overtake both vehicles.",
      "Keep well back to allow following traffic to overtake.",
      "Signal to following traffic to overtake both vehicles."
    ],
    "correct_answer": 2,
    "explanation": "You should always allow sufficient distance between your vehicle and the vehicle in front. This will enable you to stop safely (within the distance you can see clear). It will also give overtaking vehicles enough room to pull in safely to the left lane after they have passed you.",
    "image_name": ""
  },
  {
    "index": 578,
    "id": "ABMW0333RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver is driving in a line of traffic and does not intend to overtake, what should the driver do?",
    "options": [
      "Beckon to following traffic to overtake.",
      "Drive close to the vehicle in front.",
      "Stay back and leave a gap for other drivers to overtake.",
      "Indicate left as a signal to following traffic to overtake."
    ],
    "correct_answer": 2,
    "explanation": "You should always allow sufficient distance between your vehicle and the vehicle in front. This will enable you to stop safely (within the distance you can see clear). It will also give overtaking vehicles enough room to pull in safely to the left lane after they have passed you.",
    "image_name": ""
  },
  {
    "index": 579,
    "id": "ABMW0340R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when being overtaken by another vehicle?",
    "options": [
      "Move to the right.",
      "Continue at the same pace.",
      "Increase speed.",
      "Slow down quickly."
    ],
    "correct_answer": 1,
    "explanation": "When you are being overtaken by another vehicle, you should continue at the same pace but be alert in case the overtaking vehicle suddenly pulls back in front you.",
    "image_name": ""
  },
  {
    "index": 580,
    "id": "ABMW0342RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving into a narrow gap between oncoming vehicles and vehicles parked on the left. What should a driver do?",
    "options": [
      "Indicate and drive on enforcing your priority.",
      "Always slow down, stop and wait to be beckoned forward.",
      "Indicate right, stopping if necessary until oncoming traffic has passed by.",
      "Signal to oncoming traffic to stop, and then move to the right and drive as normal."
    ],
    "correct_answer": 2,
    "explanation": "When you meet approaching traffic at a narrow gap, you should show consideration and slow down to an appropriate speed so that you and the other vehicles can pass each other safely. If necessary, give way to the other vehicles.",
    "image_name": ""
  },
  {
    "index": 581,
    "id": "ABMW0350RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving behind a heavy goods vehicle that is signalling to turn right, what should a driver do?",
    "options": [
      "Stay behind until there is enough space to overtake it on the inside or until it has completed the turn.",
      "Sound the horn and overtake the heavy goods vehicle on the right.",
      "Overtake it slowly on the inside by driving partly on the footpath if necessary.",
      "See if the vehicle can complete the turn without stopping, and if not, overtake it yourself."
    ],
    "correct_answer": 0,
    "explanation": "Heavy goods vehicles need extra space on the road, and when they are turning the overhang of the vehicle may swing out into the path of overtaking or passing traffic. For that reason, it is a good idea to stay back and let the heavy goods vehicle complete its turn unless there is sufficient space to overtake safely.",
    "image_name": ""
  },
  {
    "index": 582,
    "id": "ABMW0351RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving behind a bus that is signalling to turn left and there is oncoming traffic, what should a driver do?",
    "options": [
      "Overtake it on the left-hand side.",
      "Stay back and allow it to complete the turn.",
      "Tap the brakes and sound the horn to signal to other vehicles to slow down.",
      "Overtake it on the right-hand side."
    ],
    "correct_answer": 1,
    "explanation": "Always allow a bus to complete a left-hand turn, because your field of view is restricted, and it could be dangerous to attempt overtaking it.",
    "image_name": ""
  },
  {
    "index": 583,
    "id": "ABMW0355RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving on a wide road behind a vehicle that has signalled to turn right ahead?",
    "options": [
      "Overtake on the right-hand side and carry on.",
      "Overtake on the left-hand side and carry on if safe to do so.",
      "Overtake on the left, but only if turning left a short distance ahead.",
      "Stay behind and tap the brakes to signal other drivers to slow down."
    ],
    "correct_answer": 1,
    "explanation": "You may overtake on the left when the driver in front has moved out and signalled their intent to turn right and you intend to go straight ahead - provided there is enough room to do so safely and your path will not be obstructed by the swing of a large vehicle turning right.",
    "image_name": ""
  },
  {
    "index": 584,
    "id": "ABMW0356RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is it permissible to overtake another vehicle on the nearside (left-hand side)?",
    "options": [
      "When the vehicle in front is signalling to turn right.",
      "A driver must never overtake on the left.",
      "When there are three lanes available in fast moving traffic.",
      "Only when there is no cycle lane."
    ],
    "correct_answer": 0,
    "explanation": "You may overtake on the left when the driver in front has moved out and signalled their intent to turn right and you intend to go straight ahead - provided there is enough room to do so safely and your path will not be obstructed by the swing of a large vehicle turning right.",
    "image_name": ""
  },
  {
    "index": 585,
    "id": "ABMW0361RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they are behind schedule in reaching a destination at an appointed time?",
    "options": [
      "Be patient and do not exceed the speed limit so as to arrive safely.",
      "Exceed the speed limit if necessary to make up the time.",
      "Use hazard warning lights to encourage other road users to let you pass."
    ],
    "correct_answer": 0,
    "explanation": "You should always drive at a speed that allows you to stop safely within the distance you can see to be clear. Being late for an appointment is no excuse for exceeding speed limits or for driving at an unsafe speed. Arrive alive.",
    "image_name": ""
  },
  {
    "index": 586,
    "id": "ABMW0362RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they are not travelling as fast as the vehicle in front?",
    "options": [
      "The driver should keep their position and not allow following vehicles to overtake.",
      "The driver should keep to the left and allow vehicles to overtake if they wish.",
      "The driver should switch on hazard warning lights and keep to the left.",
      "The driver should invite traffic to overtake them by giving a hand signal."
    ],
    "correct_answer": 1,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. You should not drive so slowly that your vehicle unnecessarily blocks other road users. Keep as near to the left as is safe to allow other vehicles to pass safely if they wish.",
    "image_name": ""
  },
  {
    "index": 587,
    "id": "ABMW0365RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they wish to drive across a busy road and the traffic lights which normally control the junction are temporarily out of action?",
    "options": [
      "Switch on headlights and use hand signals to show other drivers their intention to cross and then proceed.",
      "Sound the horn and proceed slowly to cross the road.",
      "Take good observation, wait for a clear break in the traffic and proceed to cross the road safely.",
      "Slowly force their way across using hazard warning lights if necessary."
    ],
    "correct_answer": 2,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. In this case, do not proceed until it is clear and safe to do so. Do not assume that you have the right of way.",
    "image_name": ""
  },
  {
    "index": 588,
    "id": "ABMW0366RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they see a school bus stopped on the nearside (left side) of the road ahead?",
    "options": [
      "Sound the horn as a warning and continue on.",
      "Reduce speed and overtake with caution.",
      "Switch on hazard warning lights and stop behind the bus.",
      "Signal and maintain current speed."
    ],
    "correct_answer": 1,
    "explanation": "Always read the road and be prepared to react to any traffic situation - in this case, be aware of vulnerable road users such as school children boarding or alighting from school buses.",
    "image_name": ""
  },
  {
    "index": 589,
    "id": "ABMW0367RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do when driving behind a vehicle that is going from side to side on the road in an unsafe manner?",
    "options": [
      "The driver should signal and go around to the left of the vehicle.",
      "The driver should signal and go around to the right of the vehicle.",
      "The driver should drive close behind the vehicle with a view to overtaking.",
      "The driver should stay well back in a safe position."
    ],
    "correct_answer": 3,
    "explanation": "You should always be prepared to react to hazards ahead. If the vehicle in front is moving from side to side, it may indicate that the driver is not paying full attention or that their driving is impaired by drink, drugs or tiredness. If you think the vehicle is a risk to the public safety, the matter should be reported to the Gardai or to Traffic Watch (lo-call 1890 205 805), but not while driving.",
    "image_name": ""
  },
  {
    "index": 590,
    "id": "ABMW0368RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if a heavy goods vehicle in front has moved out to make a left turn ahead?",
    "options": [
      "Move out immediately and overtake as quickly as possible.",
      "Move to the right but do not overtake.",
      "Drive into the space on its left-hand side.",
      "Stay behind it and allow it to complete the turn."
    ],
    "correct_answer": 3,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. In this case, you should be aware that the heavy goods vehicle will need extra space to complete the left-hand turn and you should remain behind the vehicle until it has completed its turn.",
    "image_name": ""
  },
  {
    "index": 591,
    "id": "ABMW0369RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if a bus in front has moved out to make a left-hand turn and there is oncoming traffic?",
    "options": [
      "Stay back and allow the bus to complete the turn.",
      "Maintain speed until up close behind the bus.",
      "Overtake on the left-hand side.",
      "Overtake on the right-hand side."
    ],
    "correct_answer": 0,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. In this case, you should be aware that the bus will need extra space to make the turn. So you should not overtake it if by doing so you would cause oncoming traffic to alter  speed or course. Remember, you should never overtake when approaching a junction.",
    "image_name": ""
  },
  {
    "index": 592,
    "id": "ABMW0370RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they see a truck reversing into a side entrance on the left-hand side of the road ahead?",
    "options": [
      "Try to overtake it so as not to inconvenience traffic behind.",
      "Stop and stay back safely and wait until the way is clear.",
      "Sound the horn to indicate to the driver of the truck to stop."
    ],
    "correct_answer": 1,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. You should be aware of the difficulties that drivers of large vehicles can have reversing into a side entrance. In this case, a large vehicle reversing could obstruct your view  of the road ahead as you approach, and you should afford the truck driver adequate space to manoeuvre.",
    "image_name": ""
  },
  {
    "index": 593,
    "id": "ABMW0371RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they are first in line to turn right at traffic lights while the green light is showing and there is oncoming traffic approaching?",
    "options": [
      "Remain at the stop line until a suitable gap in the oncoming traffic appears before making the turn.",
      "Wait at the stop line for the light to turn amber and then make the turn.",
      "Remain at the stop line until a green arrow comes on.",
      "Go forward towards the centre of the junction and turn safely when a suitable gap appears."
    ],
    "correct_answer": 3,
    "explanation": "If you wish to turn right at a set of traffic lights, drive into the junction when you see a green light, taking care not to block any oncoming traffic. Then complete the turn when it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 594,
    "id": "ABMW0372R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is it permitted to force oncoming traffic onto the hard shoulder on the opposite side of the road while overtaking?",
    "options": [
      "When the vehicle being overtaken is driving too slow.",
      "It is not permitted to force oncoming traffic onto the hard shoulder while overtaking.",
      "When none of the oncoming traffic is overtaking.",
      "When the hard shoulder is wide enough."
    ],
    "correct_answer": 1,
    "explanation": "Overtaking in the manner described here is dangerous. You should overtake another vehicle only when it is safe to do so, both for you and for all other traffic. Before you overtake, make sure the road ahead is clear and that you have enough room to complete the overtaking manoeuvre and return to your own side of the road without forcing any other road user to alter soeed or course.",
    "image_name": ""
  },
  {
    "index": 595,
    "id": "ABMW0374RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When meeting oncoming traffic on a national road, is it permitted to move into the hard shoulder to allow following traffic to overtake?",
    "options": [
      "No, except on '2-plus-1 roads'.",
      "No, it is never permitted to drive on a hard shoulder except in the case of an emergency.",
      "Yes, when a truck or bus is oncoming.",
      "Yes, temporarily when the hard shoulder is clear and it is safe to drive there."
    ],
    "correct_answer": 3,
    "explanation": "On national roads, the hard shoulder is normally for the use of pedestrians and cyclists only. If you want to allow a vehicle behind to overtake, you may pull into the hard shoulder briefly as long as no pedestrians or cyclists are using it and there are no junctions or entrances nearby. In the case of motorways, however, you must not drive on the hard shoulder, except in an emergency.",
    "image_name": ""
  },
  {
    "index": 596,
    "id": "ABMW0375RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a national road is it permitted to drive on the hard shoulder in order to allow faster-moving traffic to overtake?",
    "options": [
      "Yes, temporarily when the hard shoulder is clear and it is safe to drive there.",
      "Only when driving on a dual carriageway.",
      "No, except when driving on a '2-plus-1 road'.",
      "Only when a truck or bus wants to overtake."
    ],
    "correct_answer": 0,
    "explanation": "On national roads, the hard shoulder is normally for the use of pedestrians and cyclists only. If you want to allow a vehicle behind to overtake, you may pull into the hard shoulder briefly as long as no pedestrians or cyclists are using it and there are no junctions or entrances nearby. In the case of motorways, however, you must not drive on the hard shoulder, except in an emergency.",
    "image_name": ""
  },
  {
    "index": 597,
    "id": "ABMW0376RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in a queue of traffic controlled by traffic lights?",
    "options": [
      "Overtake on the left and move to the head of the queue if there is space available.",
      "Overtake on the right and move to the head of the queue if there is space available.",
      "A driver should maintain their position in the queue.",
      "Put on a right signal to prevent following vehicles from overtaking."
    ],
    "correct_answer": 2,
    "explanation": "Always read the road ahead and be prepared to react to any traffic situation. From time to time you may have to queue in traffic. In this situation, you should try to remain patient and considerate of other road users. Jumping the queue is  inconsiderate, it could be dangerous, and it could even provoke a road rage incident or cause a collision.",
    "image_name": ""
  },
  {
    "index": 598,
    "id": "ABMW0377RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver do when driving a vehicle they are not familiar with?",
    "options": [
      "Drive with hazard lights on until fully familiar with the vehicle.",
      "Initially drive with extra care and at a lower speed until fully familiar with the vehicle.",
      "Drive at a normal speed as all vehicle's features are the same."
    ],
    "correct_answer": 1,
    "explanation": "You should know where to find and how to operate all the controls on your vehicle, including all of its safety features and warning lamps. When you are driving, you need to be able to concentrate on what's happening around you and operating the vehicle controls should be second nature to you. When you sit into the driver's seat of a vehicle you are not familiar with, you should do a thorough cockpit drill before ",
    "image_name": ""
  },
  {
    "index": 599,
    "id": "ABMW0381RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When stopped at traffic lights and the green light comes on, what should a driver do?",
    "options": [
      "Accelerate at a greater rate than other drivers so as to facilitate overtaking.",
      "Check that other road users have cleared the junction and move off with care.",
      "Move off slowly and then check the mirrors.",
      "Move off quickly and then check the mirrors."
    ],
    "correct_answer": 1,
    "explanation": "When stopped at traffic lights and the green light comes on, you should check to ensure the way is clear and proceed only if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 600,
    "id": "ABMW0386RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they get a puncture while driving?",
    "options": [
      "Continue on your journey and arrange for repair when convenient.",
      "Maintain speed until a place to change the wheel is identified.",
      "If on a motorway, stop and change the wheel immediately.",
      "Stop at a safe place and change the wheel."
    ],
    "correct_answer": 3,
    "explanation": "If you get a puncture while driving, find a suitable and safe place to stop and change the wheel. If you cant find a suitable place immediately, drive slowly (with your hazard warning lights turned on) to avoid further damage to the tyre or rim until a safe place is found.",
    "image_name": ""
  },
  {
    "index": 601,
    "id": "ABMW0394RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "After overtaking another vehicle, what should a driver do?",
    "options": [
      "Continue to signal right for a distance.",
      "Move immediately into the left after passing the vehicle.",
      "Move back in front of the vehicle and reduce speed.",
      "Gradually move back into the left when the vehicle has been passed."
    ],
    "correct_answer": 3,
    "explanation": "After overtaking, check your mirrors, signal and return to your normal lane position as soon as it is safe. Take a smooth easy line, gradually moving back in and allowing the other vehicle plenty of space and don't cut in sharply.",
    "image_name": ""
  },
  {
    "index": 602,
    "id": "ABMW0395AU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What would happen if a driver cuts in too soon when overtaking another vehicle?",
    "options": [
      "The driver would not need to indicate when moving in.",
      "It will force oncoming vehicles to suddenly slow causing danger.",
      "It would force the other vehicle to suddenly slow or change direction causing danger.",
      "The safety gap between the vehicles increases."
    ],
    "correct_answer": 2,
    "explanation": "When overtaking make sure the road ahead is clear so you have enough distance to overtake and get back to your own side of the road without forcing any other road user to adjust speed or direction. When you are well past the vehicle, check the mirrors, signal and gradually return to the original lane, making sure not to cut across the vehicle you have passed.",
    "image_name": ""
  },
  {
    "index": 603,
    "id": "ABMW0398RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What clearance should drivers normally allow for when passing parked vehicles?",
    "options": [
      "The width of an average person.",
      "A car width.",
      "The width of a side mirror.",
      "A door width."
    ],
    "correct_answer": 3,
    "explanation": "When you are passing parked vehicles, you should leave at least a door's width of clearance in case somebody opens their car door unexpectedly, this will also increase visibility of pedestrians in the area.",
    "image_name": ""
  },
  {
    "index": 604,
    "id": "ABMW0427RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In dry weather how might a driver judge what is a safe following distance to vehicle in front?",
    "options": [
      "Drive at the same speed as the vehicle in front.",
      "By using a fixed point and applying the two second rule.",
      "Allow a least two vehicle lengths for each kilometre per hour.",
      "By allowing at least two vehicle lengths between the vehicles."
    ],
    "correct_answer": 1,
    "explanation": "A driver can judge a safe distance from the vehicle in front by using the two second rule. This is measured by picking a fixed point. As the vehicle in front passes it, begin saying \"only a fool breaks the two second rule\". If you pass the fixed point before you have finished the phrase, then your vehicle is too close, safely slow and increase your distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 605,
    "id": "ABMW0429RAU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What phrase is recommended for drivers to help them determine a safe distance from the vehicle in front on a dry road?",
    "options": [
      "\"Only a fool breaks the two second rule.\"",
      "\"Only a fool breaks the one second rule.\"",
      "\"Only a fool breaks the three second rule.\"",
      "\"Only a fool breaks the four second rule.\""
    ],
    "correct_answer": 0,
    "explanation": "A driver can judge a safe distance from the vehicle in front by using the two second rule. This is measured by picking a fixed point. As the vehicle in front passes it, begin saying \"only a fool breaks the two second rule\". If you pass the fixed point before you have finished the phrase, then your vehicle is too close. Safely slow and increase your distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 606,
    "id": "ABMW0470RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When wishing to turn right at the end of a one-way street, where should a driver position their vehicle?",
    "options": [
      "Drive in either lane as there is no oncoming traffic.",
      "Drive as close as possible to the left-hand side of the road.",
      "Drive as close as is possible to the right-hand side of the road.",
      "Drive occupying both lanes when approaching the end of the street."
    ],
    "correct_answer": 2,
    "explanation": "When a driver wants to turn right on a one way street, they should check their mirrors, signal right and manoeuvre into the right-hand side when it is safe to do so. Then complete the turn into the appropriate lane of the street they are entering.",
    "image_name": ""
  },
  {
    "index": 607,
    "id": "ABMW0472RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver wants to turn left into a property and there is a bus lane on the left, what should the driver do?",
    "options": [
      "Give way to cyclists, taxis and buses which may be using the bus lane.",
      "A driver should give way to buses only.",
      "A driver should never turn left across a bus lane.",
      "Give way to cyclists and taxis which may be using the bus lane."
    ],
    "correct_answer": 0,
    "explanation": "If a driver needs to cross a bus lane on their left in order to enter a property, they should take extra care that there are no buses, taxis or cyclists in the bus lane. They should check mirrors, signal and turn into the property when it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 608,
    "id": "ABMW0474U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What traffic may use a contra-flow bus lane?",
    "options": [
      "Buses, taxis and motorcycles.",
      "Buses and motorised wheelchairs only.",
      "Buses, taxis and cyclists.",
      "Buses on a scheduled service."
    ],
    "correct_answer": 3,
    "explanation": "A contra-flow bus lane is one that runs in the opposite direction to traffic beside it. Only buses on a scheduled service may use a contra-flow bus lane.",
    "image_name": ""
  },
  {
    "index": 609,
    "id": "ABMW0475RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What traffic may use a with-flow bus lane during the times specified on information signs at the start of the lane?",
    "options": [
      "All traffic.",
      "Vehicles with more than one passenger.",
      "Buses only.",
      "Buses, taxis and cyclists."
    ],
    "correct_answer": 3,
    "explanation": "A bus lane is a special lane for the use of buses. A with-flow bus lane is one that runs in the same direction as the traffic beside it. Taxis and cyclists may also use with-flow bus lanes. Other traffic may use them outside the hours posted on the accompanying plate.",
    "image_name": ""
  },
  {
    "index": 610,
    "id": "ABMW0477RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving along a dual carriageway in normal driving conditions, which lane should a driver be in?",
    "options": [
      "In either lane.",
      "In the right-hand lane.",
      "In the right-hand lane except when driving a works vehicle or HGV.",
      "In the left-hand lane unless the driver wishes to overtake or turn right."
    ],
    "correct_answer": 3,
    "explanation": "You must normally drive in the left-hand lane of a dual carriageway, except when overtaking or turning right a short distance ahead.",
    "image_name": ""
  },
  {
    "index": 611,
    "id": "ABMW0480R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does a 2-plus-1 road have?",
    "options": [
      "Two motorway lanes and one non-motorway lane in two directions.",
      "Two motorway lanes in one direction and one non-motorway lane in the opposite direction.",
      "Two non-motorway lanes in one direction and one non-motorway lane in the opposite direction.",
      "Two non-motorway lanes and one motorway lane in two directions."
    ],
    "correct_answer": 2,
    "explanation": "A 2-plus-1 road consists of two lanes in one direction of travel and one lane in the other direction. The two-lane section allows for safe overtaking and alternates with a one-lane section roughly every 2 kilometres.",
    "image_name": ""
  },
  {
    "index": 612,
    "id": "ABMW0482RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does a 2-plus-1 road have?",
    "options": [
      "Barriers between the hard shoulder and the verge.",
      "Two lanes for cars and one lane for trucks and buses.",
      "Two lanes of traffic in one direction and one in the opposite direction.",
      "Barriers between lanes of traffic going in the same direction."
    ],
    "correct_answer": 2,
    "explanation": "A 2-plus-1 road consists of two lanes in one direction of travel and one lane in the other direction. The two-lane section allows for safe overtaking and alternates with a one-lane section roughly every 2 kilometres.",
    "image_name": ""
  },
  {
    "index": 613,
    "id": "ABMW0483R",
    "section": "Safe and Socially Responsible Driving",
    "question": "Where may a driver overtake on a 2-plus-1 road?",
    "options": [
      "In the one-lane stretch if there is no oncoming traffic.",
      "In the one-lane stretch.",
      "In either the one-lane stretch or the two-lane stretch.",
      "In the two-lane stretch."
    ],
    "correct_answer": 3,
    "explanation": "A 2-plus-1 road consists of two lanes in one direction of travel and one lane in the other direction. When you need to overtake, you should wait until you reach the 2- lane section which occurs approximately every 2 kilometres.",
    "image_name": ""
  },
  {
    "index": 614,
    "id": "ABMW0484RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when travelling on a motorway or dual carriageway?",
    "options": [
      "Relax because there will be no oncoming traffic.",
      "Be alert for other drivers who may suddenly change lanes or reduce speed.",
      "Match the speed to that of the vehicle in the adjoining lane.",
      "Match the speed to that of the vehicle in front."
    ],
    "correct_answer": 1,
    "explanation": "Motorways and dual carriageways are designed to help traffic travel faster and more safely between destinations. Traffic conditions can change very quickly because of the speed and increased volumes of traffic and lanes, and you need to be particularly alert to other drivers changing lanes or reducing speed.",
    "image_name": ""
  },
  {
    "index": 615,
    "id": "ABMW0485RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In normal driving conditions on a motorway, which lane should the driver occupy?",
    "options": [
      "Drive in the offside (right-hand) lane unless intending to take a left exit.",
      "Drive in the offside (right-hand) lane as the nearside (left-hand) lane is for HGVs and buses only.",
      "Constantly manoeuvre between whichever lane has the least volume of traffic.",
      "Drive in the nearside (left-hand) lane unless intending to overtake."
    ],
    "correct_answer": 3,
    "explanation": "The normal keep left rules apply when you are driving on a motorway - a driver should stay in the nearside (left-hand) lane unless they are overtaking.",
    "image_name": ""
  },
  {
    "index": 616,
    "id": "ABMW0496RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What may the hard shoulder of a motorway be used for?",
    "options": [
      "Joining the motorway.",
      "Exiting the motorway.",
      "Stopping in an emergency.",
      "Stopping to use a mobile phone."
    ],
    "correct_answer": 2,
    "explanation": "There are extra dangers when driving on a motorway because of the increased volume of traffic and higher speed. For safety reasons a driver should not drive or stop on the hard shoulder of a motorway except in an emergency or breakdown.",
    "image_name": ""
  },
  {
    "index": 617,
    "id": "ABMW0497RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "After exiting the motorway and coming towards a junction at the end of the deceleration lane (slip road) what should a driver do?",
    "options": [
      "Maintain motorway speeds to the end of the slip road.",
      "Be alert for oncoming and crossing traffic at the end of the slip road.",
      "The driver must always stop at the end of a slip road.",
      "The driver should continue at the junction as traffic on the slip road has right of way."
    ],
    "correct_answer": 1,
    "explanation": "The driver should check for signs showing a lower speed; use the speedometer to make sure that they are obeying the reduced speed limit; remember that the slip roads and link roads between motorways may include sharp bends and that they may encounter junctions and other traffic. Remember that motorway rules no longer apply.",
    "image_name": ""
  },
  {
    "index": 618,
    "id": "ABMW0499RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver wishes to go straight ahead at a cross junction of equal importance. If they encounter other traffic, what is the general rule that applies?",
    "options": [
      "Traffic approaching from the driver's right has right of way.",
      "Carry on as normal as they always have the right of way.",
      "Give way to traffic approaching firstly from the left and then the right.",
      "Give way to traffic approaching from the left only."
    ],
    "correct_answer": 0,
    "explanation": "If a driver is at a junction where the roads are of equal importance, traffic on the driver's right has the right of way. The driver must let that traffic pass before moving on. It is important to understand that the right of way is not an absolute right. Drivers must proceed with caution whilst showing regard for other users of the road.",
    "image_name": ""
  },
  {
    "index": 619,
    "id": "ABMW0513RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In general, when turning right on a two-way road, where should a driver position the vehicle?",
    "options": [
      "At either side of the middle of the road.",
      "At the far left-hand side of the road.",
      "At the far right-hand side of the road.",
      "Just left of the middle of the road."
    ],
    "correct_answer": 3,
    "explanation": "In general, the correct position to be in before turning right is just left of the centre of the road. Where the road is wide enough, this position allows traffic coming from behind and going straight ahead to pass safely on the left. The driver should be alert for road markings which direct them to follow a certain course.",
    "image_name": ""
  },
  {
    "index": 620,
    "id": "ABMW0514RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do before turning right from a major road into a minor road?",
    "options": [
      "Stop and signal traffic to exit left from the minor road.",
      "Yield right of way to oncoming traffic and to pedestrians crossing at the junction.",
      "Commence turn in front of oncoming traffic as they must yield to traffic turning right.",
      "Stop and signal traffic to exit right from the minor road."
    ],
    "correct_answer": 1,
    "explanation": "The driver must yield to oncoming traffic and to pedestrians who are already crossing when turning right from a major road to a minor road.",
    "image_name": ""
  },
  {
    "index": 621,
    "id": "RSA0208",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when an emergency service vehicle approaches with flashing blue lights?",
    "options": [
      "Brake suddenly to allow the emergency service vehicle to pass.",
      "Do nothing and ignore the emergency service vehicle.",
      "React quickly, safely and carefully to allow the emergency service vehicle to pass.",
      "Increase speed to prevent obstructing the emergency service vehicle."
    ],
    "correct_answer": 2,
    "explanation": "A driver needs to know what to do when they see an emergency vehicle. A driver must react quickly, safely and carefully to allow emergency service vehicles to pass. It is important to be alert and attentive at all times.",
    "image_name": ""
  },
  {
    "index": 622,
    "id": "RSA0209",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver never do when an emergency service vehicle approaches with flashing blue lights?",
    "options": [
      "React quickly, safely and carefully to allow the emergency service vehicle to pass.",
      "Brake suddenly or block the road.",
      "Pull over in a place which has enough space for the emergency service vehicle to pass safely.",
      "Clear the way as soon as possible."
    ],
    "correct_answer": 1,
    "explanation": "A driver needs to know what to do when they see an emergency vehicle. A driver must react quickly, safely and carefully to allow emergency service vehicles to pass. It is important to be alert and attentive at all times.",
    "image_name": ""
  },
  {
    "index": 623,
    "id": "RSA0210",
    "section": "Safe and Socially Responsible Driving",
    "question": "Can a driver break a red light or break the speed limit to allow an emergency service vehicle to pass?",
    "options": [
      "No, a driver should never break a red light or speed up to allow an emergency service vehicle to pass.",
      "Yes, a driver may break the speed limit to allow an emergency service vehicle to pass.",
      "Yes, a driver may legally break a red light to allow an emergency service vehicle to pass.",
      "No, except where the junction or road is clear, then a driver can break a red light or speed up to allow an emergency service vehicle to pass."
    ],
    "correct_answer": 0,
    "explanation": "A driver needs to know what to do when they see an emergency vehicle. A driver must react quickly, safely and carefully to allow emergency service vehicles to pass. It is important to be alert and attentive at all times.",
    "image_name": ""
  },
  {
    "index": 624,
    "id": "RSAO215",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the likely effect of motorists 'rubbernecking' at the scene of a traffic incident?",
    "options": [
      "It allows traffic to change course without attention.",
      "It allows traffic to change speed without attention.",
      "It can cause additional incidents as drivers become distracted.",
      "It can increase traffic flow near an incident."
    ],
    "correct_answer": 2,
    "explanation": "When approaching or being near to the scene of an incident, motorists are often seen 'rubbernecking'. This means turning your head and stretching your neck to get a better view of what's happening. It can be the cause of traffic jams as drivers slow down to 'rubberneck'. It can also cause road incidents as drivers become distracted and change their soeed and/or direction while other drivers are also distracted.",
    "image_name": ""
  },
  {
    "index": 625,
    "id": "RSA0216",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver react to emergency services vehicles with flashing blue lights and/or sirens on?",
    "options": [
      "Brake suddenly and stop to avoid causing obstruction.",
      "Mount kerb on offside of the road to make room.",
      "Only move aside if it is an ambulance.",
      "Check their mirrors before looking for space to move aside."
    ],
    "correct_answer": 3,
    "explanation": "If you see any emergency vehicle approaching with lights and/or sirens activated, check your rear view mirrors to gauge the speed of the emergency vehicle/s and also look out for pedestrians, cyclists, motorcyclists and other road users. Indicate your intention to pull over. Pull over only in a space that has enough space for the emergency vehicle/s to pass safely. Move off safely with appropriate observations ",
    "image_name": ""
  },
  {
    "index": 626,
    "id": "ABMW0605RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if a front tyre bursts while driving?",
    "options": [
      "Relax the hold on the steering wheel.",
      "Brake firmly and quickly.",
      "Grip the steering wheel firmly.",
      "Apply the handbrake immediately."
    ],
    "correct_answer": 2,
    "explanation": "If a front tyre bursts on a vehicle, the steering on the vehicle will become unstable. Don't panic - slow down gradually while keeping a firm hold on the steering wheel. Stop in a safe place to change the wheel, and alert other road users by switching on  your hazard warning lights.",
    "image_name": ""
  },
  {
    "index": 627,
    "id": "ABMW0606R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle gets a puncture on a motorway?",
    "options": [
      "Pull in where safe on the hard shoulder and call for assistance.",
      "Drive on to the next service area and get assistance.",
      "Stop in the hard shoulder and get a passenger to warn traffic.",
      "Stop in the traffic lane and switch on the hazard warning lights."
    ],
    "correct_answer": 0,
    "explanation": "Don't try to change a wheel on a motorway, as this could be very dangerous. Drive the car on to the hard shoulder, and when it is safe to do so, get out of the vehicle and move behind the barrier. Call for assistance from a motorway emergency phone or using a mobile phone (call the Gardai).",
    "image_name": ""
  },
  {
    "index": 628,
    "id": "ABMW0607RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What precautions could a driver take against the risk of fire in their vehicle?",
    "options": [
      "Carry a suitable fire extinguisher in the vehicle.",
      "Keep all water levels filled to the maximum at all times.",
      "Use low-octane unleaded petrol in the vehicle.",
      "Avoid driving the vehicle with a full tank of fuel."
    ],
    "correct_answer": 0,
    "explanation": "A strong smell of fuel is usually an indication that something is wrong, and you should stop and investigate as soon as possible. Leaking or spilling petrol can be dangerous because it is so combustible. It is good practice to carry a fire extinguisher in your vehicle, so that you can deal with any small fires.",
    "image_name": ""
  },
  {
    "index": 629,
    "id": "ABMW0609R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver use hazard warning lights on a motorway?",
    "options": [
      "When another vehicle is following too closely.",
      "When the vehicle is towing a trailer.",
      "When driving on the hard shoulder.",
      "When the vehicle has broken down."
    ],
    "correct_answer": 3,
    "explanation": "If your vehicle breaks down on a motorway, drive it to the hard shoulder and switch on the hazard warning lights to warn following traffic. When it is safe to do so, get out of the vehicle and move behind the barrier. Call for assistance from a motorway emergency phone or using a mobile phone (call the Gardai).",
    "image_name": ""
  },
  {
    "index": 630,
    "id": "ABMW0610U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle is broken down on a motorway and they are awaiting assistance?",
    "options": [
      "Try to flag down other traffic from the rear of the vehicle for assistance.",
      "Switch on the vehicle hazard warning lights, get out of the vehicle and stand safely to the side.",
      "Get out of the vehicle and wait at the rear of it.",
      "Stand out on the roadway and direct traffic to pass."
    ],
    "correct_answer": 1,
    "explanation": "If your vehicle breaks down on the road, always switch on the hazard warning lights and stand clear of the vehicle while awaiting assistance - this will warn other traffic that there is a vehicle stopped on the road.",
    "image_name": ""
  },
  {
    "index": 631,
    "id": "ABMW0735RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they see plant or machinery crossing the roadway at roadworks up ahead?",
    "options": [
      "Leave the carriage way as the road ahead is blocked.",
      "Maintain the same speed along the road.",
      "Slow down and prepare to stop."
    ],
    "correct_answer": 2,
    "explanation": "When you notice works vehicles ahead, slow down and be prepared to stop for the road works. If machinery is crossing you must stop if directed.",
    "image_name": ""
  },
  {
    "index": 632,
    "id": "ABMW0736R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What action should a driver take when they meet a vehicle with flashing blue lights?",
    "options": [
      "Flash the headlights and drive up onto the footpath on the left.",
      "Switch on the vehicle hazard warning lights.",
      "Flash the headlights and come to an immediate stop.",
      "Move to the left, reduce speed and stop if necessary."
    ],
    "correct_answer": 3,
    "explanation": "When a driver notices an emergency vehicle approaching in the distance, they should check their mirror and move to the left to allow the vehicle to pass. On some occasions it may be necessary to stop.",
    "image_name": ""
  },
  {
    "index": 633,
    "id": "ABMW0737",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if an ambulance is stopped up ahead with its flashing blue lights on?",
    "options": [
      "Reduce speed and prepare to stop if necessary.",
      "Move to the centre of the road to stop other vehicles from overtaking.",
      "Stop immediately to see what is happening.",
      "Stop and offer assistance."
    ],
    "correct_answer": 0,
    "explanation": "When you come upon an emergency vehicle stopped on the road, you should slow down and be prepared to stop. Do not stop to see what is happening as this could be dangerous and you might cause an obstruction to the flow of traffic.",
    "image_name": ""
  },
  {
    "index": 634,
    "id": "ABMW0738RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How are emergency vehicles identified?",
    "options": [
      "By flashing red or blue lights.",
      "By flashing green lights.",
      "By continuously lit red lights.",
      "By flashing amber and white lights."
    ],
    "correct_answer": 0,
    "explanation": "If you hear or see an emergency vehicle approaching sounding its siren or flashing lights, be extra careful and give way if it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 635,
    "id": "RSA0217",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the penalty for a vehicle owner who allows a learner driver to drive their vehicle unaccompanied?",
    "options": [
      "Their vehicle will be seized.",
      "They will incur 2 penalty points on their licence.",
      "They will be fined €2,000.",
      "They will lose their driving licence."
    ],
    "correct_answer": 0,
    "explanation": "A learner driver needs to be aware that driving unaccompanied in a vehicle, even where the owner has given their consent to drive, may result in the vehicle being seized.",
    "image_name": ""
  },
  {
    "index": 636,
    "id": "RSA0218",
    "section": "Safe and Socially Responsible Driving",
    "question": "A learner permit driver who receives 7 penalty points in a 36 month period (three years) will be banned from driving for how many months?",
    "options": [
      "3 months.",
      "6 months.",
      "12 months.",
      "9 months."
    ],
    "correct_answer": 1,
    "explanation": "A learner driver needs to be aware that there is a lower penalty point threshold for learner or novice drivers.",
    "image_name": ""
  },
  {
    "index": 637,
    "id": "ABMW0199R",
    "section": "Safe and Socially Responsible Driving",
    "question": "If there is no footpath, where must a pedestrian walk?",
    "options": [
      "There is no regulation.",
      "1 metre from the edge of the road.",
      "Right-hand side of the road.",
      "Left-hand side of the road."
    ],
    "correct_answer": 2,
    "explanation": "Where there is no footpath provided, pedestrians should walk on the right-hand side of the road facing oncoming traffic. Drivers should be aware of the Rules of the Road for pedestrians, drive with caution and be prepared to react to any changes in the traffic situation.",
    "image_name": ""
  },
  {
    "index": 638,
    "id": "ABMW0203RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "On a narrow busy road, what should pedestrians do when walking?",
    "options": [
      "Walk more than two abreast.",
      "Walk in groups of no more than three.",
      "Walk two abreast.",
      "Walk in single file."
    ],
    "correct_answer": 3,
    "explanation": "Pedestrians should walk in single file on busy narrow roads. Drivers should be aware of the Rules of the Road for pedestrians, drive with caution and be prepared to react to any changes in the traffic situation.",
    "image_name": ""
  },
  {
    "index": 639,
    "id": "ABMW0204RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should pedestrians wear reflective clothing at night?",
    "options": [
      "At night, when walking outside built-up areas.",
      "When walking two abreast.",
      "Only when it is raining.",
      "When in urban areas."
    ],
    "correct_answer": 0,
    "explanation": "Outside built-up areas, pedestrians should wear reflective clothing at all times when walking at night. This is particularly important where there is no street lighting and no footpath for pedestrians.",
    "image_name": ""
  },
  {
    "index": 640,
    "id": "ABMW0225RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the car driver do in this situation?",
    "options": [
      "The driver must allow the cyclist to proceed.",
      "The driver may turn right before the cyclist.",
      "The driver must allow the motorcyclist to proceed.",
      "The driver must stop and yield right of way to the other road users."
    ],
    "correct_answer": 0,
    "explanation": "When you are turning right from a major road to a minor road, you must yield to oncoming traffic, and you should proceed only when it is safe to do so.",
    "image_name": "ABMW0225RU19.png"
  },
  {
    "index": 641,
    "id": "ABMW0229R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the car driver do in this situation?",
    "options": [
      "The car driver is not allowed to turn right.",
      "The car driver must allow the bus to proceed.",
      "The car driver may proceed first.",
      "The car driver must allow the motorcycle to proceed."
    ],
    "correct_answer": 3,
    "explanation": "When you are turning right from a major road to a minor road, you must yield to oncoming traffic. You should proceed only when it is safe to do so.",
    "image_name": "ABMW0229R.png"
  },
  {
    "index": 642,
    "id": "ABMW0231R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be alert to in this area?",
    "options": [
      "Parked vehicles may have trailers attached.",
      "There may be refuse bins between the parked vehicles.",
      "Pedestrians may be hitch-hiking.",
      "Pedestrians may cross between parked cars."
    ],
    "correct_answer": 3,
    "explanation": "When driving in a built-up area, you should drive with caution and be prepared to react to pedestrians crossing from between parked vehicles.",
    "image_name": "ABMW0231R.png"
  },
  {
    "index": 643,
    "id": "ABMW0242R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should the driver of the silver car do before turning left?",
    "options": [
      "Increase speed to be able to complete the left turn before the cyclist.",
      "Sound the horn to alert the cyclist to the car's presence.",
      "Overtake the cyclist on the left and complete the turn.",
      "Allow the cyclist heading straight on to pass."
    ],
    "correct_answer": 3,
    "explanation": "Do not overtake a cyclist as you approach a junction at which you are turning left. The cyclist might be continuing ahead. Cyclists are vulnerable road users and may be unstable in slow-moving traffic and at junctions. Give them more room.",
    "image_name": "ABMW0242R.png"
  },
  {
    "index": 644,
    "id": "ABMW0252RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of in this situation?",
    "options": [
      "The cyclist will stop at the end of the cycle path to allow traffic to pass by.",
      "The cyclist will stay on the cycle path.",
      "A driver should move to the left-hand side (nearside) in case the cyclist moves out.",
      "The cyclist may move onto the roadway without paying attention to moving traffic."
    ],
    "correct_answer": 3,
    "explanation": "You should show extra care when approaching cyclists who are about to exit from a cycle lane and join the roadway.",
    "image_name": "ABMW0252RU19.png"
  },
  {
    "index": 645,
    "id": "ABMW0253RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver wants to pull out of a driveway and turn right onto the road. At the same time a cyclist is approaching from the right and a pedestrian wants to cross. Who must wait?",
    "options": [
      "The driver must wait.",
      "The pedestrian and the cyclist must wait.",
      "The pedestrian must wait."
    ],
    "correct_answer": 0,
    "explanation": "By law you must give way to other road users, including pedestrians and cyclists, when you are entering or leaving a driveway.",
    "image_name": "ABMW0253RU23.png"
  },
  {
    "index": 646,
    "id": "ABMW0257R",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver overtake the cyclist in this situation?",
    "options": [
      "By crossing the broken white line.",
      "By straddling both lines and keeping close to the cyclist.",
      "Overtake the cyclist, but without crossing any of the lines.",
      "By sounding the horn to warn the cyclist they intend to pass."
    ],
    "correct_answer": 0,
    "explanation": "Where there are two lines in the centre of the road, you must obey the one closest to you. So, if the closest line is a broken white line, by law you may overtake, so long as it is safe to do so.",
    "image_name": "ABMW0257R.png"
  },
  {
    "index": 647,
    "id": "ABMW0302RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in this situation?",
    "options": [
      "Allow the pedestrian to cross the road.",
      "Sound the horn to alert the pedestrian.",
      "Proceed promptly to clear the crossing."
    ],
    "correct_answer": 0,
    "explanation": "When approaching a zebra crossing, you must yield to pedestrians already on or about to cross the road.",
    "image_name": "ABMW0302RU23.png"
  },
  {
    "index": 648,
    "id": "ABMW0327R",
    "section": "Safe and Socially Responsible Driving",
    "question": "There are pedestrians on the footpath ahead and there are pools of water on the road. What should a driver do?",
    "options": [
      "Flash the headlights as a warning to the pedestrians.",
      "Brake suddenly as you approach the pools of water.",
      "Reduce speed and try to avoid the pools of water so as not to splash the pedestrians.",
      "Sound the horn as a warning to the pedestrians and continue on."
    ],
    "correct_answer": 2,
    "explanation": "During wet conditions, you should be aware that surface water can affect the stability of your vehicle. This is particularly so where the water lies in pools. As you drive through surface water, you should show consideration to pedestrians and cyclists and try not to splash them as you pass.",
    "image_name": ""
  },
  {
    "index": 649,
    "id": "ABMW0528RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When stopped at traffic lights and the green light comes on but pedestrians are still crossing the road, what should a driver do?",
    "options": [
      "Sound the horn as a warning to them that lights have changed.",
      "Move forward to encourage them to complete the crossing quickly.",
      "Wait as long as necessary to enable them to complete the crossing.",
      "Signal the pedestrians that the lights have changed and drive on."
    ],
    "correct_answer": 2,
    "explanation": "A green traffic light means you may go if the way is clear. If pedestrians are crossing, give way to them and let them safely cross before proceeding.",
    "image_name": ""
  },
  {
    "index": 650,
    "id": "ABMW0531RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they see a slow moving vehicle up ahead being driven by a learner driver?",
    "options": [
      "Overtake the vehicle as quickly as possible.",
      "Maintain a distance behind to avoid undue pressure.",
      "Drive close behind the vehicle to show your intention to overtake."
    ],
    "correct_answer": 1,
    "explanation": "Show patience and courtesy when driving behind a learner driver. Learner drivers are not as experienced as other road users and may drive erratically when put under pressure.",
    "image_name": ""
  },
  {
    "index": 651,
    "id": "ABMW0532RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How is a learner driver likely to react in unusual traffic situations?",
    "options": [
      "Slower than an experienced driver.",
      "Quicker than an experienced driver.",
      "In the same way as an experienced driver.",
      "Better than an experienced driver."
    ],
    "correct_answer": 0,
    "explanation": "You should be patient when driving behind a learner driver. Learners may not anticipate and react to unusual traffic situations as well as an experienced driver might.",
    "image_name": ""
  },
  {
    "index": 652,
    "id": "ABMW0535RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When negotiating junctions, which road users are particularly vulnerable?",
    "options": [
      "Tractor drivers.",
      "Minibus drivers.",
      "Motorcyclists.",
      "Van drivers."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should be aware that no vehicle has an automatic right of way at a junction. Drivers must pay particular attention to vulnerable road users such as motorcyclists whose presence on the road may be less visible than other vehicle types due to their smaller size or obstructions.",
    "image_name": ""
  },
  {
    "index": 653,
    "id": "ABMW0536RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When stopped at traffic lights, a driver should take particular care for which road users coming up on their left?",
    "options": [
      "Cyclists.",
      "Cars.",
      "Tractors."
    ],
    "correct_answer": 0,
    "explanation": "Before moving off at traffic lights and particularly when turning left you should be aware of cyclists and motorcyclists coming up on the left in general - in particular where there is an advanced stop line for cyclists ahead of that for other road users.",
    "image_name": ""
  },
  {
    "index": 654,
    "id": "ABMW0539RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In slow-moving city traffic, a driver should occasionally check their blind spots for which road users in particular?",
    "options": [
      "Cyclists.",
      "Cars.",
      "Vans.",
      "Taxis."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should be aware of and check blind spots before moving off and changing direction where appropriate. Cyclists can easily become hidden in a blind spot, and in slow-moving traffic, they might be moving faster than you are.",
    "image_name": ""
  },
  {
    "index": 655,
    "id": "ABMW0541U23",
    "section": "Safe and Socially Responsible Driving",
    "question": "At traffic lights a driver should take particular care for which road users coming up on the left side (nearside)?",
    "options": [
      "Motorcyclists.",
      "Cars.",
      "Trucks."
    ],
    "correct_answer": 0,
    "explanation": "Before moving off at traffic lights you should be aware of motorcyclists unexpectedly coming up on the left-hand side (nearside).",
    "image_name": ""
  },
  {
    "index": 656,
    "id": "ABMW0549RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they see joggers ahead on the left?",
    "options": [
      "Check the mirrors, indicate and overtake, allowing them enough clearance.",
      "Expect them to move in out of the driver's path.",
      "Indicate and overtake allowing enough clearance.",
      "Sound the horn and flash the lights to warn them of your presence."
    ],
    "correct_answer": 0,
    "explanation": "People on the road are more vulnerable than vehicles so you should treat them with extra care. If you see people jogging ahead, use the Mirror-Signal-Manoeuvre routine and give plenty of clearance to the joggers when you are overtaking them.",
    "image_name": ""
  },
  {
    "index": 657,
    "id": "ABMW0550RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a road that has a potholed surface and there is a cyclist ahead, what should a driver do?",
    "options": [
      "Change to a lower gear and overtake quickly.",
      "Allow extra clearance in case the cyclist swerves to avoid a pothole.",
      "Expect the cyclist to keep to the left and maintain speed.",
      "Maintain course and sound the horn to alert the cyclist of their approach."
    ],
    "correct_answer": 1,
    "explanation": "You should always be aware of how vulnerable cyclists are. When you are driving on a road with potholes or bad surfaces, give plenty of clearance to the cyclists when overtaking them. Take into account that they may swerve suddenly to avoid potholes.",
    "image_name": ""
  },
  {
    "index": 658,
    "id": "ABMW0552RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when making a left turn into a side road?",
    "options": [
      "Cyclists may come up on the left (nearside).",
      "To approach as close to the kerb as possible.",
      "Following traffic must have room to overtake.",
      "Cyclists might come up on the right (offside)."
    ],
    "correct_answer": 0,
    "explanation": "When turning left, drivers should be aware that cyclists and pedestrians may come up on the left (nearside). Always check to your left (nearside) before you make a left turn.",
    "image_name": ""
  },
  {
    "index": 659,
    "id": "ABMW0556RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a country road without footpaths, what should a driver expect coming towards them on their side of the road?",
    "options": [
      "Cyclists.",
      "Pedestrians.",
      "Motorcyclists.",
      "Tractors."
    ],
    "correct_answer": 1,
    "explanation": "Where there is no footpath, pedestrians are required to walk on the side of the on- coming traffic and drivers should be aware of this. Pedestrians are vulnerable road users so drivers should always be aware of their presence, especially on country roads.",
    "image_name": ""
  },
  {
    "index": 660,
    "id": "ABMW0557RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving at night on an unlit road?",
    "options": [
      "Drive close to the left to avoid oncoming traffic.",
      "Watch out for pedestrians wearing dark clothing.",
      "Drive as close as possible to the line of reflective studs.",
      "Drive on the centre of the road."
    ],
    "correct_answer": 1,
    "explanation": "While driving at night and even with the best headlights, it can be very difficult to see all the hazards that you might come across - for example, pedestrians wearing dark clothing. As always drivers should drive at a speed that will enable them to stop safely within the distance they can see to be clear ahead.",
    "image_name": ""
  },
  {
    "index": 661,
    "id": "ABMW0558RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What could happen if a driver parks on a footpath?",
    "options": [
      "The tyres will lose air pressure.",
      "Pedestrians could be prevented from passing.",
      "Traffic could be prevented from passing.",
      "The suspension will be weakened."
    ],
    "correct_answer": 1,
    "explanation": "You should never park on a footpath. Pedestrians (including people with young children in pushchairs, prams and also wheelchair users) might have to go onto the road to get around your car, and this could put them in danger.",
    "image_name": ""
  },
  {
    "index": 662,
    "id": "ABMW0559RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What procedure should a driver follow when intending to overtake a cyclist travelling in the same direction up ahead?",
    "options": [
      "Indicate, move out and check the mirror for following traffic.",
      "Indicate, check the mirror, move out and overtake when safe to do so.",
      "Mirror check, and move out to overtake without indicating.",
      "Mirror check, indicate and move out if it is safe to do so."
    ],
    "correct_answer": 3,
    "explanation": "The sequence drivers should follow the mirror - signal - manoeuvre routine when overtaking. Drivers should overtake only when it is safe to do so. Give extra space to cyclists when overtaking them, as they may need to move out to avoid a pothole, or they could be blown into your path on windy days.",
    "image_name": ""
  },
  {
    "index": 663,
    "id": "ABMW0561RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when travelling on a country road with following traffic, and they meet pedestrians?",
    "options": [
      "Leave a minimum clearance of 30 centimetres.",
      "Flash the lights to alert following traffic of a pedestrian on the road.",
      "Gesture to the pedestrians to move in off the road.",
      "Signal their intention to overtake the pedestrians."
    ],
    "correct_answer": 3,
    "explanation": "When you are driving on a road without footpaths, drivers should take extra care when they come upon pedestrians on the road. When they intend to move out and overtake, they should check the mirrors and signal to following traffic in good time to alert drivers behind that they are changing direction because of the hazard ahead.",
    "image_name": ""
  },
  {
    "index": 664,
    "id": "ABMW0562RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on dark winter mornings and evenings on unlit country roads, what should a driver be aware of?",
    "options": [
      "An oncoming cyclist could never be dazzled by the vehicle lights and wobble off course into the driver's path.",
      "Cyclists are much more vulnerable in poor lighting conditions.",
      "Cyclists all wear reflective belts, have the correct lighting on their bicycles and are clearly visible.",
      "On country roads, cyclists have space in the margin of the road so that a driver can overtake them without reducing speed or moving out."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should take extra care when driving on dark winter mornings and evenings - vulnerable road users such as cyclists and pedestrians (particularly schoolchildren) might not be so easy to see in low light conditions.",
    "image_name": ""
  },
  {
    "index": 665,
    "id": "ABMW0564RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on dark winter mornings and evenings on unlit country roads, what should a driver be aware of?",
    "options": [
      "That there could be vulnerable pedestrians walking on the road.",
      "That all pedestrians will be wearing reflective armbands and bright clothing.",
      "That the lack of light will not affect the driver's ability to see vulnerable pedestrians.",
      "That there will be no pedestrians walking on the road."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should take extra care when driving on dark winter mornings and evenings - vulnerable road users such as cyclists and pedestrians (particularly schoolchildren) might not be so easy to see in low light conditions.",
    "image_name": ""
  },
  {
    "index": 666,
    "id": "ABMW0565RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on dark winter mornings and evenings on unlit country roads, what should a driver be aware of?",
    "options": [
      "That a driver should drive at all times with sidelights on in order to see pedestrians walking on unlit country roads.",
      "Schoolchildren are more vulnerable on unlit country roads on dark winter mornings and evenings.",
      "That the lack of light will not effect the driver's ability to see stray animals on the road.",
      "A driver should expect that pedestrians will be on the footpath and not be in danger of being hit."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should take extra care when driving on dark winter mornings and evenings - vulnerable road users such as cyclists and pedestrians (particularly schoolchildren) might not be so easy to see in low light conditions.",
    "image_name": ""
  },
  {
    "index": 667,
    "id": "ABMW16",
    "section": "Safe and Socially Responsible Driving",
    "question": "At road junctions, what type of road users are particularly vulnerable?",
    "options": [
      "Pedestrians.",
      "Van drivers.",
      "Car drivers.",
      "Tractor drivers."
    ],
    "correct_answer": 0,
    "explanation": "Vehicles do not have an automatic right of way at junctions. As a driver you should pay particular attention to vulnerable road users such as pedestrians, cyclists and motorcyclists and be aware that they are entitled to use the road in safety.",
    "image_name": ""
  },
  {
    "index": 668,
    "id": "ABMW18U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "At traffic lights, a driver should take particular care for which road users coming up on the left?",
    "options": [
      "Tractors.",
      "Motorcyclists.",
      "Cars.",
      "Vans."
    ],
    "correct_answer": 1,
    "explanation": "Before moving off at traffic lights the driver should be aware of traffic, particularly cyclists and motorcyclists, coming up on the left, especially where there is an advanced stop line for cyclists ahead of that which applies to other road users.",
    "image_name": ""
  },
  {
    "index": 669,
    "id": "ABMW19U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver intends to make a left-hand turn at a junction where there are pedestrians and cyclists present, what should a driver do?",
    "options": [
      "Check the right-hand mirror, make the turn and then signal.",
      "Signal left, watch the right-hand mirror and make the turn.",
      "Check your mirrors and watch for cyclists or pedestrians on the left.",
      "Sound the horn while proceeding to warn the other road users of the intention to turn."
    ],
    "correct_answer": 2,
    "explanation": "The vehicle does not have a greater right-of-way than any other road user. As a driver you should pay particular attention to vulnerable road users such as pedestrians, cyclists and motorcyclists and be aware that they are entitled to use  the road in safety.",
    "image_name": ""
  },
  {
    "index": 670,
    "id": "ABMW21U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which of the following road users are most vulnerable in slow-moving city traffic?",
    "options": [
      "Taxis.",
      "Cars.",
      "Motorcyclists.",
      "Vans."
    ],
    "correct_answer": 2,
    "explanation": "In slow-moving city traffic, you should be aware of and check your blind spots before any manoeuvre. Motorcyclists can easily become hidden in a blind spot, and in slow-moving traffic, they might be moving faster than you are.",
    "image_name": ""
  },
  {
    "index": 671,
    "id": "ABMW22U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which of the following road users are most vulnerable in slow-moving city traffic?",
    "options": [
      "Pedestrians.",
      "Cars.",
      "Vans.",
      "Taxis."
    ],
    "correct_answer": 0,
    "explanation": "In slow-moving city traffic, you should be aware of and check your blind spots before any manoeuvre. Pedestrians can easily become hidden in a blind spot, and in slow-moving traffic, they might be moving faster than you are.",
    "image_name": ""
  },
  {
    "index": 672,
    "id": "ABMW24U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving at night on an unlit road?",
    "options": [
      "Drive close to the left and switch on front fog lights.",
      "Drive at least 30 km/h below the posted speed limit.",
      "Keep well out from the left-hand side of the road.",
      "Watch out for unlit cyclists."
    ],
    "correct_answer": 3,
    "explanation": "While driving at night and even with the best headlights, it can be very difficult to see all the hazards that you might come across - for example, stray animals or livestock on the road. At night you should drive at a speed that will enable you to stop safely within the distance you can see to be clear ahead.",
    "image_name": ""
  },
  {
    "index": 673,
    "id": "AMBW0538RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver intends to make a left-hand turn on a busy city street junction and there are pedestrians and cyclists around, what should the driver do?",
    "options": [
      "Keep to the right to make room for cyclists to pass.",
      "Watch for cyclists or pedestrians who may try to cross the road in front of the vehicle.",
      "Signal left, watch the right-hand mirror and make the turn when it is clear.",
      "Stay close to the left to prevent cyclists or pedestrians coming up on your left side."
    ],
    "correct_answer": 1,
    "explanation": "When making a left-hand turn on a busy city street, drivers should pay particular attention to vulnerable road users such as pedestrians, cyclists and motorcyclists who may appear unexpectedly and may not be aware of the vehicle's intention.",
    "image_name": ""
  },
  {
    "index": 674,
    "id": "RSA0211",
    "section": "Safe and Socially Responsible Driving",
    "question": "If it is safe to overtake a cyclist in speed zones up to 50 km/h, what is the recommended minimum passing distance?",
    "options": [
      "Allow a maximum of 1.75 metres.",
      "Allow a maximum of 1 metre.",
      "Allow a minimum of 1 metre.",
      "Allow a minimum of 1.75 metres."
    ],
    "correct_answer": 2,
    "explanation": "A driver should drive their vehicle far enough to the left to allow traffic to safely pass or overtake on the right, but not so far to the left that you are driving on a cycle lane or blocking or endangering cyclists or pedestrians. Where a driver wishes to overtake a cyclist and it is safe to do so, they should, if it is possible, give the recommended clearance depending on the speed limit area they are in.",
    "image_name": ""
  },
  {
    "index": 675,
    "id": "RSA0212",
    "section": "Safe and Socially Responsible Driving",
    "question": "If it is safe to overtake a cyclist in speed zones over 50 km/h, what is the recommended minimum passing distance?",
    "options": [
      "Allow a minimum of 1 metre.",
      "Allow a maximum of 1.5 metres.",
      "Allow a maximum of 1.75 metres.",
      "Allow a minimum of 1.5 metres."
    ],
    "correct_answer": 3,
    "explanation": "A driver should drive their vehicle far enough to the left to allow traffic to safely pass or overtake on the right, but not so far to the left that you are driving on a cycle lane or blocking or endangering cyclists or pedestrians. Where a driver wishes to overtake a cyclist and it is safe to do so, they should, if it is possible, give the recommended clearance depending on the speed limit area they are in.",
    "image_name": ""
  },
  {
    "index": 676,
    "id": "RSA0213",
    "section": "Safe and Socially Responsible Driving",
    "question": "How can a pedestrian walking along a poorly lit road reduce the risk of an accident occurring?",
    "options": [
      "Wear dark clothing.",
      "Walk as part of a group.",
      "Walk on the left-hand side of the road.",
      "Wear high-visibility clothing."
    ],
    "correct_answer": 3,
    "explanation": "Even with the best headlights, drivers can see less at night than during the day. Pedestrians and unlit bicycles are extremely difficult to see in the dark, particularly if they have to deal with the glare of oncoming lights. Pedestrians should always wear bright and hi-vis clothing during the day and reflective clothing at night when walking outside built-up areas.",
    "image_name": ""
  },
  {
    "index": 677,
    "id": "RSA0214",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is a courtesy pedestrian crossing?",
    "options": [
      "An uncontrolled pedestrian crossing place.",
      "A pedestrian crossing on a pedestrian street.",
      "A pedestrian crossing with 'look right' painted on the roadway.",
      "A pedestrian crossing with flashing amber lights."
    ],
    "correct_answer": 0,
    "explanation": "Pedestrians should only enter uncontrolled crossing places (courtesy crossing) ensuring that all traffic is aware of their presence if crossing the road. Motorists entering uncontrolled crossing places (courtesy crossing) should react by driving very slowly, and be aware of the potential dangers of pedestrians using the area.",
    "image_name": ""
  },
  {
    "index": 678,
    "id": "RSA228068",
    "section": "Safe and Socially Responsible Driving",
    "question": "In slow-moving city traffic, a driver should occasionally check their blind spots for which road users in particular?",
    "options": [
      "Cars.",
      "E-scooters.",
      "Vans."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should be aware of and check blind spots before moving off and changing direction where appropriate. E-scooters can easily become hidden in a blind spot, and in slow-moving traffic, they might be moving faster than you are.",
    "image_name": ""
  },
  {
    "index": 679,
    "id": "RSA228072",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving on a road that has a potholed surface and there is an e-scooter ahead, what should a driver do?",
    "options": [
      "Allow extra clearance in case the e-scooter swerves to avoid a pothole.",
      "Maintain course and sound the horn to alert the e-scooter of their approach.",
      "Expect the e-scooter to keep to the left and maintain speed."
    ],
    "correct_answer": 0,
    "explanation": "You should always be aware of how vulnerable e-scooters are. When you are driving on a road with potholes or bad surfaces, give plenty of clearance to the e-scooters when overtaking them. Take into account that they may swerve suddenly to avoid potholes.",
    "image_name": ""
  },
  {
    "index": 680,
    "id": "RSA228074",
    "section": "Safe and Socially Responsible Driving",
    "question": "What procedure should a driver follow when intending to overtake an e-scooter travelling in the same direction up ahead?",
    "options": [
      "Check mirrors, signal and move out if it is safe to do so.",
      "Signal, check mirrors, move out and overtake when safe to do so.",
      "Signal, move out and check mirrors for following traffic."
    ],
    "correct_answer": 0,
    "explanation": "The procedure drivers should follow the mirrors - signal - manoeuvre routine when overtaking. Drivers should overtake only when it is safe to do so. Give extra space to e-scooters when overtaking them, as they may need to move out to avoid a pothole, or they could be blown into your path on windy days.",
    "image_name": ""
  },
  {
    "index": 681,
    "id": "RSA228076",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving in the dark on an unlit country road, what should a driver be aware of?",
    "options": [
      "That e-scooter users all wear reflective belts, have the correct lighting on their e-scooters and are clearly visible.",
      "That e-scooter users are much more vulnerable on dark roads.",
      "That e-scooter users have space in the margin of the road so that a driver can overtake them without moving out."
    ],
    "correct_answer": 1,
    "explanation": "Drivers should take extra care when driving on dark winter mornings and evenings - vulnerable road users such as cyclists, e-scooters and pedestrians (particularly schoolchildren) might not be so easy to see in low light conditions.",
    "image_name": ""
  },
  {
    "index": 682,
    "id": "RSA228078",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they intend to make a left-hand turn at a junction where there are cyclists and e-scooter users present?",
    "options": [
      "Signal left, check the right-hand mirror and complete the turn.",
      "Sound the horn so as to warn the other road users of the intention to turn.",
      "Use your mirrors to check for cyclists and e-scooter users on the left before turning."
    ],
    "correct_answer": 2,
    "explanation": "The vehicle does not have a greater right-of-way than any other road user. As a driver you should pay particular attention to vulnerable road users such as e- scooter users, cyclists and motorcyclists and be aware that they are entitled to use the road in safety.",
    "image_name": ""
  },
  {
    "index": 683,
    "id": "RSA228084",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when driving at night on an unlit road?",
    "options": [
      "Drive along the centre of the road.",
      "Watch out for unlit e-scooters.",
      "Drive close to the left and switch on front fog lights."
    ],
    "correct_answer": 1,
    "explanation": "While driving at night and even with the best headlights, it can be very difficult to see all the hazards that you might come across - for example, unlit e-scooters on the road. At night you should drive at a speed that will enable you to stop safely within the distance you can see to be clear ahead.",
    "image_name": ""
  },
  {
    "index": 684,
    "id": "RSA228090",
    "section": "Safe and Socially Responsible Driving",
    "question": "Which type of road users are particularly vulnerable at junctions?",
    "options": [
      "E-scooter users.",
      "Van drivers.",
      "Car drivers."
    ],
    "correct_answer": 0,
    "explanation": "Cyclists, motorcyclists and e-scooter users are often difficult to see at junctions and may approach faster than you think.",
    "image_name": ""
  },
  {
    "index": 685,
    "id": "RSA228092",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver be aware of when making a left turn into a side road?",
    "options": [
      "Following traffic must have room to overtake.",
      "E-scooters may come up on the left (nearside).",
      "E-scooters might come up on the right (offside)."
    ],
    "correct_answer": 1,
    "explanation": "When turning left, drivers should be aware that cyclists, pedestrians and e-scooters may come up on the left (nearside) . Always check to your left (nearside) before you make a left turn.",
    "image_name": ""
  },
  {
    "index": 686,
    "id": "RSA228097",
    "section": "Safe and Socially Responsible Driving",
    "question": "When stopped at traffic lights, a driver should take particular care for which road users coming up on their left?",
    "options": [
      "Tractors.",
      "Cars.",
      "E-scooters."
    ],
    "correct_answer": 2,
    "explanation": "Before moving off at traffic lights and particularly when turning left you should be aware of e-scooters coming up from behind.",
    "image_name": ""
  },
  {
    "index": 687,
    "id": "ABMW0654U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What does Anti-lock Braking System (ABS) do?",
    "options": [
      "ABS displays the name of the radio station playing on the car radio.",
      "ABS deploys the airbags during a collision.",
      "ABS locks the brakes to prevent skidding during harsh braking.",
      "ABS prevents the wheels from locking under harsh braking conditions."
    ],
    "correct_answer": 3,
    "explanation": "Anti-lock Braking System (ABS) is a type of braking system found in most modern cars. It comes into play automatically when the driver brakes harshly. In the wet it can help prevent the wheels from skidding so that, if necessary, the driver can  continue to steer while braking. Be aware that ABS does not reduce the braking distance.",
    "image_name": ""
  },
  {
    "index": 688,
    "id": "RSA225299",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the purpose of rumble strips on the sides of a carriageway?",
    "options": [
      "To prevent livestock entering the carriageway.",
      "To alert drivers that their vehicle is veering out of their lane.",
      "To improve drainage of the carriageway in heavy rain."
    ],
    "correct_answer": 1,
    "explanation": "Rumble strips are raised or grooved patterns on the roadway shoulder that provide both an audible warning (rumbling sound) and a physical vibration to alert drivers that they are leaving the driving lane. In addition to warning inattentive drivers, rumble strips help drivers on the road during inclement weather when visibility is poor.",
    "image_name": ""
  },
  {
    "index": 689,
    "id": "BW0002RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Before exiting the vehicle on a busy road, what should the driver ensure?",
    "options": [
      "Before opening the door the driver should check it is safe to do so.",
      "That the wheels are positioned straight ahead.",
      "That the passengers open their door first.",
      "That the gear lever is in neutral."
    ],
    "correct_answer": 0,
    "explanation": "When exiting from a parked vehicle on a busy road, the driver should check it is safe to do so before opening the door, as there could be cyclists or other traffic passing closely by.",
    "image_name": ""
  },
  {
    "index": 690,
    "id": "BW0113RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do before getting out of the vehicle?",
    "options": [
      "Check the interior mirror before opening the door.",
      "Open the door part way and then look behind.",
      "Open the door and exit the vehicle without delay.",
      "Check their side mirror and look behind before opening the door."
    ],
    "correct_answer": 3,
    "explanation": "Before opening any door, check for other road users passing, and in particular look out for pedestrians, cyclists and motorcyclists. Exit the vehicle only when it is safe to do so, and close the door as soon as possible. Where ever possible, passengers should exit on the side nearest the kerb wherever possible.",
    "image_name": ""
  },
  {
    "index": 691,
    "id": "BWO0114R",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver secure their vehicle before getting out of it?",
    "options": [
      "Apply the parking brake, stop the engine and engage a low gear.",
      "Angle the wheels towards the kerb and stop the engine.",
      "Engage a low gear and stop the engine.",
      "Angle the wheels away from the kerb and stop the engine."
    ],
    "correct_answer": 0,
    "explanation": "Before leaving your vehicle, apply the handbrake, switch off the engine and engage a low gear. If the vehicle is fitted with automatic transmission, select P (park).",
    "image_name": ""
  },
  {
    "index": 692,
    "id": "BW0115U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What safety precaution should a driver take when getting out of their vehicle?",
    "options": [
      "Open the door and try to get out as speedily as possible.",
      "Ensure the gear lever is in neutral.",
      "Check all around for approaching traffic and pedestrians before opening the door.",
      "Ensure all valuables are secured and out of sight."
    ],
    "correct_answer": 2,
    "explanation": "Before opening any door, check for other road users passing, and in particular look out for pedestrians, cyclists and motorcyclists. Exit the vehicle only when it is safe to do so, and close the door as soon as possible. Passengers should exit on the side  nearest the kerb wherever possible.",
    "image_name": ""
  },
  {
    "index": 693,
    "id": "BW0116RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "On a busy road, how should a driver allow passengers out of a vehicle?",
    "options": [
      "Stop and encourage them to get out as quickly as possible.",
      "Stop and allow them to get out on the side nearest the kerb.",
      "Signal to following traffic to overtake before allowing the passengers to get out.",
      "Stop and allow them to get out from whichever side of the vehicle they are sitting."
    ],
    "correct_answer": 1,
    "explanation": "Before allowing any door to be opened, check for other road users passing, and in particular look out for pedestrians, cyclists and motorcyclists. Passengers should exit on the side nearest the kerb, without getting in the way of pedestrians.",
    "image_name": ""
  },
  {
    "index": 694,
    "id": "CD0150RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to secure the vehicle before leaving it?",
    "options": [
      "Leave the engine running with the parking brake on.",
      "Leave the engine running with the exhaust brake on.",
      "Apply the parking brake and switch off the engine.",
      "Apply the exhaust brake and switch off the engine."
    ],
    "correct_answer": 2,
    "explanation": "Before you leave your vehicle, apply the parking brake and switch off the ignition. Check to make sure that you can open the door safely without endangering others, and alight when it is safe to do so.",
    "image_name": ""
  },
  {
    "index": 695,
    "id": "RSA01047",
    "section": "Safe and Socially Responsible Driving",
    "question": "What advice should a driver give to passengers before opening doors?",
    "options": [
      "Make sure that you have proper clothing protection on.",
      "Remove seat belt and exit vehicle immediately.",
      "Check all around and open door with caution.",
      "Leave windows slightly open to allow circulation of air."
    ],
    "correct_answer": 2,
    "explanation": "Before opening any doors, check for other road users nearby, in particular motorcyclists and pedestrians.",
    "image_name": ""
  },
  {
    "index": 696,
    "id": "RSA01048",
    "section": "Safe and Socially Responsible Driving",
    "question": "How do you make sure your vehicle is parked safely?",
    "options": [
      "Don't park it where it may endanger other road users.",
      "Drive into parking space as quickly as possible.",
      "Park your vehicle opposite another vehicle on a narrow road.",
      "Avoid reversing your vehicle into a space."
    ],
    "correct_answer": 0,
    "explanation": "When parking make sure you do not interfere with normal traffic flow and that your vehicle does not disturb, block or endanger other road users.",
    "image_name": ""
  },
  {
    "index": 697,
    "id": "RSA01049",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should be considered when reversing out of a parking space?",
    "options": [
      "Always reverse quickly to get out of space.",
      "Check behind using interior rear view mirror only.",
      "Avoid switching on your rear wiper.",
      "Check for pedestrians and vehicles all around."
    ],
    "correct_answer": 3,
    "explanation": "Some car parks are designed for you to park forwards to make it easier to load shopping. In these cases take extra care as you reverse out of the parking space because pedestrians and vehicles may pass behind you.",
    "image_name": ""
  },
  {
    "index": 698,
    "id": "BW0016RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they intend to reverse their vehicle into an area which they cannot see?",
    "options": [
      "Open driver's door and look behind.",
      "Look in nearside (left) mirror when reversing.",
      "Open driver's window and look behind.",
      "Ask someone to guide you when reversing."
    ],
    "correct_answer": 3,
    "explanation": "Do not attempt to reverse into an area that you cannot see into properly. You should get assistance from somebody who can guide you safely into the area.",
    "image_name": ""
  },
  {
    "index": 699,
    "id": "BW0029RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if dazzled by headlights reflecting in the rear-view mirror of their car?",
    "options": [
      "Turn on the rear fog lights to signal to the following vehicle to turn off their headlights.",
      "Adjust the mirror to reflect the light back towards the following driver.",
      "Switch the lights off and on to remind the following driver to dip their lights.",
      "Use the night driving mode on their rear-view mirror."
    ],
    "correct_answer": 3,
    "explanation": "If a driver is being dazzled by the lights of following traffic, they should adjust their rear-view mirror to the night driving mode. This will allow them to concentrate on the road ahead and not be distracted by lights from following traffic.",
    "image_name": ""
  },
  {
    "index": 700,
    "id": "BW0064RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is a tractor most likely to overturn?",
    "options": [
      "When driving on the flat.",
      "When reversing slowly.",
      "When turning sharply.",
      "When driving uphill."
    ],
    "correct_answer": 2,
    "explanation": "When you are driving a tractor, you should be aware that tractors are less stable than other vehicles and take extra care when manoeuvring.",
    "image_name": ""
  },
  {
    "index": 701,
    "id": "BW0047RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "Why is it dangerous to allow children to stand in the space between the front seats of a car?",
    "options": [
      "They could distract other drivers thus drawing attention away from the road.",
      "They could be thrown forward if the brakes are applied suddenly.",
      "They could be thrown backward if the brakes are applied suddenly."
    ],
    "correct_answer": 1,
    "explanation": "When carrying children in a car or goods vehicle, it is the driver's responsibility to make sure that they are suitably restrained.",
    "image_name": ""
  },
  {
    "index": 702,
    "id": "BWO048R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When are children allowed to stand with their heads up through an open sun roof?",
    "options": [
      "Children are never allowed to do so.",
      "When they are aged more than 12 years.",
      "When they are wearing eye protection.",
      "When travelling at speeds below 30 km/h."
    ],
    "correct_answer": 0,
    "explanation": "When carrying children in a car or goods vehicle, it is the driver's responsibility to make sure that they are suitably restrained.",
    "image_name": ""
  },
  {
    "index": 703,
    "id": "BW0049",
    "section": "Safe and Socially Responsible Driving",
    "question": "When may the holder of a Category W learner permit carry a passenger on a tractor or works vehicle?",
    "options": [
      "When the passenger has personal insurance cover.",
      "When the passenger holds a full Category M licence and has personal insurance cover.",
      "When there is a need for their assistance.",
      "When there is proper passenger seating and the passenger holds a full Category W licence."
    ],
    "correct_answer": 3,
    "explanation": "The holder of a Category W licence may carry a passenger in the vehicle only if: 1. the vehicle is designed to take a passenger, and 2. the passenger has held a full driving licence in Category W for two or more years.",
    "image_name": ""
  },
  {
    "index": 704,
    "id": "BW0050RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "Are children allowed to be left unattended in a vehicle?",
    "options": [
      "Only when there is enough ventilation.",
      "Only when the vehicle is parked in a supervised car park.",
      "Children should never be left unattended in a vehicle."
    ],
    "correct_answer": 2,
    "explanation": "Children must not be left unattended in a vehicle, even for a short period of time. Children might interfere with the vehicle's controls, and would not be able to deal with an emergency situation, such as a fire or electrical malfunction which could result in serious injury or death.",
    "image_name": ""
  },
  {
    "index": 705,
    "id": "BWOO56R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is a driver allowed to carry more passengers in a car than there are seat belts available?",
    "options": [
      "It is never allowed.",
      "It is always allowed.",
      "When the driver has the appropriate insurance cover.",
      "When the driver's visibility is not interfered with."
    ],
    "correct_answer": 0,
    "explanation": "A driver must make sure that each passenger in the vehicle has a seatbelt. Failure to wear a seatbelt is an offence. It is the driver's responsibility to ensure that passengers under the age of 17 wear seatbelts. Older passengers are themselves responsible for wearing seatbelts.",
    "image_name": ""
  },
  {
    "index": 706,
    "id": "BWO0130R",
    "section": "Safe and Socially Responsible Driving",
    "question": "At what point is a vehicle load more likely to shift?",
    "options": [
      "When braking gently.",
      "When cornering.",
      "When overtaking.",
      "When reversing."
    ],
    "correct_answer": 1,
    "explanation": "It is the driver's responsibility to ensure that the load is properly secured and evenly distributed, so that the vehicle can be properly controlled when changing direction and when braking.",
    "image_name": ""
  },
  {
    "index": 707,
    "id": "BW0131RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver manage a bend when driving a fully loaded vehicle?",
    "options": [
      "At a slower speed than when empty.",
      "At the same speed as when empty.",
      "By taking the bend more sharply than when empty."
    ],
    "correct_answer": 0,
    "explanation": "Driving too fast on the approach to a bend and while driving through it with a fully loaded vehicle can lead to a loss of control. This can be prevented by driving ina safe and sensible manner and by reading the road ahead.",
    "image_name": ""
  },
  {
    "index": 708,
    "id": "BW0030RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if dazzled by lights at night reflecting in their interior mirror?",
    "options": [
      "Switch on the rear fog lights.",
      "Adjust the mirror to reflect the light back towards the following driver.",
      "Temporarily adjust the angle of the mirror.",
      "Switch on hazard lights."
    ],
    "correct_answer": 2,
    "explanation": "If the lights of following traffic reflecting in your interior mirror are dazzling you, activate the night driving/anti dazzle mode. If the vehicle is not equipped with this feature drivers should temporarily adjust the angle of the interior mirror to relieve the glare and allow them to drive without distraction.",
    "image_name": ""
  },
  {
    "index": 709,
    "id": "BW0031RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "At night, what effect could driving with a single headlight have on oncoming drivers?",
    "options": [
      "It would have no effect on oncoming drivers.",
      "It could dazzle them.",
      "They could mistake the vehicle for a motorcycle.",
      "It could enable them to see the vehicle more clearly."
    ],
    "correct_answer": 2,
    "explanation": "Motor vehicles (except motorcycles) are required by law to have two headlights. A vehicle with only one headlight could be mistaken for a motorcycle and other road users could believe that it is in a different position on the road than it actually is. Vehicle lights should be checked on a regular basis and repair faulty lighting immediately.",
    "image_name": ""
  },
  {
    "index": 710,
    "id": "BW0033U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What lights should be shown on a parked car, tractor or works vehicle at night on an unlit public road?",
    "options": [
      "Tail lights only.",
      "Dipped headlights.",
      "At least one side lamp front and rear on the side nearest the kerb.",
      "At least one side lamp front and rear on the side nearest the centre of the road."
    ],
    "correct_answer": 3,
    "explanation": "When leaving a vehicle on an unlit public road at night this creates a potential danger for other road users. Drivers should therefore leave side/parking lights on, so that the vehicle can be seen by other road users. Drivers should not leave headlights on when parked as this may cause other road users to become disoriented.",
    "image_name": ""
  },
  {
    "index": 711,
    "id": "BW0069RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should a driver use the vehicle side lights?",
    "options": [
      "When driving in foggy conditions.",
      "When driving in an unlit area at night.",
      "When parking on an unlit road.",
      "When parking at all times."
    ],
    "correct_answer": 2,
    "explanation": "When leaving a vehicle on an unlit public road at night this creates a potential danger for other road users. Drivers should therefore leave side/parking lights on, so that the vehicle can be seen by other road users. Drivers should not leave headlights on when parked as this may cause other road users to become disoriented.",
    "image_name": ""
  },
  {
    "index": 712,
    "id": "BW0004RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In this situation, what should the driver in the right-hand lane of the dual carriageway be aware of?",
    "options": [
      "Oncoming traffic.",
      "Increased visibility.",
      "The motorcyclist may perform a U-turn.",
      "Crosswinds may blow the rider into their path."
    ],
    "correct_answer": 3,
    "explanation": "When driving in wet and windy conditions, a driver should be aware that these conditions can affect the stability of vulnerable road users such as motorcyclists or cyclists. These road users may be blown into the driver's path particularly in open and exposed areas.",
    "image_name": "BW0004RU19.png"
  },
  {
    "index": 713,
    "id": "BW0008RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "If the vehicle's windows are covered with ice, what should the driver do?",
    "options": [
      "Clear enough space in the windscreen to be able to see ahead.",
      "Use boiling water to clear the ice.",
      "Fully clear ice from all windows.",
      "Drive slowly until the heater and demister have cleared the ice."
    ],
    "correct_answer": 2,
    "explanation": "Make sure all the windows are completely clear of ice so that the driver can safely observe road and traffic conditions all around. This is especially important when driving in slippery conditions. It is good practice to carry a can of de-icer in the vehicle and if possible to fill the washer reservoir with a de-icing agent.",
    "image_name": ""
  },
  {
    "index": 714,
    "id": "BW0009RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if the vehicle's windows and mirrors are covered in ice?",
    "options": [
      "Use boiling water with salt to clear the ice.",
      "Switch on the windscreen wipers.",
      "Switch on the heating system and use a scraper to clear the ice before driving.",
      "Drive at a reduced speed until the heating system has cleared the ice."
    ],
    "correct_answer": 2,
    "explanation": "Make sure all the windows and mirrors are completely clear of ice so that the driver can safely observe road and traffic conditions all around. This is especially important when driving in slippery conditions. It is good practice to carry a can of de-icer in the vehicle and if possible to fill the washer reservoir with a de-icing agent.",
    "image_name": ""
  },
  {
    "index": 715,
    "id": "BW0026RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should rear fog lights be used?",
    "options": [
      "In dense fog or falling snow.",
      "Only in light fog.",
      "Always when driving at night in an unlit area.",
      "When the vehicle behind is too close."
    ],
    "correct_answer": 0,
    "explanation": "A driver must only use rear fog lights in dense fog or falling snow. Using fog lights in normal road and weather conditions can dazzle or blind following motorists. Also, fog lights may make brake lights harder to see.",
    "image_name": ""
  },
  {
    "index": 716,
    "id": "BW0027RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When should rear fog lights be used?",
    "options": [
      "When driving in dense fog or falling snow.",
      "Rear fog lights should be used only at dawn and dusk.",
      "Rear fog lights should always be used.",
      "When both the rear tail lights are broken."
    ],
    "correct_answer": 0,
    "explanation": "A driver must only use rear fog lights in dense fog or falling snow. Using fog lights in normal road and weather conditions can dazzle or blind following motorists. Also, fog lights may make brake lights harder to see.",
    "image_name": ""
  },
  {
    "index": 717,
    "id": "CD0083RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect can wet weather have on the vehicle's exterior mirrors?",
    "options": [
      "It can short-circuit the electrically heated mirrors.",
      "It can distort the rear vision of the driver.",
      "It has no effect.",
      "It can keep them clean."
    ],
    "correct_answer": 1,
    "explanation": "When driving in the rain, water droplets can adhere to the exterior mirrors and obscure the driver's view to the side and rear of the vehicle. If the vehicle has heated mirrors, turn them on to clear them. Alternatively, stop periodically to clear  them manually.",
    "image_name": ""
  },
  {
    "index": 718,
    "id": "CD0099AAU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do before starting a journey in poor weather conditions?",
    "options": [
      "Top up the windscreen washer reservoir with coolant.",
      "Check the weather forecast for the planned route.",
      "Increase tyre pressure to ensure better grip on the road.",
      "Reduce tyre pressure to ensure better grip on the road."
    ],
    "correct_answer": 1,
    "explanation": "Driving in adverse weather conditions is more dangerous and more tiring. Drivers should check the weather forecast and weather warnings and other sources for information on the expected conditions on the intended route, and allow extra time  to complete the journey.",
    "image_name": ""
  },
  {
    "index": 719,
    "id": "CD0100RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do before starting a journey in bad weather?",
    "options": [
      "Top up the gearbox with coolant.",
      "Top up the windscreen washer reservoir.",
      "Reduce tyre pressure to ensure better grip on the road.",
      "Increase tyre pressure to ensure better grip on the road."
    ],
    "correct_answer": 1,
    "explanation": "Before starting a long journey in adverse weather the driver should ensure that there is sufficient fluid in the windscreen washer bottle in order to keep the windscreen clear in these conditions.",
    "image_name": ""
  },
  {
    "index": 720,
    "id": "CD0103U23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver manage a steep descent in snow or frosty weather?",
    "options": [
      "Keep the clutch depressed and use gentle braking.",
      "Always keep close to the left and use short, sharp brake applications to keep the speed down.",
      "Engage a higher gear than normal in order to avoid wheel-spin.",
      "Engage a lower gear early and use gentle braking applications to keep the speed down."
    ],
    "correct_answer": 3,
    "explanation": "In snow or ice, a vehicle takes longer to stop. Before starting a steep descent ina large vehicle, the driver should reduce speed and select a lower gear, brake gently and only when needed. If the vehicle is fitted with a manually selectable retarder, engage it before starting the descent.",
    "image_name": ""
  },
  {
    "index": 721,
    "id": "CPC1138AU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What would a lightness in the steering MOST likely indicate?",
    "options": [
      "Icy surface.",
      "Smooth surface.",
      "Gravelled surface.",
      "Wet surface."
    ],
    "correct_answer": 0,
    "explanation": "Lightness in steering indicates a loss of traction. This generally happens when the road surface is icy. Ice provides a harder, smoother surface than rain, or snow so it is difficult to avoid skidding and drivers should allow up to 10 times the normal braking distance in order to stop safely.",
    "image_name": ""
  },
  {
    "index": 722,
    "id": "CD0154RAU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "Before driving through a tunnel, what should a driver do?",
    "options": [
      "Disengage the Global Positioning System (GPS).",
      "Register at the first tunnel station.",
      "Turn on side lights only.",
      "Check that you have enough fuel."
    ],
    "correct_answer": 3,
    "explanation": "If your route takes you through a tunnel, you must ensure that your vehicle has enough fuel to safely pass through.",
    "image_name": ""
  },
  {
    "index": 723,
    "id": "CD0156RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "Before entering a tunnel, what should a driver do in order to improve vision?",
    "options": [
      "Take off sunglasses.",
      "Drive close to the vehicle in front.",
      "Wear sunglasses to prevent glare from the lights.",
      "Pull down the visor to eliminate overhead light glare."
    ],
    "correct_answer": 0,
    "explanation": "Be aware that there is considerably less light available in a tunnel, even with the tunnel lights on. To improve your vision remove your sunglasses before entering the tunnel.",
    "image_name": ""
  },
  {
    "index": 724,
    "id": "CD0158RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a vehicle is stopped in a tunnel due to congestion what should a driver do?",
    "options": [
      "Switch on hazard warning lights.",
      "Keep close to the vehicle in front.",
      "Switch off the engine and leave the vehicle.",
      "Walk to the nearest emergency exit."
    ],
    "correct_answer": 0,
    "explanation": "lf, when driving a vehicle through a tunnel, you meet traffic congestion, leave a safe distance between you and the vehicle in front and switch on your hazard warning lights when stationary.",
    "image_name": ""
  },
  {
    "index": 725,
    "id": "CD0159RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a vehicle is stopped in a tunnel due to congestion what should a driver do?",
    "options": [
      "Keep the engine ticking over in a low gear.",
      "Only give hand signals.",
      "Switch on the fog lights.",
      "Switch off the engine."
    ],
    "correct_answer": 3,
    "explanation": "If, when driving a vehicle through a tunnel, you are halted in stationary traffic for any length of time, you should switch off the engine to reduce fumes in the tunnel and conserve fuel.",
    "image_name": ""
  },
  {
    "index": 726,
    "id": "CD0160RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle is forced to stop in a tunnel due to a breakdown or a crash?",
    "options": [
      "Wait in the vehicle for help to arrive.",
      "Call for help from an emergency station.",
      "Beckon other traffic to overtake."
    ],
    "correct_answer": 1,
    "explanation": "If there is a breakdown or crash in a tunnel, stop, switch off the engine, switch on the hazard warning lights, check the radio for instructions and use the emergency phone at the emergency station to call for help, check all electronic signs in the  tunnel for information.",
    "image_name": ""
  },
  {
    "index": 727,
    "id": "CD0161RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle breaks down in a tunnel?",
    "options": [
      "Hitch a lift to the nearest service area and get help.",
      "Walk to the end of the tunnel to call the Gardaí.",
      "Flag down a passing motorist and ask for help.",
      "Use the emergency telephone to call for help."
    ],
    "correct_answer": 3,
    "explanation": "If a driver's vehicle stops in a tunnel due to a breakdown, switch off the engine, switch on the hazard warning lights, check the radio for instructions and use the emergency phone at the emergency station to call for help, check all electronic signs in the tunnel for information.",
    "image_name": ""
  },
  {
    "index": 728,
    "id": "CD0162RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle breaks down in a tunnel?",
    "options": [
      "Reverse the vehicle to the exit.",
      "Beckon other traffic to overtake.",
      "Switch on the hazard warning lights.",
      "Wait in the vehicle for help to arrive."
    ],
    "correct_answer": 2,
    "explanation": "If a driver's vehicle stops in a tunnel due to a breakdown, switch off the engine, switch on the hazard warning lights, check the radio for instructions and use the emergency phone at the emergency station to call for help, check all electronic signs in the tunnel for information.",
    "image_name": ""
  },
  {
    "index": 729,
    "id": "CD0163RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "If a vehicle being driven through a tunnel goes on fire, what should the driver do?",
    "options": [
      "Wait for the tunnel traffic radio to announce the fire drill.",
      "Drive to the nearest emergency exit as quickly as possible.",
      "Stay in the vehicle and phone the emergency station to report the fire.",
      "Leave the vehicle immediately and use the emergency phone at the nearest emergency station."
    ],
    "correct_answer": 3,
    "explanation": "If there is smoke or fire in the vehicle, switch off the engine, leave the vehicle immediately, go to the emergency station and use the emergency phone to alert the tunnel operator and leave the tunnel by the nearest available exit.",
    "image_name": ""
  },
  {
    "index": 730,
    "id": "BW0083RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is a possible effect of over-filling the engine with oil?",
    "options": [
      "It could reduce the oil pressure.",
      "It could damage the oil pump.",
      "It could burst the oil filter.",
      "It could damage the catalytic converter."
    ],
    "correct_answer": 3,
    "explanation": "It is essential that the vehicle's engine is not over filled with oil as this can permanently damage the catalytic converter, which is part of most vehicles' exhaust systems and removes up to 75% of the carbon monoxide, nitrogen oxide and hydrocarbons from the vehicle's exhaust. Damaging this increase exhaust emissions.",
    "image_name": ""
  },
  {
    "index": 731,
    "id": "BW0107RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What could a driver do in order to avoid excessive exhaust pollution from their vehicle?",
    "options": [
      "Drive at a higher speed in order to reduce the time spent on the road.",
      "Drive a diesel powered vehicle.",
      "Use a fuel additive to increase the fuel octane rating.",
      "Have the vehicle's air filters changed regularly."
    ],
    "correct_answer": 3,
    "explanation": "Drivers should have their vehicle serviced regularly in accordance with the manufacturer's guidelines. A vehicle with a dirty air filter uses more fuel and creates more exhaust pollution. Air filters should be changed as part of normal servicing. If a vehicle is used in dusty conditions, the air filter may need to be changed more often. More information is available in the vehicle owner's handbook.",
    "image_name": ""
  },
  {
    "index": 732,
    "id": "BW0108RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In general how regularly should a vehicle be serviced?",
    "options": [
      "Every 30 months.",
      "Once every year.",
      "As per the manufacturer's recommendation.",
      "Every 30,000 kilometres."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should have their vehicle serviced regularly in accordance with the manufacturer's guidelines. This helps the vehicle to perform properly, and as a result saves fuel and reduces emissions. In addition, drivers should also carry out their own daily and weekly checks on fluid levels and tyres.",
    "image_name": ""
  },
  {
    "index": 733,
    "id": "BW0109RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the purpose of a catalytic converter?",
    "options": [
      "To allow the exhaust system to be reconditioned.",
      "To curb exhaust noise levels only on petrol-powered vehicles.",
      "To curb exhaust noise levels only on diesel-powered vehicles.",
      "To reduce harmful exhaust emissions."
    ],
    "correct_answer": 3,
    "explanation": "Catalytic converters are part of a vehicle's exhaust system. They help to protect the environment by removing up to 75% of the carbon monoxide, nitrogen oxide and hydrocarbons from the vehicle's exhaust.",
    "image_name": ""
  },
  {
    "index": 734,
    "id": "BW0018RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do in order to keep alert during a long journey?",
    "options": [
      "Keep the radio turned on and windows closed.",
      "Turn up the heater to maintain driver comfort.",
      "Increase speed to shorten the journey.",
      "Increase the air circulation and stop if necessary."
    ],
    "correct_answer": 3,
    "explanation": "While on a long journey, a driver should take regular rest breaks. A short walk and a caffeinated drink (tea or coffee) can help to revive them. The vehicle should be kept cool and well ventilated with a steady flow of fresh air.",
    "image_name": ""
  },
  {
    "index": 735,
    "id": "CD0032U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What can a driver do to stay alert on a long journey?",
    "options": [
      "Stop, park in a safe place and have a cup of coffee.",
      "Listen attentively to the radio.",
      "Roll down the window and allow fresh air in.",
      "Turn up the temperature in the vehicle."
    ],
    "correct_answer": 0,
    "explanation": "If a driver continues to drive fighting sleep it can be the same as being over the drink driving limit. Stopping the vehicle in a safe place, drinking caffeine and taking anap for 15 minutes will revive the driver allowing them to continue for a short  period.",
    "image_name": ""
  },
  {
    "index": 736,
    "id": "RSA01045U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "During what time periods can a driver be tested for drugs at a road side checkpoint?",
    "options": [
      "Only after an accident.",
      "Only during daylight hours.",
      "Only during night time hours.",
      "Anytime of day or night."
    ],
    "correct_answer": 3,
    "explanation": "The law allows for a driver to be tested at any time.",
    "image_name": ""
  },
  {
    "index": 737,
    "id": "RSA225189",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when feeling tired within a short distance from their destination?",
    "options": [
      "Speed up so they reach their destination sooner.",
      "Stop in a safe place and take a break.",
      "Continue their journey as they are near to their destination."
    ],
    "correct_answer": 1,
    "explanation": "Do not be tempted to keep driving when you are tired when you are close to your destination. The driver should stop in a safe place and take a break. Many driver tiredness related collisions occur within a short distance of their destination as the  body begins to relax.",
    "image_name": ""
  },
  {
    "index": 738,
    "id": "BWOO65R",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving a tractor and trailer, what should the driver do on entering a roundabout to avoid possible roll-over?",
    "options": [
      "Reduce speed.",
      "Drive in a high gear.",
      "Engage the parking brake.",
      "Increase speed."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should always drive at a speed which is safe. In particular, when changing direction, such as entering a roundabout. If driving a tractor with a trailer, extra care should be taken due to their instability.",
    "image_name": ""
  },
  {
    "index": 739,
    "id": "BW0066RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is meant by the term jack-knifing?",
    "options": [
      "When the trailer is too heavy to be drawn by the tractor.",
      "When the vehicle slides due to ice or water on the road.",
      "When the trailer is travelling faster than the drawing vehicle.",
      "When the jack is not strong enough to lift an axle."
    ],
    "correct_answer": 2,
    "explanation": "Towing a trailer or caravan dramatically reduces the stability of the towing vehicle. If a driver brakes sharply or slows down quickly, the trailer may pivot around the tow hitch coupling, causing both vehicles to go off course, and possibly overturn.",
    "image_name": ""
  },
  {
    "index": 740,
    "id": "BWO067",
    "section": "Safe and Socially Responsible Driving",
    "question": "When is jack-knifing most likely to occur?",
    "options": [
      "When travelling sideways across a slope.",
      "When trying to reduce speed sharply while travelling downhill.",
      "When the trailer springs are over-greased.",
      "When travelling uphill."
    ],
    "correct_answer": 1,
    "explanation": "Towing a trailer or caravan dramatically reduces the stability of the towing vehicle. If a driver brakes sharply or slows down quickly, the trailer may pivot around the tow hitch coupling, causing both vehicles to go off course, and possibly overturn.",
    "image_name": ""
  },
  {
    "index": 741,
    "id": "CD0173RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When joining a motorway from a slip road, what should a driver do?",
    "options": [
      "Adjust speed to match that of the motorway traffic, and merge into a suitable gap.",
      "Use the size of the vehicle to assert its position on the motorway.",
      "Stop on the slip road until a suitable gap appears in the traffic.",
      "Drive on the hard shoulder for a distance until a suitable gap appears in the traffic."
    ],
    "correct_answer": 0,
    "explanation": "When joining a motorway from a slip road, drivers should adjust their speed to that of the motorway traffic on the acceleration lane and merge into a suitable gap in lane 1. Do not force other traffic to swerve or slow down to avoid your vehicle.",
    "image_name": ""
  },
  {
    "index": 742,
    "id": "ABMW0686RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver is making a left-hand turn, what mirrors should they particularly concentrate on?",
    "options": [
      "The interior and left exterior mirror.",
      "The interior mirror.",
      "The interior and right exterior mirror.",
      "The right exterior mirror."
    ],
    "correct_answer": 0,
    "explanation": "When turning left, drivers should in particular be aware that cyclists and other vehicles may come up on their nearside (left-hand side). For that reason, when checking mirrors, it is particularly important to check both the left exterior and the interior mirror before turning. Drivers must always use the Mirrors-Signal-Mirror- Manoeuvre routine when turning. They should be particularly careful if crossing the ",
    "image_name": ""
  },
  {
    "index": 743,
    "id": "BW0006RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When towing a high and wide-bodied trailer what should a driver do?",
    "options": [
      "Drive with a red flag at the rear left of the trailer.",
      "Make use of extended mirrors to check for following traffic.",
      "Drive with hazard warning lights flashing at all times.",
      "Drive with a red flag to the front right-hand side of the trailer."
    ],
    "correct_answer": 1,
    "explanation": "When towing a high and wide-bodied trailer, a driver should use extended mirrors on both sides of the towing vehicle. This will allow the driver to better observe the traffic situation behind and to the sides.",
    "image_name": ""
  },
  {
    "index": 744,
    "id": "BW0012RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What specific observations should a driver make before reversing their vehicle?",
    "options": [
      "Look over both shoulders and behind.",
      "Look in door mirrors only.",
      "Look in interior mirror only.",
      "Look over right-hand shoulder."
    ],
    "correct_answer": 0,
    "explanation": "Before reversing, look over both shoulders and to the rear to check all around that there are no children or other road users around the vehicle and that it is safe to reverse.",
    "image_name": ""
  },
  {
    "index": 745,
    "id": "BW0013U19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What specific observations should a driver make before reversing a vehicle fitted with an external audible warning device?",
    "options": [
      "Observations should be made only in blind spots.",
      "Observations should be made by opening the driver's door and looking behind.",
      "Observations should be made to the front, sides and rear of the vehicle, including blind spots.",
      "No specific observations needed, as bystanders will be aware of the vehicle."
    ],
    "correct_answer": 2,
    "explanation": "Drivers should not rely solely on an external audible warning device to warn others that their vehicle is reversing. Before reversing, drivers must make sure it is safe to do so by taking all appropriate observations to the front, sides and rear of the vehicle, including the blind spots. Never assume it is safe to reverse just because the vehicle has an external audible warning device.",
    "image_name": ""
  },
  {
    "index": 746,
    "id": "BW0014RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when they intend to reverse into a side road?",
    "options": [
      "Focus totally on the left-side door mirror while reversing.",
      "Angle the door mirrors down before reversing.",
      "Check carefully all around before and during the reverse.",
      "Open the left-side door fully to look behind."
    ],
    "correct_answer": 2,
    "explanation": "Before and while reversing into a side road, check all around to make sure it is safe and clear to carry out the manoeuvre, paying particular attention to pedestrians crossing behind the vehicle and any other road users.",
    "image_name": ""
  },
  {
    "index": 747,
    "id": "BW0129RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "When must a driver use a red flag as a marker for a rear load overhang that exceeds one metre?",
    "options": [
      "At all times.",
      "Only during the day.",
      "Only during the night.",
      "At no time."
    ],
    "correct_answer": 1,
    "explanation": "During daylight hours, you must use a red flag to mark any load that is protruding more than one metre. At night, you must use a red light.",
    "image_name": ""
  },
  {
    "index": 748,
    "id": "BW0132R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if a tyre bursts on the vehicle they are driving?",
    "options": [
      "Apply the brakes as quickly as possible.",
      "Continue at the normal speed and stop at the next garage.",
      "Pull on the handbrake to bring the vehicle to a stop.",
      "Hold the steering wheel firmly and pull in on the side of the road."
    ],
    "correct_answer": 3,
    "explanation": "If a tyre bursts on your vehicle, keep a firm hold of the steering, slow down gradually and stop where it is safe to do so. Switch on the hazard warning lights.",
    "image_name": ""
  },
  {
    "index": 749,
    "id": "BW0135RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver apply the brakes in an emergency if the vehicle is fitted with anti-lock brakes (ABS)?",
    "options": [
      "Press the brake pedal firmly and hold.",
      "Press and release the brake at slow intervals.",
      "Press the brake pedal only lightly.",
      "Press and release the brake at rapid intervals."
    ],
    "correct_answer": 0,
    "explanation": "If your vehicle is fitted with ABS, brake firmly. ABS will not stop the vehicle more quickly, it will only prevent the wheels from locking. This helps you to maintain control of the vehicle.",
    "image_name": ""
  },
  {
    "index": 750,
    "id": "BW0136RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle gets into a four-wheel sideways skid?",
    "options": [
      "Turn the steering wheel in the same direction as the skid and apply the handbrake.",
      "Turn the steering wheel in the same direction as the skid and ease off the accelerator.",
      "Turn the steering wheel in the opposite direction to improve tyre grip.",
      "Turn the steering wheel in the opposite direction and apply the handbrake."
    ],
    "correct_answer": 1,
    "explanation": "If your vehicle goes into a four-wheel skid, turn the steering wheel in the same direction as the skid and ease off the accelerator. This should help to bring the wheels back into line and allow you to regain control.",
    "image_name": ""
  },
  {
    "index": 751,
    "id": "BWO0137R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle gets into a front-wheel sideways skid?",
    "options": [
      "Press the footbrake.",
      "Apply the handbrake.",
      "Release the accelerator.",
      "Continue to accelerate."
    ],
    "correct_answer": 2,
    "explanation": "If your vehicle goes into a front-wheel sideways skid, release the accelerator and do not try to steer until the tyres regain some grip on the road.",
    "image_name": ""
  },
  {
    "index": 752,
    "id": "BWO138R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if their vehicle gets into a rear-wheel sideways skid?",
    "options": [
      "Turn the steering wheel in the same direction as the front wheels are heading.",
      "Apply the footbrake to bring the vehicle to a halt.",
      "Turn the steering wheel in the same direction as the rear wheels are heading.",
      "Apply the handbrake to bring the vehicle to a halt."
    ],
    "correct_answer": 2,
    "explanation": "If your vehicle goes into a rear-wheel sideways skid, turn the steering in the direction the rear wheels are heading. This should be done very gradually, as too much steering could cause the vehicle to skid in the opposite direction.",
    "image_name": ""
  },
  {
    "index": 753,
    "id": "BW0139RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "How should a driver in a vehicle without anti-lock brakes (ABS) deal with a front-wheel straight-line skid?",
    "options": [
      "Press in the clutch and release the accelerator.",
      "Press and release the footbrake at rapid intervals.",
      "Turn the steering wheel gently from side to side.",
      "Pull the handbrake and hold the footbrake down."
    ],
    "correct_answer": 1,
    "explanation": "If your vehicle does not have ABS and it goes into a straight-line front-wheel skid due to braking, press and release the brake pedal repeatedly and rapidly. This will help to restore tyre grip and enable you to regain control.",
    "image_name": ""
  },
  {
    "index": 754,
    "id": "BW0140R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do if they get a tyre blow-out on the road?",
    "options": [
      "Continue driving until they reach a garage.",
      "Apply the handbrake immediately to bring the vehicle to a halt.",
      "Apply the footbrake gently and bring the vehicle to a halt.",
      "Switch off the engine ignition to bring the vehicle to a halt."
    ],
    "correct_answer": 2,
    "explanation": "If a tyre on the vehicle you are driving blows out, slow down gradually and find a safe and suitable place to stop. Switch on your hazard warning lights and change the wheel or call for assistance.",
    "image_name": ""
  },
  {
    "index": 755,
    "id": "BW0141RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect could a front-tyre blow-out have on a vehicle?",
    "options": [
      "The steering wheel will pull to one side.",
      "The steering wheel will stay in the straight on position.",
      "Anti-lock brakes will be automatically disengaged.",
      "The wheels will lock up and stop rotating."
    ],
    "correct_answer": 0,
    "explanation": "If a front tyre on the vehicle you are driving blows out, you will feel the effect of it through the steering wheel. The wheel will generally pull to the side of the blown- out tyre.",
    "image_name": ""
  },
  {
    "index": 756,
    "id": "BW0142RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What effect could a rear-tyre blow-out have on a vehicle?",
    "options": [
      "The steering wheel will pull to the right.",
      "It could cause the vehicle to sway from side to side.",
      "The handbrake will automatically come on.",
      "It could cause the wheels to lock and stop rotating."
    ],
    "correct_answer": 1,
    "explanation": "If a rear tyre on the vehicle you are driving blows out, the vehicle may sway from side to side, and this will affect its stability. Slow down, pull in where it is safe to do so, and switch on the hazard warning lights. Change the wheel or call for assistance.",
    "image_name": ""
  },
  {
    "index": 757,
    "id": "BW0143R",
    "section": "Safe and Socially Responsible Driving",
    "question": "What action should a driver take if the engine in their vehicle cuts out suddenly when they are driving along?",
    "options": [
      "Depress the accelerator and then release it.",
      "Engage a lower gear.",
      "Check the handbrake is fully off.",
      "Signal and steer the vehicle to the side of the road."
    ],
    "correct_answer": 3,
    "explanation": "If the engine in a vehicle cuts out when driving, it is important to signal and steer to the side of the road, switch on the hazard warning lights to warn other drivers, and contact the relevant breakdown service to get assistance.",
    "image_name": ""
  },
  {
    "index": 758,
    "id": "BWO0144R",
    "section": "Safe and Socially Responsible Driving",
    "question": "How would hydraulic power steering be affected if an engine stalled in slow-moving traffic?",
    "options": [
      "The steering fluid reservoir would lose all its fluid.",
      "The steering wheel would automatically lock.",
      "The steering would become heavy and difficult to operate.",
      "The steering would become much lighter and easier to operate."
    ],
    "correct_answer": 2,
    "explanation": "Hydraulic power steering is operated by a pump which is driven by the engine. If the engine stalls, the pump stops working, and the steering becomes heavy and requires much more effort to turn.",
    "image_name": ""
  },
  {
    "index": 759,
    "id": "BW0148RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving along, a driver feels that the oncoming car may crash into their vehicle. What should they do?",
    "options": [
      "Apply the handbrake immediately to help bring the vehicle to a halt.",
      "Sound the horn to attract the attention of the other driver and take evasive action.",
      "Switch off the engine ignition to help bring the vehicle to a halt.",
      "Apply the footbrake gently and bring the vehicle to a halt."
    ],
    "correct_answer": 1,
    "explanation": "If there is an oncoming vehicle in your path, take evasive action and sound your horn to alert the other driver. Bring your vehicle to a halt immediately.",
    "image_name": ""
  },
  {
    "index": 760,
    "id": "BW0149RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do when suddenly confronted by a hazard on the road?",
    "options": [
      "Apply the handbrake and the footbrake together.",
      "Slowly brake and switch off the ignition.",
      "Depress clutch and switch off the ignition.",
      "Decelerate and apply the footbrake firmly."
    ],
    "correct_answer": 3,
    "explanation": "To stop your vehicle in an emergency, apply the footbrake firmly, and maintain the pressure until the vehicle stops. Depress the clutch pedal just before stopping.",
    "image_name": ""
  },
  {
    "index": 761,
    "id": "BW0150RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When driving along and required to stop suddenly, what should a driver do?",
    "options": [
      "Steer sharply to one side and apply the handbrake.",
      "Apply the handbrake and the footbrake together.",
      "Apply the footbrake firmly.",
      "Depress the clutch and then apply the handbrake."
    ],
    "correct_answer": 2,
    "explanation": "To stop your vehicle in an emergency, apply the footbrake firmly, and maintain the pressure until the vehicle stops. Depress the clutch pedal just before stopping.",
    "image_name": ""
  },
  {
    "index": 762,
    "id": "BW0151RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When required to stop in an emergency, what should a driver do?",
    "options": [
      "Apply both the clutch and handbrake.",
      "Press the footbrake and engage a higher gear.",
      "Apply firm pressure on the footbrake.",
      "Apply gentle pressure to the footbrake."
    ],
    "correct_answer": 2,
    "explanation": "To stop your vehicle in an emergency, apply the footbrake firmly, and maintain the pressure until the vehicle stops. Depress the clutch pedal just before stopping.",
    "image_name": ""
  },
  {
    "index": 763,
    "id": "BW0152RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "When required to stop in an emergency, what should a driver do?",
    "options": [
      "Apply the footbrake and engage a higher gear.",
      "Depress the clutch pedal and engage a lower gear.",
      "Switch off the ABS system.",
      "Apply the footbrake firmly."
    ],
    "correct_answer": 3,
    "explanation": "To stop your vehicle in an emergency, apply the footbrake firmly, and maintain the pressure until the vehicle stops. Depress the clutch pedal just before stopping.",
    "image_name": ""
  },
  {
    "index": 764,
    "id": "BW0153",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to avoid having to make an emergency stop?",
    "options": [
      "Drive with the left foot covering the brake pedal.",
      "Drive with the left foot covering the clutch pedal.",
      "Keep a safe distance from the vehicle in front.",
      "Keep the left hand available to apply the handbrake."
    ],
    "correct_answer": 2,
    "explanation": "When driving in traffic, read the road ahead and keep a safe distance from the vehicle in front. Use the two-second rule to determine your safe distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 765,
    "id": "BW5",
    "section": "Safe and Socially Responsible Driving",
    "question": "What should a driver do to avoid having to make an emergency stop?",
    "options": [
      "Drive with the left foot covering the clutch pedal.",
      "Drive with the left foot covering the brake pedal.",
      "Keep the left hand available to apply the handbrake.",
      "Scan the road well ahead."
    ],
    "correct_answer": 3,
    "explanation": "When driving in traffic, read the road ahead and keep a safe distance from the vehicle in front. Use the two-second rule to determine your safe distance from the vehicle in front.",
    "image_name": ""
  },
  {
    "index": 766,
    "id": "RSA0220U23",
    "section": "Safe and Socially Responsible Driving",
    "question": "How many penalty points will an unaccompanied learner driver receive on conviction?",
    "options": [
      "4 penalty points.",
      "3 penalty points.",
      "2 penalty points."
    ],
    "correct_answer": 0,
    "explanation": "A learner driver needs to be aware that driving unaccompanied increases the penalty points to 4 on conviction.",
    "image_name": ""
  },
  {
    "index": 767,
    "id": "RSA0222U23",
    "section": "Safe and Socially Responsible Driving",
    "question": "A learner driver who has been stopped by a Garda for driving unaccompanied faces a minimum fine of how much?",
    "options": [
      "€160",
      "€140",
      "€120"
    ],
    "correct_answer": 0,
    "explanation": "A learner driver needs to be aware that if stopped by a Garda for driving unaccompanied it will lead to a financial penalty.",
    "image_name": ""
  },
  {
    "index": 768,
    "id": "RSA0223",
    "section": "Safe and Socially Responsible Driving",
    "question": "If the owner of a vehicle allows a learner driver to drive their vehicle, what is the maximum fine the owner could face?",
    "options": [
      "€2,000.",
      "€1,500.",
      "€1,000.",
      "€500."
    ],
    "correct_answer": 2,
    "explanation": "A learner driver needs to be aware that driving unaccompanied in a vehicle which they do not own could see the owner facing a fine of up to €1,000 and having the vehicle seized.",
    "image_name": ""
  },
  {
    "index": 769,
    "id": "RSA0224",
    "section": "Safe and Socially Responsible Driving",
    "question": "Is a learner driver permitted to drive unaccompanied if they have the consent of the vehicle owner?",
    "options": [
      "Yes, provided the vehicle owner has open drive insurance.",
      "Yes, provided the vehicle owner has given their consent.",
      "Yes, provided the owner is a family member and has given their consent.",
      "No, a learner driver is not permitted to drive unaccompanied even with the owner's consent."
    ],
    "correct_answer": 3,
    "explanation": "A learner driver needs to be aware that, even with the consent of the owner of the vehicle, they are not permitted to drive unaccompanied.",
    "image_name": ""
  },
  {
    "index": 770,
    "id": "RSA0225",
    "section": "Safe and Socially Responsible Driving",
    "question": "For how long is a learner driver's accompanying driver required to have held their full licence in Category B?",
    "options": [
      "6 months.",
      "1 year.",
      "2 years.",
      "3 years."
    ],
    "correct_answer": 2,
    "explanation": "A learner driver needs to be aware that not just anyone can be an accompanying driver. An accompanying driver has to have held a full licence for at least 2 years and have built up good driving experience.",
    "image_name": ""
  },
  {
    "index": 771,
    "id": "RSA0226U23",
    "section": "Safe and Socially Responsible Driving",
    "question": "What is the fine for a learner driver who drives unaccompanied?",
    "options": [
      "€120",
      "€140",
      "€160"
    ],
    "correct_answer": 2,
    "explanation": "A learner driver needs to know that there are fines for driving unaccompanied.",
    "image_name": ""
  },
  {
    "index": 772,
    "id": "RSA0228",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a learner driver has passed their driving test, are they permitted to drive unaccompanied as the holder of a Certificate of Competency?",
    "options": [
      "No, a learner driver is not permitted to drive unaccompanied until they have been issued with a full driving licence in that category.",
      "Yes, a learner driver is permitted to drive unaccompanied on a Certificate of Competency once they have notified their insurance company.",
      "No, a learner driver is not permitted to drive unaccompanied on a Certificate of Competency unless they continue to display L plates.",
      "Yes, a learner driver is permitted to drive unaccompanied on a Certificate of Competency once they have N plates displayed."
    ],
    "correct_answer": 0,
    "explanation": "A learner driver who successfully passes their driving test needs to be aware that the rules that apply to learner permit holders still apply to them until they are in  possession of a full driving licence in that category. A Certificate of Competency is not a full licence.",
    "image_name": ""
  },
  {
    "index": 773,
    "id": "RSA0229",
    "section": "Safe and Socially Responsible Driving",
    "question": "Can a learner driver drive unaccompanied if they are on their third or subsequent learner permit?",
    "options": [
      "No, they cannot drive unaccompanied on any learner permit.",
      "Yes, but not on motorways.",
      "Yes, provided they display N plates on the front and rear of the vehicle.",
      "No, unless they display L plates on the front and rear of the vehicle."
    ],
    "correct_answer": 0,
    "explanation": "A learner driver needs to be aware that they are not permitted under any circumstance to drive unaccompanied regardless of the amount of learner permits held.",
    "image_name": ""
  },
  {
    "index": 774,
    "id": "RSA0230",
    "section": "Safe and Socially Responsible Driving",
    "question": "Can a person who has passed their car driving test within the last two years act as an accompanying driver?",
    "options": [
      "No, unless they are a qualified Approved Driving Instructor (ADI).",
      "Yes, as long as they have their full licence with them.",
      "No, they must hold the full driving licence for a minimum of 2 years.",
      "Yes, as long as they have completed their Essential Driver Training (EDT)."
    ],
    "correct_answer": 2,
    "explanation": "To be an accompanying driver for a learner driver, you must have a full driving licence for at least 2 years.",
    "image_name": ""
  },
  {
    "index": 775,
    "id": "RSA0231",
    "section": "Safe and Socially Responsible Driving",
    "question": "Are there any occasions when a learner driver can drive unaccompanied?",
    "options": [
      "Yes, when driving to the test centre before the driving test.",
      "No, learner drivers must be accompanied at all times by a qualified driver.",
      "Yes, when meeting an Approved Driving Instructor (ADI).",
      "Yes, after completing a driving test."
    ],
    "correct_answer": 1,
    "explanation": "Learner drivers must be aware that they must be accompanied by a qualified driver at all times.",
    "image_name": ""
  },
  {
    "index": 776,
    "id": "CD0178RU23",
    "section": "Safe and Socially Responsible Driving",
    "question": "A driver approaches a pelican crossing with a flashing amber light showing. There is a pedestrian still on the road. What should the driver do?",
    "options": [
      "Wait and let the pedestrian cross at their own pace.",
      "Beckon the pedestrian to move along as quickly as possible.",
      "Sound the horn as a warning and proceed with care."
    ],
    "correct_answer": 0,
    "explanation": "You must yield to pedestrians at a pelican crossing when the amber light is flashing.",
    "image_name": ""
  },
  {
    "index": 777,
    "id": "RSA228086",
    "section": "Safe and Socially Responsible Driving",
    "question": "When a driver intends to make a left-hand turn at a busy city junction and there are pedestrians, cyclists and e-scooter users present, what should the driver do?",
    "options": [
      "Keep to the right to make room for cyclists and e-scooter users to pass.",
      "Watch for pedestrians, cyclists and e-scooter users who may try to cross the road in front of the driver's vehicle.",
      "Signal left, watch the right-hand mirror and make the turn when it is clear."
    ],
    "correct_answer": 1,
    "explanation": "When making a left-hand turn on a busy city street, drivers should pay particular attention to vulnerable road users such as pedestrians, cyclists, motorcyclists and e-scooter users who may appear unexpectedly and especially from the left and may not be aware of the vehicle's intention.",
    "image_name": ""
  },
  {
    "index": 778,
    "id": "BW0080RU19",
    "section": "Safe and Socially Responsible Driving",
    "question": "In general, above what gross vehicle weight must a trailer have brakes fitted?",
    "options": [
      "750 kg",
      "850 kg",
      "900 kg",
      "500 kg"
    ],
    "correct_answer": 0,
    "explanation": "Brakes must be fitted to a trailer if its gross vehicle weight exceeds either 750 kg or half the weight of the towing vehicle.",
    "image_name": ""
  },
  {
    "index": 779,
    "id": "ABMW27U19",
    "section": "Technical Matters",
    "question": "What can be affected by driving on under-inflated tyres?",
    "options": [
      "Braking ability.",
      "Engine temperature.",
      "Climate control system.",
      "The exhaust system."
    ],
    "correct_answer": 0,
    "explanation": "Under-inflated tyres may adversely affect many of the vehicle's systems, including its braking ability, suspension, steering and fuel consumption. In particular, under- inflated tyres can affect the vehicle's braking ability and can result in premature tyre wear. Tyres should always be inflated according to the vehicle manufacturer's guidelines, information on which can be found in the vehicle handbook.",
    "image_name": ""
  },
  {
    "index": 780,
    "id": "ABMW0653RU19",
    "section": "Technical Matters",
    "question": "When a driver operates the indicator switch and hears a more rapid clicking noise than normal, what could this mean?",
    "options": [
      "The voltage regulator is not functioning properly.",
      "An indicator bulb may have blown.",
      "The hazard warning lights are on.",
      "The hazard warning light switch is faulty."
    ],
    "correct_answer": 1,
    "explanation": "A rapid clicking noise when you turn on an indicator is usually a sign that one of the indicator bulbs has failed. Drivers are responsible for making sure that their vehicle is roadworthy. This should include a regular check that all lights, reflectors and indicators, are working properly.",
    "image_name": ""
  },
  {
    "index": 781,
    "id": "ABMW0660RU19",
    "section": "Technical Matters",
    "question": "If driving a vehicle with automatic transmission, what in particular should a driver be aware of?",
    "options": [
      "That wheel-spin occurs more often.",
      "That driving on a motorway is not permitted.",
      "That the gear box may overheat while being driven in low gear.",
      "That engine braking power is reduced."
    ],
    "correct_answer": 3,
    "explanation": "When driving an automatic vehicle, it may not slow at the same rate as a vehicle with a manual gearbox when the driver releases the accelerator. Drivers should be aware of this, as they may need to apply the brake earlier in order to stop where required.",
    "image_name": ""
  },
  {
    "index": 782,
    "id": "ABMW0661U19",
    "section": "Technical Matters",
    "question": "What effect does automatic transmission have on engine braking power?",
    "options": [
      "It transfers the braking ability to the handbrake.",
      "It increases it.",
      "It reduces it.",
      "It transfers the braking ability to all the wheels."
    ],
    "correct_answer": 2,
    "explanation": "When driving an automatic vehicle, it may not slow at the same rate as a vehicle with a manual gearbox when the driver releases the accelerator. Drivers should be aware of this, as they may need to apply the brake earlier in order to stop where required.",
    "image_name": ""
  },
  {
    "index": 783,
    "id": "ABMW0665RU19",
    "section": "Technical Matters",
    "question": "If the oil pressure gauge shows little or no pressure, or the warning light comes on, what could the problem be?",
    "options": [
      "The oil level is too low.",
      "The oil is too cold.",
      "The oil is too thick.",
      "The oil level is too high."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should check the oil level in their vehicle regularly, and if it is low, top it up. If it needs to be topped up very often, have the vehicle checked by a competent person to see if there is a problem.",
    "image_name": ""
  },
  {
    "index": 784,
    "id": "ABMW0666RU19",
    "section": "Technical Matters",
    "question": "What may happen if the vehicle's engine oil is not changed as required?",
    "options": [
      "The vehicle's fuel consumption may increase.",
      "The vehicle's fuel consumption may decrease.",
      "The engine may overheat.",
      "Parts of the engine may suffer increased wear."
    ],
    "correct_answer": 3,
    "explanation": "Engine oil becomes inefficient over time, losing its viscosity and lubricating qualities, and therefore must be changed as required in accordance with the manufacturer's recommendations. Failure to do so may result in costly and extensive engine damage. The oil change is usually done when the vehicle is being serviced.",
    "image_name": ""
  },
  {
    "index": 785,
    "id": "ABMW0667RU19",
    "section": "Technical Matters",
    "question": "If a vehicle is driven with low oil pressure, what effect does this have on its engine?",
    "options": [
      "It increases wear and tear on the engine.",
      "It increases fuel efficiency.",
      "It increases exhaust emissions.",
      "It increases fuel consumption."
    ],
    "correct_answer": 0,
    "explanation": "Low oil pressure is usually related to low oil level or to a faulty oil pump. Low engine oil level should be topped up in accordance with the manufacturer's recommendations. Failure to do so may result in costly and extensive engine damage.",
    "image_name": ""
  },
  {
    "index": 786,
    "id": "ABMW0668RU23",
    "section": "Technical Matters",
    "question": "If the vehicle's oil-pressure gauge is reading low or the red oil-pressure warning light comes on, what should a driver do?",
    "options": [
      "Drive in a low gear until the oil level is topped up.",
      "Drive to a safe place, stop the vehicle and check the oil level.",
      "Drive at lower speeds until the oil level is topped up."
    ],
    "correct_answer": 1,
    "explanation": "Oil circulation is essential for the safe running of the vehicle's engine. If the warning lights or gauges indicate that the oil or the oil-pressure is low, the driver should stop as soon as they can in safe place, check the oil level, and top up if necessary. Continuing to drive may damage the engine. If the problem is not just related to the oil level, have the vehicle checked by a competent person.",
    "image_name": ""
  },
  {
    "index": 787,
    "id": "ABMW0669RU19",
    "section": "Technical Matters",
    "question": "What should a driver do before checking the engine oil level on a vehicle?",
    "options": [
      "Make sure that the engine is switched off and cold.",
      "Make sure that the engine is switched on and hot.",
      "Make sure that the engine is running.",
      "Make sure that the vehicle is in a low gear."
    ],
    "correct_answer": 0,
    "explanation": "Drivers need a basic knowledge of the regular checks that should be carried out on their vehicle. Checking the engine oil level is important - do this with the vehicle parked on level ground with the engine switched off and cold for a more accurate reading. Refer to the vehicle handbook for further information and guidance.",
    "image_name": ""
  },
  {
    "index": 788,
    "id": "ABMW0670RU19",
    "section": "Technical Matters",
    "question": "What is the purpose of engine oil?",
    "options": [
      "It lubricates the exhaust system.",
      "It lubricates the wheel bearings.",
      "It lubricates the braking system.",
      "It lubricates the engine."
    ],
    "correct_answer": 3,
    "explanation": "The purpose of engine oil is to lubricate and cool the moving parts of the engine. Refer to the vehicle handbook for further information and guidance.",
    "image_name": ""
  },
  {
    "index": 789,
    "id": "ABMW0673RU19",
    "section": "Technical Matters",
    "question": "When is it recommended to use coolant?",
    "options": [
      "All year round.",
      "Summer only.",
      "In petrol engines only.",
      "Winter only."
    ],
    "correct_answer": 0,
    "explanation": "The purpose of coolant is to keep the engine cool during operation. Coolant is usually a mixture of water and anti-freeze - this ensures that the engine is kept cool and that the coolant does not freeze in very cold weather.",
    "image_name": ""
  },
  {
    "index": 790,
    "id": "ABMW0674RU23",
    "section": "Technical Matters",
    "question": "What does the warning light and/or red zone on a fuel gauge mean?",
    "options": [
      "The incorrect type of fuel is in the tank.",
      "The level of fuel in the tank is low.",
      "There is a leak in the fuel system."
    ],
    "correct_answer": 1,
    "explanation": "Many vehicles are fitted with various warning lights and gauges. A red zone or a warning light on a fuel gauge means the vehicle is low in fuel and should be refuelled as soon as possible.",
    "image_name": ""
  },
  {
    "index": 791,
    "id": "ABMW0675RU19",
    "section": "Technical Matters",
    "question": "What happens if the vehicle has a flat battery?",
    "options": [
      "The battery will leak acid into the engine.",
      "The battery will have to be replaced.",
      "The head light bulbs will have to be replaced.",
      "The engine will not start."
    ],
    "correct_answer": 3,
    "explanation": "All motor vehicles have a battery to supply power, primarily to start the engine. If the battery is flat, the driver will not be able to start the engine in the normal way. When the engine is running, it produces its own electricity to recharge the battery and run the various electrical components, including lights, heating, the radio and so on. If the battery is completely dead it will have to be replaced.",
    "image_name": ""
  },
  {
    "index": 792,
    "id": "ABMW0676RU19",
    "section": "Technical Matters",
    "question": "What is the primary purpose of the battery fitted to a petrol - or diesel - powered motor vehicle?",
    "options": [
      "To reduce fuel consumption.",
      "To provide braking.",
      "To provide heat to the engine.",
      "To start the engine."
    ],
    "correct_answer": 3,
    "explanation": "The primary purpose of the battery is to start the engine. When the engine is running, it produces its own electricity to charge the battery and run the various electrical components, including lights, heating, radio and so on.",
    "image_name": ""
  },
  {
    "index": 793,
    "id": "ABMW0681RU19",
    "section": "Technical Matters",
    "question": "What effect would a weak battery have on a vehicle's driving performance?",
    "options": [
      "The fuel would burn less efficiently.",
      "The headlights would not function.",
      "Uphill acceleration would be reduced.",
      "It would have no effect."
    ],
    "correct_answer": 3,
    "explanation": "It might be difficult to start a car with a weak battery, but once the engine is running, it makes no difference. If the battery fails to charge or maintain its full charge seek advice from a competent person.",
    "image_name": ""
  },
  {
    "index": 794,
    "id": "ABMW0682RU19",
    "section": "Technical Matters",
    "question": "What effect can a worn shock absorber have on a vehicle?",
    "options": [
      "It can cause the vehicle to 'bounce' in an unstable manner.",
      "It can cause an electrical short-circuit.",
      "It can increase fuel consumption.",
      "It can trigger the release of the airbags."
    ],
    "correct_answer": 0,
    "explanation": "A worn shock absorber can seriously affect the control of the vehicle especially on uneven surfaces or when cornering and can cause unnecessary wear and tear on tyres. It may increase stopping distance by not keeping the tyres in proper contact with the road under harsh braking.",
    "image_name": ""
  },
  {
    "index": 795,
    "id": "ABMW0692RU23",
    "section": "Technical Matters",
    "question": "What does the speed rating of a tyre indicate?",
    "options": [
      "The maximum speed the vehicle can be driven at.",
      "The maximum speed for which the tyre is designed.",
      "The minimum speed for which the tyre is designed."
    ],
    "correct_answer": 1,
    "explanation": "The speed rating of a tyre is the maximum speed for which the tyre is designed. This relates to the speed capability of the tyre. It does not relate to the speed at which the tyre should or could legally be driven.",
    "image_name": ""
  },
  {
    "index": 796,
    "id": "ABMW0693RU19",
    "section": "Technical Matters",
    "question": "Why should the valve be replaced when having a tubeless tyre fitted?",
    "options": [
      "To ensure the wheel remains balanced.",
      "To ensure the wheel nuts remain tight.",
      "To ensure the wheel remains aligned.",
      "To ensure the tyre will remain inflated."
    ],
    "correct_answer": 3,
    "explanation": "When fitting a new tubeless tyre to a vehicle it is recommended to change the valve. This is because the old valve has been on the wheel since the old tyre was fitted. The old valve may break down, leak or cause air to escape.",
    "image_name": ""
  },
  {
    "index": 797,
    "id": "ABMW0701RU19",
    "section": "Technical Matters",
    "question": "What effect does low tyre-pressure have on a vehicle?",
    "options": [
      "The engine noise increases.",
      "Braking and cornering are impaired.",
      "The vehicle accelerates faster.",
      "The brakes can overheat."
    ],
    "correct_answer": 1,
    "explanation": "Incorrect tyre pressure adversely affects many of a vehicle's systems, including suspension, steering and fuel consumption. In particular, under-inflated tyres can affect the vehicle's braking ability and its effectiveness when cornering. Tyres should always be inflated according to the vehicle manufacturer's guidelines, information on which can be found in the vehicle handbook.",
    "image_name": ""
  },
  {
    "index": 798,
    "id": "ABMW0708RU19",
    "section": "Technical Matters",
    "question": "What is an effect of under-inflated tyres on a vehicle?",
    "options": [
      "Impaired braking and steering.",
      "Increased wear on the vehicle's engine.",
      "Improved braking and steering.",
      "Improved fuel economy and braking."
    ],
    "correct_answer": 0,
    "explanation": "Drivers should check their vehicle's tyre pressures (including the spare) regularly at least once a week. Under-inflated tyres adversely affect many of a vehicle's systems, including braking ability, suspension, steering, fuel consumption and premature tyre wear. Tyres should always be inflated according to the vehicle manufacturer's guidelines, information on which can be found in the vehicle ",
    "image_name": ""
  },
  {
    "index": 799,
    "id": "ABMW0713RU19",
    "section": "Technical Matters",
    "question": "While driving at higher speeds, what does a continuous vibration in the steering indicate?",
    "options": [
      "The shock absorbers are worn.",
      "The wheel balance is uneven.",
      "The steering is out of alignment.",
      "Weight distribution is uneven."
    ],
    "correct_answer": 1,
    "explanation": "If a driver feels a continuous vibration in the steering, particularly at higher speeds, this could typically indicate that the balance of the vehicle wheels is uneven. This can lead to instability in the handling of the vehicle. If this is the case, have it investigated by a competent person.",
    "image_name": ""
  },
  {
    "index": 800,
    "id": "ABMW26U19",
    "section": "Technical Matters",
    "question": "After changing a wheel on a vehicle, which of the following should be checked after a short distance?",
    "options": [
      "The wheel nut tightness.",
      "The tyre air valve.",
      "The brake pad clearance.",
      "The tyre tread depth."
    ],
    "correct_answer": 0,
    "explanation": "After changing a wheel on a vehicle, check the tightness of the wheel nuts or studs on the replacement wheel after driving a short distance to ensure they are securely fitted. If in doubt seek assistance from a competent person.",
    "image_name": ""
  },
  {
    "index": 801,
    "id": "RSA225227",
    "section": "Technical Matters",
    "question": "When braking, what determines how quickly the vehicle will slow down and stop?",
    "options": [
      "The amount of downward pressure applied to the brake pedal.",
      "The amount of upward pressure applied to the brake pedal.",
      "The amount of downward pressure applied to the accelerator."
    ],
    "correct_answer": 0,
    "explanation": "The amount of downward pressure put on the brake pedal determines how quickly the vehicle will slow down and stop. In the normal course of driving, drivers should read the road ahead and learn to brake in good time and progressively.",
    "image_name": ""
  },
  {
    "index": 802,
    "id": "ABMWO711RU19",
    "section": "Technical Matters",
    "question": "When driving, where should a driver rest their left foot?",
    "options": [
      "Under the brake pedal.",
      "Under the clutch pedal.",
      "On the floor or foot rest.",
      "On the clutch pedal."
    ],
    "correct_answer": 2,
    "explanation": "When driving a driver should rest their left foot on the floor or foot rest but not under the pedals. To do so may cause delayed response time in an emergency. Resting the foot on the pedal may result in coasting, which may inadvertently increase the speed of the vehicle, or clutch mechanism damage."
  },
  {
    "index": 803,
    "id": "BW0071R",
    "section": "Technical Matters",
    "question": "On a motorway, when should a driver use the hazard warning lights?",
    "options": [
      "When towing another vehicle.",
      "When driving on the hard shoulder.",
      "When another vehicle is following too closely.",
      "When slowing down quickly because of danger ahead."
    ],
    "correct_answer": 3,
    "explanation": "Use the hazard warning lights to warn other road users of a danger ahead. For example, if you have to slow down sharply because of a build-up of traffic ahead, you can use the hazard warning lights to warn following vehicles that they need to  slow down."
  },
  {
    "index": 804,
    "id": "BW0084R",
    "section": "Technical Matters",
    "question": "What should a driver do if the fuel system becomes air-locked?",
    "options": [
      "Tighten the injector pipes.",
      "Loosen the fuel pump.",
      "Bleed the air out of the fuel system.",
      "Drain the fuel filter."
    ],
    "correct_answer": 2,
    "explanation": "The fuel system can become air-locked if you let the fuel get too low or if there is a leak in the system. You should have the problem corrected before driving. The solution may be as simple as bleeding the fuel system to release the air."
  },
  {
    "index": 805,
    "id": "BWO0092R",
    "section": "Technical Matters",
    "question": "Under what circumstances could both cross-ply and radial tyres be fitted to a vehicle?",
    "options": [
      "When each type is fitted on a different axle.",
      "When heavy loads are being carried.",
      "When towing a trailer in snow.",
      "When driving in slippery road conditions."
    ],
    "correct_answer": 0,
    "explanation": "In general, you should fit the same type of tyres all round the vehicle. However if you need to fit a mix of cross-ply and radials, the tyres on any axle should be of the same type."
  }
]
